import React, { useState, useEffect } from 'react';
import { avisoFormatoAntigo, converterFormatoAntigo, ehVersaoCongelada, formatarNumeroVersao, lerColunasNegociado, rotuloVersao, montarVersaoCongelada, motivoBloqueioNovaVersao, rotuloVersaoAtual, totalDaVersao, totalDaVersaoNoGrupo, valoresDaVersao } from './versaoNegociadoPolicy';
import ErpTemplate from '../../components/ErpTemplate';
import { useSetBreadcrumbLabel } from '../../context/BreadcrumbContext';
import { FaChevronDown, FaChevronLeft, FaChevronRight, FaCircle, FaCircleNotch, FaExpeditedssl, FaGgCircle, FaList, FaPlus, FaRegCircle, FaSave, FaTrash, FaDownload, FaTable, FaPen, FaEnvelope, FaBuilding, FaFileAlt, FaFilePdf, FaCopy, FaLock, FaLockOpen, FaFolder, FaGlobeAmericas, FaSearch, FaTimes, FaExclamationTriangle, FaExchangeAlt, FaPercent } from 'react-icons/fa';
import api from '../../services/api';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { TEMPO_LIMITE_SALVAR_MS, chaveSalvarBase, chaveSalvarPara, conflitoDoErroSalvar, dataParaMysql, destinoAposInserir, mensagemErroSalvar } from './salvarOrcamentoPolicy';
import ReactSelect from '../../components/ReactSelect';
import { rand18, data, extract, pontoVirgula, virgulaPonto, semValor, moeda } from '../../util/util';
import Data from '../../components/Data';
import { toast } from 'react-toastify';
import { AlcaArrastar, GrupoOrdenavel, LinhaOrdenavel, ListaOrdenavel } from './OrdenacaoOrcamento';
import { idOrdenavel, moverRespeitandoFixos, remapearExpandidos } from './ordemOrcamentoPolicy';
import { dadosDaPrevisao, fornecedoresAfetados, snapshotLinhas, variacaoDoFornecedor } from './reaprovacaoOrcamentoPolicy';
import { MSG_CLONAR_PRODUTO_INATIVO, clonarSubitem, produtoInativo } from './clonarLinhaOrcamentoPolicy';
import { MSG_CLONAR_GRUPO_UNICO, contarGrupos, grupoJaIncluido, juntarGruposRepetidos, listarGruposRepetidos, rotuloOpcaoGrupo } from './grupoUnicoOrcamentoPolicy';
import { Dropdown } from 'react-bootstrap';
import moment from 'moment';
import CampoValor from '../../components/CampoValor';
import { inicializarCamposCalculoSubitem } from './subitemCamposPadraoPolicy';
import { campoTributo, completarTributosEtapa, ETAPAS_TRIBUTO, tributosPadrao } from './tributoEtapaPolicy';
import { paraNumero } from '../../util/mascaraNumero';
import CampoPercentual from '../../components/CampoPercentual';
import { FinCheck } from '../../components/FinField';
import { FeeIntelligence } from './feeIntelligence';
import { OrcamentoClientInheritance } from './orcamentoClientInheritance';
import { ChiesiImpostoPolicy } from './chiesiImpostoPolicy';
import { AgenciaOrcamentoPolicy } from './agenciaOrcamentoPolicy';
import { divisorPrecoCatalogoLinha, precoCatalogoNaMoeda } from './precoCatalogoMoedaPolicy';
import { ChiesiAgenciaImpostoPolicy } from './chiesiAgenciaImpostoPolicy';
import { alterarPagamentoExteriorLinha, fornecedorAccessInterno as ehFornecedorAccessInterno, fornecedorIncompativelComPagamentoExterior, eventoNacional, mostrarMoedaCambioNoNacional, pagamentoExteriorDoSeletor, prepararPagamentoExteriorPayload, valorSeletorLocalPagamento } from './pagamentoExteriorPolicy';
import { alterarConfiguracaoRemessaLinha, alterarAjusteNfLinha, ajusteNfEtapa, calcularRemessaExteriorEstimativa, configuracaoRemessaEtapa, linhaElegivelRemessaExterior, resumirRemessaExteriorEstimativa, pagamentosExteriorEtapa } from './remessaExteriorEstimativaPolicy';
import { anotarBaseFeeBrlExato, anotarBaseFeeInternacional, clienteBaseFeeComImpostoItem, clienteBaseFeeComNfAccess, clienteBaseFeeComServico, clienteBaseFeeComTotalLinha, prepararExibicaoBrl } from './feeBaseInternacionalPolicy';
import { centavos, feeBrlExibido, linhaDeFeeBrl, linhaFeeSoEmReal, moedaOrcamentoDeBrl, orcamentoBrlExato, orcamentoEstrangeiro, totalBrutoLinha, unitarioFeeExato, valorBrlLinha } from './valorBrlPolicy';
import { FeeAgenciaManualPolicy } from './feeAgenciaManualPolicy';
import { alterarFechamentoExteriorLinha, calcularFechamentoExterior, cambioDaTransacao, sincronizarCambioFechamentoTransacao, decorarPreviewFechamentoExterior, limparFechamentoExteriorAoCopiar, linhaFechamentoExteriorConcluido, removerExibicaoFechamentoExterior, valorFechamentoExibicao } from './fechamentoExteriorPolicy';
import { validarDadosInternacionais, etapaColunaDoAlvo, idCampoAlvoInternacional } from './validacaoInternacionalPolicy';
import { listarPendenciasObservacao } from './observacaoObrigatoriaPolicy';
import { listarPendenciasItensObrigatorios, linhasParaIncluir, completarLinhaObrigatoria } from './itensObrigatoriosPolicy';
import { listarPendenciasSubItem, fotografarGravado, grupoFeeDesabilitado } from './subItemObrigatorioPolicy';
import AlertaDadosInternacionais from './AlertaDadosInternacionais';
import { alvoEhControleInterativo, areaUtilVertical, correcaoLarguraProxy, deslocamentoVerticalParaCampo, destinoScrollHorizontal, deveFixarCabecalho, larguraConteudoProxyParaMesmoLimite, scrollLeftParaCampo, temOverflowHorizontal } from './orcamentoGridScrollPolicy';
import { calcularTotaisAccess } from './totalAccessPolicy';
import { CAMPOS_CAMBIO_ETAPA, CAMPOS_MOEDA_ETAPA, LOCAL_EXTERIOR, MOEDAS_FORNECEDOR, MOMENTOS_MOEDA, ROTULOS_ETAPA_MOEDA, anotarFatoresMoeda, aplicarCambioEtapa, aplicarMoedaEtapa, aplicarPadraoMoedaLocal, cambioBrlLinha, cambioGlobalOrcamento, fatorAnotado, fatorMoedaOrcamento, localPagamentoLinha, moedasPorEtapaLinha, normalizarMoedaFornecedorItens, opcoesMoedaFornecedor, removerMoedaFornecedor, linhaAceitaMoedaFornecedor, listarMoedasFornecedores, moedaDaLinhaFornecedor, simboloMoeda, temCambioProprio, textoAlcanceMoedaFornecedor } from './moedaFornecedorPolicy';
import { calcularTotaisBrlOrcamento, calcularValorVigenteOrcamento, impostoNfAccessGrupoPorEtapa, valoresBrlGrupoPorEtapa } from './colunaVigentePolicy';
import { CAMPO_SOMENTE_VISUALIZACAO, ehSomenteVisualizacao } from './somenteVisualizacaoPolicy';
import { MSG_CLIENTE_BLOQUEADO, itemNaoPodeVirarCliente } from './quemPagaPorItemPolicy';
import { CAMPO_IMPOSTO_NF_CONTA_DIRETA, aceitaImpostoNfContaDireta, ehImpostoNfContaDireta, fatorBaseNf } from './impostoNfContaDiretaPolicy';
import { valorPainelBarraTotalAccess } from './valorPainelOrcamentoPolicy';
import { valorPainelNaMoedaOrcamento } from './remessaExteriorEstimativaPolicy';
import { COLUNAS_ITENS_EM_BRANCO, ROTULO_COLUNA_ITENS_EM_BRANCO, linhasEmBrancoPorColuna, resumirItensEmBranco } from './itensEmBrancoPolicy';
import { capturarCambioOrcamento, restaurarCambioOrcamento } from './cambioModalPolicy';
import { etiquetasValorPainel, simboloMoedaOrcamento } from './remessaExteriorEstimativaPolicy';
import { faixaAplicaNaColunaAdicional, faixaAplicaNoMomento } from './precificacaoFaixaPolicy';
import { aplicarRegraFeeSpeaker, isGrupoFeeSpeaker } from './feeSpeakerPolicy';
import FechamentoExteriorModal from './FechamentoExteriorModal';
import FechamentoExteriorResumo from './FechamentoExteriorResumo';
import { ImpostoNfAccessPorFornecedorPolicy } from './impostoNfAccessPorFornecedorPolicy';
import { LongPingPolicy } from './longPingPolicy';
import { AllerganFeePolicy } from './allerganFeePolicy';
import { convidadosEsperadosDoEvento, orcamentoBloqueadoPorConvidadosEsperados, paxConvidadosEsperados } from './convidadosEsperadosPolicy';
import { calcularTaxonomiaSanofi } from './taxonomiaSanofiPolicy';
import '../../css/financeiro-parcela-pagar.css';
import useRascunhoOrcamento from './useRascunhoOrcamento';
import ModalRascunhoOrcamento from './ModalRascunhoOrcamento';
import AvisoRascunhoOrcamento, { AvisoConflitoSalvarOrcamento, AvisoOutroOperadorOrcamento, ModalSairSemSalvarOrcamento } from './AvisoRascunhoOrcamento';
import { aplicarRascunho } from './rascunhoOrcamentoPolicy';
import ModalBuscaFornecedor from './ModalBuscaFornecedor';
import { rotuloFornecedor, temFornecedor } from './fornecedorRotuloPolicy';
import { umCardPorFornecedor } from './fornecedorPorGrupoPolicy';

const CNPJ_ACCESS_INTERNO = '21415772000164';
const CODIGO_PRODUTO_IMPOSTO_ACCESS = '1945';
const ALIQUOTA_IMPOSTO_NF_ACCESS = 19.05 / 100;


function verificaSeExiste(dados, data, index) {
    //encontra o item atual
    var resultado = false;
    dados.orcamentoitem.forEach((orcamentoItem, indexOrcamentoItem) => {
        orcamentoItem.subitem.forEach((subitem, indexEncontrado) => {
            if (subitem.chaveunica === dados.itemSomarAtual) {
                var arrayChavesSomar = subitem.chavessomar ? subitem.chavessomar.split(",") : [];
                if (arrayChavesSomar.includes(data.subitem[index].chaveunica?.toString() ?? '')) {
                    resultado = true;
                }
            }
        });
    });
    return resultado;
}

function adicionaCheck(dados, data, indexSubitemAdicionar) {
    //busca item de total atual
    dados.orcamentoitem.forEach((orcamentoItem, indexOrcamentoItem) => {
        orcamentoItem.subitem.forEach((subitem, indexSubItem) => {
            if (subitem.chaveunica === dados.itemSomarAtual) {
                if (dados.itemSomarAtual === data.subitem[indexSubitemAdicionar].chaveunica) {
                    toast.error('não é possível adicionar ele mesmo');
                } else {
                    //adiciona no chavessomar dele esse valor
                    var arrayChavesSomar = subitem.chavessomar ? subitem.chavessomar.split(",") : [];
                    arrayChavesSomar.push(data.subitem[indexSubitemAdicionar].chaveunica);//adiciona
                    dados.orcamentoitem[indexOrcamentoItem].subitem[indexSubItem].chavessomar = arrayChavesSomar.join(",");
                }
            }
        });
    });
}

function removeCheck(dados, data, indexSubitemAdicionar) {
    //busca item de total atual
    dados.orcamentoitem.forEach((orcamentoItem, indexOrcamentoItem) => {
        orcamentoItem.subitem.forEach((subitem, indexSubItem) => {
            if (subitem.chaveunica === dados.itemSomarAtual) {
                //adiciona no chavessomar dele esse valor
                var arrayChavesSomar = subitem.chavessomar ? subitem.chavessomar.split(",") : [];
                arrayChavesSomar = arrayChavesSomar.filter(item => item !== data.subitem[indexSubitemAdicionar].chaveunica.toString());//remove
                dados.orcamentoitem[indexOrcamentoItem].subitem[indexSubItem].chavessomar = arrayChavesSomar.join(",");
            }
        });
    });
}

function normalizarTexto(texto) {
    return (texto || '')
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toUpperCase();
}

function parseOrcamentoConfig(config) {
    if (!config) {
        return null;
    }

    if (typeof config === 'string') {
        try {
            return JSON.parse(config);
        } catch (error) {
            return null;
        }
    }

    if (typeof config === 'object') {
        return config;
    }

    return null;
}

function parseBooleanFlag(value) {
    if (typeof value === 'boolean') {
        return value;
    }

    if (typeof value === 'number') {
        return value === 1;
    }

    if (typeof value === 'string') {
        const normalized = value.trim().toLowerCase();
        return ['1', 'true', 'sim', 'yes', 'on'].includes(normalized);
    }

    return false;
}

// 20/10 (Rafael, treinamento turma 5): coluna "Fora Escopo?" oculta na grade do orçamento. Só a
// exibição: o campo continua no dado e no Salvar. true = volta a mostrar. "Equipamentos" segue visível
// (é por ela que se sobe a planilha que vira aba no Excel).
const MOSTRAR_COLUNA_FORA_ESCOPO = false;

function produtoPermiteUploadEquipamentos(produto) {
    const config = parseOrcamentoConfig(produto?.orcamentoConfig ?? produto?.orcamento_config);
    const enabled = config?.uploads?.equipamentos?.enabled;
    return parseBooleanFlag(enabled);
}

function isGrupoAgencia(item) {
    return AgenciaOrcamentoPolicy.isGrupoAgencia(item);
}

function isSubitemFeeAgencia(subitem) {
    // Cobre o 130 global e os fees de catálogo (Sanofi 2043; Abbvie 2130-2136):
    // todos têm o valor composto pelo motor conforme a tabela/regra do cliente,
    // nunca digitado — a linha mostra os valores calculados, readonly.
    return AgenciaOrcamentoPolicy.isFeeAgenciaGlobal(subitem?.produto)
        || AgenciaOrcamentoPolicy.isFeeDeCatalogo(subitem?.produto);
}

function isSubitemFeeAgenciaPadrao(subitem) {
    return isSubitemFeeAgencia(subitem);
}

function isSubitemTipoFaturamentoND(subitem) {
    return ((subitem?.tipofaturamento ?? '') + '').trim().toLowerCase() === 'nd';
}

function sincronizarValorRealComFechamentoSeND(subitem) {
    if (!isSubitemTipoFaturamentoND(subitem)) {
        return;
    }

    const totalFechamento = virgulaPonto(subitem?.totalFechamento) || 0;
    subitem.pagamentovalorreal = totalFechamento.toFixed(2);
    subitem.pagamentosavingreal = '0.00';
}

function normalizarIdsPagamentoFormas(subitem) {
    const ids = [];
    const formas = subitem?.pagamentoformas;

    if (Array.isArray(formas)) {
        formas.forEach((forma) => {
            if (forma && typeof forma === 'object') {
                const valor = forma.id ?? forma.value ?? null;
                if (valor !== null && valor !== undefined && valor !== '') {
                    ids.push(String(valor));
                }
                return;
            }

            if (forma !== null && forma !== undefined && forma !== '') {
                ids.push(String(forma));
            }
        });
    }

    if (ids.length === 0) {
        const formaUnica = subitem?.pagamentoforma;
        if (formaUnica && typeof formaUnica === 'object') {
            const valor = formaUnica.id ?? formaUnica.value ?? null;
            if (valor !== null && valor !== undefined && valor !== '') {
                ids.push(String(valor));
            }
        } else if (formaUnica !== null && formaUnica !== undefined && formaUnica !== '') {
            ids.push(String(formaUnica));
        }
    }

    return Array.from(new Set(ids));
}

function obterOpcoesPagamentoSelecionadasSubitem(subitem) {
    const ids = normalizarIdsPagamentoFormas(subitem);
    const labelsPorId = new Map();

    const formas = subitem?.pagamentoformas;
    if (Array.isArray(formas)) {
        formas.forEach((forma) => {
            if (!forma || typeof forma !== 'object') {
                return;
            }

            const id = forma.id ?? forma.value ?? null;
            const label = forma.nome ?? forma.label ?? null;
            if (id !== null && id !== undefined && id !== '' && label) {
                labelsPorId.set(String(id), String(label));
            }
        });
    }

    const formaUnica = subitem?.pagamentoforma;
    if (formaUnica && typeof formaUnica === 'object') {
        const id = formaUnica.id ?? formaUnica.value ?? null;
        const label = formaUnica.nome ?? formaUnica.label ?? null;
        if (id !== null && id !== undefined && id !== '' && label) {
            labelsPorId.set(String(id), String(label));
        }
    }

    return ids.map((id) => ({
        value: id,
        label: labelsPorId.get(String(id)) ?? String(id),
    }));
}

function atualizarPagamentoFormasSubitem(subitem, opcoesSelecionadas) {
    const opcoes = Array.isArray(opcoesSelecionadas) ? opcoesSelecionadas : [];
    const opcoesNormalizadas = opcoes
        .filter((opcao) => opcao && opcao.value !== undefined && opcao.value !== null && opcao.value !== '')
        .map((opcao) => ({ value: String(opcao.value), label: opcao.label ?? String(opcao.value) }));

    subitem.pagamentoformas = opcoesNormalizadas.map((opcao) => ({
        id: opcao.value,
        nome: opcao.label,
    }));

    if (opcoesNormalizadas.length > 0) {
        subitem.pagamentoforma = {
            id: opcoesNormalizadas[0].value,
            nome: opcoesNormalizadas[0].label,
        };
    } else {
        subitem.pagamentoforma = null;
    }
}

function ordenarGruposComAgenciaNoTopo(orcamentoItens = []) {
    if (!Array.isArray(orcamentoItens) || orcamentoItens.length <= 1) {
        return orcamentoItens;
    }

    const itensComIndice = orcamentoItens.map((item, index) => ({
        item,
        index,
        isAgencia: isGrupoAgencia(item)
    }));

    itensComIndice.sort((a, b) => {
        if (a.isAgencia === b.isAgencia) {
            return a.index - b.index;
        }
        return a.isAgencia ? -1 : 1;
    });

    return itensComIndice.map(({ item }) => item);
}

function obterIdComparavel(valor) {
    return FeeIntelligence.toComparableId(valor);
}

function obterIdsComparaveis(valor) {
    if (valor === null || valor === undefined || valor === '') {
        return [];
    }

    if (Array.isArray(valor)) {
        return valor.map((item) => obterIdComparavel(item)).filter(Boolean);
    }

    return String(valor)
        .split(',')
        .map((item) => obterIdComparavel(item.trim()))
        .filter(Boolean);
}

function obterIdsItensPermanentesAtivos(itensPermanentesIds = [], itensPermanentesInternacionaisIds = [], eventoNacionalidade = null) {
    const ids = [...(itensPermanentesIds || [])];
    const nacionalidade = (eventoNacionalidade || '').toString().toLowerCase();

    if (nacionalidade === 'internacional' && Array.isArray(itensPermanentesInternacionaisIds)) {
        ids.push(...itensPermanentesInternacionaisIds);
    }

    return [...new Set(ids.map((item) => obterIdComparavel(item)).filter(Boolean))];
}

function isFeeAgenciaGenerico(produto) {
    return FeeIntelligence.isAgencyFeeItem(produto);
}

function criarSubitemFeeAgenciaPadrao() {
    return {
        produto: {
            id: '938266831763065083',
            codigo: 130,
            nome: '130 - FEE AGÊNCIA',
            somarTodosFee: 'nao',
            tipoPreco: 'fixo',
            preco: 0,
            superior: '939529851763065082',
            atributo: null,
            feeBaseTipo: 'compoe_fee_global',
            feeBaseId: null,
            feeMomentoCalculo: 'todos',
            precificacaoFaixas: [],
        },
        compoeFee: 'nao',
        inserirCalculoTotalPlanilha: false,
        pagamento_exterior: null,
        tipopagamento: 'normal',
        quantidade: '1',
        quantidadePreEvento: '1',
        diariaPreEvento: '1',
        valorUnitarioPreEvento: '0',
        quantidadeNegociado: '1',
        diariaNegociado: '1',
        valorUnitarioNegociado: '0',
        quantidadeFechamento: '1',
        diariaFechamento: '1',
        valorUnitarioFechamento: '0',
        servicoPreEvento: '0',
        servicoNegociado: '0',
        servicoFechamento: '0',
        impostoPorcentagemItem: '0',
        ...tributosPadrao('0'),
        chaveunica: rand18(),
    };
}

function criarSubitemOrcamentoPadrao() {
    return {
        compoeFee: 'nao',
        inserirCalculoTotalPlanilha: false,
        pagamento_exterior: null,
        tipopagamento: 'normal',
        quantidade: '1',
        quantidadePreEvento: '1',
        diariaPreEvento: '1',
        valorUnitarioPreEvento: '0',
        quantidadeNegociado: '1',
        diariaNegociado: '1',
        valorUnitarioNegociado: '0',
        quantidadeFechamento: '1',
        diariaFechamento: '1',
        valorUnitarioFechamento: '0',
        servicoPreEvento: '0',
        servicoNegociado: '0',
        servicoFechamento: '0',
        impostoPorcentagemItem: '0',
        ...tributosPadrao('0'),
        chaveunica: rand18(),
    };
}


function anexarObservacaoSemDuplicar(observacaoAtual = '', texto = '') {
    const observacaoNormalizada = String(observacaoAtual ?? '').trim();
    const textoNormalizado = String(texto ?? '').trim();

    if (!textoNormalizado) {
        return observacaoNormalizada;
    }

    if (!observacaoNormalizada) {
        return textoNormalizado;
    }

    if (observacaoNormalizada.includes(textoNormalizado)) {
        return observacaoNormalizada;
    }

    return `${observacaoNormalizada} | ${textoNormalizado}`;
}

function aplicarObservacaoImpostoPlanilha(subitem = {}) {
    subitem.pagamentoobservacao = anexarObservacaoSemDuplicar(
        subitem.pagamentoobservacao,
        'Aplicado: 19.05%'
    );
}

function formatarValorUnitarioCalculado(valor = 0, limitarDuasCasas = false) {
    const numero = Number(valor) || 0;
    const valorNormalizado = limitarDuasCasas
        ? Math.round((numero + Number.EPSILON) * 100) / 100
        : numero;

    return pontoVirgula(valorNormalizado);
}

function deveLimitarValorUnitarioFeeAgencia(produto = {}) {
    return FeeIntelligence.isAgencyFeeItem(produto) || FeeIntelligence.isSanofiAgencyTierFeeItem(produto);
}

function calcularTotalMomentoSubitem(subitem = {}, momento = 'PreEvento') {
    const momentoFee = {
        PreEvento: 'pre_evento',
        Negociado: 'negociado',
        Fechamento: 'fechamento',
    }[momento] ?? 'pre_evento';
    const totalFeePercentual = FeeIntelligence.calculateAgencyFeeLineTotal(subitem, momentoFee);
    if (totalFeePercentual !== null) {
        return totalFeePercentual;
    }

    // Fórmula única da linha (valorBrlPolicy.totalBrutoLinha): linha de imposto (1945/marcada) =
    // subtotal × (1 + % Serviço) — o % Impostos dela é alíquota sobre o grupo; demais = % Serviço e
    // % Impostos aditivos sobre o valor base, % Imposto NF por gross-up (base × a/(1−a)).
    return totalBrutoLinha(subitem, momento);
}

function normalizarCampoCompoeFee(subitem = {}) {
    const compoeFeeAtivo = parseBooleanFlag(subitem.compoeFee);
    subitem.compoeFee = compoeFeeAtivo ? 'sim' : 'nao';
    subitem.nomeCompoeFee = compoeFeeAtivo ? 'Sim' : 'Não';
}

function sincronizarSubitemQueCompoeFee(subitem = {}) {
    const produto = subitem?.produto ?? {};
    const itemMapeadoParaFee =
        FeeIntelligence.isAgencyFeeRuleItem(produto) ||
        FeeIntelligence.isVoucherManualBaseItem(produto);

    if (!itemMapeadoParaFee) {
        return;
    }

    subitem.compoeFee = 'sim';
    subitem.nomeCompoeFee = 'Sim';

    const idFornecedorPagamentoAtual = (subitem.fornecedorpagamento?.id ?? subitem.fornecedorpagamento ?? '').toString().toLowerCase();
    if (idFornecedorPagamentoAtual !== 'agencia' && idFornecedorPagamentoAtual !== 'cliente') {
        subitem.fornecedorpagamento = {
            id: 'agencia',
            nome: 'Agência'
        };
    }
}

function mesclarProdutoComCatalogo(produtoAtual = {}, produtoCatalogo = null) {
    if (!produtoCatalogo) {
        return produtoAtual;
    }

    return {
        ...produtoAtual,
        id: produtoAtual?.id ?? produtoCatalogo.id,
        codigo: produtoCatalogo.codigo ?? produtoAtual?.codigo ?? null,
        codigoFornecedor: produtoCatalogo.codigoFornecedor ?? produtoAtual?.codigoFornecedor ?? null,
        nome: produtoCatalogo.nome ?? produtoAtual?.nome ?? '',
        somarTodosFee: produtoCatalogo.somarTodosFee ?? produtoAtual?.somarTodosFee ?? 'nao',
        tipoPreco: produtoCatalogo.tipoPreco ?? produtoAtual?.tipoPreco ?? 'fixo',
        preco: produtoCatalogo.preco ?? produtoAtual?.preco ?? 0,
        superior: obterIdComparavel(produtoCatalogo.superior ?? produtoAtual?.superior),
        atributo: obterIdComparavel(produtoCatalogo.atributo ?? produtoAtual?.atributo),
        feeBaseTipo: produtoCatalogo.feeBaseTipo ?? produtoAtual?.feeBaseTipo ?? 'compoe_fee_global',
        feeBaseId: produtoCatalogo.feeBaseId ?? produtoAtual?.feeBaseId ?? null,
        feeMomentoCalculo: produtoCatalogo.feeMomentoCalculo ?? produtoAtual?.feeMomentoCalculo ?? 'todos',
        orcamentoConfig: produtoCatalogo.orcamento_config ?? produtoCatalogo.orcamentoConfig ?? produtoAtual?.orcamentoConfig ?? null,
        precificacaoFaixas: normalizarFaixasPrecificacao(produtoCatalogo),
    };
}

function criarGrupoAgenciaPadrao(incluirFeePadrao = true) {
    return {
        chavegrupo: rand18(),
        quantidade: '1',
        produto: {
            id: '939529851763065082',
            codigo: 130,
            nome: '130 - AGÊNCIA',
            somarTodosFee: 'nao',
            feeBaseTipo: 'compoe_fee_global',
            feeBaseId: null,
            feeMomentoCalculo: 'todos',
            precificacaoFaixas: [],
        },
        subitem: incluirFeePadrao ? [criarSubitemFeeAgenciaPadrao()] : [],
        valorTotalPreEvento: '0.00',
        valorTotalNegociado: '0.00',
        valorTotalFechamento: '0.00',
    };
}

function garantirEstruturaAgencia(orcamentoItens = [], { incluirFeePadrao = true } = {}) {
    AgenciaOrcamentoPolicy.garantirEstrutura(orcamentoItens, {
        incluirFeePadrao, criarGrupo: criarGrupoAgenciaPadrao, criarFee: criarSubitemFeeAgenciaPadrao
    });
}

function isClienteAbbvie(cliente) {
    const clienteId = obterIdComparavel(cliente?.id ?? cliente);
    return clienteId === '1761594621000';
}

function isClienteSanofi(cliente) {
    return OrcamentoClientInheritance.usesSanofiBudgetRules(cliente);
}

// Épico 13 — clientes cujo fee é escolhido no catálogo (produto de fee), sem a linha fixa
// "130 - FEE AGÊNCIA" auto-injetada. Sanofi (fee percentual por valor) e Abbvie (fee por
// categoria × faixa de pax). Outros clientes seguem com a linha 130 padrão.
function clienteEscolheFeeNoCatalogo(cliente) {
    // Só a Sanofi troca a linha 130 pelo fee de catálogo próprio (2043).
    // A Abbvie usa a linha "Fee Agência" padrão como todos os clientes — os
    // fees por categoria (2130-2136) são tabela de cálculo, não linha.
    return isClienteSanofi(cliente);
}

function isClienteChiesi(cliente) {
    const nomeCliente = cliente?.nome ?? '';
    return normalizarTexto(nomeCliente).includes('CHIESI');
}

function normalizarDocumento(documento) {
    return (documento || '').toString().replace(/\D/g, '');
}

function isGrupoServicosAgencia(item) {
    const codigo = (item?.produto?.codigo ?? '').toString().trim();
    const nome = normalizarTexto(item?.produto?.nome ?? '').trim();
    return codigo === '3027' || nome === 'SERVICOS AGENCIA';
}

function isSubitemImpostoNfAccess(subitem = {}) {
    return (subitem?.produto?.codigo ?? '').toString().trim() === CODIGO_PRODUTO_IMPOSTO_ACCESS;
}

function calcularImpostoNfAccess(base = 0) {
    const baseNumerica = Number(base) || 0;
    if (baseNumerica <= 0) {
        return 0;
    }

    return Math.round(((baseNumerica * ALIQUOTA_IMPOSTO_NF_ACCESS) / (1 - ALIQUOTA_IMPOSTO_NF_ACCESS) + Number.EPSILON) * 100) / 100;
}

function criarSubitemImpostoNfAccess(produtoImposto, fornecedorAccess = null, existente = {}) {
    return {
        ...existente,
        produto: {
            ...produtoImposto,
            codigo: CODIGO_PRODUTO_IMPOSTO_ACCESS,
        },
        fornecedor: fornecedorAccess?.id ? {
            id: fornecedorAccess.id,
            nome: fornecedorAccess.nome,
            cnpj: fornecedorAccess.cnpj,
        } : (existente.fornecedor ?? null),
        fornecedorpagamento: { id: 'agencia', nome: 'Agência' },
        tipofaturamento: 'nf',
        tipopagamento: 'normal',
        compoeFee: 'nao',
        nomeCompoeFee: 'Não',
        inserirCalculoTotalPlanilha: false,
        moeda: 'real',
        quantidadePreEvento: '1',
        diariaPreEvento: '1',
        valorUnitarioPreEvento: existente.valorUnitarioPreEvento ?? '0',
        quantidadeNegociado: '1',
        diariaNegociado: '1',
        valorUnitarioNegociado: existente.valorUnitarioNegociado ?? '0',
        quantidadeFechamento: '1',
        diariaFechamento: '1',
        valorUnitarioFechamento: existente.valorUnitarioFechamento ?? '0',
        servicoPreEvento: '0',
        servicoNegociado: '0',
        servicoFechamento: '0',
        imposto: '0',
        impostoPorcentagemItem: '0',
        ...tributosPadrao('0'),
        observacaoPreEvento: 'Cálculo por fora: 19,05%',
        observacaoNegociado: 'Cálculo por fora: 19,05%',
        observacaoFechamento: 'Cálculo por fora: 19,05%',
        pagamentoobservacao: 'Imposto NF Access calculado automaticamente.',
        chaveunica: existente.chaveunica ?? `imposto-nf-access-${rand18()}`,
        linhaCalculadaImpostoAccess: true,
    };
}

function aplicarRegraServicosAgenciaChiesi(orcamentoItens = [], cliente = null, fornecedorAccess = null, produtoImposto = null) {
    if (!isClienteChiesi(cliente) || !Array.isArray(orcamentoItens)) {
        return;
    }

    orcamentoItens.forEach((item) => {
        if (!isGrupoServicosAgencia(item) || !Array.isArray(item?.subitem)) {
            return;
        }

        item.subitem.forEach((subitem) => {
            subitem.compoeFee = 'nao';
            subitem.nomeCompoeFee = 'Não';
            subitem.inserirCalculoTotalPlanilha = false;

            if (fornecedorAccess?.id) {
                subitem.fornecedor = {
                    id: fornecedorAccess.id,
                    nome: fornecedorAccess.nome,
                    cnpj: fornecedorAccess.cnpj,
                };
            }
        });

        const linhasImposto = item.subitem.filter(isSubitemImpostoNfAccess);
        const produtoImpostoDisponivel = produtoImposto ?? linhasImposto[0]?.produto ?? null;
        if (produtoImpostoDisponivel?.id) {
            const subitensNormais = item.subitem.filter((subitem) => !isSubitemImpostoNfAccess(subitem));
            item.subitem = [
                ...subitensNormais,
                criarSubitemImpostoNfAccess(produtoImpostoDisponivel, fornecedorAccess, linhasImposto[0] ?? {}),
            ];
        }
    });
}

function sincronizarValoresImpostoServicosAgenciaChiesi(orcamentoItens = [], cliente = null, cambioGlobal = 1) {
    if (!isClienteChiesi(cliente) || !Array.isArray(orcamentoItens)) {
        return;
    }

    orcamentoItens.forEach((item) => {
        if (!isGrupoServicosAgencia(item) || !Array.isArray(item?.subitem)) {
            return;
        }

        const linhaImposto = item.subitem.find(isSubitemImpostoNfAccess);
        if (!linhaImposto) {
            return;
        }

        ['PreEvento', 'Negociado', 'Fechamento'].forEach((momento) => {
            const base = item.subitem.reduce((total, subitem) => {
                // Linha que já cobra o % Imposto NF dela (o 3027 força a Access) não volta para a 1945.
                const impostoNfLinha = virgulaPonto(subitem?.imposto) || 0;
                if (isSubitemImpostoNfAccess(subitem) || ehSomenteVisualizacao(subitem) || (impostoNfLinha > 0 && impostoNfLinha < 100)) {
                    return total;
                }
                // A 1945 fica na moeda do orçamento: linha com moeda própria (RSVP em R$ num orçamento
                // em US$, 04/10) entra convertida — mesma conta da API (normalizarImpostoServicosAgenciaChiesi).
                return total + (virgulaPonto(subitem[`total${momento}`]) || 0) * fatorMoedaOrcamento(subitem, momento, cambioGlobal);
            }, 0);
            linhaImposto[`quantidade${momento}`] = '1';
            linhaImposto[`diaria${momento}`] = '1';
            // D-0112: a 1945 marcada na conta direta (planilha antiga) cobra base × 19,05%.
            linhaImposto[`valorUnitario${momento}`] = pontoVirgula(calcularImpostoNfAccess(base * fatorBaseNf(linhaImposto)));
            linhaImposto[`observacao${momento}`] = ehImpostoNfContaDireta(linhaImposto) ? 'Conta direta: 19,05%' : 'Cálculo por fora: 19,05%';
            linhaImposto[`servico${momento}`] = '0';
        });
    });
}

function ordenarSubitensSanofiComFeeNoTopo(orcamentoItens = [], cliente = null) {
    if (!isClienteSanofi(cliente) || !Array.isArray(orcamentoItens)) {
        return orcamentoItens;
    }

    orcamentoItens.forEach((item) => {
        if (!Array.isArray(item?.subitem) || item.subitem.length <= 1) {
            return;
        }

        const subitensComIndice = item.subitem.map((subitem, index) => ({
            subitem,
            index,
            isFeeSanofi: FeeIntelligence.isSanofiAgencyTierFeeItem(subitem?.produto ?? {}),
        }));

        subitensComIndice.sort((a, b) => {
            if (a.isFeeSanofi === b.isFeeSanofi) {
                return a.index - b.index;
            }

            return a.isFeeSanofi ? -1 : 1;
        });

        item.subitem = subitensComIndice.map(({ subitem }) => subitem);
    });

    return orcamentoItens;
}

function isGrupoVoucherAbbvie(itemPrincipal = {}) {
    const config = parseOrcamentoConfig(itemPrincipal?.orcamentoConfig ?? itemPrincipal?.orcamento_config);
    const feeConfig = config?.fee ?? {};
    if (feeConfig.groupKey === 'voucher' || feeConfig.groupType === 'voucher') {
        return true;
    }

    const nomeProduto = (itemPrincipal?.nome ?? '').toString();

    return (
        normalizarTexto(nomeProduto).includes('VOUCHER')
    );
}

function normalizarTipoPreco(tipoPreco) {
    return (tipoPreco ?? 'fixo').toString().toLowerCase();
}

function normalizarFaixasPrecificacao(produto = {}) {
    const faixasOriginais = produto?.precificacaoFaixas ?? produto?.precificacao_faixas ?? [];
    if (!Array.isArray(faixasOriginais)) {
        return [];
    }

    return faixasOriginais
        .map((faixa, index) => ({
            ordem: faixa?.ordem ?? (index + 1),
            faixaMin: faixa?.faixaMin !== undefined && faixa?.faixaMin !== null && faixa?.faixaMin !== '' ? virgulaPonto(faixa.faixaMin) : null,
            faixaMax: faixa?.faixaMax !== undefined && faixa?.faixaMax !== null && faixa?.faixaMax !== '' ? virgulaPonto(faixa.faixaMax) : null,
            tipoPreco: normalizarTipoPreco(faixa?.tipoPreco),
            valor: virgulaPonto(faixa?.valor ?? 0) || 0,
            unidadeCobranca: faixa?.unidadeCobranca ?? 'total',
            // Épico 13 — período da faixa (Abbvie: 2025/2026); null = aplica sempre
            versao: (faixa?.versao === undefined || faixa?.versao === null || faixa?.versao === '') ? null : String(faixa.versao)
        }))
        .sort((a, b) => {
            const ordemA = Number(a.ordem ?? 0);
            const ordemB = Number(b.ordem ?? 0);
            if (ordemA !== ordemB) {
                return ordemA - ordemB;
            }
            const minA = a.faixaMin ?? 0;
            const minB = b.faixaMin ?? 0;
            return minA - minB;
        });
}

function obterFaixaPorQuantidade(faixas = [], quantidade = 0) {
    if (!Array.isArray(faixas) || faixas.length === 0) {
        return null;
    }

    const quantidadeNumerica = Number(quantidade ?? 0);
    const quantidadeNormalizada = Number.isFinite(quantidadeNumerica) ? quantidadeNumerica : 0;

    for (const faixa of faixas) {
        const min = faixa.faixaMin ?? 0;
        const max = faixa.faixaMax;
        const atendeMin = quantidadeNormalizada >= min;
        const atendeMax = max === null || max === undefined || quantidadeNormalizada <= max;
        if (atendeMin && atendeMax) {
            return faixa;
        }
    }

    const primeiraFaixa = faixas[0];
    const ultimoIndice = faixas.length - 1;
    const ultimaFaixa = faixas[ultimoIndice];
    if (quantidadeNormalizada < (primeiraFaixa.faixaMin ?? 0)) {
        return primeiraFaixa;
    }

    return ultimaFaixa;
}

// Épico 13 — filtra faixas pelo período (tabela_versao) do orçamento. Faixa sem versão
// aplica sempre; com versão, só quando bate com o período (retroativo 2025 / novo 2026).
function filtrarFaixasPorVersao(faixas = [], tabelaVersao = null) {
    if (!Array.isArray(faixas)) {
        return [];
    }
    const versaoAlvo = (tabelaVersao === null || tabelaVersao === undefined || tabelaVersao === '') ? null : String(tabelaVersao);
    return faixas.filter((f) => {
        const v = (f?.versao === undefined || f?.versao === null || f?.versao === '') ? null : String(f.versao);
        return v === null || v === versaoAlvo;
    });
}

// D-0157: a faixa de preço só reprecifica uma etapa quando muda o que a define naquela etapa (produto,
// quantidade, tabela, câmbio do catálogo). Antes ela rodava em todo recálculo nas três etapas e trocava o
// % Serviço digitado à mão em uma etapa quando o operador mexia em outra. O registro fica na linha
// (CAMPO_FAIXA_APLICADA) e nasce com o gravado ao abrir o orçamento: abrir não reprecifica nada.
const CAMPO_FAIXA_APLICADA = '__faixaAplicada';

function chaveFaixaAplicada(subitem = {}, campoQuantidade, tabelaVersao, divisorMoeda) {
    return [subitem?.produto?.id ?? '', virgulaPonto(subitem?.[campoQuantidade]) || 0, tabelaVersao ?? '', divisorMoeda ?? 1].join('|');
}

// true = já aplicada com esta chave (não reprecifica); false = registra a chave e segue para aplicar.
function faixaJaAplicada(subitem, etapa, chave) {
    const registro = subitem[CAMPO_FAIXA_APLICADA] && typeof subitem[CAMPO_FAIXA_APLICADA] === 'object' ? subitem[CAMPO_FAIXA_APLICADA] : {};
    if (registro[etapa] === chave) return true;
    subitem[CAMPO_FAIXA_APLICADA] = { ...registro, [etapa]: chave };
    return false;
}

// Marca a etapa como já precificada no estado atual (ao abrir o orçamento e depois do Copiar).
function marcarFaixaAplicada(subitem = {}, etapa, dadosOrcamento = {}) {
    if (!subitem || typeof subitem !== 'object') return;
    const adicional = String(etapa).startsWith('NegociadoAdicional_');
    const momentoMoeda = adicional ? 'Negociado' : etapa;
    const divisor = divisorPrecoCatalogoLinha(subitem, momentoMoeda, dadosOrcamento.moeda, dadosOrcamento.cambio);
    faixaJaAplicada(subitem, etapa, chaveFaixaAplicada(subitem, `quantidade${etapa}`, dadosOrcamento.tabela_versao, divisor));
}

function marcarFaixasDoGravado(dadosOrcamento = {}) {
    const colunas = Array.isArray(dadosOrcamento.colunasNegociadoAdicionais) ? dadosOrcamento.colunasNegociadoAdicionais : [];
    (dadosOrcamento.orcamentoitem || []).forEach((item) => (item?.subitem || []).forEach((subitem) => {
        ['PreEvento', 'Negociado', 'Fechamento'].forEach((etapa) => marcarFaixaAplicada(subitem, etapa, dadosOrcamento));
        colunas.forEach((coluna) => { if (coluna?.id !== undefined) marcarFaixaAplicada(subitem, `NegociadoAdicional_${coluna.id}`, dadosOrcamento); });
    }));
}

function aplicarPrecificacaoPorFaixaNoMomento(subitem = {}, sufixoMomento = 'PreEvento', tabelaVersao = null, divisorMoeda = 1) {
    const produto = subitem?.produto ?? {};
    if (FeeIntelligence.isAgencyFeeRuleItem(produto)) {
        return;
    }
    if (faixaJaAplicada(subitem, sufixoMomento, chaveFaixaAplicada(subitem, `quantidade${sufixoMomento}`, tabelaVersao, divisorMoeda))) {
        return;
    }
    // Faixa sempre no Pré-Evento; nas demais etapas só reaplica se já houver preço (nunca do zero).
    if (!faixaAplicaNoMomento(subitem, sufixoMomento)) {
        return;
    }
    const faixas = filtrarFaixasPorVersao(normalizarFaixasPrecificacao(produto), tabelaVersao);
    if (faixas.length === 0) {
        return;
    }

    const campoQuantidade = `quantidade${sufixoMomento}`;
    const campoValorUnitario = `valorUnitario${sufixoMomento}`;
    const campoServico = `servico${sufixoMomento}`;

    const quantidadeAtual = virgulaPonto(subitem[campoQuantidade]) || 0;
    const faixaAplicavel = obterFaixaPorQuantidade(faixas, quantidadeAtual);
    if (!faixaAplicavel) {
        return;
    }

    const tipoPrecoFaixa = normalizarTipoPreco(faixaAplicavel.tipoPreco);
    const valorFaixa = virgulaPonto(faixaAplicavel.valor) || 0;

    subitem.produto.tipoPreco = tipoPrecoFaixa;
    subitem.produto.preco = valorFaixa;

    if (tipoPrecoFaixa === 'percentual') {
        subitem[campoServico] = pontoVirgula(valorFaixa);
        if (!FeeIntelligence.isVoucherManualBaseItem(produto)) {
            subitem[campoValorUnitario] = '0';
        }
        return;
    }

    subitem[campoValorUnitario] = pontoVirgula(precoCatalogoNaMoeda(valorFaixa, divisorMoeda));
    subitem[campoServico] = '0';
}

function inicializarCamposColunaNegociadoAdicional(subitem = {}, colunaId) {
    const campoValorUnitario = `valorUnitarioNegociadoAdicional_${colunaId}`;
    const campoDiaria = `diariaNegociadoAdicional_${colunaId}`;
    const campoQuantidade = `quantidadeNegociadoAdicional_${colunaId}`;
    const campoServico = `servicoNegociadoAdicional_${colunaId}`;

    if (subitem[campoValorUnitario] === undefined || subitem[campoValorUnitario] === null || subitem[campoValorUnitario] === '') {
        subitem[campoValorUnitario] = '0';
    }
    if (subitem[campoServico] === undefined || subitem[campoServico] === null || subitem[campoServico] === '') {
        subitem[campoServico] = '0';
    }
    if (subitem[campoDiaria] === undefined || subitem[campoDiaria] === null || subitem[campoDiaria] === '') {
        subitem[campoDiaria] = '1';
    }
    if (subitem[campoQuantidade] === undefined || subitem[campoQuantidade] === null || subitem[campoQuantidade] === '') {
        subitem[campoQuantidade] = '1';
    }
}

function aplicarPrecificacaoPorFaixaNaColunaAdicional(subitem = {}, colunaId, tabelaVersao = null, divisorMoeda = 1) {
    const produto = subitem?.produto ?? {};
    if (FeeIntelligence.isAgencyFeeRuleItem(produto)) {
        return;
    }
    const etapaAdicional = `NegociadoAdicional_${colunaId}`;
    if (faixaJaAplicada(subitem, etapaAdicional, chaveFaixaAplicada(subitem, `quantidade${etapaAdicional}`, tabelaVersao, divisorMoeda))) {
        return;
    }
    // Coluna negociada adicional: só reaplica a faixa quando a coluna já tem preço.
    if (!faixaAplicaNaColunaAdicional(subitem, colunaId)) {
        return;
    }

    const faixas = filtrarFaixasPorVersao(normalizarFaixasPrecificacao(produto), tabelaVersao);
    if (faixas.length === 0) {
        return;
    }

    const campoQuantidade = `quantidadeNegociadoAdicional_${colunaId}`;
    const campoValorUnitario = `valorUnitarioNegociadoAdicional_${colunaId}`;
    const campoServico = `servicoNegociadoAdicional_${colunaId}`;

    const quantidadeAtual = virgulaPonto(subitem[campoQuantidade]) || 0;
    const faixaAplicavel = obterFaixaPorQuantidade(faixas, quantidadeAtual);
    if (!faixaAplicavel) {
        return;
    }

    const tipoPrecoFaixa = normalizarTipoPreco(faixaAplicavel.tipoPreco);
    const valorFaixa = virgulaPonto(faixaAplicavel.valor) || 0;

    if (tipoPrecoFaixa === 'percentual') {
        subitem[campoServico] = pontoVirgula(valorFaixa);
        if (!FeeIntelligence.isVoucherManualBaseItem(produto)) {
            subitem[campoValorUnitario] = '0';
        }
        return;
    }

    subitem[campoValorUnitario] = pontoVirgula(precoCatalogoNaMoeda(valorFaixa, divisorMoeda));
    subitem[campoServico] = '0';
}

// Função ExpanableComponent removida - agora usamos tabela HTML pura

export default function CadastroOrcamento({ match }) {
    const id = match.params.id;
    const empresa = localStorage.getItem("empresa");
    const usuario = localStorage.getItem("idUsuario");
    const token = localStorage.getItem('token');
    const setLabel = useSetBreadcrumbLabel();
    let [dados, setDados] = useState({
        modulo: 1,
        moeda: 'real',
        cambio: 1,
        orcamentoitem: [],
    });// 1 - orcamento
    const [expandedRows, setExpandedRows] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(!!id);
    // Rascunho não salvo (08/10): a primeira carga (buscar) terminou — só então o rascunho é conferido.
    const [carregouOrcamento, setCarregouOrcamento] = useState(false);
    const [showModalModelosOrcamento, setShowModalModelosOrcamento] = useState(false);
    const [tipoModalModelosOrcamento, setTipoModalModelosOrcamento] = useState('meus');
    const [listaModelosOrcamento, setListaModelosOrcamento] = useState([]);
    const [buscaModelosOrcamento, setBuscaModelosOrcamento] = useState('');
    const [carregandoModelosOrcamento, setCarregandoModelosOrcamento] = useState(false);
    const [modeloSelecionadoOrcamento, setModeloSelecionadoOrcamento] = useState(null);
    const [showPagamento, setShowPagamento] = useState(false);
    const orcamentoConteudoRef = React.useRef(null);
    const orcamentoGridRef = React.useRef(null);
    const orcamentoGridCabecalhoFixoRef = React.useRef(null);
    const orcamentoGridScrollControlRef = React.useRef(null);
    const orcamentoGridScrollProxyRef = React.useRef(null);
    const orcamentoGridScrollProxyConteudoRef = React.useRef(null);
    // Função de sincronização grade → barra/cabeçalho registrada pelo efeito de rolagem (caso 20).
    const orcamentoGridSincronizarRef = React.useRef(null);

    const deslocarScrollOrcamento = (direcao) => {
        const grade = orcamentoGridRef.current;
        const scrollProxy = orcamentoGridScrollProxyRef.current;
        if (!grade) {
            return;
        }

        // Caso 20: passo de ~40% da faixa rolável (fora das colunas fixas), encaixado no início
        // de uma coluna — ver destinoScrollHorizontal.
        const areaGrade = grade.getBoundingClientRect();
        const cabecalhos = Array.from(grade.querySelectorAll('thead th'));
        const fixo = (th) => window.getComputedStyle(th).position === 'sticky';
        // Borda direita das fixas na posição ROLADA (left do sticky + largura): parada, a borda da
        // tabela desloca a coluna 1px e o encaixe ficava 1px antes da coluna.
        const limiteFixo = cabecalhos.filter(fixo).reduce((maior, th) => Math.max(maior, (parseFloat(window.getComputedStyle(th).left) || 0) + th.getBoundingClientRect().width), 0);
        const bordasColunas = cabecalhos.filter((th) => !fixo(th)).map((th) => th.getBoundingClientRect().left - areaGrade.left + grade.scrollLeft);

        // A grade é a fonte da verdade; barra e cabeçalho espelho seguem pela sincronização única.
        grade.scrollLeft = destinoScrollHorizontal({
            atual: grade.scrollLeft,
            direcao,
            larguraVisivel: grade.clientWidth,
            limiteFixo,
            limite: grade.scrollWidth - grade.clientWidth,
            bordasColunas,
        });
        if (typeof orcamentoGridSincronizarRef.current === 'function') {
            orcamentoGridSincronizarRef.current();
        } else if (scrollProxy) {
            scrollProxy.scrollLeft = grade.scrollLeft;
        }
    };

    const lidarComTeclaNoScrollOrcamento = (evento) => {
        // O foco é aplicado no conteúdo do orçamento quando o operador clica em
        // qualquer área livre (grade, Total Access ou resumos). Campos de edição
        // seguem donos das próprias setas.
        if (alvoEhControleInterativo(evento.target)) {
            return;
        }

        if (evento.key === 'ArrowLeft') {
            evento.preventDefault();
            deslocarScrollOrcamento(-1);
        }

        if (evento.key === 'ArrowRight') {
            evento.preventDefault();
            deslocarScrollOrcamento(1);
        }
    };

    const focarConteudoParaScrollHorizontal = (evento) => {
        if (!alvoEhControleInterativo(evento.target)) {
            orcamentoConteudoRef.current?.focus({ preventScroll: true });
        }
    };
    const [showPreEvento, setShowPreEvento] = useState(false);
    const [showNegociado, setShowNegociado] = useState(false);
    const [showFechamento, setShowFechamento] = useState(false);
    const [colunasNegociadoAdicionais, setColunasNegociadoAdicionais] = useState([]);
    const [colunasNegociadoVisibility, setColunasNegociadoVisibility] = useState({});
    const [showModalProdutos, setShowModalProdutos] = useState(false);
    const [showModalInformacoes, setShowModalInformacoes] = useState(false);
    const [showModalCambio, setShowModalCambio] = useState(false);
    // Internacional da linha (Rafael 19/10): a célula mostra o resumo por etapa; a edição fica num modal com tabela.
    const [modalInternacional, setModalInternacional] = useState(null);
    // Busca do fornecedor da linha (Rafael 20/10): um modal só para a grade; guarda { indexSuperior, indexInferior }.
    const [modalFornecedorLinha, setModalFornecedorLinha] = useState(null);
    // 09/10: linhas do orçamento antigo cujo Fechamento ainda está gravado com outro câmbio (aviso até salvar)
    // Moeda/câmbio de antes de abrir o modal: Cancelar/fechar sem salvar devolve estes valores.
    const cambioAntesDoModalRef = React.useRef(null);
    // 11/10: havia alteração não salva antes de abrir o modal do câmbio? (decide se o "Salvar Câmbio" limpa o rascunho)
    const sujoAntesModalCambioRef = React.useRef(false);
    const cancelarModalCambio = () => {
        const capturado = cambioAntesDoModalRef.current;
        cambioAntesDoModalRef.current = null;
        setInfoCambioSugerido(null);
        setDados((dadosAnteriores) => restaurarCambioOrcamento(dadosAnteriores, capturado));
        setShowModalCambio(false);
    };
    const [modalFechamentoExterior, setModalFechamentoExterior] = useState(null);
    const [showModalFeeVersao, setShowModalFeeVersao] = useState(false); // Épico 12
    const [feeVersaoSel, setFeeVersaoSel] = useState(''); // seleção temporária no modal de fee
    const [tabelaValores, setTabelaValores] = useState([]); // valores por versão (fee + serviços) p/ exibição
    const [showModalTabelaVersao, setShowModalTabelaVersao] = useState(false); // Épico 13 (Abbvie): seletor de período
    const [tabelaVersaoSel, setTabelaVersaoSel] = useState(''); // seleção temporária no modal de período
    const [faixasVersao, setFaixasVersao] = useState([]); // faixas versionadas do cliente (2025/2026) p/ exibição
    const [carregandoCambioSugerido, setCarregandoCambioSugerido] = useState(false);
    const [infoCambioSugerido, setInfoCambioSugerido] = useState(null);
    const [showModalForaEscopo, setShowModalForaEscopo] = useState(false);
    const [itemForaEscopo, setItemForaEscopo] = useState({ indexSuperior: null, indexInferior: null });
    const [dadosForaEscopo, setDadosForaEscopo] = useState({ motivo: '', descricao: '' });
    const [showModalSolicitarNF, setShowModalSolicitarNF] = useState(false);
    const [itemSolicitarNF, setItemSolicitarNF] = useState({ indexSuperior: null, indexInferior: null });
    const [emailsDestinatarios, setEmailsDestinatarios] = useState([]);
    const [novoEmail, setNovoEmail] = useState('');
    const [loadingNF, setLoadingNF] = useState(false);
    const [solicitarAntecipacao, setSolicitarAntecipacao] = useState(false);
    const [valorAntecipacao, setValorAntecipacao] = useState('');
    const [historicoAntecipacoes, setHistoricoAntecipacoes] = useState([]);
    // Épico 1 financeiro — Modal de Estornos por subitem (22/05/2026)
    const [showModalEstornos, setShowModalEstornos] = useState(false);
    const [subitemEstornoAtual, setSubitemEstornoAtual] = useState(null); // { id, indexSuperior, indexInferior, descricao }
    const [estornosCarregados, setEstornosCarregados] = useState([]);
    const [carregandoEstornos, setCarregandoEstornos] = useState(false);
    const [novoEstorno, setNovoEstorno] = useState({ valor: '', data_estorno: '', justificativa: '', tipo: 'duplicidade' });
    // Épico 1 financeiro — Modal de Vínculo Aéreo (22/05/2026)
    const [showModalAereo, setShowModalAereo] = useState(false);
    const [subitemAereoAtual, setSubitemAereoAtual] = useState(null); // { indexSuperior, indexInferior, descricao, currentAereoId }
    const [aereosDoEvento, setAereosDoEvento] = useState([]);
    const [carregandoAereos, setCarregandoAereos] = useState(false);
    // Épico 1 Fase 4 — POs aprovadas do evento (para banner de aviso)
    const [posAprovadasDoEvento, setPosAprovadasDoEvento] = useState(null); // null = ainda não checado; [] = checado, sem POs
    // Épico 2 — Modal de Adiantamento por item (vinculação a recibos do orçamento)
    const [showModalAdiantamento, setShowModalAdiantamento] = useState(false);
    const [subitemAdiantamentoAtual, setSubitemAdiantamentoAtual] = useState(null); // { id, descricao, valorTotal }
    const [distribuicoesItem, setDistribuicoesItem] = useState([]);
    const [recibosDisponiveis, setRecibosDisponiveis] = useState([]);
    const [carregandoAdiantamento, setCarregandoAdiantamento] = useState(false);
    const [novaDistribuicao, setNovaDistribuicao] = useState({ orcamento_recibo_adiantamento_id: '', valor: '', observacao: '' });
    // Épico 2.1 — NFs vinculadas ao item (conciliação adiantamento × NF)
    const [nfsDoItem, setNfsDoItem] = useState([]);
    const [carregandoNfsItem, setCarregandoNfsItem] = useState(false);
    // Épico 2 — Modal Forma de Pagamento do adiantamento
    const [showModalFormaPgto, setShowModalFormaPgto] = useState(false);
    const [subitemFormaPgtoAtual, setSubitemFormaPgtoAtual] = useState(null);
    const [formaPgtoAtual, setFormaPgtoAtual] = useState({ forma: '', dados_pagamento: {}, observacao: '' });
    const [salvandoFormaPgto, setSalvandoFormaPgto] = useState(false);
    const [carregandoFormaPgto, setCarregandoFormaPgto] = useState(false);
    // cache: itemId → { forma, dados_pagamento, observacao }
    const [formaPgtosPorItem, setFormaPgtosPorItem] = useState({});
    // Modal Forma de Pagamento do Item (pagamento regular — independente do adiantamento)
    const [showModalFormaPgtoPagamento, setShowModalFormaPgtoPagamento] = useState(false);
    const [subitemFormaPgtoPagamentoAtual, setSubitemFormaPgtoPagamentoAtual] = useState(null);
    const [formaPgtoPagamentoAtual, setFormaPgtoPagamentoAtual] = useState({ forma: '', dados_pagamento: {}, observacao: '' });
    const [salvandoFormaPgtoPagamento, setSalvandoFormaPgtoPagamento] = useState(false);
    // cache local: itemId → { forma, dados_pagamento, observacao } — TODO: persistir via endpoint /orcamentoItem/{id}/pagamento
    const [formaPgtoPagamentoPorItem, setFormaPgtoPagamentoPorItem] = useState({});
    const [loadingHistorico, setLoadingHistorico] = useState(false);
    const [historicoNotasFiscais, setHistoricoNotasFiscais] = useState([]);
    const [loadingNotasFiscais, setLoadingNotasFiscais] = useState(false);
    const [showModalVisualizarNF, setShowModalVisualizarNF] = useState(false);
    const [showNFSection, setShowNFSection] = useState(false);
    const [nfParaVisualizar, setNfParaVisualizar] = useState(null);
    const [modalNFKey, setModalNFKey] = useState(0); // Para forçar re-render do modal
    // Épico 7 ajuste — modal de re-aprovação ao salvar orçamento com OPFs aprovados
    const [showModalReaprovacao, setShowModalReaprovacao] = useState(false);
    const [activeTabNF, setActiveTabNF] = useState('solicitar');
    const [opfsAprovados, setOpfsAprovados] = useState([]); // [{pagamento_id, fornecedor_nome}] — aprovado mas NÃO liberado
    const [opfsLiberados, setOpfsLiberados] = useState([]); // [{...}] — já liberado em Contas Pendentes (intocável)
    // D-0096: linhas e parcelas (com grupo) da Previsão — o aviso segue a regra do servidor para troca de grupo inteiro.
    const previsaoDosCards = React.useRef(null);
    // Recorte do que o modal mostra: só os fornecedores efetivamente alterados
    const [opfsAprovadosFiltrados, setOpfsAprovadosFiltrados] = useState([]);
    const [opfsLiberadosFiltrados, setOpfsLiberadosFiltrados] = useState([]);
    // Trava de pagamento (07/10): fornecedores com conta travada pelo Financeiro
    const [opfsTravados, setOpfsTravados] = useState([]);
    const [travadosViraramCliente, setTravadosViraramCliente] = useState([]);
    // 07/10: fornecedores "em processo de pagamento" (conta travada ou paga) e o aviso do save
    const [opfsEmPagamento, setOpfsEmPagamento] = useState([]);
    const [avisoPagamento, setAvisoPagamento] = useState([]);
    const cientePagamento = React.useRef(false);
    // Fornecedores que passaram a ser pagos pelo cliente E já estão em Contas
    // Pendentes — modal de confirmação (era toast, "ninguém lê")
    const [clientesEmPendentes, setClientesEmPendentes] = useState([]);
    const salvarIgnorarOPFCheck = React.useRef(false);
    const salvarComReaprovacao  = React.useRef(false);
    // Aviso de itens em branco/zerados ao Salvar (Rafael 02/10): só avisa; "Salvar mesmo assim" segue o fluxo.
    const salvarIgnorarItensEmBranco = React.useRef(false);
    const [itensEmBrancoAviso, setItensEmBrancoAviso] = useState(null);
    // Snapshot dos campos que importam para re-aprovação, tirado no load.
    // Sem ele o alerta disparava pela EXISTÊNCIA de OPF aprovado, listando
    // fornecedores que o operador nem tocou (relatado pelo Rafael 2026-08-02).
    const snapshotItens = React.useRef(null);
    // D-0121: foto dos valores e grupos gravados — linha alterada sem Sub Item e 3028 - FEE novo travam o Salvar.
    const fotoGravadoSubItem = React.useRef(null);
    // D-0134: quantas vezes cada grupo está gravado; a repetição que já existe não trava.
    const gruposGravados = React.useRef({});
    const [empresaAtiva, setEmpresaAtiva] = useState(null);
    const [itensPermanentesIds, setItensPermanentesIds] = useState([]);
    const [itensPermanentesInternacionaisIds, setItensPermanentesInternacionaisIds] = useState([]);
    const [feeRulesCliente, setFeeRulesCliente] = useState([]);
    // Carga das regras de FEE do cliente: 'pendente' | 'ok' | 'falha'. O ref é lido pelo cálculo
    // (síncrono); o estado, pela grade (FEE digitável quando o cliente não tem regra — 27/09).
    const [statusRegrasFee, setStatusRegrasFee] = useState('pendente');
    const statusRegrasFeeRef = React.useRef('pendente');
    const marcarStatusRegrasFee = (status) => { statusRegrasFeeRef.current = status; setStatusRegrasFee(status); };
    const feeAgenciaManual = FeeAgenciaManualPolicy.decidir({ status: statusRegrasFee, feeRules: feeRulesCliente, faixasVersao }).editavel;
    // Falha ao buscar regras/faixas de FEE (ex.: HTTP 429): o cálculo seguiria com FEE 0 em silêncio.
    // Enquanto houver falha, a tela avisa e o Salvar fica bloqueado até recarregar.
    const [falhaRegrasFee, setFalhaRegrasFee] = useState({ regras: false, faixas: false });
    const regrasFeeIndisponiveis = falhaRegrasFee.regras || falhaRegrasFee.faixas;
    const [fornecedorAccessInterno, setFornecedorAccessInterno] = useState(null);
    const [statusFornecedorAccessInterno, setStatusFornecedorAccessInterno] = useState('idle');
    const [produtoImpostoAccess, setProdutoImpostoAccess] = useState(null);
    const [statusProdutoImpostoAccess, setStatusProdutoImpostoAccess] = useState('idle');
    const alertaFornecedorAccessAusenteExibido = React.useRef(false);
    const [eventoNacionalidade, setEventoNacionalidade] = useState(null);
    // Pax do evento para as faixas do fee por categoria (Abbvie): o extract()
    // do load troca dados.evento pelo ID, então o campo vive em estado próprio.
    // 01/10: é o "Número de convidados esperados" do evento (quantidadeConvidadosEsperados),
    // não mais o quantidadeConvidados do RSVP. null = evento sem o número (Salvar trava).
    const [eventoConvidadosEsperados, setEventoConvidadosEsperados] = useState(null);
    // Tipo do evento (Mini Meeting da AbbVie, 28/09): mesmo motivo do pax, vive em estado próprio.
    const [eventoTipo, setEventoTipo] = useState(null);
    // Realização do evento (digital/presencial/hibrido) para a tag da Taxonomia Sanofi (23/10).
    const [eventoTipoRealizacao, setEventoTipoRealizacao] = useState(null);
    // Regra de FEE do Mini Meeting do cliente ({ limite, fixo, percentual } ou null): GET /produto/feeMiniMeetingCliente.
    const [regraMiniMeeting, setRegraMiniMeeting] = useState(null);
    // Rótulo do FEE do Mini Meeting por etapa (a mesma conta do cálculo, só para exibir).
    const resumoFeeMiniMeeting = (() => {
        const regra = FeeIntelligence.miniMeetingParaEvento(regraMiniMeeting, eventoTipo);
        if (!regra || !Array.isArray(dados?.orcamentoitem)) return null;
        const resultado = FeeIntelligence.calculateMiniMeetingFee(dados.orcamentoitem, regra);
        return [['pre_evento', 'Pré'], ['negociado', 'Neg.'], ['fechamento', 'Fech.']].map(([momento, etapa]) => ({
            etapa,
            texto: String(FeeIntelligence.rotuloMiniMeeting(resultado, momento) || '').replace(/^Mini Meeting: /, ''),
            base: Math.round(resultado.mini_meeting.momentos[momento].base * 100) / 100,
            valor: Math.round(resultado[momento] * 100) / 100,
        }));
    })();
    const nacionalidadeEventoAtual = eventoNacionalidade ?? dados?.evento?.nacionalidade ?? null;
    const eventoEhInternacional = (nacionalidadeEventoAtual || '').toString().toLowerCase() === 'internacional';
    // Treinamento turma 5 (20/10): no nacional o local da linha vem como Brasil e some o bloco de moeda/câmbio.
    const eventoEhNacional = eventoNacional(nacionalidadeEventoAtual);
    const [saving, setSaving] = useState(false);
    // D-0052 parte 4b: Salvar recusado (409) porque outra pessoa salvou depois que a tela abriu. Trava o
    // Salvar até recarregar: { mensagem, nome, salvoEm } | null.
    const [conflitoSalvar, setConflitoSalvar] = useState(null);
    // Salvar nunca trava (16/10): a ref barra clique duplo/Enter no form na mesma hora (o state só
    // muda no próximo render) e o aviso de demora diz que o envio continua em vez de parecer travado.
    const salvandoRef = React.useRef(false);
    const avisoDemoraRef = React.useRef(null);
    // Parte 2 (16/10): chave do envio. Reenvio do MESMO conteúdo (depois do tempo limite) leva a mesma
    // chave e o servidor não grava de novo; conteúdo editado ganha chave nova. Zera ao salvar.
    const chaveSalvarRef = React.useRef(null);
    const comChaveSalvar = (conteudo) => {
        // Parte 3 (19/10): a chave leva a marca da tela (sessão + último envio de rascunho) — o servidor
        // ignora um rascunho desta tela que saiu antes deste Salvar e chegou depois.
        chaveSalvarRef.current = chaveSalvarPara(conteudo, chaveSalvarRef.current, rascunhoOrcamento.marcaSalvar());
        return { ...conteudo, chaveSalvar: chaveSalvarRef.current.chave };
    };
    const iniciarSalvando = () => {
        salvandoRef.current = true;
        // Parte 3 (19/10): durante o Salvar nenhum rascunho vai ao servidor.
        rascunhoOrcamento.antesDeSalvar();
        setSaving(true);
        clearTimeout(avisoDemoraRef.current);
        avisoDemoraRef.current = setTimeout(() => {
            toast.info('Ainda salvando… o servidor está demorando. Não feche a tela.', { toastId: 'orcamento-salvando-demora', autoClose: false });
        }, 30000);
    };
    const terminarSalvando = () => {
        salvandoRef.current = false;
        rascunhoOrcamento.fimDoSalvar();
        setSaving(false);
        clearTimeout(avisoDemoraRef.current);
        toast.dismiss('orcamento-salvando-demora');
    };
    // Erro de JavaScript entre o clique e o envio deixava "Aguarde..." para sempre, sem nada enviado.
    const falhaAntesDeEnviar = (erro) => {
        console.error('Salvar orçamento: erro antes de enviar', erro);
        terminarSalvando();
        salvarIgnorarOPFCheck.current = false;
        salvarIgnorarItensEmBranco.current = false;
        toast.error('Não foi possível salvar agora. Suas alterações continuam na tela e no rascunho — tente de novo; se repetir, avise o suporte.');
    };
    const errosInternacionais = validarDadosInternacionais(dados, fornecedorAccessInterno);
    // 21/10: itens únicos (Palestrante, Sala Evento, Brinde...) exigem observação na linha nova/clonada/trocada.
    const errosObservacao = listarPendenciasObservacao(dados);
    // 21/10: ART obrigatória com Gerador, RRT com equipamento (regra no catálogo, no grupo).
    const errosItensObrigatorios = listarPendenciasItensObrigatorios(dados);
    // D-0121: linha com valor e sem Sub Item fica fora do FEE; 3028 - FEE não entra com o 130 - FEE.
    // Linha/grupo novo ou alterado trava o Salvar; antigo parado só avisa.
    const pendenciasSubItem = listarPendenciasSubItem(dados, fotoGravadoSubItem.current);
    const errosSubItem = pendenciasSubItem.bloqueiam;
    const avisosSubItem = pendenciasSubItem.avisos;
    // D-0134: cada grupo só 1 vez. Repetição nova trava o Salvar; a já gravada só avisa.
    const gruposRepetidos = listarGruposRepetidos(dados.orcamentoitem, gruposGravados.current);
    const errosGrupoRepetido = gruposRepetidos.bloqueiam;
    const avisosGrupoRepetido = gruposRepetidos.avisos;
    // Item 2 (01/10): o orçamento sempre sabe o "Número de convidados esperados" do evento.
    // Evento sem o número → aviso acima do Salvar + Salvar travado (a API devolve 422 com a
    // mesma mensagem). Orçamento sem evento: a regra não se aplica.
    const eventoIdOrcamento = dados?.evento?.id ?? dados?.evento ?? null;
    const faltaConvidadosEsperados = orcamentoBloqueadoPorConvidadosEsperados({ eventoId: eventoIdOrcamento, convidadosEsperados: eventoConvidadosEsperados });
    // Taxonomia Sanofi (23/10): tag só visual (nada é gravado), recalculada a cada mudança do
    // orçamento com o evento (convidados esperados, realização) e os itens escolhidos.
    const taxonomiaSanofi = eventoIdOrcamento && isClienteSanofi(dados?.cliente)
        ? calcularTaxonomiaSanofi({ convidadosEsperados: eventoConvidadosEsperados, tipoRealizacao: eventoTipoRealizacao, grupos: dados?.orcamentoitem })
        : null;
    const [showTaxonomiaSanofi, setShowTaxonomiaSanofi] = useState(false);
    // Item 13: o alerta NÃO expande coluna sozinho (a validação roda a cada tecla — abrir a coluna
    // no meio da digitação deslocaria a grade). O caminho é o botão "Mostrar campo": expande a
    // coluna/grupo do alvo e, após o render, rola até o campo, foca e destaca por ~2s.
    const colunasEtapaVisiveis = { pre: showPreEvento, neg: showNegociado, fechamento: showFechamento };
    const [pedidoCampoInternacional, setPedidoCampoInternacional] = useState(null);
    const mostrarCampoInternacional = (alvo) => {
        if (!idCampoAlvoInternacional(alvo)) return;
        const etapa = etapaColunaDoAlvo(alvo);
        if (etapa === 'pre') setShowPreEvento(true);
        if (etapa === 'neg') setShowNegociado(true);
        if (etapa === 'fechamento') setShowFechamento(true);
        setExpandedRows((atual) => (atual === true || (Array.isArray(atual) && atual.includes(alvo.grupoIndex))
            ? atual : [...(Array.isArray(atual) ? atual : []), alvo.grupoIndex]));
        setPedidoCampoInternacional({ alvo, em: Date.now() });
    };
    useEffect(() => {
        if (!pedidoCampoInternacional) return undefined;
        const { alvo } = pedidoCampoInternacional;
        let temporizador = null;
        let elemento = null;
        const quadro = window.requestAnimationFrame(() => {
            elemento = document.getElementById(idCampoAlvoInternacional(alvo))
                || document.querySelector(`[data-linha-orcamento="${alvo.grupoIndex}-${alvo.linhaIndex}"]`);
            if (!elemento) return;
            // Horizontal: calculado à parte (inline 'center' escondia a Descrição de Custos em 1280px) —
            // campo fora das colunas fixas e, se couber, com a Descrição da mesma linha à vista.
            // Vertical: centraliza na ÁREA ÚTIL (abaixo da barra do sistema/cabeçalho espelho e acima da
            // pilha fixa do rodapé: avisos + barra horizontal + botões), não na janela inteira.
            elemento.scrollIntoView({ block: 'center', inline: 'nearest' });
            const grade = orcamentoGridRef.current;
            const linhaGrade = elemento.closest('tr[data-linha-orcamento]');
            if (grade && linhaGrade && elemento !== linhaGrade) {
                const areaGrade = grade.getBoundingClientRect();
                const noConteudo = (x) => x - areaGrade.left + grade.scrollLeft;
                const celulas = Array.from(linhaGrade.children);
                const fixa = (celula) => window.getComputedStyle(celula).position === 'sticky';
                const limiteFixo = celulas.filter(fixa).reduce((maior, celula) => Math.max(maior, celula.getBoundingClientRect().right - areaGrade.left), 0);
                const descricao = celulas[1];
                const campo = elemento.getBoundingClientRect();
                grade.scrollLeft = scrollLeftParaCampo({
                    campoEsq: noConteudo(campo.left), campoDir: noConteudo(campo.right),
                    descricaoEsq: descricao && !fixa(descricao) ? noConteudo(descricao.getBoundingClientRect().left) : null,
                    limiteFixo, larguraVisivel: grade.clientWidth, scrollMax: grade.scrollWidth - grade.clientWidth,
                });
            }
            if (grade) {
                // Topo fixo: barra do sistema (o que está fixo no ponto superior da grade) e o cabeçalho
                // espelho (top 0, altura do thead), que aparece assim que a grade passa do topo.
                const alturaThead = grade.querySelector('thead')?.getBoundingClientRect().height || 0;
                let fixoTopo = document.elementFromPoint(grade.getBoundingClientRect().left + 4, 2);
                while (fixoTopo && fixoTopo !== document.body && !['fixed', 'sticky'].includes(window.getComputedStyle(fixoTopo).position)) fixoTopo = fixoTopo.parentElement;
                const visivelTopo = (el) => (el && window.getComputedStyle(el).display !== 'none' ? el.getBoundingClientRect().top : null);
                const { topoUtil, baseUtil } = areaUtilVertical({
                    alturaJanela: window.innerHeight,
                    basesFixasTopo: [alturaThead, fixoTopo && fixoTopo !== document.body ? fixoTopo.getBoundingClientRect().bottom : null],
                    toposFixosRodape: [visivelTopo(refAvisosRodape.current), visivelTopo(orcamentoGridScrollControlRef.current), visivelTopo(document.querySelector('.fixoRodape'))],
                });
                const campo = elemento.getBoundingClientRect();
                const deslocamento = deslocamentoVerticalParaCampo({ campoTopo: campo.top, campoBase: campo.bottom, topoUtil, baseUtil });
                if (deslocamento !== 0) window.scrollBy(0, deslocamento);
                // Caso 20: barra e cabeçalho espelho acompanham no mesmo quadro (sem esperar o evento).
                if (typeof orcamentoGridSincronizarRef.current === 'function') orcamentoGridSincronizarRef.current();
            }
            if (typeof elemento.focus === 'function') elemento.focus({ preventScroll: true });
            elemento.classList.add('fin-pp__campo-destaque');
            temporizador = window.setTimeout(() => elemento.classList.remove('fin-pp__campo-destaque'), 2400);
        });
        return () => {
            window.cancelAnimationFrame(quadro);
            if (temporizador) window.clearTimeout(temporizador);
            if (elemento) elemento.classList.remove('fin-pp__campo-destaque');
        };
    }, [pedidoCampoInternacional]);
    // Altura real do bloco de avisos acima do rodapé: a barra de rolagem horizontal fica logo acima dele.
    const refAvisosRodape = React.useRef(null);
    const [alturaAvisosRodape, setAlturaAvisosRodape] = useState(0);
    // Parte 3 (19/10): o aviso do rascunho entra na mesma pilha (o hook do rascunho vem mais abaixo).
    const [avisoRascunhoNoRodape, setAvisoRascunhoNoRodape] = useState(false);
    useEffect(() => {
        const el = refAvisosRodape.current;
        if (!el) { setAlturaAvisosRodape(0); return undefined; }
        const medir = () => setAlturaAvisosRodape(el.offsetHeight || 0);
        medir();
        if (typeof ResizeObserver === 'undefined') return undefined;
        const observador = new ResizeObserver(medir);
        observador.observe(el);
        return () => observador.disconnect();
    }, [regrasFeeIndisponiveis, errosInternacionais.length, errosObservacao.length, errosItensObrigatorios.length, errosSubItem.length, avisosSubItem.length, errosGrupoRepetido.length, avisosGrupoRepetido.length, faltaConvidadosEsperados, avisoRascunhoNoRodape, colunasNegociadoAdicionais, conflitoSalvar]);
    // Item 2 (01/10): o link do aviso abre o evento em outra aba (para não perder o orçamento
    // não salvo). Enquanto faltar o número, ao voltar para esta aba relê o evento.
    useEffect(() => {
        if (!faltaConvidadosEsperados || !eventoIdOrcamento) return undefined;
        const recarregarConvidadosEsperados = () => {
            api({ method: 'get', action: '/evento/' + eventoIdOrcamento, token: token })
                .then((response) => {
                    const valor = convidadosEsperadosDoEvento(response?.data?.data);
                    if (valor !== null) setEventoConvidadosEsperados(valor);
                })
                .catch(() => {});
        };
        window.addEventListener('focus', recarregarConvidadosEsperados);
        return () => window.removeEventListener('focus', recarregarConvidadosEsperados);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [faltaConvidadosEsperados, eventoIdOrcamento]);
    const [gerandoNdEvento, setGerandoNdEvento] = useState(false);
    const history = useHistory();
    const params = new URLSearchParams(window.location.search);
    let { state } = useLocation();
    const copiar = (state?.copiar ?? false);
    const itemDestacado = params.get('itemId'); // ID do item para destacar
    const [valorTotalPreEvento, setValorTotalPreEvento] = useState(0);
    const [valorTotalNegociado, setValorTotalNegociado] = useState(0);
    const [valorTotalFechamento, setValorTotalFechamento] = useState(0);
    const [colunaAcoesTravada, setColunaAcoesTravada] = useState(true);
    const [colunaDescricaoTravada, setColunaDescricaoTravada] = useState(false);
    const larguraColunaAcoes = 240;
    const larguraColunaDescricao = 300;
    const colunaAcoesTravadaEfetiva = colunaAcoesTravada || colunaDescricaoTravada;
    // Épico 12: o cliente do orçamento mora em evento.cliente (o payload do /orcamento/{id}
    // NÃO traz um `cliente` no topo). Resolver só por dados.cliente deixava as regras de fee
    // sem carregar -> o filtro por versão ficava vazio -> caía no fee legado (taxa 2025).
    const clienteIdFeeRules = obterIdComparavel(
        dados?.evento?.cliente?.id ?? dados?.evento?.cliente ?? dados?.cliente?.id ?? dados?.cliente
    );
    const clienteAtualEhChiesi = isClienteChiesi(dados?.evento?.cliente ?? dados?.cliente ?? null);
    const clienteAtualEhLongPing = LongPingPolicy.ehClienteLongPing(dados?.evento?.cliente ?? dados?.cliente ?? null);
    const podeCalcularImpostoNfAccess = clienteAtualEhChiesi || eventoEhInternacional;
    const remessaEstimativaAtiva = (dados.orcamentoitem || []).some((grupo) => (grupo.subitem || []).some((linha) => linhaElegivelRemessaExterior(linha, fornecedorAccessInterno)));
    // Mesmo valorTotal da API (painel, e-mail, % do adiantamento): última coluna preenchida no agregado
    // de CADA fornecedor (A01, 28/09) + Imposto NF Access dos grupos sobre esses valores.
    const opcoesImpostoVigente = { aplicaImposto: podeCalcularImpostoNfAccess, clienteEhChiesi: clienteAtualEhChiesi };
    // Total Access inclui o Imposto NF Access automático dos grupos (mesma fórmula do valorTotal).
    // Valor exato em reais (contrato 02/10): todo R$ da tela = soma dos R$ das linhas (+ automáticas).
    // Orçamento estrangeiro (inclusive legado, item 3): a exibição usa uma cópia com o FEE em R$ = % × base
    // em R$ (prepararExibicaoBrl); `dados` (o que se grava) não é tocado.
    const orcamentoEmBrlExato = orcamentoBrlExato(dados);
    const orcamentoEmMoedaEstrangeira = orcamentoEstrangeiro(dados);
    const exibicaoBrl = prepararExibicaoBrl(dados, { fornecedorAccess: fornecedorAccessInterno, nacionalidade: dados?.evento?.nacionalidade ?? eventoNacionalidade });
    const totaisBrl = calcularTotaisBrlOrcamento(exibicaoBrl.orcamento, fornecedorAccessInterno, opcoesImpostoVigente);
    const totaisAccess = calcularTotaisAccess(exibicaoBrl.orcamento.orcamentoitem || [], {
        ...opcoesImpostoVigente, fornecedorAccess: fornecedorAccessInterno, cambio: cambioGlobalOrcamento(dados),
        exato: orcamentoEmBrlExato, estrangeiro: orcamentoEmMoedaEstrangeira, orcamento: dados,
    });
    const valorVigente = calcularValorVigenteOrcamento(exibicaoBrl.orcamento, fornecedorAccessInterno, opcoesImpostoVigente);
    // Item 12: no internacional a barra mostra o MESMO valor do painel (com remessa do exterior),
    // pela mesma regra (valorRemessaExteriorPainel) sobre os números ao vivo da tela.
    const valorPainelAoVivo = valorPainelBarraTotalAccess(exibicaoBrl.orcamento, { internacional: eventoEhInternacional, fornecedorAccess: fornecedorAccessInterno, ...opcoesImpostoVigente });
    // +5 colunas adicionadas em 22/05/2026 (Épico 1 financeiro): Requisitante, Cartão, Adiantamento item, Estornos, Aéreo
    // -1 em 2026-06-01: coluna "Tipo Pagamento" (Antecipado/Padrão) removida a pedido
    // -2 em 2026-06-01: colunas "Forma Pagamento" e "Vencimento" removidas a pedido
    // -6 em 2026-06-02: Tipo Faturamento, Valor Real, Prazo, Estornos, Aéreo, Forma Pgto/Adiantamento removidos
    // Nome Item Planilha permanece no payload/export, mas está oculto no cadastro
    // temporariamente a pedido do usuário.
    // (a antiga "% Imposto" daqui virou a coluna "% Imposto NF" da precificação, ao lado da "% Impostos")
    // A coluna extra aparece para Chiesi e para qualquer evento internacional.
    const quantidadeColunasPagamento = podeCalcularImpostoNfAccess ? 4 : 3;
    const larguraColunaMonetaria = '120px';
    const larguraColunaTotalMonetaria = '130px';
    const estiloBaseInputOrcamento = {
        textAlign: 'right',
        fontSize: '12px',
        border: '1px solid #dee2e6'
    };
    const estiloInputMonetario = {
        ...estiloBaseInputOrcamento,
        minHeight: '42px',
        paddingTop: '8px',
        paddingBottom: '8px'
    };
    const estiloInputMonetarioTotal = {
        ...estiloInputMonetario,
        fontWeight: 'bold'
    };

    const toggleColunaAcoesTravada = () => {
        if (colunaDescricaoTravada) {
            return;
        }
        setColunaAcoesTravada((valorAtual) => !valorAtual);
    };

    const toggleColunaDescricaoTravada = () => {
        setColunaDescricaoTravada((valorAtual) => {
            const novoValor = !valorAtual;
            if (novoValor) {
                setColunaAcoesTravada(true);
            }
            return novoValor;
        });
    };

    const getColunaAcoesStickyStyle = (zIndex = 9) => {
        if (!colunaAcoesTravadaEfetiva) {
            return {};
        }

        return {
            position: 'sticky',
            left: 0,
            zIndex,
            boxShadow: '2px 0 4px rgba(0,0,0,0.1)'
        };
    };

    const getColunaDescricaoStickyStyle = (zIndex = 8) => {
        if (!colunaDescricaoTravada) {
            return {};
        }

        return {
            position: 'sticky',
            left: larguraColunaAcoes,
            zIndex,
            boxShadow: '2px 0 4px rgba(0,0,0,0.08)'
        };
    };

    const obterMoedaOrcamento = () => {
        const moedaAtual = (dados?.moeda || 'real').toString().toLowerCase();
        if (['real', 'dolar', 'euro', 'iene', 'libra', 'dolarcad'].includes(moedaAtual)) {
            return moedaAtual;
        }
        return 'real';
    };

    const obterSimboloMoedaOrcamento = () => {
        const mapa = {
            real: 'R$',
            dolar: 'US$',
            euro: '€',
            iene: '¥',
            libra: '£',
            dolarcad: 'C$',
        };
        return mapa[obterMoedaOrcamento()] || 'R$';
    };

    const obterLabelMoedaOrcamento = () => {
        const mapa = {
            real: 'Real (BRL)',
            dolar: 'Dólar (USD)',
            euro: 'Euro (EUR)',
            iene: 'Iene (JPY)',
            libra: 'Libra (GBP)',
            dolarcad: 'Dólar Canadense (CAD)',
        };
        return mapa[obterMoedaOrcamento()] || 'Real (BRL)';
    };

    const formatarCambio = (valor, casas = 4) => {
        const numero = virgulaPonto(valor) || 0;
        return numero.toLocaleString('pt-BR', {
            minimumFractionDigits: casas,
            maximumFractionDigits: casas,
        });
    };

    const obterCambioAtual = () => {
        if (obterMoedaOrcamento() === 'real') {
            return 1;
        }
        const cambioNumero = virgulaPonto(dados?.cambio);
        if (!Number.isFinite(cambioNumero) || cambioNumero <= 0) {
            return 1;
        }
        return cambioNumero;
    };

    const converterParaReais = (valor) => {
        const valorNumero = virgulaPonto(valor) || 0;
        return valorNumero * obterCambioAtual();
    };

    // Moeda do FORNECEDOR por ETAPA da negociação (08/10, Inter): cada linha escolhe, para Pré-evento,
    // Negociado e Fechamento, a moeda e o câmbio (o mesmo fornecedor pode ter valor em moedas diferentes
    // conforme o estágio). Vale só para a linha (não propaga mais para o fornecedor). Pré-evento "Moeda do
    // orçamento" = legado (câmbio global); Negociado/Fechamento vazio = mesma moeda da etapa anterior.
    // Real = valores em R$, sem câmbio. Fechamento: Exterior usa o câmbio real de cada pagamento; sem
    // câmbio próprio do Fechamento, o do Negociado. A API valida a mesma regra (422) e a tela mostra a
    // mesma pendência acima do Salvar.
    const renderMoedaFornecedorLinha = (subitem, indexSuperior, indexInferior, { tabela = false } = {}) => {
        if (!linhaAceitaMoedaFornecedor(subitem, fornecedorAccessInterno)) return null;
        const proprio = temCambioProprio(subitem);
        const moedaOrcamento = obterMoedaOrcamento();
        const opcoesPolicy = { moedaOrcamento, fornecedorAccess: fornecedorAccessInterno };
        const exterior = localPagamentoLinha(subitem) === LOCAL_EXTERIOR;
        const moedas = moedasPorEtapaLinha(subitem, moedaOrcamento);
        const posicao = `${indexSuperior}-${indexInferior}`;
        // Câmbio inicial da moeda: o de outra etapa da linha na mesma moeda; senão o do orçamento na mesma
        // moeda; senão a cotação sugerida (mesmo endpoint do modal de câmbio). Sem cotação, parte do câmbio
        // global e avisa para conferir.
        const cambioSugerido = async (valor) => {
            if (valor === 'real') return 1;
            const etapaMesmaMoeda = proprio ? MOMENTOS_MOEDA.find((m) => moedas[m] === valor) : null;
            if (etapaMesmaMoeda) return cambioBrlLinha(subitem, etapaMesmaMoeda, obterCambioAtual());
            if (valor === moedaOrcamento) return obterCambioAtual();
            try {
                const resposta = await api({ method: 'get', action: '/orcamento/cambio/sugerido', token, params: { moeda: valor } });
                const cotacao = virgulaPonto(resposta?.data?.data?.cambio);
                if (cotacao > 0) return cotacao;
            } catch (error) { /* aviso abaixo */ }
            toast.warning('Não foi possível buscar a cotação desta moeda. Confira o câmbio do fornecedor.');
            return obterCambioAtual();
        };
        const valorSeletor = (momento) => {
            if (!proprio) return '';
            if (momento === 'PreEvento') return moedaOrcamento === 'real' && moedas.PreEvento === 'real' ? '' : moedas.PreEvento;
            const explicita = String(subitem[CAMPOS_MOEDA_ETAPA[momento]] || '').toLowerCase();
            return MOEDAS_FORNECEDOR.some(([valor]) => valor === explicita) ? explicita : '';
        };
        const alterarMoeda = async (momento, valor) => {
            if (valor === valorSeletor(momento)) return;
            if (momento === 'PreEvento' && !valor) {
                // "Moeda do orçamento": sem moeda própria nas outras etapas, a linha volta ao legado (câmbio
                // global); com Negociado/Fechamento em outra moeda, só o Pré-evento passa à moeda do orçamento.
                const outrasEtapas = proprio && (valorSeletor('Negociado') || valorSeletor('Fechamento'));
                calculaTotalOrcamento2(outrasEtapas
                    ? aplicarMoedaEtapa(dados, indexSuperior, indexInferior, 'PreEvento', moedaOrcamento, { sugerido: await cambioSugerido(moedaOrcamento) }, opcoesPolicy)
                    : removerMoedaFornecedor(dados, indexSuperior, indexInferior, opcoesPolicy));
                return;
            }
            // Vazio no Negociado/Fechamento = mesma moeda da etapa anterior (herda).
            const anterior = momento === 'Fechamento' ? moedas.Negociado : moedas.PreEvento;
            const sugerido = await cambioSugerido(valor || anterior);
            calculaTotalOrcamento2(aplicarMoedaEtapa(dados, indexSuperior, indexInferior, momento, valor || null, { sugerido }, opcoesPolicy));
        };
        const alterarCambio = (momento, valor) => {
            calculaTotalOrcamento2(aplicarCambioEtapa(dados, indexSuperior, indexInferior, momento,
                valor === '' || valor === undefined ? null : virgulaPonto(valor), opcoesPolicy));
        };
        const rotuloVazio = {
            PreEvento: `Moeda do orçamento (${obterSimboloMoedaOrcamento()}${moedaOrcamento !== 'real' ? ` · câmbio ${formatarCambio(obterCambioAtual())}` : ''})`,
            Negociado: `Mesma do pré-evento (${simboloMoeda(moedas.PreEvento)})`,
            Fechamento: `Mesma do negociado (${simboloMoeda(moedas.Negociado)})`,
        };
        const opcoes = (momento) => (momento === 'PreEvento' ? opcoesMoedaFornecedor(moedaOrcamento) : MOEDAS_FORNECEDOR);
        const estiloCampo = { padding: '2px 4px', fontSize: 11, height: 26, minHeight: 26 };
        const linhaEtapa = (momento) => {
            const campoCambio = CAMPOS_CAMBIO_ETAPA[momento];
            const moedaEtapa = moedas[momento];
            // Rafael 19/10: com pagamento registrado no exterior, o Fechamento usa o câmbio da transação (travado).
            const cambioTransacao = momento === 'Fechamento' ? cambioDaTransacao(subitem) : null;
            const fechamentoTransacao = cambioTransacao !== null;
            const fechamentoHerdado = momento === 'Fechamento' && !valorSeletor('Fechamento') && !fechamentoTransacao;
            const idSeletor = momento === 'PreEvento' ? `moeda-fornecedor-${posicao}` : `moeda-fornecedor-${momento === 'Negociado' ? 'negociado' : 'fechamento'}-${posicao}`;
            const seletor = (
                    <select id={idSeletor} className="form-control form-control-sm" style={{ ...estiloCampo, flex: 1, minWidth: 0 }}
                        value={valorSeletor(momento)} onChange={(e) => alterarMoeda(momento, e.target.value)}
                        title={`Moeda do ${ROTULOS_ETAPA_MOEDA[momento].toLowerCase()} desta linha`}>
                        <option value="">{rotuloVazio[momento]}</option>
                        {opcoes(momento).map(([valor, label]) => <option key={valor} value={valor}>{label}</option>)}
                    </select>
            );
            const inputCambio = proprio && moedaEtapa !== 'real' ? (
                        <CampoValor id={`${campoCambio}-fornecedor-${posicao}`} className="form-control form-control-sm"
                            style={{ ...estiloCampo, width: 92, flex: '0 0 92px', textAlign: 'right' }}
                            title={fechamentoTransacao
                                ? 'Câmbio do fechamento = câmbio da transação registrada (botão azul do pagamento no exterior).'
                                : `Câmbio ${ROTULOS_ETAPA_MOEDA[momento].toLowerCase()}: R$ por 1 ${simboloMoeda(moedaEtapa)}${fechamentoHerdado ? ' (vazio = câmbio do negociado)' : ''}`}
                            disabled={fechamentoTransacao} data-cambio-fechamento-transacao={fechamentoTransacao ? '1' : undefined}
                            value={fechamentoTransacao ? cambioTransacao : (subitem[campoCambio] ?? '')} milhar={false} decimalScale={6} fixedDecimalScale={false} allowNegative={false}
                            placeholder={fechamentoHerdado ? '= negociado' : 'Câmbio'} onValueChange={({ value }) => alterarCambio(momento, value)} />
            ) : null;
            if (tabela) return { seletor, campoCambio: inputCambio };
            return (
                <div key={momento} className="d-flex align-items-center" style={{ gap: 6, marginTop: 4 }} data-moeda-fornecedor-etapa={momento}>
                    <label className="small text-muted mb-0" htmlFor={idSeletor} style={{ minWidth: 68, fontWeight: 400 }}>{ROTULOS_ETAPA_MOEDA[momento]}</label>
                    {seletor}
                    {inputCambio}
                </div>
            );
        };
        if (tabela) {
            const porEtapa = {};
            MOMENTOS_MOEDA.forEach((momento) => { porEtapa[momento] = linhaEtapa(momento); });
            return { porEtapa, proprio, alcance: proprio ? textoAlcanceMoedaFornecedor(subitem) : null };
        }
        return <div className="mt-2" data-moeda-fornecedor style={{ fontSize: 11 }}>
            <span className="small text-muted d-block">Moeda do fornecedor por etapa</span>
            {MOMENTOS_MOEDA.map(linhaEtapa)}
            {proprio && <small className="d-block text-muted" style={{ marginTop: 3 }} data-moeda-fornecedor-alcance>
                {textoAlcanceMoedaFornecedor(subitem)}{' '}
                {moedas.Fechamento === 'real'
                    ? 'Fechamento em R$, sem câmbio.'
                    : cambioDaTransacao(subitem) !== null
                        ? 'Fechamento usa o câmbio da transação registrada.'
                        : (exterior ? 'Fechamento usa o câmbio da transação quando o pagamento for registrado; vazio = câmbio negociado.' : 'Câmbio do fechamento vazio = câmbio negociado.')}
            </small>}
        </div>;
    };

    // Ajuste manual do Imposto NF Access por etapa (reunião Inter 19/10): só no evento internacional. Liberado pela
    // API (imposto_nf_ajuste_liberado) na semana de acerto dos projetos antigos; travado, o ajuste já gravado
    // continua valendo e aparece só como texto.
    const textoAjusteNf = (ajuste) => `${String(ajuste.percentual).replace('.', ',')}% ${ajuste.modo === 'direto' ? 'conta direta' : 'conta invertida'}`;
    const renderAjusteNf = (subitem, etapa, indexSuperior, indexInferior, { compacto = false } = {}) => {
        if (!eventoEhInternacional) return null;
        const ajuste = ajusteNfEtapa(subitem, etapa);
        const nfAjuste = subitem.remessa_estimativa?.nf_ajuste?.[etapa];
        const marcado = !!nfAjuste;
        const liberado = dados?.imposto_nf_ajuste_liberado === true;
        if (!liberado) {
            return ajuste ? <span className="d-block" style={{ marginTop: 3, fontSize: 10, color: '#a85b07' }} data-nf-ajuste-etapa={etapa}
                title={ajuste.ajustado_em ? `Ajustado em ${ajuste.ajustado_em}` : undefined}>Imposto NF Access ajustado manualmente: {textoAjusteNf(ajuste)}</span> : null;
        }
        const id = `nf-ajuste-${etapa}-${indexSuperior}-${indexInferior}`;
        const alterar = (novo) => calculaTotalOrcamento2(alterarAjusteNfLinha(dados, indexSuperior, indexInferior, etapa, novo));
        return (
            <div style={{ marginTop: 4 }} data-nf-ajuste-etapa={etapa}>
                <label htmlFor={id} style={{ margin: 0, fontWeight: 400, display: 'flex', alignItems: 'center', gap: 4, color: marcado ? '#a85b07' : undefined }}>
                    <input type="checkbox" id={id} checked={marcado}
                        onChange={(e) => alterar(e.target.checked ? { percentual: 19.05, modo: 'dentro' } : null)} />
                    {compacto ? 'Ajustar' : 'Ajustar Imposto NF Access (projeto antigo)'}
                </label>
                {marcado && (
                    <div style={{ display: 'grid', gridTemplateColumns: compacto ? '62px 1fr' : '1fr 1.4fr', gap: 3 }}>
                        <label htmlFor={`${id}-percentual`} style={{ margin: 0, fontWeight: 400, whiteSpace: 'nowrap' }}>
                            {compacto ? 'Alíq. %' : 'Alíquota %'}
                            <CampoPercentual id={`${id}-percentual`} className="form-control form-control-sm" sufixo=""
                                style={{ padding: '2px 4px', fontSize: 11, height: 26, minHeight: 26, textAlign: 'right' }}
                                value={nfAjuste.percentual ?? ''} decimalScale={6} fixedDecimalScale={false} allowNegative={false}
                                placeholder="Informe"
                                onValueChange={({ value }) => alterar({ percentual: value === '' ? null : value, modo: nfAjuste.modo })} />
                        </label>
                        <label htmlFor={`${id}-modo`} style={{ margin: 0, fontWeight: 400 }}>
                            Conta
                            <select id={`${id}-modo`} className="form-control form-control-sm" style={{ padding: '2px 4px', fontSize: 11, height: 26, minHeight: 26 }}
                                value={nfAjuste.modo === 'direto' ? 'direto' : 'dentro'}
                                onChange={(e) => alterar({ percentual: nfAjuste.percentual, modo: e.target.value })}>
                                <option value="dentro">{compacto ? 'Invertida' : 'Invertida (÷ (1 − %))'}</option>
                                <option value="direto">{compacto ? 'Direta' : 'Direta (× %)'}</option>
                            </select>
                        </label>
                    </div>
                )}
            </div>
        );
    };

    // Resumo da linha internacional na célula (Rafael 19/10): uma linha por etapa (moeda · câmbio · NF Access) e o
    // botão Editar, que abre o modal com a tabela por etapa. Os campos são os mesmos de antes (mesmas regras).
    const ETAPAS_INTERNACIONAL = [
        { momento: 'PreEvento', etapa: 'pre', label: 'Pré-evento', curto: 'Pré' },
        { momento: 'Negociado', etapa: 'neg', label: 'Negociado', curto: 'Neg.' },
        { momento: 'Fechamento', etapa: 'fech', label: 'Fechamento', curto: 'Fech.' },
    ];
    const textoNfEtapa = (subitem, etapa) => {
        const ajuste = ajusteNfEtapa(subitem, etapa);
        if (!ajuste) return { texto: 'NF 19,05% inv.', ajustado: false };
        return { texto: `NF ${String(ajuste.percentual).replace('.', ',')}% ${ajuste.modo === 'direto' ? 'direta' : 'inv.'}`, ajustado: true };
    };
    // D-0112 (Rafael 27/10): planilha antiga fechada com o Imposto NF Access 19,05% na conta direta (base × 19,05%).
    // Marcada, o imposto que este item gera sai na conta direta em todas as etapas; desmarcada (padrão), por fora.
    const renderImpostoNfContaDireta = (item, subitem, indexSuperior, indexInferior) => {
        if (!aceitaImpostoNfContaDireta(subitem)) return null;
        const direta = ehImpostoNfContaDireta(subitem);
        // Mesma trava da API: item com adiantamento não troca a conta (muda o valor que vai ao financeiro).
        const travada = (virgulaPonto(subitem.valor_adiantamento_item) || 0) > 0;
        return (
            <div className="mt-2">
                <FinCheck
                    id={`imposto-nf-direta-${indexSuperior}-${indexInferior}`}
                    label="Imposto NF Access em conta direta (projeto antigo)"
                    checked={direta}
                    disabled={travada}
                    title={travada
                        ? 'Este item já tem adiantamento: a conta do imposto não pode mudar. Fale com o Financeiro.'
                        : 'Marcada: o Imposto NF Access deste item é base × 19,05% (como nas planilhas antigas). Desmarcada: por fora, base × 19,05% ÷ 80,95%.'}
                    onChange={(e) => {
                        item.subitem[indexInferior][CAMPO_IMPOSTO_NF_CONTA_DIRETA] = e.target.checked;
                        calculaTotalOrcamento();
                    }}
                />
                {direta && <span className="fin-pp__pill is-warn mt-1">NF em conta direta</span>}
            </div>
        );
    };

    const renderResumoInternacional = (subitem, indexSuperior, indexInferior) => {
        const temMoeda = linhaAceitaMoedaFornecedor(subitem, fornecedorAccessInterno);
        const exterior = linhaElegivelRemessaExterior(subitem, fornecedorAccessInterno);
        if (!temMoeda && !exterior) return null;
        const proprio = temCambioProprio(subitem);
        const moedas = moedasPorEtapaLinha(subitem, obterMoedaOrcamento());
        if (eventoEhNacional && !mostrarMoedaCambioNoNacional({ exterior, cambioProprio: proprio, moedasEtapa: ETAPAS_INTERNACIONAL.map(({ momento }) => moedas[momento]) })) return null;
        const fechamento = exterior ? calcularFechamentoExterior(subitem, fornecedorAccessInterno) : null;
        return (
            <div className="fin-pp" data-resumo-internacional style={{ marginTop: 6, border: '1px solid #e2e8f0', borderRadius: 6, padding: '6px 8px', fontSize: 11, background: '#fff' }}>
                <div className="d-flex align-items-center justify-content-between" style={{ marginBottom: 3 }}>
                    <span style={{ fontWeight: 500, color: '#1f3556' }}>{exterior ? 'Internacional' : 'Moeda e câmbio'}</span>
                    <button type="button" className="fin-pp__btn fin-pp__btn--sm" style={{ height: 24, padding: '0 8px', fontSize: 11 }}
                        id={`editar-internacional-${indexSuperior}-${indexInferior}`}
                        onClick={() => setModalInternacional({ grupoIndex: indexSuperior, linhaIndex: indexInferior })}>
                        <FaPen size={10} style={{ marginRight: 4 }} /> Editar
                    </button>
                </div>
                {!exterior && ETAPAS_INTERNACIONAL.every(({ momento }) => (proprio ? moedas[momento] : obterMoedaOrcamento()) === 'real')
                    ? <div style={{ borderTop: '1px solid #f1f5f9', padding: '2px 0', color: '#64748b' }}>R$ nas 3 etapas</div>
                    : ETAPAS_INTERNACIONAL.map(({ momento, etapa, curto }) => {
                    const moedaEtapa = proprio ? moedas[momento] : obterMoedaOrcamento();
                    const transacao = momento === 'Fechamento' ? cambioDaTransacao(subitem) : null;
                    const cambio = moedaEtapa === 'real' ? null : (transacao ?? cambioBrlLinha(subitem, momento, obterCambioAtual()));
                    const nf = exterior ? textoNfEtapa(subitem, etapa) : null;
                    return (
                        <div key={momento} className="d-flex justify-content-between" style={{ gap: 6, borderTop: '1px solid #f1f5f9', padding: '2px 0' }} data-resumo-etapa={etapa}>
                            <span style={{ color: '#64748b' }}>{curto}</span>
                            <span style={{ textAlign: 'right' }}>
                                {moedaEtapa === 'real' ? 'R$' : `${simboloMoeda(moedaEtapa)} ${formatarCambio(cambio)}`}
                                {transacao !== null && <> <FaLock size={8} title="Câmbio da transação registrada" /> transação</>}
                                {!proprio && moedaEtapa !== 'real' && ' (orçamento)'}
                                {nf && <> · <span style={nf.ajustado ? { background: '#fdf3e2', color: '#a85b07', padding: '0 3px', borderRadius: 3 } : undefined}>{nf.texto}</span></>}
                            </span>
                        </div>
                    );
                })}
                {fechamento?.ativo && (
                    <div style={{ borderTop: '1px solid #f1f5f9', paddingTop: 2, color: fechamento.completo ? '#15803d' : '#b45309' }}>
                        Pago no exterior · {fechamento.completo ? 'conciliado' : 'parcial'} · R$ {moeda(fechamento.principal_brl)}
                    </div>
                )}
            </div>
        );
    };

    const renderModalInternacional = () => {
        if (!modalInternacional) return null;
        const { grupoIndex, linhaIndex } = modalInternacional;
        const subitem = dados?.orcamentoitem?.[grupoIndex]?.subitem?.[linhaIndex];
        if (!subitem) return null;
        const fechar = () => setModalInternacional(null);
        const moedaTabela = renderMoedaFornecedorLinha(subitem, grupoIndex, linhaIndex, { tabela: true });
        const remessaTabela = renderConfiguracaoRemessaLinha(subitem, grupoIndex, linhaIndex, { tabela: true });
        const fechamento = remessaTabela ? calcularFechamentoExterior(subitem, fornecedorAccessInterno) : null;
        const nomeLinha = subitem?.produto?.nome || subitem?.descricao || `Linha ${grupoIndex + 1}.${linhaIndex + 1}`;
        const th = { fontWeight: 500, fontSize: 12, color: '#586478', padding: '6px', textAlign: 'left', whiteSpace: 'normal' };
        const td = { padding: '6px', verticalAlign: 'top' };
        return (
            <div className="modal fade show d-block fin-pp fin-pp__modalbg" onClick={(e) => { if (e.target === e.currentTarget) fechar(); }} data-modal-internacional>
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div className="modal-content fin-pp__modal fin-pp__modal--scroll">
                        <div className="fin-pp__modal-head">
                            <span className="fin-pp__modal-head-ic"><FaGlobeAmericas size={17} /></span>
                            <h3 className="fin-pp__modal-title">Internacional
                                <span className="fin-pp__modal-sub">{nomeLinha}</span>
                            </h3>
                            <button type="button" className="fin-pp__modal-close" onClick={fechar}><FaTimes size={16} /></button>
                        </div>
                        <div className="modal-body" style={{ fontSize: 12 }}>
                            <div className="fin-pp__tblwrap">
                                <table className="fin-pp__tbl" style={{ tableLayout: 'auto' }}>
                                    <thead><tr>
                                        <th style={th}>Etapa</th>
                                        {moedaTabela && <th style={th}>Moeda</th>}
                                        {moedaTabela && <th style={th}>Câmbio</th>}
                                        {remessaTabela && <th style={th}>IR e IOF %</th>}
                                        {remessaTabela && <th style={th}>Qtd. envios</th>}
                                        {remessaTabela && <th style={th}>Valor do envio</th>}
                                        {remessaTabela && <th style={th}>NF Access</th>}
                                    </tr></thead>
                                    <tbody>
                                        {ETAPAS_INTERNACIONAL.map(({ momento, etapa, label }) => {
                                            const moedaEtapa = moedaTabela?.porEtapa?.[momento];
                                            const fech = etapa === 'fech';
                                            const campos = remessaTabela && !fech ? remessaTabela.camposEtapa(etapa, { comRotulo: false }) : null;
                                            return (
                                                <tr key={momento} data-moeda-fornecedor-etapa={momento} data-remessa-config-etapa={etapa}>
                                                    <td style={{ ...td, fontWeight: 500 }}>{label}</td>
                                                    {moedaTabela && <td style={{ ...td, minWidth: 130 }}>{moedaEtapa?.seletor}</td>}
                                                    {moedaTabela && <td style={{ ...td, width: 95 }}>{moedaEtapa?.campoCambio || <span className="text-muted">—</span>}</td>}
                                                    {remessaTabela && !fech && campos.map((campo, i) => <td key={i} style={{ ...td, width: 85 }}>{campo}</td>)}
                                                    {remessaTabela && fech && (
                                                        <td colSpan={3} style={td}>
                                                            <span className="d-block text-muted" style={{ marginBottom: 4 }}>IR, IOF e envio vêm do pagamento registrado.</span>
                                                            <button type="button" className="fin-pp__btn fin-pp__btn--sm" id={`fechamento-exterior-${grupoIndex}-${linhaIndex}`}
                                                                onClick={() => { fechar(); setModalFechamentoExterior({ grupoIndex, linhaIndex, deInternacional: true }); }}>
                                                                <FaGlobeAmericas size={11} style={{ marginRight: 4 }} /> {fechamento?.ativo ? 'Ver pagamento no exterior' : 'Registrar pagamento no exterior'}
                                                            </button>
                                                            {fechamento?.ativo && <span className="d-block" style={{ marginTop: 4, color: fechamento.completo ? '#15803d' : '#b45309' }}>
                                                                {fechamento.completo ? 'Conciliado' : 'Parcial'} · principal R$ {moeda(fechamento.principal_brl)} · custos Access R$ {moeda(fechamento.adicional_brl)}
                                                            </span>}
                                                        </td>
                                                    )}
                                                    {remessaTabela && (
                                                        <td style={{ ...td, minWidth: 150 }}>
                                                            {subitem.nfAccessPrincipalExteriorChiesi
                                                                ? <span>19,05% sobre tudo (Coordenação)</span>
                                                                : <span className="d-block" style={ajusteNfEtapa(subitem, etapa) ? { color: '#a85b07' } : undefined}>{ajusteNfEtapa(subitem, etapa) ? `${String(ajusteNfEtapa(subitem, etapa).percentual).replace('.', ',')}% · ${ajusteNfEtapa(subitem, etapa).modo === 'direto' ? 'direta' : 'invertida'}` : '19,05% · invertida'}</span>}
                                                            {renderAjusteNf(subitem, etapa, grupoIndex, linhaIndex, { compacto: true })}
                                                        </td>
                                                    )}
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                            {moedaTabela?.alcance && <small className="d-block text-muted" style={{ marginTop: 8 }}>{moedaTabela.alcance} Câmbio do Fechamento vazio = câmbio negociado; com pagamento registrado, vale o câmbio da transação.</small>}
                            {remessaTabela && <small className="d-block text-muted">Imposto NF Access: só sobre IR e IOF + envios da linha paga no exterior.</small>}
                        </div>
                        <div className="fin-pp__modal-foot">
                            <button type="button" className="fin-pp__btn fin-pp__btn--primary" onClick={fechar}>Concluir</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const renderConfiguracaoRemessaLinha = (subitem, indexSuperior, indexInferior, { tabela = false } = {}) => {
        if (!linhaElegivelRemessaExterior(subitem, fornecedorAccessInterno)) return null;
        const campos = [
            // Rótulos pedidos pelo time Inter (reunião 02/10): "IR e IOF", "Quantidade", "Valor do envio".
            { campo: 'percentual_remessa', label: 'IR e IOF %', casas: 6 },
            { campo: 'quantidade_envios', label: 'Quantidade', casas: 0 },
            { campo: 'taxa_envio_brl', label: 'Valor do envio', casas: 2 },
        ];
        const camposEtapa = (etapa, { comRotulo = true } = {}) => {
            const config = configuracaoRemessaEtapa(subitem, etapa);
            return campos.map(({ campo, label: campoLabel, casas }) => {
                            const inputId = `remessa-${etapa}-${campo}-${indexSuperior}-${indexInferior}`;
                            const Campo = campo === 'percentual_remessa' ? CampoPercentual : CampoValor; // rótulo já diz "%": sem sufixo (célula de 26px)
                            return <label key={campo} htmlFor={inputId} style={{ margin: 0, fontWeight: 400 }} aria-label={comRotulo ? undefined : campoLabel}>
                                {comRotulo && campoLabel}
                                <Campo id={inputId} className="form-control form-control-sm"
                                    style={{ padding: '2px 4px', fontSize: 11, height: 26, minHeight: 26, textAlign: 'right' }}
                                    value={config[campo] ?? ''} decimalScale={casas} fixedDecimalScale={false} allowNegative={false} {...(campo === 'percentual_remessa' ? { sufixo: '' } : {})}
                                    placeholder={campo === 'quantidade_envios' ? 'Informe' : undefined}
                                    title={campo === 'quantidade_envios' ? 'Quantidade manual por linha. Informe 0 para nenhum envio.' : undefined}
                                    onValueChange={({ value }) => calculaTotalOrcamento2(alterarConfiguracaoRemessaLinha(dados, indexSuperior, indexInferior, etapa, campo, value))} />
                            </label>;
            });
        };
        if (tabela) return { camposEtapa };
        const renderEtapa = (etapa, label) => {
            return (
                <div key={etapa} style={{ marginTop: 5 }} data-remessa-config-etapa={etapa}>
                    <span>{label} · estimativa em R$</span>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr .8fr 1fr', gap: 3 }}>
                        {camposEtapa(etapa)}
                    </div>
                    <span style={{ display: 'block', marginTop: 3, fontSize: 10 }}>{subitem.nfAccessPrincipalExteriorChiesi
                        ? 'NF Access: 19,05% sobre tudo — principal da Coordenação + IR e IOF + envios.'
                        : (ajusteNfEtapa(subitem, etapa)
                            ? `NF Access: ${textoAjusteNf(ajusteNfEtapa(subitem, etapa))}, só sobre IR e IOF + envios.`
                            : 'NF Access: 19,05% por fora, só sobre IR e IOF + envios.')}</span>
                    {renderAjusteNf(subitem, etapa, indexSuperior, indexInferior)}
                </div>
            );
        };
        return (
            <div style={{ marginTop: 6, fontSize: 10, color: '#64748b' }}>
                {showPreEvento && renderEtapa('pre', 'Pré-evento')}
                {showNegociado && renderEtapa('neg', 'Negociado')}
                {!showPreEvento && !showNegociado && !showFechamento && (
                    <span style={{ display: 'block', marginTop: 4, fontStyle: 'italic' }}>
                        Estimativa internacional configurada. Expanda Pré-evento ou Negociado no menu da coluna para editar.
                    </span>
                )}
                {showFechamento && (
                    <>
                        <button type="button" id={`fechamento-exterior-${indexSuperior}-${indexInferior}`} className="btn btn-link btn-sm p-0 mt-2" style={{ fontSize: 11 }} onClick={() => setModalFechamentoExterior({ grupoIndex: indexSuperior, linhaIndex: indexInferior })}>Registrar fechamento exterior</button>
                        {renderAjusteNf(subitem, 'fech', indexSuperior, indexInferior)}
                        {calcularFechamentoExterior(subitem, fornecedorAccessInterno).ativo && <span className="d-block" style={{ color: calcularFechamentoExterior(subitem, fornecedorAccessInterno).completo ? '#15803d' : '#b45309' }}>{calcularFechamentoExterior(subitem, fornecedorAccessInterno).completo ? 'Conciliado' : 'PARCIAL'} · principal R$ {moeda(calcularFechamentoExterior(subitem, fornecedorAccessInterno).principal_brl)} · custos Access R$ {moeda(calcularFechamentoExterior(subitem, fornecedorAccessInterno).adicional_brl)}</span>}
                    </>
                )}
            </div>
        );
    };

    const renderLinhasRemessaExterior = (subitem) => {
        const estimativa = calcularRemessaExteriorEstimativa(subitem, dados, fornecedorAccessInterno, { exato: true });
        if (!estimativa.elegivel) return null;
        const estilo = { border: '1px solid #e2e8f0', background: '#f8fafc', color: '#64748b', padding: '5px 8px', fontSize: 11 };
        const linhas = [
            ['imposto_remessa_brl', 'IR e IOF'],
            ['taxa_envio_brl', 'Taxa de envio'],
            ['imposto_nf_brl', ['pre', 'neg', 'fech'].some((etapa) => ajusteNfEtapa(subitem, etapa)) ? 'Imposto NF Access' : 'Imposto NF Access (19,05%)'],
            // Reunião Inter 02/10: total do item em R$ + as 3 linhas acima (IR e IOF, envio, NF) por etapa.
            ['total_brl', 'Total com impostos'],
        ];
        // Linha do NF com ajuste manual na etapa: mostra a alíquota/conta usada embaixo do valor.
        const notaAjusteNf = (etapa, campo) => (campo === 'imposto_nf_brl' && ajusteNfEtapa(subitem, etapa)
            ? <small className="d-block" style={{ fontSize: 10, color: '#a85b07' }}>{textoAjusteNf(ajusteNfEtapa(subitem, etapa))} · ajuste manual</small> : null);
        const valor = (etapa, campo) => <span title={eventoEhInternacional ? "Estimativa em reais, já convertida. Compõe a base do FEE (evento internacional) e não altera o preço original." : "Estimativa em reais, já convertida. Não compõe FEE nem altera o preço original."}>R$ {moeda(estimativa[etapa][campo])}{notaAjusteNf(etapa, campo)}</span>;
        // Ledger concluído: encargos reais (IOF+IR, envio, NF sobre custos) na coluna Fechamento, ÷ câmbio.
        const real = linhaFechamentoExteriorConcluido(subitem) ? subitem.fechamento_exibicao : null;
        const somaReal = (mapa = {}) => Object.values(mapa).reduce((soma, v) => soma + (virgulaPonto(v) || 0), 0);
        // Total com impostos = principal pago + encargos reais (em R$, e ÷ câmbio do orçamento na moeda dele).
        const encargoReal = (mapa, campo, principal) => (campo === 'total_brl' ? principal + somaReal(mapa) : mapa[campo]);
        const realBrl = (campo) => encargoReal(real.encargos_brl, campo, virgulaPonto(real.principal_brl) || 0);
        const realMoeda = (campo) => encargoReal(real.encargos_moeda_orcamento, campo, (virgulaPonto(real.principal_brl) || 0) / (virgulaPonto(real.cambio_orcamento) || 1));
        const valorReal = (campo) => <span title={`Real: R$ ${moeda(realBrl(campo))} — fechamento exterior concluído.`}>{formatarValorMoedaOrcamento(realMoeda(campo))}{obterMoedaOrcamento() !== 'real' && <small className="d-block" style={{ fontSize: 10 }}>R$ {moeda(realBrl(campo))} real</small>}{notaAjusteNf('fech', campo)}</span>;
        // Cada etapa visível tem 8 colunas (Valor Unit. … Total, Observação): o valor ocupa as 7 primeiras
        // e termina sob a coluna Total; a Observação fica vazia. Etapa oculta = 1 coluna, como no cabeçalho.
        const celulasEtapa = (visivel, conteudo, extra = {}) => (visivel
            ? <><td colSpan={7} style={{ ...estilo, textAlign: 'right' }} {...extra}>{conteudo}</td><td style={estilo} /></>
            : <td style={estilo} />);
        return linhas.map(([campo, label]) => (
            <tr key={campo} data-remessa-estimativa={campo}>
                <td colSpan={3} style={campo === 'total_brl' ? { ...estilo, fontWeight: 600, color: '#334155' } : estilo}>↳ {label} <span style={{ opacity: .75 }}>· {real ? 'estimativa e realizado Access' : 'estimativa Access em BRL'}</span></td>
                {celulasEtapa(showPreEvento, valor('pre', campo))}
                {colunasNegociadoAdicionais.map((coluna) => <td key={coluna.id} colSpan={colunasNegociadoVisibility[coluna.id] ? 6 : 1} style={estilo} />)}
                {celulasEtapa(showNegociado, valor('neg', campo))}
                {celulasEtapa(showFechamento, real ? valorReal(campo) : null, real ? { 'data-fechamento-encargo': campo } : {})}
                <td colSpan={showPagamento ? quantidadeColunasPagamento : 1} style={estilo} />
                <td colSpan={2} style={estilo} />
            </tr>
        ));
    };

    // D-0156 (Rafael 04/11): totalizador do bloco "igual à planilha" — no orçamento internacional, o grupo com
    // item pago no exterior ganha, acima do Subtotal, as linhas do Excel Sanofi Inter: IOF/IRR, TAXA DE REMESSA,
    // IMPOSTO NF (só sobre IOF + envio) e, à parte, o Imposto NF Access do grupo. Em R$, Pré/Negociado/Fechamento.
    // Só exibição: soma as mesmas contas das linhas ↳ (encargosExteriorGrupoPorComponenteBrl) e o NF Access que
    // já entra no Subtotal (totaisBrl.grupos[i].nf). Fechamento só com o pagamento no exterior concluído.
    const renderTotalizadorBlocoExterior = (indexSuperior) => {
        if (!eventoEhInternacional && obterMoedaOrcamento() === 'real') return null;
        const grupoBrl = totaisBrl.grupos[indexSuperior];
        const componentes = grupoBrl?.encargosComponentes;
        if (!componentes?.elegivel) return null;
        const nfAccess = grupoBrl.nf || { preEvento: 0, negociado: 0, fechamento: 0 };
        const linhas = [
            ['imposto_remessa_brl', 'IOF/IRR', componentes.imposto_remessa_brl],
            ['taxa_envio_brl', 'Taxa de remessa', componentes.taxa_envio_brl],
            ['imposto_nf_brl', 'Imposto NF', componentes.imposto_nf_brl],
        ];
        if (['preEvento', 'negociado', 'fechamento'].some((etapa) => Math.abs(nfAccess[etapa] || 0) >= 0.005)) {
            linhas.push(['imposto_nf_access', 'Imposto NF Access', nfAccess]);
        }
        const estilo = { border: '1px solid #dee2e6', background: 'var(--fin-acw, #eef2fd)', color: 'var(--fin-tx, #0f172a)', padding: '5px 8px', fontSize: 12 };
        const dicas = {
            preEvento: 'Total do bloco no Pré-evento, em R$ (igual ao Excel).',
            negociado: 'Total do bloco no Negociado, em R$ (igual ao Excel).',
            fechamento: 'Total do bloco no Fechamento, em R$: só itens com o pagamento no exterior concluído (igual ao Excel).',
        };
        const celulasEtapa = (visivel, valores, etapa) => (visivel
            ? <><td colSpan={7} style={{ ...estilo, textAlign: 'right', fontWeight: 600 }} title={dicas[etapa]} data-totalizador-etapa={etapa}>R$ {moeda(valores[etapa] || 0)}</td><td style={estilo} /></>
            : <td style={estilo} />);
        return linhas.map(([campo, label, valores]) => (
            <tr key={`totalizador-${campo}`} data-totalizador-bloco={campo}>
                <td colSpan={3} style={{ ...estilo, fontWeight: 600 }}>{label} <span style={{ fontWeight: 400, color: 'var(--fin-mt, #586478)', fontSize: 11 }}>· total do bloco em R$</span></td>
                {celulasEtapa(showPreEvento, valores, 'preEvento')}
                {colunasNegociadoAdicionais.map((coluna) => <td key={coluna.id} colSpan={colunasNegociadoVisibility[coluna.id] ? 6 : 1} style={estilo} />)}
                {celulasEtapa(showNegociado, valores, 'negociado')}
                {celulasEtapa(showFechamento, valores, 'fechamento')}
                <td colSpan={showPagamento ? quantidadeColunasPagamento : 1} style={estilo} />
                <td colSpan={2} style={estilo} />
            </tr>
        ));
    };

    const renderResumoRemessaExterior = () => {
        const resumo = resumirRemessaExteriorEstimativa(dados, fornecedorAccessInterno);
        if (!resumo.quantidade_linhas) return null;
        return <div className="fin-pp__card" style={{ marginTop: 16, padding: '16px 18px', border: '1px solid #dbeafe', background: '#f8fbff' }} data-remessa-resumo>
            <div className="d-flex align-items-center justify-content-between flex-wrap" style={{ gap: 8 }}>
                <div style={{ fontSize: 14, fontWeight: 700, color: '#1e3a8a' }}>Estimativa de pagamento no exterior</div>
                <span className="badge" style={{ background: resumo.completo ? '#dcfce7' : '#fef3c7', color: resumo.completo ? '#166534' : '#92400e', fontWeight: 600 }}>
                    {resumo.completo ? 'Estimativa preenchida' : 'Pendente de configuração'}
                </span>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 10, marginTop: 12 }}>
                {[['pre', 'Pré-evento', totaisBrl.total.preEvento, '#eff6ff', '#1d4ed8'], ['neg', 'Negociado', totaisBrl.total.negociado, '#fff7ed', '#c2410c']].map(([etapa, nome, subtotalBrl, fundo, cor]) => {
                    // Pagamentos no exterior à parte; o total do orçamento (com linhas Brasil) fica como linha secundária.
                    // Subtotal em R$ = soma dos R$ das linhas (contrato 02/10), não o subtotal na moeda × câmbio.
                    const pagamentos = pagamentosExteriorEtapa(resumo, etapa, subtotalBrl);
                    return <div key={etapa} style={{ background: fundo, border: `1px solid ${cor}33`, borderRadius: 8, padding: '10px 12px' }} data-remessa-resumo-etapa={etapa}>
                        <div style={{ fontSize: 11, fontWeight: 700, color: cor, textTransform: 'uppercase', letterSpacing: '.02em' }}>{nome}</div>
                        <strong className="d-block" style={{ fontSize: 14, marginTop: 3 }}>Pagamentos no exterior: principal R$ {moeda(pagamentos.principal)} + encargos R$ {moeda(pagamentos.encargos)} = R$ {moeda(pagamentos.total)}</strong>
                        <span className="d-block text-muted" style={{ fontSize: 11, marginTop: 3 }}>Total do orçamento com encargos R$ {moeda(pagamentos.totalOrcamento)}</span>
                        {/* Cada linha no exterior na moeda do fornecedor × câmbio da etapa = R$ (27/09). */}
                        {(dados.orcamentoitem || []).flatMap((grupo) => grupo.subitem || []).map((linha, i) => {
                            // Opção (D-0113): não é pagamento no exterior; fica só na linha do grid.
                            if (ehSomenteVisualizacao(linha)) return null;
                            const calc = calcularRemessaExteriorEstimativa(linha, dados, fornecedorAccessInterno, { exato: true });
                            if (!calc.elegivel ||!calc[etapa] || !(virgulaPonto(linha[etapa === 'pre' ? 'totalPreEvento' : 'totalNegociado']) > 0)) return null;
                            return <span key={`${etapa}-${linha.id ?? i}`} className="d-block text-muted" style={{ fontSize: 11 }} data-remessa-linha-moeda={calc[etapa].moeda_original}>
                                {linha.fornecedor?.nome || 'Fornecedor'}: {simboloMoeda(calc[etapa].moeda_original)} {moeda(virgulaPonto(linha[etapa === 'pre' ? 'totalPreEvento' : 'totalNegociado']) || 0)} × {formatarCambio(calc[etapa].cambio_aplicado || 0)} = R$ {moeda(calc[etapa].principal_brl)} + encargos R$ {moeda(calc[etapa].adicional_brl)}
                            </span>;
                        })}
                    </div>;
                })}
            </div>
            <small className={resumo.completo ? 'text-muted' : 'text-warning'} style={{ display: 'block', marginTop: 10 }}>
                {resumo.completo ? (eventoEhInternacional ? 'Estimativas em reais; no evento internacional entram na base do FEE. Não são pagamentos realizados.' : 'Estimativas em reais, fora da base de FEE. Não são pagamentos realizados.') : 'Prévia incompleta: informe os envios de cada etapa; zero é uma escolha válida.'}
            </small>
        </div>;
    };

    const formatarValorMoedaOrcamento = (valor) => {
        const valorNumero = virgulaPonto(valor) || 0;
        return `${obterSimboloMoedaOrcamento()} ${moeda(valorNumero)}`;
    };

    // Subtotal do grupo / TOTAL na tela (item 4, pós-QA 02/10): soma dos R$ das linhas + NF Access + taxas
    // do exterior (imposto de remessa + envios + NF da estimativa). Na moeda: orçamento estrangeiro = R$ ÷
    // câmbio, arredondado uma vez; em Real = o próprio R$. Só exibição: o gravado (valorTotal* do grupo e
    // do orçamento) não inclui as taxas, como antes.
    const renderSubtotalComTaxas = (valoresEtapa) => {
        const brl = valoresEtapa || 0;
        const valorMoeda = obterMoedaOrcamento() === 'real' ? brl : moedaOrcamentoDeBrl(brl, obterCambioAtual());
        return renderValorComEquivalente(valorMoeda, 'right', brl);
    };

    // `valorBrl`: R$ exato (soma dos R$ das linhas); sem ele, valor × câmbio (legado).
    const renderValorComEquivalente = (valor, align = 'right', valorBrl = null) => {
        const moedaAtual = obterMoedaOrcamento();
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: align === 'right' ? 'flex-end' : 'flex-start',
                lineHeight: 1.2,
                textAlign: align
            }}>
                <span>{formatarValorMoedaOrcamento(valor)}</span>
                {moedaAtual !== 'real' && (
                    <small style={{ fontSize: '10px', color: '#6c757d' }}>
                        Equivalente em reais: R$ {moeda(valorBrl !== null && valorBrl !== undefined ? valorBrl : converterParaReais(valor))}
                    </small>
                )}
            </div>
        );
    };

    // Moeda do fornecedor (27/09): a linha com câmbio próprio mostra a moeda DELA e o R$ pelo câmbio
    // dela na etapa (+ o câmbio); a linha legada segue a moeda/câmbio do orçamento, como antes.
    // 08/10: moeda por etapa — cada coluna (Pré-evento, Negociado, Fechamento) na moeda DA ETAPA.
    const moedaLinhaGrade = (subitem, momento = 'PreEvento') => moedaDaLinhaFornecedor(subitem || {}, obterMoedaOrcamento(), momento);
    const formatarValorMoedaLinha = (subitem, valor, momento = 'PreEvento') => (subitem && temCambioProprio(subitem)
        ? `${simboloMoeda(moedaLinhaGrade(subitem, momento))} ${moeda(virgulaPonto(valor) || 0)}`
        : formatarValorMoedaOrcamento(valor));
    // Resumo das moedas próprias (listarMoedasFornecedores): linha com moedas diferentes entre as etapas
    // mostra cada etapa ("Pré US$ 5,0000 · Neg € 6,0000 · Fech R$").
    // D-0132: a linha de FEE aparece só em R$ (só exibição; o gravado segue na moeda do orçamento).
    const feeSoEmReal = (subitem) => linhaFeeSoEmReal(subitem || {}, orcamentoEmMoedaEstrangeira);
    const textoFeeBrl = (subitem, momento) => `R$ ${moeda(feeBrlExibido(subitem, momento, obterCambioAtual(), exibicaoBrl.porLinha.get(subitem)))}`;
    const baseFeeBrlExibida = (subitem, momento, valorUnitario) => {
        const base = exibicaoBrl.porLinha.get(subitem)?.base?.[{ PreEvento: 'pre_evento', Negociado: 'negociado', Fechamento: 'fechamento' }[momento]];
        return centavos(typeof base === 'number' ? base : converterParaReais(valorUnitario));
    };
    const fornecedorComMoedaEstrangeira = (f) => Object.values(f.moedas || { PreEvento: f.moeda }).some((m) => m !== 'real');
    const textoMoedasPorEtapa = (f) => MOMENTOS_MOEDA.map((m, i) => {
        const moedaEtapa = f.moedas[m];
        const cambio = [f.cambioPreEvento, f.cambioNegociado, f.cambioFechamento][i];
        return `${['Pré', 'Neg', 'Fech'][i]} ${simboloMoeda(moedaEtapa)}${moedaEtapa !== 'real' ? ` ${formatarCambio(cambio)}` : ''}`;
    }).join(' · ');

    const renderEquivalenteAbaixoCampo = (valor, subitem = null, momento = 'PreEvento', ehTotal = false, ehUnitario = false) => {
        const proprio = !!subitem && temCambioProprio(subitem);
        // Round 3 item B/A: o unitário da linha de FEE é a base; no orçamento estrangeiro o rótulo mostra a
        // base em R$ que gera o FEE exibido (Σ das bases em R$ das linhas, arredondadas por linha; no
        // Fechamento conciliado, a base do FEE real).
        const baseFeeBrl = ehUnitario && !proprio && subitem && orcamentoEmMoedaEstrangeira && linhaDeFeeBrl(subitem)
            ? exibicaoBrl.porLinha.get(subitem)?.base?.[{ PreEvento: 'pre_evento', Negociado: 'negociado', Fechamento: 'fechamento' }[momento]] : undefined;
        if (typeof baseFeeBrl === 'number') {
            return (
                <div style={{ marginTop: '2px', textAlign: 'right', fontSize: '10px', color: '#6c757d' }} data-base-fee-brl title="Base do FEE em reais: soma dos R$ das linhas que compõem o FEE">
                    R$ {moeda(baseFeeBrl)}
                </div>
            );
        }
        if (proprio) {
            if (moedaLinhaGrade(subitem, momento) === 'real') {
                // Linha em Real num orçamento em moeda estrangeira (02/10): mostra o equivalente na moeda do
                // orçamento (R$ ÷ câmbio do orçamento), que é o que entra nos totais.
                const cambioOrcamento = obterCambioAtual();
                if (obterMoedaOrcamento() === 'real' || !(cambioOrcamento > 0)) return null;
                return (
                    <div style={{ marginTop: '2px', textAlign: 'right', fontSize: '10px', color: '#6c757d' }} data-equivalente-moeda-orcamento title="Equivalente na moeda do orçamento (R$ ÷ câmbio do orçamento)">
                        {obterSimboloMoedaOrcamento()} {moeda((virgulaPonto(valor) || 0) / cambioOrcamento)} · câmbio {formatarCambio(cambioOrcamento)}
                    </div>
                );
            }
            const cambioLinha = cambioBrlLinha(subitem, momento, obterCambioAtual());
            return (
                <div style={{ marginTop: '2px', textAlign: 'right', fontSize: '10px', color: '#6c757d' }} data-equivalente-moeda-fornecedor title={`Câmbio do fornecedor (${momento === 'PreEvento' ? 'Pré-evento' : momento === 'Negociado' ? 'Negociado' : (localPagamentoLinha(subitem) === LOCAL_EXTERIOR ? 'Fechamento: câmbio do fechamento (vazio = negociado) até o pagamento real' : 'Fechamento: câmbio do fechamento (vazio = negociado)')})`}>
                    R$ {moeda((virgulaPonto(valor) || 0) * cambioLinha)} · câmbio {formatarCambio(cambioLinha)}
                </div>
            );
        }
        if (obterMoedaOrcamento() === 'real') {
            return null;
        }

        return (
            <div style={{ marginTop: '2px', textAlign: 'right', fontSize: '10px', color: '#6c757d' }}>
                R$ {moeda(converterParaReais(valor))}
            </div>
        );
    };

    const buscarCambioSugerido = async (moedaSelecionada) => {
        const moedaNormalizada = (moedaSelecionada || 'real').toLowerCase();
        if (moedaNormalizada === 'real') {
            setInfoCambioSugerido(null);
            setDados((dadosAnteriores) => ({
                ...dadosAnteriores,
                moeda: 'real',
                cambio: 1
            }));
            return;
        }

        setInfoCambioSugerido(null);
        setDados((dadosAnteriores) => ({
            ...dadosAnteriores,
            moeda: moedaNormalizada,
            cambio: ''
        }));

        setCarregandoCambioSugerido(true);
        try {
            const response = await api({
                method: 'get',
                action: '/orcamento/cambio/sugerido',
                token,
                params: {
                    moeda: moedaNormalizada
                }
            });

            const payload = response?.data?.data || {};
            const cambioSugerido = virgulaPonto(payload?.cambio);
            if (cambioSugerido && cambioSugerido > 0) {
                setDados((dadosAnteriores) => ({
                    ...dadosAnteriores,
                    cambio: cambioSugerido
                }));
                setInfoCambioSugerido({
                    fonte: payload?.fonte || null,
                    dataCotacao: payload?.dataCotacao || null,
                    dataHoraCotacao: payload?.dataHoraCotacao || null
                });
            } else {
                setInfoCambioSugerido(null);
                toast.warning('Não foi possível preencher o câmbio automaticamente.');
            }
        } catch (error) {
            setInfoCambioSugerido(null);
            toast.warning('Não foi possível buscar cotação automática. Informe manualmente.');
        } finally {
            setCarregandoCambioSugerido(false);
        }
    };

    const salvarCambio = async () => {
        const moedaSelecionada = obterMoedaOrcamento();
        const cambioInformado = virgulaPonto(dados?.cambio);
        const cambioNormalizado = moedaSelecionada === 'real' ? 1 : cambioInformado;

        if (moedaSelecionada !== 'real' && (!Number.isFinite(cambioNormalizado) || cambioNormalizado <= 0)) {
            toast.error('Informe um valor de câmbio válido.');
            return;
        }

        // Recalcula já com o câmbio novo: o preço por faixa (catálogo em R$) é
        // convertido pelo câmbio, e o Salvar grava o que a tela mostra.
        calculaTotalOrcamento2({
            ...dados,
            moeda: moedaSelecionada,
            cambio: cambioNormalizado,
        });

        if (id && !copiar) {
            try {
                await api({
                    method: 'put',
                    action: `/orcamento/${id}/cambio`,
                    token,
                    data: {
                        moeda: moedaSelecionada,
                        cambio: cambioNormalizado,
                    }
                });
                toast.success('Câmbio salvo no orçamento.');
                // O câmbio já está gravado: sem outra alteração pendente, a tela não fica "Não salvo" nem cria rascunho.
                if (!sujoAntesModalCambioRef.current) rascunhoOrcamento.aceitarEstadoAtualComoSalvo();
            } catch (error) {
                toast.error('Erro ao salvar câmbio neste orçamento.');
                return;
            }
        } else {
            toast.success('Câmbio aplicado. Salve o orçamento para persistir.');
        }

        cambioAntesDoModalRef.current = null;
        setShowModalCambio(false);
    };

    useEffect(() => {
        if (!showModalCambio) {
            return;
        }
        // Captura antes da cotação sugerida (buscarCambioSugerido) mexer em `dados`.
        cambioAntesDoModalRef.current = capturarCambioOrcamento(dados);
        sujoAntesModalCambioRef.current = !!rascunhoOrcamento.sujo;

        const moedaAtual = obterMoedaOrcamento();
        if (moedaAtual === 'real') {
            return;
        }

        const cambioAtual = virgulaPonto(dados?.cambio);
        if (!cambioAtual || cambioAtual <= 0 || cambioAtual === 1) {
            buscarCambioSugerido(moedaAtual);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showModalCambio]);

    useEffect(() => {
        if (!Array.isArray(dados.orcamentoitem) || dados.orcamentoitem.length <= 1) {
            return;
        }

        const itensOrdenados = ordenarGruposComAgenciaNoTopo(dados.orcamentoitem);
        const mudouOrdem = itensOrdenados.some((item, index) => item !== dados.orcamentoitem[index]);

        if (mudouOrdem) {
            setDados(prevDados => ({
                ...prevDados,
                orcamentoitem: itensOrdenados
            }));
        }
    }, [dados.orcamentoitem]);

    // Troca do fornecedor da linha — as mesmas regras do antigo onChange do select (Rafael 20/10: só
    // mudou o componente de escolha). `null` remove. Devolve false quando a troca foi recusada.
    const aplicarFornecedorNaLinha = (indexSuperior, indexInferior, fornecedorSelecionado) => {
        const item = dados.orcamentoitem?.[indexSuperior];
        const subitem = item?.subitem?.[indexInferior];
        if (!subitem) return false;
        if (!fornecedorSelecionado) {
            if (clienteAtualEhChiesi && isGrupoServicosAgencia(item) && statusFornecedorAccessInterno === 'missing') {
                item.subitem.forEach((subitemGrupo) => {
                    subitemGrupo.fornecedor = null;
                });
            } else {
                item.subitem[indexInferior].fornecedor = null;
            }
            calculaTotalOrcamento();
            return true;
        }
        if (fornecedorIncompativelComPagamentoExterior(fornecedorSelecionado, subitem.pagamento_exterior, fornecedorAccessInterno)) {
            toast.error('Uma linha marcada como pagamento no exterior não pode usar o fornecedor interno da Access. Selecione um fornecedor externo ou altere o local do pagamento.');
            return false;
        }
        if (clienteAtualEhChiesi && isGrupoServicosAgencia(item) && statusFornecedorAccessInterno === 'missing') {
            item.subitem.forEach((subitemGrupo) => {
                subitemGrupo.fornecedor = { ...fornecedorSelecionado };
            });
        } else {
            item.subitem[indexInferior].fornecedor = fornecedorSelecionado;
            // 21/10: a ART/RRT criada por esta linha (ainda sem fornecedor) segue o fornecedor dela.
            const chaveLinha = item.subitem[indexInferior].chaveunica;
            if (chaveLinha) {
                item.subitem.forEach((subitemGrupo) => {
                    if (subitemGrupo.linhaObrigatoriaDe === chaveLinha && !subitemGrupo.fornecedor?.id) {
                        subitemGrupo.fornecedor = { ...fornecedorSelecionado };
                        const pagador = (subitemGrupo.fornecedorpagamento?.id ?? '').toString().toLowerCase();
                        if (pagador !== 'agencia' && pagador !== 'cliente') subitemGrupo.fornecedorpagamento = { id: 'agencia', nome: 'Agência' };
                    }
                });
            }
        }
        const fornecedorpagamentoAtual = item.subitem[indexInferior].fornecedorpagamento;
        const idFornecedorPagamentoAtual = (fornecedorpagamentoAtual?.id ?? '').toString().toLowerCase();
        if (idFornecedorPagamentoAtual !== 'agencia' && idFornecedorPagamentoAtual !== 'cliente') {
            item.subitem[indexInferior].fornecedorpagamento = {
                id: 'agencia',
                nome: 'Agência'
            };
        }
        // R2 (QA 02/10): a linha segue a moeda do grupo fornecedor × Local (nunca o contrário —
        // antes, uma linha nova em Real convertia em silêncio a linha antiga do fornecedor).
        calculaTotalOrcamento2(aplicarPadraoMoedaLocal(dados, indexSuperior, indexInferior, { moedaOrcamento: obterMoedaOrcamento(), fornecedorAccess: fornecedorAccessInterno }));
        return true;
    };

    const calculaTotalOrcamento = () => {
        var dadosAtualizados = calculaTotalOrcamento2();
        setDados(dadosAtualizados);
    }//calculaTotalOrcamento

    // Arrastar para reordenar (Rafael, 07/10). A posição no array vira `ordem` ao salvar.
    // Fixos (o recálculo reimpõe): Agência no topo; FEE Sanofi no topo do grupo; 1945 (Chiesi) por último.
    const grupoTemPosicaoFixa = (grupo) => isGrupoAgencia(grupo);
    const subitemFixoNoTopo = (subitem) => FeeIntelligence.isSanofiAgencyTierFeeItem(subitem?.produto ?? {});
    const subitemFixoNoFim = (grupo, subitem) => clienteAtualEhChiesi && isGrupoServicosAgencia(grupo) && isSubitemImpostoNfAccess(subitem);
    const subitemTemPosicaoFixa = (grupo, subitem) => subitemFixoNoTopo(subitem) || subitemFixoNoFim(grupo, subitem);

    const moverGrupo = (de, para) => {
        const nova = moverRespeitandoFixos(dados.orcamentoitem || [], de, para, { fixoTopo: grupoTemPosicaoFixa });
        if (!nova) {
            toast.info('O grupo Agência fica sempre no topo do orçamento.');
            return;
        }
        setExpandedRows((atual) => remapearExpandidos(atual, de, para));
        setDados(calculaTotalOrcamento2({ ...dados, orcamentoitem: nova }));
    };

    const moverSubitem = (indexSuperior, de, para) => {
        const grupo = (dados.orcamentoitem || [])[indexSuperior];
        if (!grupo) return;
        const nova = moverRespeitandoFixos(grupo.subitem || [], de, para, {
            fixoTopo: subitemFixoNoTopo,
            fixoFim: (subitem) => subitemFixoNoFim(grupo, subitem),
        });
        if (!nova) {
            toast.info('Esta linha tem posição fixa no grupo.');
            return;
        }
        const orcamentoitem = dados.orcamentoitem.map((g, i) => (i === indexSuperior ? { ...g, subitem: nova } : g));
        setDados(calculaTotalOrcamento2({ ...dados, orcamentoitem }));
    };

    // Clonar (Rafael, 07/10): a cópia entra logo abaixo da original e só é gravada ao Salvar.
    // O que o sistema monta sozinho não se clona (duplicaria): grupo Agência, linha do FEE da
    // Agência, FEE Sanofi e Imposto NF Access (1945). Clonar grupo ficou desabilitado em 30/10 (D-0134): cada
    // grupo só aparece 1 vez; o botão fica para mostrar o motivo.
    const podeClonarGrupo = (grupo) => !isGrupoAgencia(grupo);
    const podeClonarSubitem = (grupo, subitem) => !(isSubitemFeeAgencia(subitem)
        || FeeIntelligence.isSanofiAgencyTierFeeItem(subitem?.produto ?? {})
        || isSubitemImpostoNfAccess(subitem));

    const clonarSubitemNaPosicao = (indexSuperior, indexInferior) => {
        const grupo = (dados.orcamentoitem || [])[indexSuperior];
        const original = grupo && (grupo.subitem || [])[indexInferior];
        if (!original || !podeClonarSubitem(grupo, original)) return;
        if (produtoInativo(original)) {
            toast.warning(MSG_CLONAR_PRODUTO_INATIVO);
            return;
        }
        const subitem = [...grupo.subitem];
        subitem.splice(indexInferior + 1, 0, clonarSubitem(original, rand18));
        const orcamentoitem = dados.orcamentoitem.map((g, i) => (i === indexSuperior ? { ...g, subitem } : g));
        setDados(calculaTotalOrcamento2({ ...dados, orcamentoitem }));
        toast.success('Item clonado logo abaixo do original. Clique em Salvar para gravar.');
    };

    const carregarFeeRulesCliente = async (clienteId = null) => {
        const clienteResolvido = obterIdComparavel(clienteId ?? dados?.evento?.cliente?.id ?? dados?.evento?.cliente ?? dados?.cliente?.id ?? dados?.cliente);
        if (!clienteResolvido) {
            setFeeRulesCliente([]);
            marcarStatusRegrasFee('pendente');
            return [];
        }

        try {
            const response = await api({
                method: 'get',
                action: '/produto/feeRegrasCliente',
                token: token,
                params: {
                    cliente: clienteResolvido,
                },
            });

            const regras = Array.isArray(response?.data?.data) ? response.data.data : [];
            setFeeRulesCliente(regras);
            setFalhaRegrasFee((atual) => ({ ...atual, regras: false }));
            marcarStatusRegrasFee('ok');
            return regras;
        } catch (error) {
            console.error('Erro ao carregar regras de fee por cliente:', error);
            setFeeRulesCliente([]);
            setFalhaRegrasFee((atual) => ({ ...atual, regras: true }));
            marcarStatusRegrasFee('falha');
            return [];
        }
    };

    // Épico 12: valores por versão (fee + serviços) para exibição no modal "Versão do Fee"
    const carregarTabelaValores = async (clienteId = null) => {
        const clienteResolvido = obterIdComparavel(clienteId ?? dados?.cliente?.id ?? dados?.cliente);
        if (!clienteResolvido) {
            setTabelaValores([]);
            return [];
        }
        try {
            const response = await api({
                method: 'get',
                action: '/produto/tabelaValoresCliente',
                token: token,
                params: { cliente: clienteResolvido },
            });
            const valores = Array.isArray(response?.data?.data) ? response.data.data : [];
            setTabelaValores(valores);
            return valores;
        } catch (error) {
            setTabelaValores([]);
            return [];
        }
    };

    // Épico 13 (Abbvie): faixas versionadas do cliente (2025/2026) p/ o seletor de período
    const carregarFaixasVersao = async (clienteId = null) => {
        const clienteResolvido = obterIdComparavel(clienteId ?? dados?.cliente?.id ?? dados?.cliente ?? dados?.evento?.cliente?.id ?? dados?.evento?.cliente);
        if (!clienteResolvido) {
            setFaixasVersao([]);
            setRegraMiniMeeting(null);
            return [];
        }
        try {
            // Mini Meeting (28/09): a regra vem junto das faixas; falha em qualquer uma bloqueia o Salvar (item 10).
            const [response, respostaMiniMeeting] = await Promise.all([
                api({
                    method: 'get',
                    action: '/produto/faixasVersaoCliente',
                    token: token,
                    params: { cliente: clienteResolvido },
                }),
                api({
                    method: 'get',
                    action: '/produto/feeMiniMeetingCliente',
                    token: token,
                    params: { cliente: clienteResolvido },
                }),
            ]);
            const valores = Array.isArray(response?.data?.data) ? response.data.data : [];
            const regraMm = respostaMiniMeeting?.data?.data;
            setRegraMiniMeeting(regraMm && typeof regraMm === 'object' ? regraMm : null);
            setFaixasVersao(valores);
            setFalhaRegrasFee((atual) => ({ ...atual, faixas: false }));
            return valores;
        } catch (error) {
            setFaixasVersao([]);
            setRegraMiniMeeting(null);
            setFalhaRegrasFee((atual) => ({ ...atual, faixas: true }));
            return [];
        }
    };

    const aplicarModeloAoOrcamento = (modelo) => {
        const grupos = (modelo?.itens || []).map((g) => {
            const produtoId = g.produto && typeof g.produto === 'object' ? g.produto.id : g.produto;
            return {
                produto: produtoId ? { id: produtoId, nome: g.produto?.nome ?? null } : null,
                subitem: (g.sub_item || []).map((s) => {
                    const subProdId = s.produto && typeof s.produto === 'object' ? s.produto.id : s.produto;
                    return {
                        produto: subProdId ? { id: subProdId, nome: s.produto?.nome ?? null } : null,
                        chaveunica: rand18(),
                        compoeFee: 'nao',
                        tipopagamento: 'normal',
                    };
                })
            };
        });

        // D-0134: modelo antigo com grupo repetido entra com os itens reunidos em um só grupo.
        const { grupos: gruposSemRepeticao, juntados } = juntarGruposRepetidos(grupos);
        dados.orcamentoitem = gruposSemRepeticao;
        calculaTotalOrcamento();
        if (juntados.length > 0) {
            toast.warning(`O modelo repetia ${juntados.join(', ')}: os itens foram reunidos em um só grupo.`);
        }
    };

    const carregarModelosOrcamento = async (escopo = 'meus', nome = '') => {
        setCarregandoModelosOrcamento(true);
        try {
            const response = await api({
                method: 'get',
                action: '/orcamentoModelo',
                token,
                params: {
                    escopo,
                    nome: nome || undefined,
                }
            });
            setListaModelosOrcamento(Array.isArray(response?.data?.data) ? response.data.data : []);
        } catch (error) {
            toast.error('Erro ao carregar modelos de orçamento');
            setListaModelosOrcamento([]);
        } finally {
            setCarregandoModelosOrcamento(false);
        }
    };

    const abrirModalModelosOrcamento = (escopo = 'meus') => {
        setTipoModalModelosOrcamento(escopo);
        setBuscaModelosOrcamento('');
        setShowModalModelosOrcamento(true);
        carregarModelosOrcamento(escopo, '');
    };

    const selecionarModeloOrcamento = async (modeloId) => {
        const escopo = tipoModalModelosOrcamento === 'outros' ? 'outros' : 'meus';
        try {
            const response = await api({
                method: 'get',
                action: `/orcamentoModelo/${modeloId}`,
                token,
                params: { escopo }
            });
            const modelo = response?.data?.data ?? {};
            aplicarModeloAoOrcamento(modelo);
            setModeloSelecionadoOrcamento({
                id: modelo?.id ?? modeloId,
                nome: modelo?.nome ?? '',
                operadorNome: modelo?.operadorNome ?? null,
                escopo,
            });
            setShowModalModelosOrcamento(false);
            toast.success('Modelo aplicado com sucesso');
        } catch (error) {
            toast.error('Erro ao aplicar modelo');
        }
    };

    // Nova versão do Negociado (Rafael 23/10): congela a coluna Custos Negociados como está (V1, V2…, só
    // leitura) e a principal segue editável e vigente. Antes criava uma "V2" editável que nada lia.
    const adicionarColunaNegociado = () => {
        const motivo = motivoBloqueioNovaVersao(dados.orcamentoitem);
        if (motivo) { toast.error(motivo); return; }
        const novaVersao = montarVersaoCongelada(dados.orcamentoitem, colunasNegociadoAdicionais, {
            moedaDaLinha: (subitem) => moedaLinhaGrade(subitem, 'Negociado'),
        });
        setColunasNegociadoAdicionais([...colunasNegociadoAdicionais, novaVersao]);
        setColunasNegociadoVisibility({ ...colunasNegociadoVisibility, [novaVersao.id]: true });
        toast.success(`${novaVersao.nome} guardada. Os Custos Negociados seguem editáveis e valem como ${rotuloVersaoAtual([...colunasNegociadoAdicionais, novaVersao])}. Salve o orçamento para gravar.`);
    };

    // Botão "Converter V2" (23/10): coluna do jeito antigo vira o Negociado vigente; o Negociado de agora
    // vira histórico. Só muda a tela — a operadora confere e salva (o salvar recalcula FEE e total na API).
    const converterNegociadoFormatoAntigo = () => {
        const motivo = motivoBloqueioNovaVersao(dados.orcamentoitem);
        if (motivo) { toast.error(motivo); return; }
        const resultado = converterFormatoAntigo(dados.orcamentoitem, colunasNegociadoAdicionais, {
            moedaDaLinha: (subitem) => moedaLinhaGrade(subitem, 'Negociado'),
        });
        if (!resultado) return;
        if (!window.confirm(`Converter? ${resultado.nomeVigente} passa a valer como Custos Negociados (${resultado.linhasAlteradas} linha(s)) e o Negociado de agora vira histórico. Confira os valores e salve.`)) return;
        setColunasNegociadoAdicionais(resultado.colunas);
        setColunasNegociadoVisibility(resultado.colunas.reduce((acc, coluna) => ({ ...acc, [coluna.id]: true }), {}));
        setDados(calculaTotalOrcamento2({ ...dados, orcamentoitem: resultado.orcamentoitem }));
        toast.success(`${resultado.nomeVigente} convertida. Confira os Custos Negociados e salve o orçamento.`);
    };

    // Função para alternar visibilidade de coluna adicional
    const toggleColunaVisibility = (colunaId) => {
        setColunasNegociadoVisibility({
            ...colunasNegociadoVisibility,
            [colunaId]: !colunasNegociadoVisibility[colunaId]
        });
    };

    // Função para remover coluna de negociado
    const removerColunaNegociado = (colunaId) => {
        const coluna = colunasNegociadoAdicionais.find(col => col.id === colunaId);
        if (ehVersaoCongelada(coluna) && !window.confirm(`Excluir a ${coluna.nome}? O histórico dessa versão some ao salvar o orçamento.`)) return;
        setColunasNegociadoAdicionais(colunasNegociadoAdicionais.filter(col => col.id !== colunaId));
    };

    // Função para converter dados para JSON
    const converterParaJSON = () => {
        return JSON.stringify(colunasNegociadoAdicionais);
    };

    // Função para carregar JSON salvo
    const carregarJSON = (jsonString) => {
        try {
            if (jsonString) {
                const colunas = lerColunasNegociado(jsonString);
                setColunasNegociadoAdicionais(colunas);

                // Aplica os dados salvos aos subitens (versão congelada é lida direto do JSON)
                colunas.filter(coluna => !ehVersaoCongelada(coluna)).forEach(coluna => {
                    coluna.itens.forEach(itemColuna => {
                        const itemIndex = dados.orcamentoitem.findIndex(item => item.id === itemColuna.itemId);
                        if (itemIndex !== -1) {
                            itemColuna.subitens.forEach(subitemColuna => {
                                const subitemIndex = dados.orcamentoitem[itemIndex].subitem.findIndex(subitem => subitem.id === subitemColuna.subitemId);
                                if (subitemIndex !== -1) {
                                    // Aplica os dados aos campos do subitem
                                    dados.orcamentoitem[itemIndex].subitem[subitemIndex][`valorUnitarioNegociadoAdicional_${coluna.id}`] = subitemColuna.valorUnitario;
                                    dados.orcamentoitem[itemIndex].subitem[subitemIndex][`diariaNegociadoAdicional_${coluna.id}`] = subitemColuna.diaria;
                                    dados.orcamentoitem[itemIndex].subitem[subitemIndex][`quantidadeNegociadoAdicional_${coluna.id}`] = subitemColuna.quantidade;
                                    dados.orcamentoitem[itemIndex].subitem[subitemIndex][`servicoNegociadoAdicional_${coluna.id}`] = subitemColuna.servico;
                                    dados.orcamentoitem[itemIndex].subitem[subitemIndex][`observacaoNegociadoAdicional_${coluna.id}`] = subitemColuna.observacao;
                                }
                            });
                        }
                    });
                });

                // Força atualização dos dados
                setDados({ ...dados });

                // Inicializa visibilidade como false para todas as colunas
                const visibilityState = {};
                colunas.forEach(coluna => {
                    visibilityState[coluna.id] = false;
                });
                setColunasNegociadoVisibility(visibilityState);
            }
        } catch (error) {
            console.error('Erro ao carregar JSON das colunas adicionais:', error);
        }
    };

    // Função para calcular total de coluna adicional
    const calcularTotalColunaAdicional = (subitem, colunaId) => {
        inicializarCamposColunaNegociadoAdicional(subitem, colunaId);
        const valorUnitario = virgulaPonto(subitem[`valorUnitarioNegociadoAdicional_${colunaId}`] || 0);
        const diaria = virgulaPonto(subitem[`diariaNegociadoAdicional_${colunaId}`] || 0);
        const quantidade = virgulaPonto(subitem[`quantidadeNegociadoAdicional_${colunaId}`] || 0);
        const servico = virgulaPonto(subitem[`servicoNegociadoAdicional_${colunaId}`] || 0);

        const total = quantidade * diaria * valorUnitario;
        const totalComServico = total * (1 + (servico / 100));

        return totalComServico.toFixed(2);
    };

    // Função para calcular subtotal de item para uma coluna adicional
    const calcularSubtotalItemColunaAdicional = (item, colunaId) => {
        if (!item || !item.subitem) return 0;

        let subtotal = 0;
        item.subitem.forEach(subitem => {
            subtotal += parseFloat(calcularTotalColunaAdicional(subitem, colunaId));
        });

        return subtotal.toFixed(2);
    };

    // Função para calcular total geral de uma coluna adicional
    const calcularTotalGeralColunaAdicional = (colunaId) => {
        if (!dados.orcamentoitem) return 0;

        let totalGeral = 0;
        dados.orcamentoitem.forEach(item => {
            totalGeral += parseFloat(calcularSubtotalItemColunaAdicional(item, colunaId));
        });

        return totalGeral.toFixed(2);
    };

    // Função para atualizar JSON quando valores forem alterados
    const atualizarJSONColunasAdicionais = () => {
        const colunasAtualizadas = colunasNegociadoAdicionais.map(coluna => {
            if (ehVersaoCongelada(coluna)) return coluna; // histórico: não muda
            const itensColuna = dados.orcamentoitem.map(item => ({
                itemId: item.id || `item_${Math.random()}`,
                subitens: (item.subitem || []).map(subitem => ({
                    subitemId: subitem.id || `subitem_${Math.random()}`,
                    valorUnitario: subitem[`valorUnitarioNegociadoAdicional_${coluna.id}`] || '',
                    diaria: subitem[`diariaNegociadoAdicional_${coluna.id}`] || '',
                    quantidade: subitem[`quantidadeNegociadoAdicional_${coluna.id}`] || '',
                    servico: subitem[`servicoNegociadoAdicional_${coluna.id}`] || '',
                    total: calcularTotalColunaAdicional(subitem, coluna.id),
                    observacao: subitem[`observacaoNegociadoAdicional_${coluna.id}`] || ''
                }))
            }));

            return {
                ...coluna,
                itens: itensColuna
            };
        });

        setColunasNegociadoAdicionais(colunasAtualizadas);
        return JSON.stringify(colunasAtualizadas);
    };

    const calculaTotalOrcamento2 = (dadosParaCalcular = null, opcoes = null) => {
        var valorTotalFinalPreEvento = 0;
        var valorTotalFinalNegociado = 0;
        var valorTotalFinalFechamento = 0;
        let feeRulesContexto = Array.isArray(opcoes?.feeRules) ? opcoes.feeRules : feeRulesCliente;
        // Todas as versões (antes do filtro por fee_versao): decide se o cliente tem regra de FEE.
        const feeRulesClienteTodas = feeRulesContexto;
        const fornecedorAccessContexto = opcoes?.fornecedorAccessInterno ?? fornecedorAccessInterno;
        const produtoImpostoAccessContexto = opcoes?.produtoImpostoAccess ?? produtoImpostoAccess;
        // Épico 12: se o orçamento tem versão de fee definida, aplica só as regras daquela versão
        const feeVersaoContexto = (dadosParaCalcular ?? dados)?.fee_versao ?? null;
        if (feeVersaoContexto && Array.isArray(feeRulesContexto)) {
            // Só as regras da versão escolhida. Se NÃO houver regra dessa versão, usa lista
            // vazia — nunca as regras de outra versão (isso aplicava a taxa de 2025 num
            // orçamento marcado como 2026, silenciosamente).
            feeRulesContexto = feeRulesContexto.filter((r) => String(r?.versao ?? '') === String(feeVersaoContexto));
        }

        // Cria uma cópia dos dados para não modificar diretamente
        const dadosAtualizados = dadosParaCalcular ? { ...dadosParaCalcular } : { ...dados };
        dadosAtualizados.orcamentoitem = Array.isArray(dadosAtualizados.orcamentoitem) ? dadosAtualizados.orcamentoitem : [];
        // Rafael 19/10: sem câmbio do topo no Fechamento; linha com transação registrada usa o câmbio dela (a API grava igual).
        dadosAtualizados.orcamentoitem = sincronizarCambioFechamentoTransacao(dadosAtualizados.orcamentoitem);
        const clienteContexto = dadosAtualizados?.evento?.cliente ?? dadosAtualizados?.cliente ?? dados?.evento?.cliente ?? dados?.cliente ?? null;
        // Abbvie: faixas versionadas do catálogo e pax do evento para o fee por categoria
        const faixasVersaoContexto = Array.isArray(opcoes?.faixasVersao) ? opcoes.faixasVersao : faixasVersao;
        const paxEventoContexto = paxConvidadosEsperados(
            convidadosEsperadosDoEvento(dadosAtualizados?.evento)
            ?? convidadosEsperadosDoEvento(dados?.evento)
            ?? eventoConvidadosEsperados
        );
        // AbbVie Mini Meeting (28/09): evento tipo 'minimeet' troca as categorias pela regra do catálogo.
        const tipoEventoContexto = dadosAtualizados?.evento?.tipo ?? dados?.evento?.tipo ?? eventoTipo;
        const miniMeetingContexto = FeeIntelligence.miniMeetingParaEvento(
            opcoes && Object.prototype.hasOwnProperty.call(opcoes, 'miniMeeting') ? opcoes.miniMeeting : regraMiniMeeting,
            tipoEventoContexto
        );
        const nacionalidadeContexto = opcoes?.eventoNacionalidade
            ?? dadosAtualizados?.evento?.nacionalidade
            ?? eventoNacionalidade;
        const aplicaImpostoNfAccess = isClienteChiesi(clienteContexto)
            || (nacionalidadeContexto || '').toString().toLowerCase() === 'internacional';
        garantirEstruturaAgencia(dadosAtualizados.orcamentoitem, { incluirFeePadrao: !clienteEscolheFeeNoCatalogo(clienteContexto) });
        ordenarSubitensSanofiComFeeNoTopo(dadosAtualizados.orcamentoitem, clienteContexto);
        dadosAtualizados.orcamentoitem = ordenarGruposComAgenciaNoTopo(dadosAtualizados.orcamentoitem);
        aplicarRegraServicosAgenciaChiesi(
            dadosAtualizados.orcamentoitem,
            clienteContexto,
            fornecedorAccessContexto,
            produtoImpostoAccessContexto
        );
        ChiesiImpostoPolicy.aplicar(
            dadosAtualizados.orcamentoitem,
            isClienteChiesi(clienteContexto),
            fornecedorAccessContexto
        );
        // Sanofi (Inter 13/10): na COORDENAÇÃO o imposto NF incide sobre tudo — diárias, RDV, IOF/IR, remessa.
        if (!isClienteChiesi(clienteContexto)) {
            ChiesiImpostoPolicy.aplicarCoordenacaoExterior(
                dadosAtualizados.orcamentoitem,
                OrcamentoClientInheritance.resolveVisualModel(clienteContexto) === 'sanofi',
                fornecedorAccessContexto
            );
        }
        ChiesiAgenciaImpostoPolicy.marcar(dadosAtualizados.orcamentoitem, isClienteChiesi(clienteContexto));
        // Long Ping (D-0119): % Imposto NF 19,05 nas linhas da Access e no FEE AGÊNCIA (longPingPolicy).
        const clienteLongPingContexto = LongPingPolicy.ehClienteLongPing(clienteContexto);
        // Long Ping em Real: FEE com 6 casas e totais somados sem arredondar por linha (como a planilha).
        const somaSemArredondarContexto = LongPingPolicy.somaSemArredondar(clienteContexto, dadosAtualizados.moeda);
        // Moeda do fornecedor (27/09; 02/10 em qualquer Local do pagamento): linha sem seletor (Access,
        // FEE, imposto/NF) volta ao legado como a API; em orçamento em Real, "Real" próprio = legado; linha
        // sem moeda herda a do fornecedor no MESMO Local. Cada linha de moeda própria recebe o fator
        // câmbio-dela ÷ câmbio global (subtotais, FEE e Total Access na moeda do orçamento). Linha legada:
        // fator 1, nenhuma conta muda. Não muta: troca grupos/linhas alterados por cópias.
        dadosAtualizados.orcamentoitem = normalizarMoedaFornecedorItens(dadosAtualizados.orcamentoitem, {
            moedaOrcamento: dadosAtualizados.moeda, fornecedorAccess: fornecedorAccessContexto,
        });
        dadosAtualizados.orcamentoitem = anotarFatoresMoeda(dadosAtualizados.orcamentoitem, cambioGlobalOrcamento(dadosAtualizados));

        dadosAtualizados.orcamentoitem.forEach(function (valor, indexSuperior) {
            dadosAtualizados.orcamentoitem[indexSuperior].indexSuperior = indexSuperior;
            dadosAtualizados.orcamentoitem[indexSuperior].valorTotalPreEvento = 0;
            dadosAtualizados.orcamentoitem[indexSuperior].valorTotalNegociado = 0;
            dadosAtualizados.orcamentoitem[indexSuperior].valorTotalFechamento = 0;
            dadosAtualizados.orcamentoitem[indexSuperior].subitem.forEach(function (valor, indexInferior) {
                dadosAtualizados.orcamentoitem[indexSuperior].subitem[indexInferior].indexInferior = indexInferior;
                const subitemAtual = dadosAtualizados.orcamentoitem[indexSuperior].subitem[indexInferior];
                inicializarCamposCalculoSubitem(subitemAtual);
                normalizarCampoCompoeFee(subitemAtual);
                sincronizarSubitemQueCompoeFee(subitemAtual);
                if (isClienteChiesi(clienteContexto) && isGrupoServicosAgencia(dadosAtualizados.orcamentoitem[indexSuperior])) {
                    subitemAtual.compoeFee = 'nao';
                    subitemAtual.nomeCompoeFee = 'Não';
                    if (fornecedorAccessContexto?.id) {
                        subitemAtual.fornecedor = {
                            id: fornecedorAccessContexto.id,
                            nome: fornecedorAccessContexto.nome,
                            cnpj: fornecedorAccessContexto.cnpj,
                        };
                    }
                }
                if (clienteLongPingContexto) LongPingPolicy.normalizarSubitem(subitemAtual, fornecedorAccessContexto);
                LongPingPolicy.marcarSomaSemArredondar(subitemAtual, somaSemArredondarContexto);
                ImpostoNfAccessPorFornecedorPolicy.normalizarSubitem(subitemAtual, fornecedorAccessContexto);
                aplicarPrecificacaoPorFaixaNoMomento(subitemAtual, 'PreEvento', dadosAtualizados.tabela_versao, divisorPrecoCatalogoLinha(subitemAtual, 'PreEvento', dadosAtualizados.moeda, dadosAtualizados.cambio));
                aplicarPrecificacaoPorFaixaNoMomento(subitemAtual, 'Negociado', dadosAtualizados.tabela_versao, divisorPrecoCatalogoLinha(subitemAtual, 'Negociado', dadosAtualizados.moeda, dadosAtualizados.cambio));
                aplicarPrecificacaoPorFaixaNoMomento(subitemAtual, 'Fechamento', dadosAtualizados.tabela_versao, divisorPrecoCatalogoLinha(subitemAtual, 'Fechamento', dadosAtualizados.moeda, dadosAtualizados.cambio));
                colunasNegociadoAdicionais.filter((coluna) => !ehVersaoCongelada(coluna)).forEach((coluna) => {
                    inicializarCamposColunaNegociadoAdicional(subitemAtual, coluna.id);
                    aplicarPrecificacaoPorFaixaNaColunaAdicional(subitemAtual, coluna.id, dadosAtualizados.tabela_versao, divisorPrecoCatalogoLinha(subitemAtual, 'Negociado', dadosAtualizados.moeda, dadosAtualizados.cambio));
                });
                var quantidadePreEvento = virgulaPonto(dadosAtualizados.orcamentoitem[indexSuperior].subitem[indexInferior].quantidadePreEvento);
                var valorUnitarioPreEvento = virgulaPonto(dadosAtualizados.orcamentoitem[indexSuperior].subitem[indexInferior].valorUnitarioPreEvento);
                var diariaPreEvento = virgulaPonto(dadosAtualizados.orcamentoitem[indexSuperior].subitem[indexInferior].diariaPreEvento);
                var servicoPreEvento = virgulaPonto(dadosAtualizados.orcamentoitem[indexSuperior].subitem[indexInferior].servicoPreEvento);

                var quantidadeNegociado = virgulaPonto(dadosAtualizados.orcamentoitem[indexSuperior].subitem[indexInferior].quantidadeNegociado);
                var valorUnitarioNegociado = virgulaPonto(dadosAtualizados.orcamentoitem[indexSuperior].subitem[indexInferior].valorUnitarioNegociado);
                var diariaNegociado = virgulaPonto(dadosAtualizados.orcamentoitem[indexSuperior].subitem[indexInferior].diariaNegociado);
                var servicoNegociado = virgulaPonto(dadosAtualizados.orcamentoitem[indexSuperior].subitem[indexInferior].servicoNegociado);

                var quantidadeFechamento = virgulaPonto(dadosAtualizados.orcamentoitem[indexSuperior].subitem[indexInferior].quantidadeFechamento);
                var valorUnitarioFechamento = virgulaPonto(dadosAtualizados.orcamentoitem[indexSuperior].subitem[indexInferior].valorUnitarioFechamento);
                var diariaFechamento = virgulaPonto(dadosAtualizados.orcamentoitem[indexSuperior].subitem[indexInferior].diariaFechamento);
                var servicoFechamento = virgulaPonto(dadosAtualizados.orcamentoitem[indexSuperior].subitem[indexInferior].servicoFechamento);

                var totalPreEvento = calcularTotalMomentoSubitem(subitemAtual, 'PreEvento');
                var totalNegociado = calcularTotalMomentoSubitem(subitemAtual, 'Negociado');
                var totalFechamento = calcularTotalMomentoSubitem(subitemAtual, 'Fechamento');

                // Opção (D-0113): o total da linha é calculado e mostrado, mas não soma no grupo.
                if (!ehSomenteVisualizacao(subitemAtual)) {
                    dadosAtualizados.orcamentoitem[indexSuperior].valorTotalPreEvento += totalPreEvento * fatorAnotado(subitemAtual, 'pre_evento');
                    dadosAtualizados.orcamentoitem[indexSuperior].valorTotalNegociado += totalNegociado * fatorAnotado(subitemAtual, 'negociado');
                    dadosAtualizados.orcamentoitem[indexSuperior].valorTotalFechamento += totalFechamento * fatorAnotado(subitemAtual, 'fechamento');
                }

                dadosAtualizados.orcamentoitem[indexSuperior].subitem[indexInferior].totalPreEvento = totalPreEvento.toFixed(2);
                dadosAtualizados.orcamentoitem[indexSuperior].subitem[indexInferior].totalNegociado = totalNegociado.toFixed(2);
                dadosAtualizados.orcamentoitem[indexSuperior].subitem[indexInferior].totalFechamento = totalFechamento.toFixed(2);
                sincronizarValorRealComFechamentoSeND(dadosAtualizados.orcamentoitem[indexSuperior].subitem[indexInferior]);
            });

            valorTotalFinalPreEvento += dadosAtualizados.orcamentoitem[indexSuperior].valorTotalPreEvento;
            valorTotalFinalNegociado += dadosAtualizados.orcamentoitem[indexSuperior].valorTotalNegociado;
            valorTotalFinalFechamento += dadosAtualizados.orcamentoitem[indexSuperior].valorTotalFechamento;

            dadosAtualizados.orcamentoitem[indexSuperior].valorTotalPreEvento = dadosAtualizados.orcamentoitem[indexSuperior].valorTotalPreEvento.toFixed(2);
            dadosAtualizados.orcamentoitem[indexSuperior].valorTotalNegociado = dadosAtualizados.orcamentoitem[indexSuperior].valorTotalNegociado.toFixed(2);
            dadosAtualizados.orcamentoitem[indexSuperior].valorTotalFechamento = dadosAtualizados.orcamentoitem[indexSuperior].valorTotalFechamento.toFixed(2);
        });

        //calcula valor de itens que são o somatorio de outros itens
        dadosAtualizados.orcamentoitem.forEach(function (itemSuperiorX, indexSuperiorX) { //loop nos itens superiores
            dadosAtualizados.orcamentoitem[indexSuperiorX].subitem.forEach(function (subitemX, indexInferiorX) { //loop nos subitens
                //calcula valor do item se ele for resultado da soma de outros
                var arrayChavesSomar = dadosAtualizados.orcamentoitem[indexSuperiorX].subitem[indexInferiorX].chavessomar ? dadosAtualizados.orcamentoitem[indexSuperiorX].subitem[indexInferiorX].chavessomar.split(",") : [];
                var totalSomado = 0;
                if (arrayChavesSomar.length > 0) {
                    arrayChavesSomar.forEach((chaveUnicaItemSomar) => {
                        //busca item pra achar o preço
                        dadosAtualizados.orcamentoitem.forEach((orcamentoItemX, indexOrcamentoItem) => {
                            orcamentoItemX.subitem.forEach((subitemX2, indexSubItem) => {
                                if (chaveUnicaItemSomar === subitemX2.chaveunica) {
                                    totalSomado += virgulaPonto(subitemX2.totalPreEvento);
                                }
                            });
                        });
                    });
                    dadosAtualizados.orcamentoitem[indexSuperiorX].subitem[indexInferiorX].valorUnitarioPreEvento = pontoVirgula(totalSomado);
                }//se for soma de outros itens
            });
        });

        // Internacional: base do FEE = total da linha + encargos da remessa (planilha, 25/09).
        // Nacional Sanofi-família/Chiesi (regra B, 28/09): base com o % Serviço da linha.
        anotarBaseFeeInternacional(dadosAtualizados.orcamentoitem, {
            nacionalidade: nacionalidadeContexto,
            moeda: dadosAtualizados.moeda,
            cambio: dadosAtualizados.cambio,
            baseComServico: clienteBaseFeeComServico(clienteContexto),
            // Chiesi nacional (D-0153): + Imposto NF Access da linha, como as planilhas antigas.
            baseComNfAccess: clienteBaseFeeComNfAccess(clienteContexto),
            // AbbVie nacional (06/10): base com % Serviço + % Impostos do item, como a planilha.
            baseComImpostoItem: clienteBaseFeeComImpostoItem(clienteContexto),
            // Long Ping nacional (D-0119): base = total da linha, já com a NF 19,05.
            baseComTotalLinha: clienteBaseFeeComTotalLinha(clienteContexto),
        }, fornecedorAccessContexto);
        // Valor exato em reais (contrato 02/10): orçamento estrangeiro com linha de moeda própria calcula
        // FEE, NF Access e subtotais a partir dos R$ das linhas (valorBrlPolicy). Legado/Real: nada muda.
        const brlExato = orcamentoBrlExato(dadosAtualizados);
        const cambioBrlExato = cambioGlobalOrcamento(dadosAtualizados);
        anotarBaseFeeBrlExato(dadosAtualizados.orcamentoitem, {
            exato: brlExato, moeda: dadosAtualizados.moeda, cambio: cambioBrlExato,
        }, fornecedorAccessContexto);
        const valorLinhaBaseFeeGenerico = (linha, momento) => (brlExato
            ? valorBrlLinha(linha, momento, cambioBrlExato, { exato: true }) / cambioBrlExato
            : virgulaPonto(linha[`total${momento}`]));

        //calcula total de itens que somam todos os que compõem o FEE
        dadosAtualizados.orcamentoitem.forEach(function (itemSuperiorY, indexSuperiorY) { //loop nos itens superiores
            dadosAtualizados.orcamentoitem[indexSuperiorY].subitem.forEach(function (subitemY, indexInferiorY) { //loop nos subitens
                const produtoFee = dadosAtualizados.orcamentoitem[indexSuperiorY].subitem[indexInferiorY].produto ?? {};
                const feeBaseTipo = produtoFee.feeBaseTipo ?? 'compoe_fee_global';
                const feeBaseIds = obterIdsComparaveis(produtoFee.feeBaseId);
                const feeMomentoCalculo = produtoFee.feeMomentoCalculo ?? 'todos';
                const tipoPrecoOriginal = (produtoFee.tipoPreco ?? 'fixo').toString().toLowerCase();
                const precoOriginal = parseFloat(produtoFee.preco ?? 0);
                const feeAgenciaGenerico = isFeeAgenciaGenerico(produtoFee);
                const itemRegraFeeAgencia = FeeIntelligence.isAgencyFeeRuleItem(produtoFee);
                const regraSomenteFeeAgencia = itemRegraFeeAgencia && !feeAgenciaGenerico;
                const itemVoucherBaseManual = FeeIntelligence.isVoucherManualBaseItem(produtoFee);
                const deveSomarTodosFee =
                    !itemVoucherBaseManual && (
                        produtoFee.somarTodosFee === 'sim' ||
                        itemRegraFeeAgencia ||
                        feeAgenciaGenerico
                    );

                // Cliente sem regra de FEE (27/09): o FEE AGÊNCIA gravado/digitado fica como está.
                // D-0152: Allergan aprovado pelo cliente também fica com o FEE gravado.
                if (feeAgenciaGenerico && AllerganFeePolicy.mantemFeeGravado({ cliente: dadosAtualizados.cliente, dataAprovacaoCliente: dadosAtualizados.dataAprovacaoCliente, id, copiar })) {
                    return;
                }
                if (feeAgenciaGenerico && !FeeAgenciaManualPolicy.decidir({
                    status: statusRegrasFeeRef.current, feeRules: feeRulesClienteTodas, faixasVersao: faixasVersaoContexto,
                }).recalcular) {
                    return;
                }

                if (deveSomarTodosFee) { // é um item que deve executar somatoria
                    var totalGruposPreEvento = 0;
                    var totalGruposNegociado = 0;
                    var totalGruposFechamento = 0;

                    if (feeAgenciaGenerico) {
                        // Abbvie: fee composto pelas categorias do catálogo — faixa única
                        // resolvida pelo pax do EVENTO na versão da "Tabela de valores";
                        // sem versão selecionada o fee fica 0 até o operador escolher.
                        const feeCategorias = FeeIntelligence.calculateCatalogCategoryFees(
                            dadosAtualizados.orcamentoitem,
                            faixasVersaoContexto,
                            dadosAtualizados?.tabela_versao ?? null,
                            paxEventoContexto,
                            miniMeetingContexto
                        );
                        if (feeCategorias.aplicavel) {
                            totalGruposPreEvento = feeCategorias.pre_evento;
                            totalGruposNegociado = feeCategorias.negociado;
                            totalGruposFechamento = feeCategorias.fechamento;
                        } else {
                            // Regra FEE Agência: soma item a item somente dos pagos pela agência
                            const feeAgenciaValores = FeeIntelligence.calculateAgencyFeeValues(
                                dadosAtualizados.orcamentoitem,
                                subitemY,
                                {
                                    cliente: dadosAtualizados?.cliente ?? dados?.cliente ?? null,
                                    feeRules: feeRulesContexto,
                                    // Épico 13 — período da tabela de faixas (Abbvie: 2025 retroativo / 2026 novo)
                                    tabelaVersao: dadosAtualizados?.tabela_versao ?? null
                                }
                            );
                            totalGruposPreEvento = feeAgenciaValores.pre_evento;
                            totalGruposNegociado = feeAgenciaValores.negociado;
                            totalGruposFechamento = feeAgenciaValores.fechamento;
                        }
                    } else if (!regraSomenteFeeAgencia) {
                        //somar base do fee conforme regra configurada
                        dadosAtualizados.orcamentoitem.forEach(function (itemSuperiorY2, indexSuperiorY2) { //loop nos itens superiores
                            dadosAtualizados.orcamentoitem[indexSuperiorY2].subitem.forEach(function (subitemY2, indexInferiorY2) { //loop nos subitens
                                const idProdutoAtual = obterIdComparavel(subitemY.produto?.id);
                                const idProdutoIteracao = obterIdComparavel(subitemY2.produto?.id);

                                // Não soma ele mesmo
                                if (idProdutoAtual && idProdutoIteracao && idProdutoAtual === idProdutoIteracao) {
                                    return;
                                }

                                // Exclui outros itens que também executam cálculo de fee
                                const produtoIteracaoFee = subitemY2.produto ?? {};
                                const itemIteracaoCalculaFee = FeeIntelligence.isFeeCalculatorItem(produtoIteracaoFee);
                                if (itemIteracaoCalculaFee || ehSomenteVisualizacao(subitemY2)) {
                                    return;
                                }

                                const superiorIteracao = obterIdComparavel(subitemY2.produto?.superior);
                                const atributoIteracao = obterIdComparavel(subitemY2.produto?.atributo);
                                let itemEntraNaBase = false;

                                if (feeBaseTipo === 'superior_especifico') {
                                    itemEntraNaBase = feeBaseIds.length > 0 && feeBaseIds.includes(superiorIteracao);
                                } else if (feeBaseTipo === 'atributo_especifico') {
                                    itemEntraNaBase = feeBaseIds.length > 0 && feeBaseIds.includes(atributoIteracao);
                                } else {
                                    itemEntraNaBase = parseBooleanFlag(subitemY2.compoeFee);
                                }

                                if (itemEntraNaBase) {
                                    totalGruposPreEvento += valorLinhaBaseFeeGenerico(subitemY2, 'PreEvento');
                                    totalGruposNegociado += valorLinhaBaseFeeGenerico(subitemY2, 'Negociado');
                                    totalGruposFechamento += valorLinhaBaseFeeGenerico(subitemY2, 'Fechamento');
                                }
                            });
                        });
                    }

                    // Verifica se é FEE percentual ou fixo
                    let tipoPreco = tipoPrecoOriginal;
                    let precoProduto = !Number.isNaN(precoOriginal) ? precoOriginal : 0;

                    let valorBasePreEvento = totalGruposPreEvento;
                    let valorBaseNegociado = totalGruposNegociado;
                    let valorBaseFechamento = totalGruposFechamento;
                    let percentuaisRegra = {
                        pre_evento: 0,
                        negociado: 0,
                        fechamento: 0
                    };

                    if (regraSomenteFeeAgencia) {
                        const basesRegra = FeeIntelligence.calculateRuleBaseTotals(dadosAtualizados.orcamentoitem, subitemY);
                        // Épico 12/13 no fee de catálogo (Sanofi 2043): a versão de fee escolhida
                        // (regras do cliente) e o período da tabela valem aqui também; sem versão
                        // selecionada o cálculo continua o do produto (orçamentos legados).
                        const valoresRegra = FeeIntelligence.calculateRuleContributionValues(
                            dadosAtualizados.orcamentoitem,
                            subitemY,
                            dadosAtualizados?.tabela_versao ?? null,
                            feeVersaoContexto ? feeRulesContexto : []
                        );
                        valorBasePreEvento = basesRegra.pre_evento ?? 0;
                        valorBaseNegociado = basesRegra.negociado ?? 0;
                        valorBaseFechamento = basesRegra.fechamento ?? 0;
                        percentuaisRegra = valoresRegra.percentuais ?? percentuaisRegra;
                    } else {
                        if (tipoPreco === 'percentual') {
                            // Aplica o percentual sobre a base do fee
                            const percentual = precoProduto / 100;
                            valorBasePreEvento = totalGruposPreEvento * percentual;
                            valorBaseNegociado = totalGruposNegociado * percentual;
                            valorBaseFechamento = totalGruposFechamento * percentual;
                        }

                        if (feeMomentoCalculo === 'pre_evento') {
                            valorBaseNegociado = 0;
                            valorBaseFechamento = 0;
                        } else if (feeMomentoCalculo === 'negociado') {
                            valorBasePreEvento = 0;
                            valorBaseFechamento = 0;
                        } else if (feeMomentoCalculo === 'fechamento') {
                            valorBasePreEvento = 0;
                            valorBaseNegociado = 0;
                        }
                    }

                    const limitarValorUnitarioFee = deveLimitarValorUnitarioFeeAgencia(produtoFee);
                    // R$ exato: unitário com 6 casas (sem o corte em 2), para o FEE R$ = % × base R$ sair exato
                    // e poder ser refeito do gravado (valorBrlPolicy.valorBrlLinha).
                    // Long Ping em Real (D-0119): idem, para o total bater com a planilha (a API grava as mesmas 6 casas).
                    const unitarioFee = (valor) => (brlExato || somaSemArredondarContexto ? pontoVirgula(unitarioFeeExato(valor)) : formatarValorUnitarioCalculado(valor, limitarValorUnitarioFee));
                    dadosAtualizados.orcamentoitem[indexSuperiorY].subitem[indexInferiorY].valorUnitarioPreEvento = unitarioFee(valorBasePreEvento);
                    dadosAtualizados.orcamentoitem[indexSuperiorY].subitem[indexInferiorY].valorUnitarioNegociado = unitarioFee(valorBaseNegociado);
                    dadosAtualizados.orcamentoitem[indexSuperiorY].subitem[indexInferiorY].valorUnitarioFechamento = unitarioFee(valorBaseFechamento);

                    const subitemFee = dadosAtualizados.orcamentoitem[indexSuperiorY].subitem[indexInferiorY];
                    let percentualAplicadoPreEvento = 0;
                    let percentualAplicadoNegociado = 0;
                    let percentualAplicadoFechamento = 0;
                    if (regraSomenteFeeAgencia && tipoPreco === 'percentual') {
                        const percentualPreEvento = percentuaisRegra.pre_evento > 0 ? percentuaisRegra.pre_evento : precoProduto;
                        const percentualNegociado = percentuaisRegra.negociado > 0 ? percentuaisRegra.negociado : percentualPreEvento;
                        const percentualFechamento = percentuaisRegra.fechamento > 0 ? percentuaisRegra.fechamento : percentualNegociado;
                        percentualAplicadoPreEvento = percentualPreEvento;
                        percentualAplicadoNegociado = percentualNegociado;
                        percentualAplicadoFechamento = percentualFechamento;
                        subitemFee.servicoPreEvento = pontoVirgula(percentualPreEvento);
                        subitemFee.servicoNegociado = pontoVirgula(percentualNegociado);
                        subitemFee.servicoFechamento = pontoVirgula(percentualFechamento);
                    } else {
                        subitemFee.servicoPreEvento = '0';
                        subitemFee.servicoNegociado = '0';
                        subitemFee.servicoFechamento = '0';
                    }
                    const ajustarFatores = (campoQuantidade, campoDiaria, valorCalculado) => {
                        const quantidadeAtual = virgulaPonto(subitemFee[campoQuantidade]) || 0;
                        const diariaAtual = virgulaPonto(subitemFee[campoDiaria]) || 0;
                        if (valorCalculado > 0 && quantidadeAtual === 0 && diariaAtual === 0) {
                            subitemFee[campoQuantidade] = '1';
                            subitemFee[campoDiaria] = '1';
                        }
                    };

                    ajustarFatores('quantidadePreEvento', 'diariaPreEvento', valorBasePreEvento);
                    ajustarFatores('quantidadeNegociado', 'diariaNegociado', valorBaseNegociado);
                    ajustarFatores('quantidadeFechamento', 'diariaFechamento', valorBaseFechamento);
                }
            });
        });

        sincronizarValoresImpostoServicosAgenciaChiesi(dadosAtualizados.orcamentoitem, clienteContexto, cambioGlobalOrcamento(dadosAtualizados));
        ChiesiAgenciaImpostoPolicy.sincronizar(
            dadosAtualizados.orcamentoitem, isClienteChiesi(clienteContexto), fornecedorAccessContexto
        );

        // Recalcula os totais após aplicar o FEE para incluir o valor do fee nos totais
        valorTotalFinalPreEvento = 0;
        valorTotalFinalNegociado = 0;
        valorTotalFinalFechamento = 0;

        console.log('=== RECALCULANDO TOTAIS ===');
        const totalBrlExato = { preEvento: 0, negociado: 0, fechamento: 0 };

        dadosAtualizados.orcamentoitem.forEach(function (item, indexItem) {
            item.valorTotalPreEvento = 0;
            item.valorTotalNegociado = 0;
            item.valorTotalFechamento = 0;
            item.impostoPlanilhaPreEvento = '0.00';
            item.impostoPlanilhaNegociado = '0.00';
            item.impostoPlanilhaFechamento = '0.00';

            item.subitem.forEach(function (subitem, indexSubitem) {
                aplicarPrecificacaoPorFaixaNoMomento(subitem, 'PreEvento', dadosAtualizados.tabela_versao, divisorPrecoCatalogoLinha(subitem, 'PreEvento', dadosAtualizados.moeda, dadosAtualizados.cambio));
                aplicarPrecificacaoPorFaixaNoMomento(subitem, 'Negociado', dadosAtualizados.tabela_versao, divisorPrecoCatalogoLinha(subitem, 'Negociado', dadosAtualizados.moeda, dadosAtualizados.cambio));
                aplicarPrecificacaoPorFaixaNoMomento(subitem, 'Fechamento', dadosAtualizados.tabela_versao, divisorPrecoCatalogoLinha(subitem, 'Fechamento', dadosAtualizados.moeda, dadosAtualizados.cambio));

                const quantidadePreEvento = virgulaPonto(subitem.quantidadePreEvento) || 0;
                const valorUnitarioPreEvento = virgulaPonto(subitem.valorUnitarioPreEvento) || 0;
                const diariaPreEvento = virgulaPonto(subitem.diariaPreEvento) || 0;
                const servicoPreEvento = virgulaPonto(subitem.servicoPreEvento) || 0;

                const quantidadeNegociado = virgulaPonto(subitem.quantidadeNegociado) || 0;
                const valorUnitarioNegociado = virgulaPonto(subitem.valorUnitarioNegociado) || 0;
                const diariaNegociado = virgulaPonto(subitem.diariaNegociado) || 0;
                const servicoNegociado = virgulaPonto(subitem.servicoNegociado) || 0;

                const quantidadeFechamento = virgulaPonto(subitem.quantidadeFechamento) || 0;
                const valorUnitarioFechamento = virgulaPonto(subitem.valorUnitarioFechamento) || 0;
                const diariaFechamento = virgulaPonto(subitem.diariaFechamento) || 0;
                const servicoFechamento = virgulaPonto(subitem.servicoFechamento) || 0;

                let totalPreEvento = calcularTotalMomentoSubitem(subitem, 'PreEvento');
                let totalNegociado = calcularTotalMomentoSubitem(subitem, 'Negociado');
                let totalFechamento = calcularTotalMomentoSubitem(subitem, 'Fechamento');
                // Regra 4 (R$ exato): FEE R$ = % × base R$ (2 casas); na moeda do orçamento = FEE R$ ÷ câmbio.
                if (brlExato && !temCambioProprio(subitem) && linhaDeFeeBrl(subitem)) {
                    totalPreEvento = moedaOrcamentoDeBrl(valorBrlLinha(subitem, 'PreEvento', cambioBrlExato, { exato: true }), cambioBrlExato);
                    totalNegociado = moedaOrcamentoDeBrl(valorBrlLinha(subitem, 'Negociado', cambioBrlExato, { exato: true }), cambioBrlExato);
                    totalFechamento = moedaOrcamentoDeBrl(valorBrlLinha(subitem, 'Fechamento', cambioBrlExato, { exato: true }), cambioBrlExato);
                }

                // Subtotal do grupo na moeda do orçamento (linha de moeda própria × fator; legado × 1).
                // Opção (D-0113): fora do subtotal do grupo.
                if (!ehSomenteVisualizacao(subitem)) {
                    item.valorTotalPreEvento += totalPreEvento * fatorAnotado(subitem, 'pre_evento');
                    item.valorTotalNegociado += totalNegociado * fatorAnotado(subitem, 'negociado');
                    item.valorTotalFechamento += totalFechamento * fatorAnotado(subitem, 'fechamento');
                }

                dadosAtualizados.orcamentoitem[indexItem].subitem[indexSubitem].totalPreEvento = totalPreEvento.toFixed(2);
                dadosAtualizados.orcamentoitem[indexItem].subitem[indexSubitem].totalNegociado = totalNegociado.toFixed(2);
                dadosAtualizados.orcamentoitem[indexItem].subitem[indexSubitem].totalFechamento = totalFechamento.toFixed(2);
                sincronizarValorRealComFechamentoSeND(dadosAtualizados.orcamentoitem[indexItem].subitem[indexSubitem]);
            });

            if (aplicaImpostoNfAccess && !ChiesiAgenciaImpostoPolicy.resolver(item, isClienteChiesi(clienteContexto))) {
                // Fórmula única (colunaVigentePolicy.impostoNfAccessGrupoPorEtapa, espelho da API): base =
                // linhas marcadas, sem 1945, sem % Imposto NF próprio e sem pagamento no exterior, cada uma
                // na moeda do orçamento pelo fator da moeda dela (câmbio da linha ÷ câmbio global).
                const nfGrupo = impostoNfAccessGrupoPorEtapa(item, {
                    aplicaImposto: aplicaImpostoNfAccess,
                    clienteEhChiesi: isClienteChiesi(clienteContexto),
                    fornecedorAccess: fornecedorAccessContexto,
                    cambio: cambioGlobalOrcamento(dadosAtualizados),
                });
                const impostoPlanilhaPreEventoGrupo = nfGrupo.preEvento;
                const impostoPlanilhaNegociadoGrupo = nfGrupo.negociado;
                const impostoPlanilhaFechamentoGrupo = nfGrupo.fechamento;

                item.valorTotalPreEvento += impostoPlanilhaPreEventoGrupo;
                item.valorTotalNegociado += impostoPlanilhaNegociadoGrupo;
                item.valorTotalFechamento += impostoPlanilhaFechamentoGrupo;

                item.impostoPlanilhaPreEvento = impostoPlanilhaPreEventoGrupo.toFixed(2);
                item.impostoPlanilhaNegociado = impostoPlanilhaNegociadoGrupo.toFixed(2);
                item.impostoPlanilhaFechamento = impostoPlanilhaFechamentoGrupo.toFixed(2);
            }

            if (brlExato) {
                // Regra 3 (R$ exato): subtotal do grupo = Σ R$ das linhas + NF Access em R$; na moeda do
                // orçamento = R$ ÷ câmbio, arredondado uma vez (nunca a soma dos valores na moeda).
                const brlGrupo = valoresBrlGrupoPorEtapa(item, {
                    cambio: cambioBrlExato, exato: true, aplicaImposto: aplicaImpostoNfAccess,
                    clienteEhChiesi: isClienteChiesi(clienteContexto), fornecedorAccess: fornecedorAccessContexto,
                });
                item.valorTotalPreEvento = moedaOrcamentoDeBrl(brlGrupo.preEvento, cambioBrlExato);
                item.valorTotalNegociado = moedaOrcamentoDeBrl(brlGrupo.negociado, cambioBrlExato);
                item.valorTotalFechamento = moedaOrcamentoDeBrl(brlGrupo.fechamento, cambioBrlExato);
                if (aplicaImpostoNfAccess && !ChiesiAgenciaImpostoPolicy.resolver(item, isClienteChiesi(clienteContexto))) {
                    item.impostoPlanilhaPreEvento = moedaOrcamentoDeBrl(brlGrupo.nf.preEvento, cambioBrlExato).toFixed(2);
                    item.impostoPlanilhaNegociado = moedaOrcamentoDeBrl(brlGrupo.nf.negociado, cambioBrlExato).toFixed(2);
                    item.impostoPlanilhaFechamento = moedaOrcamentoDeBrl(brlGrupo.nf.fechamento, cambioBrlExato).toFixed(2);
                }
                totalBrlExato.preEvento += brlGrupo.preEvento;
                totalBrlExato.negociado += brlGrupo.negociado;
                totalBrlExato.fechamento += brlGrupo.fechamento;
            }

            console.log(`Item ${indexItem} Total PreEvento: ${item.valorTotalPreEvento}`);

            valorTotalFinalPreEvento += item.valorTotalPreEvento;
            valorTotalFinalNegociado += item.valorTotalNegociado;
            valorTotalFinalFechamento += item.valorTotalFechamento;

            dadosAtualizados.orcamentoitem[indexItem].valorTotalPreEvento = item.valorTotalPreEvento.toFixed(2);
            dadosAtualizados.orcamentoitem[indexItem].valorTotalNegociado = item.valorTotalNegociado.toFixed(2);
            dadosAtualizados.orcamentoitem[indexItem].valorTotalFechamento = item.valorTotalFechamento.toFixed(2);
        });

        dadosAtualizados.impostoPlanilhaPreEvento = (dadosAtualizados.orcamentoitem || [])
            .reduce((total, item) => total + (virgulaPonto(item?.impostoPlanilhaPreEvento) || 0), 0)
            .toFixed(2);
        dadosAtualizados.impostoPlanilhaNegociado = (dadosAtualizados.orcamentoitem || [])
            .reduce((total, item) => total + (virgulaPonto(item?.impostoPlanilhaNegociado) || 0), 0)
            .toFixed(2);
        dadosAtualizados.impostoPlanilhaFechamento = (dadosAtualizados.orcamentoitem || [])
            .reduce((total, item) => total + (virgulaPonto(item?.impostoPlanilhaFechamento) || 0), 0)
            .toFixed(2);

        console.log(`TOTAL GERAL PreEvento: ${valorTotalFinalPreEvento}`);

        calculaPreenchimento(dadosAtualizados);

        if (brlExato) {
            // Total do orçamento na moeda = Σ R$ dos grupos ÷ câmbio, arredondado uma vez (regra 3).
            valorTotalFinalPreEvento = moedaOrcamentoDeBrl(totalBrlExato.preEvento, cambioBrlExato);
            valorTotalFinalNegociado = moedaOrcamentoDeBrl(totalBrlExato.negociado, cambioBrlExato);
            valorTotalFinalFechamento = moedaOrcamentoDeBrl(totalBrlExato.fechamento, cambioBrlExato);
        }
        dadosAtualizados.valorTotalPreEvento = valorTotalFinalPreEvento.toFixed(2);
        dadosAtualizados.valorTotalNegociado = valorTotalFinalNegociado.toFixed(2);
        dadosAtualizados.valorTotalFechamento = valorTotalFinalFechamento.toFixed(2);
        setValorTotalPreEvento(dadosAtualizados.valorTotalPreEvento);
        setValorTotalNegociado(dadosAtualizados.valorTotalNegociado);
        setValorTotalFechamento(dadosAtualizados.valorTotalFechamento);
        const dadosComRealizado = decorarPreviewFechamentoExterior(dadosAtualizados, { feeRules: feeRulesContexto, fornecedorAccess: fornecedorAccessContexto, eventoNacionalidade: nacionalidadeContexto, faixasVersao: faixasVersaoContexto, paxEvento: paxEventoContexto, miniMeeting: miniMeetingContexto });
        setDados(dadosComRealizado);
        console.log('RETORNANDO DADOS ATUALIZADOS:', dadosAtualizados.valorTotalPreEvento);

        return dadosComRealizado;
    }//calculaTotalOrcamento

    const calculaPreenchimento = (dados) => {
        //verifica status de preenchimento para mostrar no cabeçalho
        dados.orcamentoitem.forEach(function (valor, indexSuperior) {
            dados.orcamentoitem[indexSuperior]["statuspreenchimento"] = "embranco";
            dados.orcamentoitem[indexSuperior].subitem.forEach(function (valor, indexInferior) {
                var subitem = dados.orcamentoitem[indexSuperior].subitem[indexInferior];
                if ((subitem.totalPreEvento > 0) || (subitem.totalNegociado > 0) || (subitem.totalFechamento > 0)) {
                    dados.orcamentoitem[indexSuperior]["statuspreenchimento"] = "preenchendo";
                }
                if ((subitem.totalPreEvento > 0) && (subitem.totalNegociado > 0) && (subitem.totalFechamento > 0)) {
                    dados.orcamentoitem[indexSuperior]["statuspreenchimento"] = "completo";
                }
            });
        });//verifica status preenchimento
    }//calculaPreenchimento

    // ====== Estornos do subitem (Épico 1 financeiro) ======
    const abrirModalEstornos = (subitem, indexSuperior, indexInferior) => {
        if (!subitem?.id) {
            toast.info('Salve o orçamento antes de registrar estornos neste item.');
            return;
        }
        setSubitemEstornoAtual({
            id: subitem.id,
            indexSuperior,
            indexInferior,
            descricao: subitem.codigoFornecedor || subitem.nomeProduto || ('Item #' + (indexInferior + 1)),
        });
        setNovoEstorno({
            valor: '',
            data_estorno: moment().format('YYYY-MM-DD'),
            justificativa: '',
            tipo: 'duplicidade',
        });
        carregarEstornos(subitem.id);
        setShowModalEstornos(true);
    };

    const fecharModalEstornos = () => {
        setShowModalEstornos(false);
        setSubitemEstornoAtual(null);
        setEstornosCarregados([]);
    };

    const carregarEstornos = (idSubitem) => {
        setCarregandoEstornos(true);
        api({
            method: 'get',
            action: '/orcamentoItem/' + idSubitem + '/estornos',
            token: token,
        }).then((response) => {
            setEstornosCarregados(response.data?.data ?? []);
        }).catch(() => {
            setEstornosCarregados([]);
        }).finally(() => {
            setCarregandoEstornos(false);
        });
    };

    const salvarEstorno = () => {
        if (!subitemEstornoAtual?.id) return;
        const valor = paraNumero(novoEstorno.valor ?? '0');
        if (!valor || valor <= 0) {
            toast.error('Informe um valor de estorno maior que zero.');
            return;
        }
        if (!String(novoEstorno.justificativa ?? '').trim()) {
            toast.error('Informe a justificativa do estorno.');
            return;
        }

        api({
            method: 'post',
            action: '/orcamentoItem/' + subitemEstornoAtual.id + '/estornos',
            token: token,
            data: {
                valor,
                data_estorno: novoEstorno.data_estorno,
                justificativa: novoEstorno.justificativa,
                tipo: novoEstorno.tipo,
            },
        }).then(() => {
            toast.success('✅ Estorno registrado.');
            setNovoEstorno({ valor: '', data_estorno: moment().format('YYYY-MM-DD'), justificativa: '', tipo: 'duplicidade' });
            carregarEstornos(subitemEstornoAtual.id);
        }).catch(() => toast.error('❌ Falha ao registrar estorno.'));
    };

    const removerEstorno = (estornoId) => {
        if (!window.confirm('Remover este registro de estorno? Esta ação não pode ser desfeita.')) return;
        api({
            method: 'delete',
            action: '/orcamentoItemEstorno/' + estornoId,
            token: token,
        }).then(() => {
            toast.success('✅ Estorno removido.');
            if (subitemEstornoAtual?.id) carregarEstornos(subitemEstornoAtual.id);
        }).catch(() => toast.error('❌ Falha ao remover estorno.'));
    };

    const totalEstornado = (estornosCarregados || []).reduce((sum, e) => sum + (parseFloat(e.valor) || 0), 0);

    // ====== Vínculo Aéreo (Épico 1 financeiro) ======
    const abrirModalAereo = (subitem, indexSuperior, indexInferior) => {
        const idEvento = dados?.evento?.id ?? dados?.evento;
        if (!idEvento) {
            toast.info('Salve o orçamento associado a um evento antes de vincular aéreos.');
            return;
        }
        setSubitemAereoAtual({
            indexSuperior,
            indexInferior,
            descricao: subitem.codigoFornecedor || subitem.nomeProduto || ('Item #' + (indexInferior + 1)),
            currentAereoId: subitem.evento_aereo_id ?? null,
        });
        carregarAereosDoEvento(idEvento);
        setShowModalAereo(true);
    };

    const fecharModalAereo = () => {
        setShowModalAereo(false);
        setSubitemAereoAtual(null);
        setAereosDoEvento([]);
    };

    const carregarAereosDoEvento = (idEvento) => {
        setCarregandoAereos(true);
        api({
            method: 'get',
            action: '/eventoAereo',
            token: token,
            params: { evento: idEvento },
        }).then((response) => {
            // EventoAereoController::index retorna { data: { participante, evento, opcoes: [...] } }
            // (não um array direto — formato específico desse endpoint)
            const payload = response.data?.data;
            const lista = Array.isArray(payload?.opcoes)
                ? payload.opcoes
                : (Array.isArray(payload) ? payload : []);
            setAereosDoEvento(lista);
        }).catch(() => setAereosDoEvento([]))
          .finally(() => setCarregandoAereos(false));
    };

    const selecionarAereoParaSubitem = (aereo) => {
        if (!subitemAereoAtual) return;
        const { indexSuperior, indexInferior } = subitemAereoAtual;
        const dadosAtualizados = JSON.parse(JSON.stringify(dados));
        dadosAtualizados.orcamentoitem[indexSuperior].subitem[indexInferior].evento_aereo_id = aereo.id;
        dadosAtualizados.orcamentoitem[indexSuperior].subitem[indexInferior].evento_aereo_label = montarLabelAereo(aereo);
        setDados(dadosAtualizados);
        toast.success('✅ Aéreo vinculado. Salve o orçamento para confirmar.');
        fecharModalAereo();
    };

    const desvincularAereoDoSubitem = () => {
        if (!subitemAereoAtual) return;
        const { indexSuperior, indexInferior } = subitemAereoAtual;
        const dadosAtualizados = JSON.parse(JSON.stringify(dados));
        dadosAtualizados.orcamentoitem[indexSuperior].subitem[indexInferior].evento_aereo_id = null;
        dadosAtualizados.orcamentoitem[indexSuperior].subitem[indexInferior].evento_aereo_label = null;
        setDados(dadosAtualizados);
        toast.success('✅ Vínculo removido. Salve o orçamento.');
        fecharModalAereo();
    };

    const montarLabelAereo = (aereo) => {
        const partes = [];
        if (aereo.codigo) partes.push(aereo.codigo);
        if (aereo.idaorigem || aereo.idadestino) {
            partes.push((aereo.idaorigem ?? '?') + '→' + (aereo.idadestino ?? '?'));
        }
        if (aereo.idadata) partes.push(moment(aereo.idadata).format('DD/MM'));
        return partes.length > 0 ? partes.join(' · ') : ('Aéreo #' + aereo.id);
    };

    // ====== Épico 2 — Adiantamento por item (recibo distribuído) ======

    const abrirModalAdiantamento = (subitem, indexSuperior, indexInferior) => {
        if (!subitem?.id) {
            toast.info('Salve o orçamento antes de vincular adiantamentos a este item.');
            return;
        }
        const totalFech = parseFloat(subitem.totalFechamento ?? subitem.totalNegociado ?? 0) || 0;
        setSubitemAdiantamentoAtual({
            id: subitem.id,
            indexSuperior,
            indexInferior,
            descricao: subitem.codigoFornecedor || subitem.nomeProduto || ('Item #' + (indexInferior + 1)),
            valorTotal: totalFech,
        });
        setNovaDistribuicao({ orcamento_recibo_adiantamento_id: '', valor: '', observacao: '' });
        carregarDistribuicoesERecibos(subitem.id);
        carregarNfsDoItem(subitem.id); // Épico 2.1 — conciliação
        setShowModalAdiantamento(true);
    };

    const fecharModalAdiantamento = () => {
        setShowModalAdiantamento(false);
        setSubitemAdiantamentoAtual(null);
        setDistribuicoesItem([]);
        setRecibosDisponiveis([]);
        setNfsDoItem([]);
    };

    const carregarDistribuicoesERecibos = (idItem) => {
        setCarregandoAdiantamento(true);
        const idOrcamento = dados.id;
        Promise.all([
            api({ method: 'get', action: '/orcamentoItem/' + idItem + '/distribuicoesRecibo', token: token }),
            idOrcamento
                ? api({ method: 'get', action: '/orcamento/' + idOrcamento + '/recibosDisponiveis', token: token })
                : Promise.resolve({ data: { data: [] } }),
        ]).then(([respDistr, respRecibos]) => {
            setDistribuicoesItem(respDistr.data?.data ?? []);
            setRecibosDisponiveis(respRecibos.data?.data ?? []);
        }).catch(() => {
            setDistribuicoesItem([]);
            setRecibosDisponiveis([]);
        }).finally(() => setCarregandoAdiantamento(false));
    };

    // Épico 2.1 — Carrega NFs vinculadas ao item (conciliação adiantamento × NF)
    const carregarNfsDoItem = (idItem) => {
        setCarregandoNfsItem(true);
        setNfsDoItem([]);
        api({ method: 'get', action: '/orcamentoItem/' + idItem + '/notasFiscais', token: token })
            .then((resp) => setNfsDoItem(resp.data?.data ?? []))
            .catch(() => setNfsDoItem([]))
            .finally(() => setCarregandoNfsItem(false));
    };

    // ── Épico 2 — Modal Forma de Pagamento do adiantamento ─────────────────
    const abrirModalFormaPgto = (subitem, indexSuperior, indexInferior) => {
        setSubitemFormaPgtoAtual({ id: subitem.id, indexSuperior, indexInferior, descricao: subitem.codigoFornecedor || ('Item #' + (indexInferior + 1)) });
        // Carrega dado existente (se já foi salvo)
        const cache = formaPgtosPorItem[subitem.id];
        if (cache) {
            setFormaPgtoAtual({ forma: cache.forma || '', dados_pagamento: cache.dados_pagamento || {}, observacao: cache.observacao || '' });
        } else {
            setFormaPgtoAtual({ forma: '', dados_pagamento: {}, observacao: '' });
            setCarregandoFormaPgto(true);
            api({ method: 'get', action: '/orcamentoItem/' + subitem.id + '/adiantamentoPagamento', token: token })
                .then((resp) => {
                    const d = resp.data?.data;
                    if (d) {
                        setFormaPgtoAtual({ forma: d.forma || '', dados_pagamento: d.dados_pagamento || {}, observacao: d.observacao || '' });
                        setFormaPgtosPorItem((prev) => ({ ...prev, [subitem.id]: d }));
                    }
                })
                .catch(() => {})
                .finally(() => setCarregandoFormaPgto(false));
        }
        setShowModalFormaPgto(true);
    };

    const fecharModalFormaPgto = () => {
        setShowModalFormaPgto(false);
        setSubitemFormaPgtoAtual(null);
    };

    const salvarFormaPgto = () => {
        if (!subitemFormaPgtoAtual?.id || !formaPgtoAtual.forma) {
            toast.error('Selecione uma forma de pagamento.');
            return;
        }
        setSalvandoFormaPgto(true);
        api({
            method: 'post',
            action: '/orcamentoItem/' + subitemFormaPgtoAtual.id + '/adiantamentoPagamento',
            token: token,
            data: formaPgtoAtual,
        }).then((resp) => {
            const d = resp.data?.data;
            if (d) {
                setFormaPgtosPorItem((prev) => ({ ...prev, [subitemFormaPgtoAtual.id]: d }));
            }
            toast.success('✅ Forma de pagamento salva.');
            fecharModalFormaPgto();
        }).catch(() => toast.error('Erro ao salvar forma de pagamento.'))
          .finally(() => setSalvandoFormaPgto(false));
    };

    const removerFormaPgto = () => {
        if (!subitemFormaPgtoAtual?.id) return;
        if (!window.confirm('Remover forma de pagamento deste item?')) return;
        api({ method: 'delete', action: '/orcamentoItem/' + subitemFormaPgtoAtual.id + '/adiantamentoPagamento', token: token })
            .then(() => {
                setFormaPgtosPorItem((prev) => { const n = { ...prev }; delete n[subitemFormaPgtoAtual.id]; return n; });
                setFormaPgtoAtual({ forma: '', dados_pagamento: {}, observacao: '' });
                toast.success('Forma de pagamento removida.');
                fecharModalFormaPgto();
            }).catch(() => toast.error('Erro ao remover.'));
    };

    const labelFormaPgto = (forma) => {
        const map = {
            pix: 'PIX', cartao_credito: 'Cartão Crédito', cartao_debito: 'Cartão Débito',
            boleto: 'Boleto', fatura: 'Fatura', remessa: 'Remessa', link: 'Link',
        };
        return map[forma] || forma;
    };

    // ── Forma de Pagamento do Item (pagamento regular — NÃO é adiantamento) ────────────────
    const abrirModalFormaPgtoPagamento = (subitem) => {
        const cache = formaPgtoPagamentoPorItem[subitem.id];
        if (cache) {
            setFormaPgtoPagamentoAtual({ forma: cache.forma || '', dados_pagamento: cache.dados_pagamento || {}, observacao: cache.observacao || '' });
        } else {
            setFormaPgtoPagamentoAtual({ forma: '', dados_pagamento: {}, observacao: '' });
        }
        setSubitemFormaPgtoPagamentoAtual(subitem);
        setShowModalFormaPgtoPagamento(true);
    };

    const fecharModalFormaPgtoPagamento = () => {
        setShowModalFormaPgtoPagamento(false);
        setSubitemFormaPgtoPagamentoAtual(null);
        setFormaPgtoPagamentoAtual({ forma: '', dados_pagamento: {}, observacao: '' });
    };

    const salvarFormaPgtoPagamento = () => {
        if (!formaPgtoPagamentoAtual.forma) { toast.error('Selecione uma forma de pagamento'); return; }
        // TODO: persistir via endpoint /orcamentoItem/{id}/pagamento quando backend estiver pronto
        setSalvandoFormaPgtoPagamento(true);
        setFormaPgtoPagamentoPorItem((prev) => ({ ...prev, [subitemFormaPgtoPagamentoAtual.id]: { ...formaPgtoPagamentoAtual } }));
        toast.success('Forma de pagamento salva!');
        setSalvandoFormaPgtoPagamento(false);
        fecharModalFormaPgtoPagamento();
    };

    const removerFormaPgtoPagamento = () => {
        if (!window.confirm('Remover a forma de pagamento deste item?')) return;
        setFormaPgtoPagamentoPorItem((prev) => { const n = { ...prev }; delete n[subitemFormaPgtoPagamentoAtual.id]; return n; });
        toast.success('Forma de pagamento removida');
        fecharModalFormaPgtoPagamento();
    };

    const salvarDistribuicao = () => {
        if (!subitemAdiantamentoAtual?.id) return;
        const idRecibo = novaDistribuicao.orcamento_recibo_adiantamento_id;
        const valor = paraNumero(novaDistribuicao.valor ?? '0');
        if (!idRecibo) {
            toast.error('Selecione um recibo do orçamento.');
            return;
        }
        if (!valor || valor <= 0) {
            toast.error('Informe um valor maior que zero.');
            return;
        }

        // Quick Win 2.3 — validação de overflow no front
        const reciboSel = recibosDisponiveis.find((r) => String(r.id) === String(idRecibo));
        if (reciboSel && valor > reciboSel.saldo_disponivel + 0.001) {
            toast.error(`❌ Valor R$ ${valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 })} excede o saldo do recibo (R$ ${reciboSel.saldo_disponivel.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}).`);
            return;
        }

        api({
            method: 'post',
            action: '/orcamentoItem/' + subitemAdiantamentoAtual.id + '/distribuicoesRecibo',
            token: token,
            data: {
                orcamento_recibo_adiantamento_id: idRecibo,
                valor,
                observacao: novaDistribuicao.observacao,
            },
        }).then((resp) => {
            toast.success('✅ Adiantamento vinculado.');
            setNovaDistribuicao({ orcamento_recibo_adiantamento_id: '', valor: '', observacao: '' });
            carregarDistribuicoesERecibos(subitemAdiantamentoAtual.id);
            // Sincroniza valor_adiantamento_item no estado local com o valor calculado pelo backend
            const novoTotal = parseFloat(resp?.data?.data?.novo_total_item);
            if (!isNaN(novoTotal)) {
                aplicarNovoTotalAdiantamentoItem(subitemAdiantamentoAtual, novoTotal);
            }
        }).catch((err) => {
            const msg = err?.response?.data?.data?.erro ?? 'Falha ao vincular adiantamento.';
            toast.error('❌ ' + msg);
        });
    };

    const removerDistribuicao = (idDistribuicao) => {
        if (!window.confirm('Remover esta distribuição de adiantamento?')) return;
        api({
            method: 'delete',
            action: '/orcamentoReciboDistribuicao/' + idDistribuicao,
            token: token,
        }).then((resp) => {
            toast.success('✅ Distribuição removida.');
            if (subitemAdiantamentoAtual?.id) {
                carregarDistribuicoesERecibos(subitemAdiantamentoAtual.id);
                const novoTotal = parseFloat(resp?.data?.data?.novo_total_item);
                if (!isNaN(novoTotal)) {
                    aplicarNovoTotalAdiantamentoItem(subitemAdiantamentoAtual, novoTotal);
                }
            }
        }).catch(() => toast.error('❌ Falha ao remover.'));
    };

    /**
     * Aplica um novo total de adiantamento do item no estado local.
     * Valor já vem calculado pelo backend (mais confiável que somar no front).
     * Usa funcional state + path-check + try/catch para nunca crashar.
     */
    const aplicarNovoTotalAdiantamentoItem = (subitemRef, novoTotal) => {
        if (!subitemRef) return;
        const indexSuperior = subitemRef.indexSuperior;
        const indexInferior = subitemRef.indexInferior;
        if (indexSuperior == null || indexInferior == null) return;

        setDados((prev) => {
            if (!prev || !Array.isArray(prev.orcamentoitem)) return prev;
            if (!prev.orcamentoitem[indexSuperior]) return prev;
            if (!Array.isArray(prev.orcamentoitem[indexSuperior].subitem)) return prev;
            if (!prev.orcamentoitem[indexSuperior].subitem[indexInferior]) return prev;

            try {
                const novos = JSON.parse(JSON.stringify(prev));
                novos.orcamentoitem[indexSuperior].subitem[indexInferior].valor_adiantamento_item = novoTotal;
                return novos;
            } catch (e) {
                console.warn('Falha ao aplicar novo total de adiantamento no estado:', e);
                return prev;
            }
        });
    };

    /**
     * @deprecated Usar `aplicarNovoTotalAdiantamentoItem` com o valor retornado pelo backend.
     * Mantido para compatibilidade caso o endpoint não retorne `novo_total_item`.
     */
    const atualizarValorAdiantamentoItemNoEstado = (subitemRef) => {
        if (!subitemRef?.id) return;
        api({
            method: 'get',
            action: '/orcamentoItem/' + subitemRef.id + '/distribuicoesRecibo',
            token: token,
        }).then((resp) => {
            try {
                const lista = Array.isArray(resp.data?.data) ? resp.data.data : [];
                const totalAdiantado = lista.reduce(
                    (sum, d) => sum + (parseFloat(d && d.valor) || 0),
                    0,
                );
                const indexSuperior = subitemRef.indexSuperior;
                const indexInferior = subitemRef.indexInferior;
                if (indexSuperior == null || indexInferior == null) return;

                setDados((prev) => {
                    // Validação defensiva: caminho precisa existir
                    if (!prev || !Array.isArray(prev.orcamentoitem)) return prev;
                    if (!prev.orcamentoitem[indexSuperior]) return prev;
                    if (!Array.isArray(prev.orcamentoitem[indexSuperior].subitem)) return prev;
                    if (!prev.orcamentoitem[indexSuperior].subitem[indexInferior]) return prev;

                    try {
                        const novos = JSON.parse(JSON.stringify(prev));
                        novos.orcamentoitem[indexSuperior].subitem[indexInferior].valor_adiantamento_item = totalAdiantado;
                        return novos;
                    } catch (e) {
                        // Se deep copy falhar (state muito grande, circular ref, etc.), não atualiza
                        console.warn('Falha ao atualizar valor_adiantamento_item no estado:', e);
                        return prev;
                    }
                });
            } catch (e) {
                console.warn('Erro inesperado em atualizarValorAdiantamentoItemNoEstado:', e);
            }
        }).catch(() => {});
    };

    const totalDistribuicoesItem = (distribuicoesItem || []).reduce((sum, d) => sum + (parseFloat(d.valor) || 0), 0);

    // ====== Épico 1 Fase 4 — Análise de pendências para travas de negócio ======

    /**
     * Parse robusto de valor monetário aceitando 3 formatos:
     *  - Número JS: 100, 100.5, 100.00
     *  - String BR: "100,00", "1.234,56"
     *  - String regular: "100", "100.50"
     *
     * Bug anterior: `String(100.5).replace(/\./g, '')` retornava "1005",
     * inflando valores quando o backend devolvia float com decimal.
     */
    const parseValorBrFlexivel = (valor) => {
        if (valor === null || valor === undefined || valor === '') return 0;
        if (typeof valor === 'number') return isNaN(valor) ? 0 : valor;
        const str = String(valor).trim();
        if (str === '') return 0;
        // Formato BR (com vírgula como decimal): remove pontos de milhar, troca vírgula por ponto
        if (str.includes(',')) {
            return parseFloat(str.replace(/\./g, '').replace(',', '.')) || 0;
        }
        // Sem vírgula: parseFloat já trata "100" e "100.50" corretamente
        return parseFloat(str) || 0;
    };

    // ND/NF e o arquivo da NF vivem no Efetivo, por FORNECEDOR (OPF), desde 02/06/2026;
    // o `tipofaturamento` por item não é mais gravado por esta tela — só sobrevive em
    // linhas legadas (444 linhas em 98 orçamentos em 09/2026), e é por isso que o
    // contorno âmbar "NF sem arquivo" acendia em orçamento sem pendência nenhuma.
    // Mantido o gancho para pendências por linha futuras.
    const analisarPendenciasSubitem = () => [];

    const resumoPendenciasOrcamento = () => {
        let nfSemArquivo = 0;
        let nfSemRequisitante = 0;
        let totalAdiantamentoItens = 0;

        (dados.orcamentoitem ?? []).forEach((item) => {
            (item.subitem ?? []).forEach((sub) => {
                const pendencias = analisarPendenciasSubitem(sub);
                pendencias.forEach((p) => {
                    if (p.tipo === 'nf_sem_arquivo') nfSemArquivo++;
                    if (p.tipo === 'nf_sem_requisitante') nfSemRequisitante++;
                });
                totalAdiantamentoItens += parseValorBrFlexivel(sub.valor_adiantamento_item);
            });
        });

        const totalAdiantamentoOrcamento = parseValorBrFlexivel(dados.valorAdiantamento);
        const divergencia = Math.abs(totalAdiantamentoItens - totalAdiantamentoOrcamento);
        const temDivergenciaAdiantamento = totalAdiantamentoItens > 0
            && totalAdiantamentoOrcamento > 0
            && divergencia > 0.01;

        return {
            nfSemArquivo,
            nfSemRequisitante,
            totalAdiantamentoItens,
            totalAdiantamentoOrcamento,
            divergencia,
            temDivergenciaAdiantamento,
            temPendencias: nfSemArquivo > 0 || nfSemRequisitante > 0 || temDivergenciaAdiantamento,
        };
    };

    // Épico 2.F — Resumo financeiro de adiantamento (28/05/2026)
    const calcularResumoFinanceiro = () => {
        let totalOrcamento = 0;
        let totalDistribuido = 0;
        (dados.orcamentoitem ?? []).forEach((item) => {
            (item.subitem ?? []).forEach((sub) => {
                totalOrcamento += parseValorBrFlexivel(sub.totalFechamento);
                totalDistribuido += parseValorBrFlexivel(sub.valor_adiantamento_item);
            });
        });
        const aprovado = parseValorBrFlexivel(dados.valorAdiantamento);
        const saldo = aprovado - totalDistribuido;
        return { totalOrcamento, aprovado, totalDistribuido, saldo };
    };

    const carregarPosDoEvento = (idEvento) => {
        if (!idEvento) {
            setPosAprovadasDoEvento([]);
            return;
        }
        api({
            method: 'get',
            action: '/eventoPo',
            token: token,
            params: { evento: idEvento },
        }).then((response) => {
            const lista = Array.isArray(response.data?.data) ? response.data.data : [];
            // `aprovada` é string ('sim' / 'nao' / null) no banco — não confiar em bool
            const aprovadas = lista.filter((po) => {
                const flag = String(po.aprovada ?? '').toLowerCase();
                return flag === 'sim' || flag === '1' || flag === 'true';
            });
            setPosAprovadasDoEvento(aprovadas);
        }).catch(() => setPosAprovadasDoEvento([]));
    };

    const calculaSaldoAdiantamento = (valorAdiantamento, orcamentoitem) => {
        if (!orcamentoitem || !valorAdiantamento) return 0;

        const valorAdiantamentoNum = virgulaPonto(valorAdiantamento);
        let totalAntecipado = 0;

        orcamentoitem.forEach(item => {
            if (item.subitem) {
                item.subitem.forEach(subitem => {
                    if (subitem.tipopagamento === 'antecipado') {
                        // Soma o valor de fechamento do subitem que está marcado como antecipado
                        const valorSubitem = virgulaPonto(subitem.totalFechamento || 0);
                        totalAntecipado += valorSubitem;
                    }
                });
            }
        });

        return valorAdiantamentoNum - totalAntecipado;
    }//calculaSaldoAdiantamento

    const sincronizarProdutosOrcamentoComCatalogo = async (dadosBase = {}, clienteId = null) => {
        if (!dadosBase?.orcamentoitem || !Array.isArray(dadosBase.orcamentoitem)) {
            return dadosBase;
        }

        const idsProduto = [];
        dadosBase.orcamentoitem.forEach((item) => {
            const idSuperior = obterIdComparavel(item?.produto?.id);
            if (idSuperior) {
                idsProduto.push(idSuperior);
            }
            (item?.subitem || []).forEach((subitem) => {
                const idSubitem = obterIdComparavel(subitem?.produto?.id);
                if (idSubitem) {
                    idsProduto.push(idSubitem);
                }
            });
        });

        const idsUnicos = [...new Set(idsProduto)];
        if (idsUnicos.length === 0) {
            return dadosBase;
        }

        try {
            const response = await api({
                method: 'get',
                action: '/produto',
                token: token,
                params: {
                    modulo: 'servicoOrcamento',
                    cliente: clienteId || undefined,
                    ids: idsUnicos.join(','),
                }
            });

            const catalogo = response?.data?.data || [];
            const catalogoPorId = new Map(
                catalogo
                    .map((produto) => [obterIdComparavel(produto.id), produto])
                    .filter(([id]) => !!id)
            );

            dadosBase.orcamentoitem.forEach((item, indexItem) => {
                const idSuperior = obterIdComparavel(item?.produto?.id);
                const produtoSuperiorCatalogo = idSuperior ? catalogoPorId.get(idSuperior) : null;
                if (produtoSuperiorCatalogo) {
                    dadosBase.orcamentoitem[indexItem].produto = mesclarProdutoComCatalogo(item.produto, produtoSuperiorCatalogo);
                }

                (item?.subitem || []).forEach((subitem, indexSubitem) => {
                    const idSubitem = obterIdComparavel(subitem?.produto?.id);
                    const produtoCatalogo = idSubitem ? catalogoPorId.get(idSubitem) : null;
                    if (produtoCatalogo) {
                        dadosBase.orcamentoitem[indexItem].subitem[indexSubitem].produto = mesclarProdutoComCatalogo(subitem.produto, produtoCatalogo);
                    }
                });
            });
        } catch (error) {
            console.error('Erro ao sincronizar produtos do orçamento com catálogo atual:', error);
        }

        return dadosBase;
    };

    // Linha nova a partir de um produto do catálogo (itens permanentes da Agência e itens obrigatórios do grupo).
    const subitemDoCatalogo = (produto) => {
        const tipoPrecoProduto = (produto.tipoPreco ?? 'fixo').toString().toLowerCase();
        return {
            produto: {
                id: produto.id,
                nome: produto.nome,
                codigoFornecedor: produto.codigoFornecedor ?? null,
                somarTodosFee: produto.somarTodosFee ?? 'nao',
                tipoPreco: produto.tipoPreco ?? 'fixo',
                preco: produto.preco,
                superior: obterIdComparavel(produto.superior),
                atributo: obterIdComparavel(produto.atributo),
                feeBaseTipo: produto.feeBaseTipo ?? 'compoe_fee_global',
                feeBaseId: produto.feeBaseId ?? null,
                feeMomentoCalculo: produto.feeMomentoCalculo ?? 'todos',
                orcamentoConfig: produto.orcamento_config ?? produto.orcamentoConfig ?? null,
                precificacaoFaixas: normalizarFaixasPrecificacao(produto)
            },
            compoeFee: "nao",
            inserirCalculoTotalPlanilha: false,
            pagamento_exterior: null,
            tipopagamento: "normal",
            quantidade: produto.quantidade || "1",
            valorUnitarioPreEvento: tipoPrecoProduto !== 'percentual' ? (produto.preco || "") : "",
            servicoPreEvento: tipoPrecoProduto === 'percentual' ? (produto.preco || "") : "",
            servicoNegociado: tipoPrecoProduto === 'percentual' ? (produto.preco || "") : "",
            servicoFechamento: tipoPrecoProduto === 'percentual' ? (produto.preco || "") : "",
            chaveunica: rand18(),
            codigoFornecedor: produto.codigoFornecedor || null
        };
    };

    // 21/10: ART com Gerador / RRT com equipamento — cria no grupo a linha obrigatória que falta (mesmo
    // fornecedor da linha que disparou). Chamado ao escolher o item da linha e pelo "Incluir" do aviso.
    // 25/10 (D-0104): ART/RRT viraram sugestão (itens_sugeridos) — entram ao escolher o item, sem travar.
    const incluirItensObrigatorios = async (indexSuperior, indexInferior = null) => {
        const faltantes = linhasParaIncluir(dados?.orcamentoitem?.[indexSuperior], indexInferior);
        if (faltantes.length === 0) return;
        try {
            const resposta = await api({
                method: 'get',
                action: '/produto',
                token: token,
                params: {
                    modulo: 'servicoOrcamento',
                    situacaoRegistro: 'ativo',
                    cliente: dados.cliente?.id ?? undefined,
                    ids: faltantes.map((f) => f.regra.produto).join(','),
                }
            });
            const porId = new Map((resposta?.data?.data || []).map((p) => [obterIdComparavel(p.id), p]));
            setDados((prevDados) => {
                const grupo = prevDados?.orcamentoitem?.[indexSuperior];
                if (!grupo) return prevDados;
                const pendentes = linhasParaIncluir(grupo, indexInferior);
                if (pendentes.length === 0) return prevDados;
                const dadosAtualizados = { ...prevDados };
                const grupoAtualizado = dadosAtualizados.orcamentoitem[indexSuperior];
                grupoAtualizado.subitem = [...(grupoAtualizado.subitem || [])];
                pendentes.forEach(({ regra, gatilhoIndex }) => {
                    const produto = porId.get(obterIdComparavel(regra.produto));
                    if (!produto) return;
                    grupoAtualizado.subitem.push(completarLinhaObrigatoria(subitemDoCatalogo(produto), grupoAtualizado.subitem[gatilhoIndex]));
                });
                return calculaTotalOrcamento2(dadosAtualizados);
            });
        } catch (erro) {
            console.error('Itens obrigatórios do grupo:', erro);
            toast.error('Não foi possível incluir a linha automática do grupo (ART/RRT). Inclua pelo "+ Subitem".');
        }
    };

    // Função para adicionar automaticamente subitens permanentes
    const adicionarSubitensPermanentes = async (itemIndex, produtoId) => {
        const clienteId = dados.cliente?.id ?? null;
        if (!clienteId) {
            return;
        }

        const itemPrincipal = dados?.orcamentoitem?.[itemIndex];
        if (!isGrupoAgencia(itemPrincipal)) {
            return;
        }

        // Determina quais IDs de itens permanentes devem ser adicionados
        let idsParaAdicionar = [...(itensPermanentesIds || [])];

        // Se o evento for internacional, adiciona também os itens permanentes internacionais
        if (eventoEhInternacional && itensPermanentesInternacionaisIds && itensPermanentesInternacionaisIds.length > 0) {
            idsParaAdicionar = [...idsParaAdicionar, ...itensPermanentesInternacionaisIds];
        }

        if (idsParaAdicionar.length === 0) {
            return; // Não há itens permanentes configurados
        }

        // Busca todos os subitens do produto selecionado e filtra pelos permanentes
        try {
            const produtosResponse = await api({
                method: 'get',
                action: '/produto',
                token: token,
                params: {
                    situacaoRegistro: 'ativo',
                    modulo: 'servicoOrcamento',
                    cliente: clienteId,
                    superior: produtoId
                }
            });

            if (produtosResponse.data && produtosResponse.data.data) {
                // Filtra apenas os produtos que estão na lista de permanentes (nacionais ou internacionais)
                const produtosPermanentes = produtosResponse.data.data.filter(produto =>
                    idsParaAdicionar.includes(produto.id)
                );

                if (produtosPermanentes.length === 0) {
                    return; // Nenhum produto permanente encontrado para este item principal
                }

                // Atualiza os dados verificando e adicionando os subitens permanentes
                setDados(prevDados => {
                    const dadosAtualizados = { ...prevDados };
                    const item = dadosAtualizados.orcamentoitem[itemIndex];

                    if (!item.subitem) {
                        item.subitem = [];
                    }

                    // Verifica quais subitens permanentes já existem
                    const subitensExistentes = item.subitem
                        .filter(subitem => subitem.produto && subitem.produto.id)
                        .map(subitem => subitem.produto.id);

                    // Adiciona apenas os produtos permanentes que ainda não existem
                    produtosPermanentes.forEach(produto => {
                        if (!subitensExistentes.includes(produto.id)) {
                            item.subitem.push(subitemDoCatalogo(produto));
                        }
                    });

                    // Recalcula os totais
                    const dadosCalculados = calculaTotalOrcamento2(dadosAtualizados);
                    return dadosCalculados;
                });
            }
        } catch (error) {
            console.error('Erro ao buscar produtos permanentes:', error);
        }
    }//adicionarSubitensPermanentes

    const calculaTotalAntecipado = (orcamentoitem) => {
        if (!orcamentoitem) return 0;

        let totalAntecipado = 0;

        orcamentoitem.forEach(item => {
            if (item.subitem) {
                item.subitem.forEach(subitem => {
                    if (subitem.tipopagamento === 'antecipado') {
                        // Soma o valor de fechamento do subitem que está marcado como antecipado
                        const valorSubitem = virgulaPonto(subitem.totalFechamento || 0);
                        totalAntecipado += valorSubitem;
                    }
                });
            }
        });

        return totalAntecipado;
    }//calculaTotalAntecipado

    const copiarCamposEntreMomentos = (subitem, anterior, atual) => {
        var valorUnitario = virgulaPonto(subitem["valorUnitario" + anterior]);
        var diaria = virgulaPonto(subitem["diaria" + anterior]);
        var quantidade = virgulaPonto(subitem["quantidade" + anterior]);
        var servico = virgulaPonto(subitem["servico" + anterior]);

        // Campos base são copiados e os totais são sempre recalculados pelas regras
        subitem["valorUnitario" + atual] = valorUnitario;
        subitem["diaria" + atual] = diaria;
        subitem["quantidade" + atual] = quantidade;
        subitem["servico" + atual] = servico;
        // D-0157: o Copiar também leva o % Tributo fornecedor (só entre Pré-evento, Negociado e Fechamento).
        if (ETAPAS_TRIBUTO.includes(anterior) && ETAPAS_TRIBUTO.includes(atual)) {
            const tributo = subitem[campoTributo(anterior)];
            subitem[campoTributo(atual)] = tributo === undefined ? subitem.impostoPorcentagemItem : tributo;
        }
    };

    const copiaValores = (anterior, atual, indexSuperiorCopiar = null, showToast = true) => {
        // Cria deep copy dos dados para evitar mutação direta do estado
        const dadosAtualizados = JSON.parse(JSON.stringify(dados));

        dadosAtualizados.orcamentoitem.forEach(function (item, indexSuperior) {
            if (indexSuperiorCopiar !== null && indexSuperior !== indexSuperiorCopiar) {
                return;
            }

            item.subitem.forEach(function (subitem) {
                // Fechamento de ledger exterior concluído é definido pelo fechamento: reabra para editar.
                if (atual === 'Fechamento' && linhaFechamentoExteriorConcluido(subitem)) return;
                copiarCamposEntreMomentos(subitem, anterior, atual);
                // A faixa não troca o que acabou de ser copiado.
                marcarFaixaAplicada(subitem, atual, dadosAtualizados);
            });
        });

        // Recalcula para manter regras por cliente (fee/faixas) nas colunas copiadas
        calculaTotalOrcamento2(dadosAtualizados);

        // Feedback visual (apenas se solicitado)
        if (showToast) {
            toast.success('Valores copiados com sucesso!');
        }
    }//copiaValores

    const copiaValoresInferior = (anterior, atual, indexSuperiorCopiar, indexInferiorCopiar) => {
        // Cria deep copy dos dados para evitar mutação direta do estado
        const dadosAtualizados = JSON.parse(JSON.stringify(dados));

        const itemSuperior = dadosAtualizados.orcamentoitem[indexSuperiorCopiar];
        if (atual === 'Fechamento' && linhaFechamentoExteriorConcluido(itemSuperior?.subitem?.[indexInferiorCopiar])) {
            toast.info('Fechamento definido pelo fechamento exterior — reabra o fechamento para editar.');
            return;
        }
        if (itemSuperior && itemSuperior.subitem && itemSuperior.subitem[indexInferiorCopiar]) {
            copiarCamposEntreMomentos(itemSuperior.subitem[indexInferiorCopiar], anterior, atual);
            marcarFaixaAplicada(itemSuperior.subitem[indexInferiorCopiar], atual, dadosAtualizados);
        }

        // Recalcula para manter regras por cliente (fee/faixas) nas colunas copiadas
        calculaTotalOrcamento2(dadosAtualizados);

        // Feedback visual
        toast.success('Valores copiados com sucesso!');
    }//copiaValoresInferior

    const buscar = (contextoInicial = null) => {
        setIsLoading(true);
        if (id) {
            api({
                method: "get",
                action: '/orcamento/' + id,
                token: token,
            }).then(async response => {
                //extrai cliente do evento para ter acesso e restringir serviços
                var dadosCliente = response.data.data.evento?.cliente ?? null;
                // Preserva a nacionalidade do evento
                var nacionalidadeEvento = response.data.data.evento?.nacionalidade ?? null;
                setEventoNacionalidade(nacionalidadeEvento);
                setEventoConvidadosEsperados(convidadosEsperadosDoEvento(response.data.data.evento));
                setEventoTipo(response.data.data.evento?.tipo ?? null);
                setEventoTipoRealizacao(response.data.data.evento?.tipoRealizacao ?? null);
                //extrai dados internos para o array principal
                var dadosRecebidos = extract({
                    jsonLaravel: response.data.data,
                    chaves: ['evento']
                });

                //ao copiar nao repetir codigo/numero
                if (copiar) {
                    delete dadosRecebidos.codigo;
                    dadosRecebidos = limparFechamentoExteriorAoCopiar(dadosRecebidos);
                }

                //transforma data para javascript
                dadosRecebidos.data = data(dadosRecebidos.data);
                dadosRecebidos.cliente = dadosCliente; //extrai cliente para serviços terem acesso

                // Preserva o campo arquivoReciboAdiantamento do response original
                dadosRecebidos.arquivoReciboAdiantamento = response.data.data.arquivoReciboAdiantamento || null;

                // Inicializa campos de adiantamento se não existirem
                if (dadosRecebidos.valorAdiantamento === undefined) dadosRecebidos.valorAdiantamento = 0;
                if (dadosRecebidos.saldoAdiantamento === undefined) dadosRecebidos.saldoAdiantamento = 0;
                dadosRecebidos.moeda = (dadosRecebidos.moeda || 'real').toString().toLowerCase();
                const cambioRecebido = virgulaPonto(dadosRecebidos.cambio);
                dadosRecebidos.cambio = dadosRecebidos.moeda === 'real'
                    ? 1
                    : ((Number.isFinite(cambioRecebido) && cambioRecebido > 0) ? cambioRecebido : null);

                // Processa datas de pagamento dos subitens
                dadosRecebidos.orcamentoitem.forEach(function (item, index) {
                    item.subitem.forEach(function (subitem, indexsubitem) {
                        dadosRecebidos.orcamentoitem[index].subitem[indexsubitem].pagamentovencimento = data(dadosRecebidos.orcamentoitem[index].subitem[indexsubitem].pagamentovencimento);
                        // Moeda do fornecedor (27/09; 08/10 por etapa): câmbio próprio numérico (a API devolve "5.100000"); null = legado/herda.
                        ['cambioPreEvento', 'cambioNegociado', 'cambioFechamento'].forEach((campo) => {
                            const valorCambio = virgulaPonto(dadosRecebidos.orcamentoitem[index].subitem[indexsubitem][campo]);
                            dadosRecebidos.orcamentoitem[index].subitem[indexsubitem][campo] = Number.isFinite(valorCambio) && valorCambio > 0 ? valorCambio : null;
                        });
                        normalizarCampoCompoeFee(dadosRecebidos.orcamentoitem[index].subitem[indexsubitem]);
                        // D-0157: linha sem o % Tributo por etapa (gravada antes) recebe o antigo nas três.
                        completarTributosEtapa(dadosRecebidos.orcamentoitem[index].subitem[indexsubitem]);
                        atualizarPagamentoFormasSubitem(
                            dadosRecebidos.orcamentoitem[index].subitem[indexsubitem],
                            obterOpcoesPagamentoSelecionadasSubitem(dadosRecebidos.orcamentoitem[index].subitem[indexsubitem])
                        );

                        // Converte fornecedorpagamento de string para objeto (se for string)
                        const fornecPag = dadosRecebidos.orcamentoitem[index].subitem[indexsubitem].fornecedorpagamento;
                        if (fornecPag && typeof fornecPag === 'string') {
                            dadosRecebidos.orcamentoitem[index].subitem[indexsubitem].fornecedorpagamento = {
                                id: fornecPag,
                                nome: fornecPag === 'agencia' ? 'Agência' : fornecPag === 'cliente' ? 'Cliente' : fornecPag
                            };
                        }
                    });
                });

                dadosRecebidos = await sincronizarProdutosOrcamentoComCatalogo(dadosRecebidos, dadosCliente?.id ?? null);
                const regrasCliente = await carregarFeeRulesCliente(dadosCliente?.id ?? null);

                dadosRecebidos.orcamentoitem = Array.isArray(dadosRecebidos.orcamentoitem) ? dadosRecebidos.orcamentoitem : [];
                garantirEstruturaAgencia(dadosRecebidos.orcamentoitem, { incluirFeePadrao: !clienteEscolheFeeNoCatalogo(dadosCliente) });
                ordenarSubitensSanofiComFeeNoTopo(dadosRecebidos.orcamentoitem, dadosCliente);
                dadosRecebidos.orcamentoitem = ordenarGruposComAgenciaNoTopo(dadosRecebidos.orcamentoitem);
                calculaPreenchimento(dadosRecebidos);
                // D-0157: abrir o orçamento não reprecifica pela faixa o que está gravado.
                marcarFaixasDoGravado(dadosRecebidos);
                dados = dadosRecebidos;
                const dadosCalculados = calculaTotalOrcamento2(dadosRecebidos, { feeRules: regrasCliente });
                gruposGravados.current = contarGrupos(dadosCalculados.orcamentoitem);
                setDados(dadosCalculados);
                // Snapshot para detectar o que REALMENTE mudou nesta edição
                snapshotItens.current = montarSnapshotItens(dadosCalculados);
                fotoGravadoSubItem.current = fotografarGravado(dadosCalculados);

                // Carrega colunas adicionais de negociado se existirem
                if (dadosRecebidos.colunasNegociadoAdicionais) {
                    carregarJSON(dadosRecebidos.colunasNegociadoAdicionais);
                }
            }).catch(err => {
                console.error('Falha ao carregar orçamento:', String(err?.message ?? 'Erro desconhecido'),
                    'HTTP:', err?.response?.status ?? 'indisponível',
                    typeof err?.stack === 'string' ? err.stack : '');
            }).finally(() => { setIsLoading(false); setCarregouOrcamento(true); });
        } else {
            api({
                method: "get",
                action: '/orcamento/0',
                token: token,
            }).then(response => {
                var dadosRecebidos = response.data.data;
                const contextoEvento = contextoInicial || {};
                // Define a data como hoje para novos orçamentos
                dadosRecebidos.data = moment().format('DD/MM/YYYY');
                // Inicializa campos de adiantamento
                dadosRecebidos.valorAdiantamento = 0;
                dadosRecebidos.saldoAdiantamento = 0;
                dadosRecebidos.moeda = (dadosRecebidos.moeda || 'real').toString().toLowerCase();
                dadosRecebidos.cambio = dadosRecebidos.moeda === 'real'
                    ? 1
                    : ((virgulaPonto(dadosRecebidos.cambio) || 1));
                // Preserva os dados do evento que já foram carregados
                setDados(prevDados => {
                    const eventoSelecionado = contextoEvento.eventoId || prevDados.evento || dadosRecebidos.evento;
                    const nomeEventoSelecionado = contextoEvento.nomeEvento || prevDados.nomeEvento || dadosRecebidos.nomeEvento;
                    const clienteSelecionado = contextoEvento.cliente || prevDados.cliente || dadosRecebidos.cliente;
                    const novosDados = {
                        ...dadosRecebidos,
                        evento: eventoSelecionado,
                        nomeEvento: nomeEventoSelecionado,
                        cliente: clienteSelecionado
                    };
                    const incluirFeePadrao = !clienteEscolheFeeNoCatalogo(novosDados?.cliente ?? null);
                    // Novo orçamento deve iniciar com o grupo Agência. Para SANOFI, sem Fee fixo automático.
                    novosDados.orcamentoitem = [criarGrupoAgenciaPadrao(incluirFeePadrao)];
                    return calculaTotalOrcamento2(novosDados);
                });
            }).catch(err => {
                // console.log(err)
            }).finally(() => { setIsLoading(false); setCarregouOrcamento(true); });
        }
    }; //buscar

    // Rascunho não salvo (Rafael, 08/10): autosave no navegador + servidor, aviso ao sair e
    // oferta de restaurar ao voltar. Por usuário + evento + orçamento; some ao Salvar ou Descartar.
    const aplicarRascunhoOrcamento = (payload) => {
        const restaurado = aplicarRascunho(dados, payload);
        if (Array.isArray(restaurado.colunasNegociadoAdicionais)) {
            setColunasNegociadoAdicionais(restaurado.colunasNegociadoAdicionais);
        }
        calculaTotalOrcamento2(restaurado.dados, { feeRules: feeRulesCliente });
    };
    const rascunhoOrcamento = useRascunhoOrcamento({
        usuario,
        token,
        id,
        copiar,
        dados,
        colunasNegociadoAdicionais,
        // carga com falha (orçamento não veio) não confere rascunho
        carregado: carregouOrcamento && (!id || String(dados?.id ?? '') === String(id)),
        carregando: isLoading,
        aplicar: aplicarRascunhoOrcamento,
    });
    const temAvisoRascunho = !!(rascunhoOrcamento.sujo || rascunhoOrcamento.erroServidor);
    useEffect(() => { setAvisoRascunhoNoRodape(temAvisoRascunho); }, [temAvisoRascunho]);

    // Épico 12: versões de fee disponíveis (do cliente) e formatação das faixas
    const obterVersoesFee = () => [...new Set((feeRulesCliente || [])
        .map((r) => r?.versao)
        .filter((v) => v !== null && v !== undefined && String(v).trim() !== ''))];

    const formatarFaixaFee = (min, max) => {
        const m = Number(min || 0);
        const x = (max === null || max === undefined || max === '') ? null : Number(max);
        const fmt = (n) => 'R$ ' + pontoVirgula(n);
        if (m <= 0 && x === null) return 'sobre tudo';
        if (m <= 0 && x !== null) return 'até ' + fmt(x);
        if (m > 0 && x === null) return 'acima de ' + fmt(m);
        return 'de ' + fmt(m) + ' até ' + fmt(x);
    };

    // Épico 12: dados do modal de versão (esquerda = versões; direita = itens por categoria)
    const versoesTabela = () => [...new Set((tabelaValores || []).map((x) => x.versao))].filter(Boolean);
    const categoriasDaVersao = (v) => [...new Set((tabelaValores || [])
        .filter((x) => String(x.versao) === String(v)).map((x) => x.categoria))].filter(Boolean);
    const itensDaVersaoCategoria = (v, cat) => (tabelaValores || [])
        .filter((x) => String(x.versao) === String(v) && x.categoria === cat);
    const formatarValorItem = (it) => {
        if ((it?.tipoPreco || 'fixo') === 'percentual') {
            return String(Number(it?.valor ?? 0)).replace('.', ',') + '% — ' + formatarFaixaFee(it?.faixaMinTotal, it?.faixaMaxTotal);
        }
        return 'R$ ' + pontoVirgula(Number(it?.valor ?? 0));
    };
    const abrirModalFeeVersao = () => {
        setFeeVersaoSel(dados.fee_versao || '');
        carregarTabelaValores(clienteIdFeeRules);
        setShowModalFeeVersao(true);
    };

    // Épico 13 (Abbvie): seletor de período da tabela de valores (faixas por participantes)
    const feeAllerganGravado = AllerganFeePolicy.mantemFeeGravado({ cliente: dados.cliente, dataAprovacaoCliente: dados.dataAprovacaoCliente, id, copiar });
    const obterVersoesTabela = () => [...new Set((faixasVersao || [])
        .map((x) => x?.versao)
        .filter((v) => v !== null && v !== undefined && String(v).trim() !== ''))];
    const categoriasDaVersaoFaixa = (v) => [...new Set((faixasVersao || [])
        .filter((x) => String(x.versao) === String(v)).map((x) => x.categoria))].filter(Boolean);
    const itensDaVersaoFaixaCategoria = (v, cat) => (faixasVersao || [])
        .filter((x) => String(x.versao) === String(v) && x.categoria === cat);
    const formatarFaixaPax = (min, max) => {
        const m = Number(min || 0);
        const x = (max === null || max === undefined || max === '') ? null : Number(max);
        if (m <= 0 && x === null) return 'todas as faixas';
        if (m <= 0 && x !== null) return 'até ' + x + ' pax';
        if (m > 0 && x === null) return 'acima de ' + (m - 1) + ' pax';
        return m + ' a ' + x + ' pax';
    };
    const formatarValorFaixa = (it) => {
        const faixa = formatarFaixaPax(it?.faixaMin, it?.faixaMax);
        if ((it?.tipoPreco || 'fixo') === 'percentual') {
            return String(Number(it?.valor ?? 0)).replace('.', ',') + '% · ' + faixa;
        }
        return 'R$ ' + pontoVirgula(Number(it?.valor ?? 0)) + ' · ' + faixa;
    };
    // Mini Meeting AbbVie (06/10: "a tabela de valores é a fonte de verdade"): a regra vem do catálogo
    // (1930 fixo, 1929 %, limite da base) e aparece no modal em qualquer período, como na aba MINI MEETING.
    const reaisModal = (v) => 'R$ ' + Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const itensMiniMeetingModal = () => {
        const r = regraMiniMeeting;
        if (!r || typeof r !== 'object' || !(Number(r.fixo) > 0 || Number(r.percentual) > 0)) return [];
        const limite = Number(r.limite || 0);
        return [
            { nome: 'Mini Meeting — base até ' + reaisModal(limite), valor: reaisModal(r.fixo) + ' (fixo)' },
            { nome: 'Mini Meeting — base acima de ' + reaisModal(limite),
                valor: String(Number(r.percentual || 0)).replace('.', ',') + '% (mínimo ' + reaisModal(r.fixo) + ')' },
        ];
    };
    const abrirModalTabelaVersao = () => {
        setTabelaVersaoSel(dados.tabela_versao || '');
        carregarFaixasVersao(clienteIdFeeRules);
        setShowModalTabelaVersao(true);
    };

    const validar = () => {
        // Validação do evento
        if (!dados.evento) {
            const eventoParam = params.get('evento');
            if (eventoParam) {
                // Se há parâmetro de evento na URL mas não foi carregado, pode ser um erro de carregamento
                toast.error(`Erro ao carregar evento ID ${eventoParam}. Verifique se o evento existe no sistema.`);
            } else {
                toast.error('Evento não encontrado. É necessário selecionar um evento válido.');
            }
            return false;
        }

        // Validação do título
        if (!dados.titulo || dados.titulo.trim() === '') {
            setShowModalInformacoes(true);
            toast.error('É necessário preencher o título');
            // Foca no campo título após o modal abrir
            setTimeout(() => {
                const tituloInput = document.getElementById('titulo');
                if (tituloInput) {
                    tituloInput.focus();
                }
            }, 300);
            return false;
        }

        const erroImpostoAgencia = ChiesiAgenciaImpostoPolicy.validar(dados.orcamentoitem || [], clienteAtualEhChiesi);
        if (erroImpostoAgencia) {
            toast.error(erroImpostoAgencia);
            return false;
        }

        const erroInternacional = validarDadosInternacionais(dados, fornecedorAccessInterno)[0];
        if (erroInternacional) {
            toast.error(erroInternacional.mensagem);
            if (erroInternacional.tipo === 'cambio') setShowModalCambio(true);
            return false;
        }

        const erroObservacao = listarPendenciasObservacao(dados)[0];
        if (erroObservacao) {
            toast.error(erroObservacao.mensagem);
            return false;
        }

        const erroItemObrigatorio = listarPendenciasItensObrigatorios(dados)[0];
        if (erroItemObrigatorio) {
            toast.error(erroItemObrigatorio.mensagem);
            return false;
        }

        const erroGrupoRepetido = listarGruposRepetidos(dados.orcamentoitem, gruposGravados.current).bloqueiam[0];
        if (erroGrupoRepetido) {
            toast.error(erroGrupoRepetido.mensagem);
            return false;
        }
        const erroSubItem = listarPendenciasSubItem(dados, fotoGravadoSubItem.current).bloqueiam[0];
        if (erroSubItem) {
            toast.error(erroSubItem.mensagem);
            return false;
        }

        if (clienteAtualEhChiesi && statusFornecedorAccessInterno === 'missing') {
            const possuiServicoAgenciaSemFornecedor = (dados.orcamentoitem || [])
                .filter((item) => isGrupoServicosAgencia(item))
                .some((item) => (item.subitem || []).some((subitem) => !obterIdComparavel(subitem?.fornecedor)));

            if (possuiServicoAgenciaSemFornecedor) {
                toast.error('Fornecedor Access não encontrado. Selecione manualmente um fornecedor para todos os itens de Serviços Agência.');
                return false;
            }
        }

        if (clienteAtualEhChiesi && statusProdutoImpostoAccess === 'missing') {
            const possuiGrupoServicosAgencia = (dados.orcamentoitem || []).some(isGrupoServicosAgencia);
            if (possuiGrupoServicosAgencia) {
                toast.error('Produto ativo 1945 - Imposto não encontrado. Cadastre-o antes de salvar Serviços Agência da Chiesi.');
                return false;
            }
        }

        if (dados.orcamentoproduto?.length > 0) { //se tiver produtos, obrigar preencher
            var temEmBranco = false;
            dados.orcamentoproduto.forEach((element, index) => {
                if (element.produto?.nome === undefined || element.produto?.nome === null) {
                    toast.error('É necessário selecionar o produto ' + (index + 1).toString());
                    temEmBranco = true;
                    return false;
                }
            })
            if (temEmBranco) {
                return false;
            }
        }

        // Épico 12: se o cliente tem MAIS DE UMA versão de fee pra escolher, exige selecionar antes de salvar.
        // (versão única não conta — a migration deu default 'versao=2025' pra toda regra pré-existente,
        // não só quem realmente foi versionado; com 1 só opção não há o que escolher)
        if (obterVersoesFee().length > 1 && (!dados.fee_versao || String(dados.fee_versao).trim() === '')) {
            abrirModalFeeVersao();
            toast.error('Selecione a tabela do FEE do orçamento (botão "Tabela do FEE").');
            return false;
        }

        // Épico 13: se o cliente tem faixas versionadas (Abbvie), exige selecionar o período antes de salvar
        if (obterVersoesTabela().length > 0 && (!dados.tabela_versao || String(dados.tabela_versao).trim() === '') && !feeAllerganGravado) {
            abrirModalTabelaVersao();
            toast.error('Selecione o período da tabela de valores (botão "Tabela de valores").');
            return false;
        }

        return true;
    };

    const salvar = () => {
        if (salvandoRef.current) return false;
        if (conflitoSalvar) {
            toast.error(`Não foi salvo: ${conflitoSalvar.mensagem}`);
            return false;
        }
        if (regrasFeeIndisponiveis) {
            toast.error('Não foi possível carregar as regras de FEE do cliente. Recarregue as regras antes de salvar.');
            return;
        }
        const erroInternacional = validarDadosInternacionais(dados, fornecedorAccessInterno)[0];
        if (erroInternacional) {
            toast.error(erroInternacional.mensagem);
            if (erroInternacional.tipo === 'cambio') setShowModalCambio(true);
            salvarIgnorarOPFCheck.current = false;
            return false;
        }
        // Épico 7 ajuste: intercepta save quando há OPFs aprovados (re-aprovação)
        // OU liberados em Contas Pendentes (aviso de nova previsão — item novo, nota nova)
        if (id && !copiar && !salvarIgnorarOPFCheck.current && (opfsAprovados.length > 0 || opfsLiberados.length > 0 || opfsEmPagamento.length > 0)) {
            // Só alerta sobre fornecedores REALMENTE alterados nesta edição.
            // Fornecedor que virou "pago pelo cliente" NÃO entra: o item deixa de
            // ser pago pela Access, então não faz sentido pedir nova previsão —
            // o backend tira as parcelas da fila e avisa o Financeiro.
            const { alterados, viraramCliente } = diffFornecedores();
            // Aprovado que virou "pago pelo cliente" também volta para aprovação no servidor — avisa.
            const aprovadosFiltrados = opfsAprovados.filter(f => alterados.has(idComparavelSimples(f.fornecedor_id)) || viraramCliente.has(idComparavelSimples(f.fornecedor_id)));
            const liberadosFiltrados = opfsLiberados.filter(f => alterados.has(idComparavelSimples(f.fornecedor_id)));
            const clientesLiberados  = opfsLiberados.filter(f => viraramCliente.has(idComparavelSimples(f.fornecedor_id)));
            // Trava de pagamento (07/10): fornecedor travado pelo Financeiro não pode virar "pago pelo cliente".
            const travadosCliente    = opfsTravados.filter(f => viraramCliente.has(idComparavelSimples(f.fornecedor_id)));
            setTravadosViraramCliente(travadosCliente);
            // Rafael 07/10: fornecedor em processo de pagamento (travado ou pago) — aviso próprio:
            // subiu → a diferença vai para o Custo Previsto; desceu/removeu → falar URGENTE com o Financeiro.
            const snapAgora = snapshotLinhas(dados);
            const emPagamento = opfsEmPagamento
                .filter(f => alterados.has(idComparavelSimples(f.fornecedor_id)))
                .map(f => ({
                    fornecedor_id: String(f.fornecedor_id),
                    nome: f.fornecedor_nome,
                    pago: (f.parcelas_pagas || 0) > 0,
                    travado: (f.parcelas_travadas || 0) > 0,
                    livres: f.parcelas_livres_pendentes || 0,
                    ...variacaoDoFornecedor(snapshotItens.current, snapAgora, String(f.fornecedor_id)),
                }));
            setAvisoPagamento(emPagamento);
            cientePagamento.current = false;
            const ehEmPagamento = (f) => emPagamento.some(e => idComparavelSimples(e.fornecedor_id) === idComparavelSimples(f.fornecedor_id));

            if (travadosCliente.length > 0 || emPagamento.length > 0 || aprovadosFiltrados.length > 0 || liberadosFiltrados.length > 0) {
                // Quem está em processo de pagamento aparece só no aviso próprio (sem repetir nos outros blocos).
                setOpfsAprovadosFiltrados(aprovadosFiltrados.filter(f => !ehEmPagamento(f)));
                setOpfsLiberadosFiltrados(liberadosFiltrados.filter(f => !ehEmPagamento(f)));
                setShowModalReaprovacao(true);
                return;
            }
            // Nada de valor/forma mudou. Se algum fornecedor virou "cliente" e já
            // estava em Contas Pendentes, avisa o operador para falar com o
            // Financeiro (o e-mail é disparado pelo backend no salvar do Efetivo).
            if (clientesLiberados.length > 0) {
                // Modal, não toast: o operador precisa LER e confirmar — o item já
                // estava na agenda de pagamentos (Rafael 2026-08-02).
                setClientesEmPendentes(clientesLiberados);
                return;
            }
        }

        iniciarSalvando();
        try {
        if (!validar()) {
            terminarSalvando();
            salvarIgnorarOPFCheck.current = false;
            salvarIgnorarItensEmBranco.current = false;
            return false; //para codigo aqui
        }

        // Aviso NÃO bloqueante (Rafael 02/10): depois de todas as validações que bloqueiam e dos avisos de
        // re-aprovação/Contas Pendentes, lista as linhas em branco/zeradas por coluna (itensEmBrancoPolicy).
        // Nada é preenchido. "Salvar mesmo assim" chama salvar() de novo com este passo pulado; as flags
        // de re-aprovação já escolhidas (salvarIgnorarOPFCheck/salvarComReaprovacao) seguem valendo.
        if (!salvarIgnorarItensEmBranco.current) {
            const itensEmBranco = linhasEmBrancoPorColuna(dados, { fornecedorAccess: fornecedorAccessInterno });
            if (itensEmBranco.total > 0) {
                terminarSalvando();
                setItensEmBrancoAviso({ ...itensEmBranco, continuar: 'salvar' });
                return false;
            }
        }
        salvarIgnorarItensEmBranco.current = false;

        if (dados.data) {
            dados.data = dataParaMysql(dados.data);
        }

        // Processa datas de pagamento dos subitens para MySQL
        if (dados.orcamentoitem && Array.isArray(dados.orcamentoitem)) {
            dados.orcamentoitem.forEach(function (item, index) {
                if (item.subitem && Array.isArray(item.subitem)) {
                    item.subitem.forEach(function (subitem, indexsubitem) {
                        if (dados.orcamentoitem[index].subitem[indexsubitem].pagamentovencimento) {
                            dados.orcamentoitem[index].subitem[indexsubitem].pagamentovencimento = dataParaMysql(dados.orcamentoitem[index].subitem[indexsubitem].pagamentovencimento);
                        }
                    });
                }
            });
        }

        // Determina a URL de redirecionamento baseada no evento
        // let redirectUrl = "/orcamento";
        // if (dados.evento) {
        //     redirectUrl = `/orcamento?idEvento=${dados.evento}`;
        // } else {
        //     // Fallback: verifica se há parâmetro de evento na URL
        //     const eventoParam = params.get('evento');
        //     if (eventoParam) {
        //         redirectUrl = `/orcamento?idEvento=${eventoParam}`;
        //     }
        // }

        if (id && !copiar) {//update
            // Remove campos de adiantamento do update que não devem ser enviados por aqui
            const dadosParaEnviar = prepararPagamentoExteriorPayload(removerExibicaoFechamentoExterior(dados));
            delete dadosParaEnviar.valorAdiantamento;
            // Mantemos observacaoAdiantamento para permitir edição no cadastro
            delete dadosParaEnviar.arquivoReciboAdiantamento;
            dadosParaEnviar.moeda = (dadosParaEnviar.moeda || 'real').toString().toLowerCase();
            const cambioAtual = virgulaPonto(dadosParaEnviar.cambio);
            dadosParaEnviar.cambio = dadosParaEnviar.moeda === 'real'
                ? 1
                : ((cambioAtual && cambioAtual > 0) ? cambioAtual : 1);

            // Garante que orcamentoitem seja sempre um array válido
            if (!dadosParaEnviar.orcamentoitem || !Array.isArray(dadosParaEnviar.orcamentoitem)) {
                dadosParaEnviar.orcamentoitem = [];
            }

            // Deep copy dos orcamentoitem para não modificar o estado original
            dadosParaEnviar.orcamentoitem = dadosParaEnviar.orcamentoitem.map(item => ({
                ...item,
                subitem: item.subitem ? item.subitem.map(subitem => {
                    const subitemCopy = { ...subitem };
                    // Converte fornecedorpagamento de objeto para string antes de enviar
                    if (subitemCopy.fornecedorpagamento && typeof subitemCopy.fornecedorpagamento === 'object') {
                        subitemCopy.fornecedorpagamento = subitemCopy.fornecedorpagamento.id;
                    }
                    const opcoesPagamento = obterOpcoesPagamentoSelecionadasSubitem(subitemCopy);
                    const idsPagamento = opcoesPagamento
                        .map((opcao) => parseInt(opcao.value, 10))
                        .filter((idForma) => !Number.isNaN(idForma) && idForma > 0);
                    subitemCopy.pagamentoformas = idsPagamento;
                    subitemCopy.pagamentoforma = idsPagamento.length > 0 ? { id: idsPagamento[0] } : null;
                    return subitemCopy;
                }) : []
            }));

            api({
                method: 'put',
                action: '/orcamento/' + id,
                token: token,
                timeout: TEMPO_LIMITE_SALVAR_MS,
                data: comChaveSalvar({
                    ...dadosParaEnviar,
                    ...{ operador: usuario },
                    valorTotalPreEvento: valorTotalPreEvento,
                    valorTotalNegociado: valorTotalNegociado,
                    valorTotalFechamento: valorTotalFechamento,
                    colunasNegociadoAdicionais: atualizarJSONColunasAdicionais(),
                    // 07/10: prova de que o operador viu o aviso "item em processo de pagamento"
                    ciente_pagamento_em_processo: cientePagamento.current,
                    // 08/10: o servidor apaga o rascunho desta tela ao salvar
                    rascunhoChave: rascunhoOrcamento.chaveAtual(),
                    // D-0052 parte 4b: versão carregada; outra pessoa salvou depois → 409
                    chaveSalvarBase: chaveSalvarBase(dados)
                })
            })
                .then(function (response) {
                    cientePagamento.current = false;
                    console.log('SALVOU COM TOTAIS:', {
                        valorTotalPreEvento,
                        valorTotalNegociado,
                        valorTotalFechamento
                    });

                    salvarIgnorarOPFCheck.current = false;
                    salvarComReaprovacao.current  = false;
                    // Rafael 07/10: quem devolve para aprovação é o próprio salvar (servidor). O antigo
                    // PUT /reaprovarOPFs ("Sim, re-enviar") saiu — achava 0 e confundia.
                    toast.success("Salvo com sucesso!");
                    chaveSalvarRef.current = null;
                    terminarSalvando();
                    rascunhoOrcamento.limparAposSalvar();
                    buscar();
                    // O salvar pode ter devolvido planos para aprovação: atualiza a lista do aviso.
                    carregarOpfsDoOrcamento();
                })
                .catch(function (error) {
                    salvarIgnorarOPFCheck.current = false;
                    salvarComReaprovacao.current  = false;
                    terminarSalvando();
                    setConflitoSalvar(conflitoDoErroSalvar(error));
                    toast.error(mensagemErroSalvar(error));
                });
        } else {//insert
            // Remove campos de adiantamento do insert que não devem ser enviados por aqui
            const dadosParaEnviar = prepararPagamentoExteriorPayload(removerExibicaoFechamentoExterior(dados));
            delete dadosParaEnviar.valorAdiantamento;
            // Mantemos observacaoAdiantamento para permitir edição no cadastro
            delete dadosParaEnviar.arquivoReciboAdiantamento;
            dadosParaEnviar.moeda = (dadosParaEnviar.moeda || 'real').toString().toLowerCase();
            const cambioAtual = virgulaPonto(dadosParaEnviar.cambio);
            dadosParaEnviar.cambio = dadosParaEnviar.moeda === 'real'
                ? 1
                : ((cambioAtual && cambioAtual > 0) ? cambioAtual : 1);

            // Garante que orcamentoitem seja sempre um array válido
            if (!dadosParaEnviar.orcamentoitem || !Array.isArray(dadosParaEnviar.orcamentoitem)) {
                dadosParaEnviar.orcamentoitem = [];
            }

            // Deep copy dos orcamentoitem para não modificar o estado original
            dadosParaEnviar.orcamentoitem = dadosParaEnviar.orcamentoitem.map(item => ({
                ...item,
                subitem: item.subitem ? item.subitem.map(subitem => {
                    const subitemCopy = { ...subitem };
                    // Converte fornecedorpagamento de objeto para string antes de enviar
                    if (subitemCopy.fornecedorpagamento && typeof subitemCopy.fornecedorpagamento === 'object') {
                        subitemCopy.fornecedorpagamento = subitemCopy.fornecedorpagamento.id;
                    }
                    const opcoesPagamento = obterOpcoesPagamentoSelecionadasSubitem(subitemCopy);
                    const idsPagamento = opcoesPagamento
                        .map((opcao) => parseInt(opcao.value, 10))
                        .filter((idForma) => !Number.isNaN(idForma) && idForma > 0);
                    subitemCopy.pagamentoformas = idsPagamento;
                    subitemCopy.pagamentoforma = idsPagamento.length > 0 ? { id: idsPagamento[0] } : null;
                    return subitemCopy;
                }) : []
            }));

            api({
                method: 'post',
                action: '/orcamento',
                token: token,
                timeout: TEMPO_LIMITE_SALVAR_MS,
                data: comChaveSalvar({
                    ...dadosParaEnviar,
                    ...{ empresa: empresa },
                    ...{ operador: usuario },
                    valorTotalPreEvento: valorTotalPreEvento,
                    valorTotalNegociado: valorTotalNegociado,
                    valorTotalFechamento: valorTotalFechamento,
                    colunasNegociadoAdicionais: atualizarJSONColunasAdicionais(),
                    rascunhoChave: rascunhoOrcamento.chaveAtual()
                })
            })
                .then(function (response) {
                    const novoId = response.data.data.id;
                    toast.success("Salvo com sucesso!");
                    chaveSalvarRef.current = null;
                    terminarSalvando();
                    // Antes do push: sem pendência, o aviso de saída do rascunho deixa navegar.
                    rascunhoOrcamento.limparAposSalvar();
                    // Redireciona para a tela de edição do orçamento criado
                    history.push(`/cadastroOrcamento/${novoId}`);
                })
                .catch(function (error) {
                    terminarSalvando();
                    toast.error(mensagemErroSalvar(error));
                });
        }
        } catch (erro) {
            falhaAntesDeEnviar(erro);
            return false;
        }
    };

    // "Salvar e baixar": o Excel do orçamento e, na AbbVie Internacional (o orçamento que sai no Excel Inter:
    // evento internacional ou moeda estrangeira), o PDF da aba de proposta (D-0101, Rafael 24/10).
    const ARQUIVOS_SALVAR_E_BAIXAR = {
        excel: { rota: 'gerarPlanilhaExcel', accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', padrao: 'Orcamento', extensao: 'xlsx', nome: 'o Excel' },
        propostaPdf: { rota: 'gerarPropostaPdf', accept: 'application/pdf', tipo: 'application/pdf', padrao: 'Proposta', extensao: 'pdf', nome: 'o PDF da proposta' },
    };
    const propostaAbbvieInter = OrcamentoClientInheritance.resolveVisualModel(dados?.evento?.cliente ?? dados?.cliente ?? null) === 'abbvie'
        && (obterMoedaOrcamento() !== 'real' || eventoEhInternacional);
    const salvarEBaixarExcel = () => salvarEBaixar('excel');
    const salvarEBaixarPropostaPdf = () => salvarEBaixar('propostaPdf');

    const salvarEBaixar = (tipoArquivo) => {
        const arquivo = ARQUIVOS_SALVAR_E_BAIXAR[tipoArquivo];
        if (salvandoRef.current) return false;
        if (conflitoSalvar) {
            toast.error(`Não foi salvo: ${conflitoSalvar.mensagem}`);
            return false;
        }
        if (regrasFeeIndisponiveis) {
            toast.error('Não foi possível carregar as regras de FEE do cliente. Recarregue as regras antes de salvar.');
            return false;
        }
        iniciarSalvando();
        try {
        if (!validar()) {
            terminarSalvando();
            salvarIgnorarItensEmBranco.current = false;
            return false;
        }

        // Mesmo aviso não bloqueante do Salvar (Rafael 02/10): "Salvar mesmo assim" volta para cá.
        if (!salvarIgnorarItensEmBranco.current) {
            const itensEmBranco = linhasEmBrancoPorColuna(dados, { fornecedorAccess: fornecedorAccessInterno });
            if (itensEmBranco.total > 0) {
                terminarSalvando();
                setItensEmBrancoAviso({ ...itensEmBranco, continuar: tipoArquivo });
                return false;
            }
        }
        salvarIgnorarItensEmBranco.current = false;

        // Rafael 07/10: devolver aprovação do Financeiro (e o e-mail) só pelo botão Salvar, que mostra o aviso.
        if (id && !copiar && (opfsAprovados.length > 0 || opfsLiberados.length > 0)) {
            const { alterados, viraramCliente } = diffFornecedores();
            const afeta = (f) => alterados.has(idComparavelSimples(f.fornecedor_id)) || viraramCliente.has(idComparavelSimples(f.fornecedor_id));
            if (opfsAprovados.some(afeta) || opfsLiberados.some(afeta)) {
                terminarSalvando();
                toast.warning(`Esta alteração mexe em fornecedor com Previsão de Pagamento já aprovada. Use o botão Salvar (ele mostra o aviso) e depois baixe ${arquivo.nome}.`);
                return false;
            }
        }

        if (dados.data) {
            dados.data = dataParaMysql(dados.data);
        }

        // Processa datas de pagamento dos subitens para MySQL
        if (dados.orcamentoitem && Array.isArray(dados.orcamentoitem)) {
            dados.orcamentoitem.forEach(function (item, index) {
                if (item.subitem && Array.isArray(item.subitem)) {
                    item.subitem.forEach(function (subitem, indexsubitem) {
                        if (dados.orcamentoitem[index].subitem[indexsubitem].pagamentovencimento) {
                            dados.orcamentoitem[index].subitem[indexsubitem].pagamentovencimento = dataParaMysql(dados.orcamentoitem[index].subitem[indexsubitem].pagamentovencimento);
                        }
                    });
                }
            });
        }

        // Remove campos de adiantamento que não devem ser enviados
        const dadosParaEnviar = prepararPagamentoExteriorPayload(removerExibicaoFechamentoExterior(dados));
        delete dadosParaEnviar.valorAdiantamento;
        delete dadosParaEnviar.arquivoReciboAdiantamento;
        dadosParaEnviar.moeda = (dadosParaEnviar.moeda || 'real').toString().toLowerCase();
        const cambioAtual = virgulaPonto(dadosParaEnviar.cambio);
        dadosParaEnviar.cambio = dadosParaEnviar.moeda === 'real'
            ? 1
            : ((cambioAtual && cambioAtual > 0) ? cambioAtual : 1);

        // Garante que orcamentoitem seja sempre um array válido
        if (!dadosParaEnviar.orcamentoitem || !Array.isArray(dadosParaEnviar.orcamentoitem)) {
            dadosParaEnviar.orcamentoitem = [];
        }

        const salvarPromise = id && !copiar ?
            // Update
            api({
                method: 'put',
                action: '/orcamento/' + id,
                token: token,
                timeout: TEMPO_LIMITE_SALVAR_MS,
                data: comChaveSalvar({
                    ...dadosParaEnviar,
                    ...{ operador: usuario },
                    colunasNegociadoAdicionais: atualizarJSONColunasAdicionais(),
                    rascunhoChave: rascunhoOrcamento.chaveAtual(),
                    chaveSalvarBase: chaveSalvarBase(dados)
                })
            }) :
            // Insert
            api({
                method: 'post',
                action: '/orcamento',
                token: token,
                timeout: TEMPO_LIMITE_SALVAR_MS,
                data: comChaveSalvar({
                    ...dadosParaEnviar,
                    ...{ empresa: empresa },
                    ...{ operador: usuario },
                    colunasNegociadoAdicionais: atualizarJSONColunasAdicionais(),
                    rascunhoChave: rascunhoOrcamento.chaveAtual()
                })
            });

        salvarPromise
            .then(async function (response) {
                const { orcamentoId, irPara } = destinoAposInserir({ id, copiar, novoId: response.data?.data?.id });
                toast.success(`Salvo com sucesso! Baixando ${arquivo.nome}...`);
                chaveSalvarRef.current = null;
                rascunhoOrcamento.limparAposSalvar();
                if (id && !copiar) {
                    buscar();
                }

                // Insert (novo ou cópia): vai para o id criado pelo roteador. Com replaceState o `id` da
                // rota não mudava e o próximo Salvar criava OUTRO orçamento (16/10).
                if (irPara) {
                    history.replace(irPara);
                }

                try {
                    const responseDownload = await fetch(`${process.env.REACT_APP_API_URL}/orcamento/${arquivo.rota}`, {
                        method: 'POST',
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Accept': arquivo.accept,
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            data: JSON.stringify({
                                token: token,
                                rows: [orcamentoId]
                            })
                        })
                    });

                    // O PDF confere o tipo: "Acesso Negado" e os avisos da API voltam em JSON com status 200/422.
                    if (!responseDownload.ok || (arquivo.tipo && !(responseDownload.headers.get('content-type') || '').includes(arquivo.tipo))) {
                        const erroTexto = await responseDownload.text();
                        throw new Error(erroTexto || `Falha ao gerar ${arquivo.nome}`);
                    }

                    const blob = await responseDownload.blob();
                    const contentDisposition = responseDownload.headers.get('content-disposition') || '';
                    const nomeArquivoMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i);
                    const nomeArquivo = (nomeArquivoMatch?.[1] || `${arquivo.padrao}-${orcamentoId}.${arquivo.extensao}`).replace(/['"]/g, '');

                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = nomeArquivo;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                } catch (downloadError) {
                    console.error(`Erro ao baixar ${arquivo.nome} do orçamento:`, downloadError);
                    toast.error(`Salvo com sucesso, mas houve erro ao baixar ${arquivo.nome}.`);
                } finally {
                    terminarSalvando();
                }
            })
            .catch(function (error) {
                terminarSalvando();
                if (id && !copiar) setConflitoSalvar(conflitoDoErroSalvar(error));
                toast.error(mensagemErroSalvar(error));
            });
        } catch (erro) {
            falhaAntesDeEnviar(erro);
            return false;
        }
    };

    const gerarNdEvento = async () => {
        if (!id || copiar) {
            toast.error('Salve o orçamento antes de gerar a ND do evento.');
            return;
        }

        try {
            setGerandoNdEvento(true);

            const response = await fetch(`${process.env.REACT_APP_API_URL}/orcamento/gerarNdEvento/${id}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept': 'application/pdf',
                },
            });

            if (!response.ok) {
                const contentType = response.headers.get('content-type') || '';
                let mensagemErro = 'Falha ao gerar ND do evento.';

                if (contentType.includes('application/json')) {
                    const payload = await response.json();
                    mensagemErro = payload?.message || payload?.error || mensagemErro;
                } else {
                    const erroTexto = await response.text();
                    if (erroTexto) {
                        mensagemErro = erroTexto;
                    }
                }

                throw new Error(mensagemErro);
            }

            const blob = await response.blob();
            const contentDisposition = response.headers.get('content-disposition') || '';
            const nomeArquivoMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i);
            const nomeArquivo = (nomeArquivoMatch?.[1] || `ND-Evento-${id}.pdf`).replace(/['"]/g, '');

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = nomeArquivo;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Erro ao gerar ND do evento:', error);
            toast.error(error.message || 'Erro ao gerar ND do evento.');
        } finally {
            setGerandoNdEvento(false);
        }
    };

    // Carrega itens permanentes da configuração
    useEffect(() => {
        const carregarItensPermanentes = async () => {
            try {
                const configResponse = await api({
                    method: 'get',
                    action: '/empresaConfiguracao',
                    token: token,
                    params: {
                        empresa: empresa
                    }
                });

                if (configResponse.data && configResponse.data.data) {
                    const config = configResponse.data.data;
                    setItensPermanentesIds(config.itensPermanentes || []);
                    setItensPermanentesInternacionaisIds(config.itensPermanentesInternacionais || []);
                }
            } catch (error) {
                // Silencioso - se não houver configuração, apenas não adiciona itens permanentes
                console.log('Configuração de itens permanentes não encontrada');
            }
        };

        carregarItensPermanentes();
    }, [empresa, token]);

    // ─── Detecção do que MUDOU nesta edição (Rafael 2026-08-02) ──────────────
    // Antes o modal de re-aprovação disparava pela EXISTÊNCIA de OPF aprovado e
    // listava todos os fornecedores do orçamento — inclusive os que o operador
    // não tocou. Agora comparamos com o snapshot do load.
    //
    // Campos que contam como alteração relevante (definido com o Rafael):
    // valores (pré-evento / negociado / fechamento), forma de pagamento e
    // fornecedor. Observação, imposto e % FEE NÃO disparam alerta.
    const idComparavelSimples = (v) => (v && typeof v === 'object' ? (v.id ?? '') : (v ?? '')).toString();

    // Rafael 07/10: mesmo critério do servidor (assinaturasDasLinhas/diffLinhas) — inclui linha NOVA
    // (clone, "+ Subitem") e linha REMOVIDA; forma de pagamento e observação não contam.
    const montarSnapshotItens = (d) => snapshotLinhas(d);

    // Devolve { alterados:Set, viraramCliente:Set }
    const diffFornecedores = () => fornecedoresAfetados(snapshotItens.current, snapshotLinhas(dados), previsaoDosCards.current);

    // Épico 7 ajuste — carrega OPFs aprovados para detectar necessidade de re-aprovação ao salvar
    const carregarOpfsDoOrcamento = function() {
        if (!id) return;
        api({ method: 'get', action: '/orcamento/' + id + '/pagamentoFornecedores', token: token })
            .then(function(response) {
                // D-0096: fornecedor em 2+ grupos vem em um card por grupo ('{fornecedor}:{grupo}') — o plano é um só,
                // então aqui fica um por fornecedor, com o id real (o aviso compara com o fornecedor da linha).
                var cards = (response.data && response.data.data) ? response.data.data : [];
                previsaoDosCards.current = dadosDaPrevisao(cards);
                var forn = umCardPorFornecedor(cards)
                    .map(function(f) { return f.fornecedor_real_id ? Object.assign({}, f, { fornecedor_id: f.fornecedor_real_id }) : f; });
                // Liberado (em Contas Pendentes) = intocável; aprovado-não-liberado = re-aprovação normal
                setOpfsLiberados(forn.filter(function(f) { return !!f.liberado_financeiro_at; }));
                setOpfsAprovados(forn.filter(function(f) { return f.status === 'aprovado' && !f.liberado_financeiro_at; }));
                setOpfsTravados(forn.filter(function(f) { return (f.parcelas_travadas || 0) > 0; }));
                setOpfsEmPagamento(forn.filter(function(f) { return (f.parcelas_travadas || 0) > 0 || (f.parcelas_pagas || 0) > 0; }));
            })
            .catch(function() { /* silencioso — não crítico */ });
    };
    useEffect(function() {
        carregarOpfsDoOrcamento();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    useEffect(() => { //onload
        // Busca dados da empresa ativa (não bloqueia o carregamento se falhar)
        api({
            method: 'get',
            action: '/participante',
            token: token,
            params: {
                tipoCadastro: "empresa",
                situacaoRegistro: "ativo"
            }
        })
            .then(response => {
                if (response.data.data && response.data.data.length > 0) {
                    setEmpresaAtiva(response.data.data[0]); // Pega a primeira empresa ativa
                }
            })
            .catch(err => {
                console.error('Erro ao carregar empresa (não crítico):', err);
                // Não impede o carregamento do orçamento
            });

        // Se há parâmetro de evento na URL, carrega automaticamente primeiro
        const eventoParam = params.get('evento');
        if (eventoParam && !id) {
            api({
                method: 'get',
                action: '/evento/' + eventoParam,
                token: token
            })
                .then(response => {
                    const evento = response.data.data;
                    setEventoNacionalidade(evento.nacionalidade);
                    setEventoConvidadosEsperados(convidadosEsperadosDoEvento(evento));
                    setEventoTipo(evento.tipo ?? null);
                    setEventoTipoRealizacao(evento.tipoRealizacao ?? null);
                    setDados(prevDados => ({
                        ...prevDados,
                        evento: evento.id,
                        nomeEvento: evento.nome,
                        cliente: evento.cliente
                    }));
                    // Chama buscar() após carregar o evento
                    buscar({
                        eventoId: evento.id,
                        nomeEvento: evento.nome,
                        cliente: evento.cliente,
                    });
                })
                .catch(err => {
                    console.error('Erro ao carregar evento:', err);
                    toast.error('Erro ao carregar dados do evento. Verifique se o evento existe.');
                    // Chama buscar() mesmo com erro para não travar a tela
                    buscar();
                });
        } else {
            // Se não há parâmetro de evento, chama buscar() diretamente
            buscar();
        }
    },
        // eslint-disable-next-line
        []);

    useEffect(() => {
        if (!token) {
            return;
        }
        if (!clienteIdFeeRules) {
            setFeeRulesCliente([]);
            setFaixasVersao([]);
            setRegraMiniMeeting(null);
            marcarStatusRegrasFee('pendente');
            return;
        }
        carregarFeeRulesCliente(clienteIdFeeRules);
        carregarFaixasVersao(clienteIdFeeRules); // Épico 13 — versões de faixa (Abbvie)
        // eslint-disable-next-line
    }, [clienteIdFeeRules, token]);

    useEffect(() => {
        if (!token) {
            setFornecedorAccessInterno(null);
            setStatusFornecedorAccessInterno('idle');
            alertaFornecedorAccessAusenteExibido.current = false;
            return;
        }

        let consultaCancelada = false;
        setStatusFornecedorAccessInterno('loading');

        api({
            method: 'get',
            action: '/participante',
            token: token,
            params: {
                cnpj: CNPJ_ACCESS_INTERNO,
                tipoCadastro: ['empresa', 'orcamento'],
                situacaoRegistro: 'ativo',
            }
        })
            .then((response) => {
                if (consultaCancelada) {
                    return;
                }

                const registros = Array.isArray(response?.data?.data) ? response.data.data : [];
                const candidatos = registros
                    .filter((registro) => normalizarDocumento(registro?.cnpj) === CNPJ_ACCESS_INTERNO)
                    .sort((a, b) => {
                        const prioridadeA = a?.tipoCadastro === 'empresa' ? 0 : 1;
                        const prioridadeB = b?.tipoCadastro === 'empresa' ? 0 : 1;
                        return prioridadeA - prioridadeB || String(a?.id ?? '').localeCompare(String(b?.id ?? ''));
                    });
                const registroAccess = candidatos[0] ?? null;

                if (!registroAccess) {
                    setFornecedorAccessInterno(null);
                    setStatusFornecedorAccessInterno('missing');
                    if (clienteAtualEhChiesi && !alertaFornecedorAccessAusenteExibido.current) {
                        toast.warning('Fornecedor Access não encontrado pelo CNPJ 21.415.772/0001-64. A seleção manual foi liberada.');
                        alertaFornecedorAccessAusenteExibido.current = true;
                    }
                    return;
                }

                setFornecedorAccessInterno({
                    id: registroAccess.id,
                    nome: registroAccess.nome,
                    cnpj: registroAccess.cnpj,
                });
                setStatusFornecedorAccessInterno('found');
                alertaFornecedorAccessAusenteExibido.current = false;
            })
            .catch(() => {
                if (consultaCancelada) {
                    return;
                }
                setFornecedorAccessInterno(null);
                setStatusFornecedorAccessInterno('missing');
                if (clienteAtualEhChiesi && !alertaFornecedorAccessAusenteExibido.current) {
                    toast.warning('Não foi possível localizar o fornecedor Access. A seleção manual foi liberada.');
                    alertaFornecedorAccessAusenteExibido.current = true;
                }
            });

        return () => {
            consultaCancelada = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clienteAtualEhChiesi, token]);

    useEffect(() => {
        const clienteId = clienteIdFeeRules;
        if (!clienteAtualEhChiesi || !token || !clienteId) {
            setProdutoImpostoAccess(null);
            setStatusProdutoImpostoAccess('idle');
            return;
        }

        let consultaCancelada = false;
        setStatusProdutoImpostoAccess('loading');

        api({
            method: 'get',
            action: '/produto',
            token: token,
            params: {
                nome: CODIGO_PRODUTO_IMPOSTO_ACCESS,
                situacaoRegistro: 'ativo',
                modulo: 'servicoOrcamento',
                cliente: clienteId,
            }
        })
            .then((response) => {
                if (consultaCancelada) {
                    return;
                }

                const produtosExatos = (response?.data?.data ?? [])
                    .filter((produto) => String(produto?.codigo ?? '').trim() === CODIGO_PRODUTO_IMPOSTO_ACCESS);
                const produto = produtosExatos.length === 1 ? produtosExatos[0] : null;
                if (!produto) {
                    setProdutoImpostoAccess(null);
                    setStatusProdutoImpostoAccess('missing');
                    toast.warning('Produto ativo 1945 - Imposto não encontrado de forma única. O grupo Serviços Agência da Chiesi não poderá ser salvo.');
                    return;
                }

                setProdutoImpostoAccess({
                    id: produto.id,
                    codigo: produto.codigo,
                    codigoFornecedor: produto.codigoFornecedor ?? null,
                    nome: `${produto.codigo} - ${produto.nome}`,
                    somarTodosFee: produto.somarTodosFee ?? 'nao',
                    tipoPreco: produto.tipoPreco ?? 'fixo',
                    preco: produto.preco ?? 0,
                    superior: obterIdComparavel(produto.superior),
                    atributo: obterIdComparavel(produto.atributo),
                    feeBaseTipo: produto.feeBaseTipo ?? 'compoe_fee_global',
                    feeBaseId: produto.feeBaseId ?? null,
                    feeMomentoCalculo: produto.feeMomentoCalculo ?? 'todos',
                    orcamentoConfig: produto.orcamento_config ?? produto.orcamentoConfig ?? null,
                    precificacaoFaixas: normalizarFaixasPrecificacao(produto),
                });
                setStatusProdutoImpostoAccess('found');
            })
            .catch(() => {
                if (!consultaCancelada) {
                    setProdutoImpostoAccess(null);
                    setStatusProdutoImpostoAccess('missing');
                    toast.warning('Não foi possível localizar o produto 1945 - Imposto para a Chiesi.');
                }
            });

        return () => {
            consultaCancelada = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clienteAtualEhChiesi, token, clienteIdFeeRules]);

    useEffect(() => {
        if (!fornecedorAccessInterno?.id || (clienteAtualEhChiesi && !produtoImpostoAccess?.id)) {
            return;
        }
        calculaTotalOrcamento2(undefined, {
            feeRules: feeRulesCliente,
            fornecedorAccessInterno: fornecedorAccessInterno,
            produtoImpostoAccess: produtoImpostoAccess,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fornecedorAccessInterno?.id, produtoImpostoAccess?.id]);

    useEffect(() => {
        if (!Array.isArray(dados?.orcamentoitem) || dados.orcamentoitem.length === 0) {
            return;
        }
        calculaTotalOrcamento2(undefined, { feeRules: feeRulesCliente });
        // eslint-disable-next-line
    }, [feeRulesCliente, faixasVersao, eventoConvidadosEsperados, eventoTipo, regraMiniMeeting, dados.fee_versao, dados.tabela_versao]);

    // Épico 12: orçamento NOVO entra na tabela de fee mais recente do cliente (decisão 05/10). Orçamento
    // salvo, cópia e clone mantêm a tabela gravada; a troca é sempre pelo botão "Tabela do FEE".
    // Fica DEPOIS do recálculo acima e grava pelo próprio recálculo: os dois rodam no mesmo render e o
    // setDados do recálculo (com o fee_versao antigo) sobrescreveria um setDados separado.
    useEffect(() => {
        if (id) return;
        const versoes = obterVersoesFee();
        if (versoes.length < 2) return;
        const atual = String(dados?.fee_versao ?? '').trim();
        if (atual !== '' && versoes.some((v) => String(v) === atual)) return;
        const maisRecente = [...versoes].sort((a, b) => String(a).localeCompare(String(b), undefined, { numeric: true })).pop();
        calculaTotalOrcamento2({ ...dados, fee_versao: maisRecente }, { feeRules: feeRulesCliente });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, feeRulesCliente, dados?.fee_versao]);

    // Atualiza o breadcrumb com o título real do orçamento após carregar
    useEffect(() => {
        if (dados.titulo) setLabel(dados.titulo);
    }, [dados.titulo]); // eslint-disable-line react-hooks/exhaustive-deps

    // Expande automaticamente o grupo que contém o item destacado
    useEffect(() => {
        if (itemDestacado && dados.orcamentoitem && dados.orcamentoitem.length > 0) {
            dados.orcamentoitem.forEach((item, indexSuperior) => {
                if (item.subitem && item.subitem.some(subitem => subitem.id === itemDestacado)) {
                    if (!expandedRows.includes(indexSuperior)) {
                        setExpandedRows(prev => [...prev, indexSuperior]);
                    }
                }
            });
        }
    }, [dados.orcamentoitem, itemDestacado, expandedRows]);

    // Atualiza o modal de NF quando os dados mudam
    useEffect(() => {
        if (showModalSolicitarNF) {
            setModalNFKey(prev => prev + 1);
        }
    }, [dados.orcamentoitem, showModalSolicitarNF]);

    // Épico 1 Fase 4 Quick Win 1.1 — Carregar POs do evento para banner
    useEffect(() => {
        const idEvento = dados?.evento?.id ?? dados?.evento;
        if (idEvento) {
            carregarPosDoEvento(idEvento);
        } else {
            setPosAprovadasDoEvento(null);
        }
        // eslint-disable-next-line
    }, [dados?.evento?.id, dados?.evento]);

    // Busca histórico de antecipações quando o modal abre
    useEffect(() => {
        if (showModalSolicitarNF && itemSolicitarNF && itemSolicitarNF.fornecedor_nome && dados.id) {
            console.log('🔄 Buscando histórico de antecipações...');
            console.log('Params:', {
                orcamento_id: dados.id,
                fornecedor_nome: itemSolicitarNF.fornecedor_nome
            });

            setLoadingHistorico(true);
            api({
                method: 'get',
                action: '/orcamento/historicoAntecipacoes',
                token: token,
                params: {
                    orcamento_id: dados.id,
                    fornecedor_nome: itemSolicitarNF.fornecedor_nome
                }
            }).then(response => {
                console.log('✅ Histórico recebido:', response.data);
                setHistoricoAntecipacoes(response.data.data || []);
            }).catch(err => {
                console.error('❌ Erro ao buscar histórico:', err);
                setHistoricoAntecipacoes([]);
            }).finally(() => {
                setLoadingHistorico(false);
            });
        }
    }, [showModalSolicitarNF, itemSolicitarNF?.fornecedor_nome, dados.id]);

    // Busca histórico de notas fiscais quando o modal abre
    useEffect(() => {
        if (showModalSolicitarNF && itemSolicitarNF && itemSolicitarNF.fornecedor_nome && dados.id) {
            console.log('🔄 Buscando histórico de NFs...');

            setLoadingNotasFiscais(true);
            api({
                method: 'get',
                action: '/orcamento/historicoNotasFiscais',
                token: token,
                params: {
                    orcamento_id: dados.id,
                    fornecedor_nome: itemSolicitarNF.fornecedor_nome
                }
            }).then(response => {
                console.log('✅ Notas Fiscais recebidas:', response.data);
                setHistoricoNotasFiscais(response.data.dados || []);
            }).catch(err => {
                console.error('❌ Erro ao buscar NFs:', err);
                setHistoricoNotasFiscais([]);
            }).finally(() => {
                setLoadingNotasFiscais(false);
            });
        } else {
            setHistoricoNotasFiscais([]);
        }
    }, [showModalSolicitarNF, itemSolicitarNF?.fornecedor_nome, dados.id]);

    // A página continua sendo a única rolagem vertical do orçamento. Como a grade
    // precisa de overflow horizontal, o sticky nativo do thead fica preso nesse
    // ancestral em alguns navegadores. O espelho visual resolve o cabeçalho e a
    // barra-proxy evita que o operador precise chegar ao fim da tabela para rolar.
    // Caso 20 (QA 25/09) — grade, barra e cabeçalho agora andam juntos, com 0px de diferença:
    //  1) a barra parava ~10px antes da grade (o navegador reservava um "gutter" que o
    //     scrollWidth não desconta): o limite REAL da barra é conferido e corrigido a cada
    //     mudança de tamanho — grade, colunas, a própria barra, fontes carregando, avisos do rodapé;
    //  2) eco entre as rolagens: com limites diferentes, o evento atrasado da barra "puxava" a
    //     grade de volta. Cada lado agora ignora o eco do valor que a sincronização escreveu;
    //  3) cabeçalho espelho: fora de .orcamento-grid ele perdia o CSS compacto (colunas com
    //     larguras diferentes) e, movido por transform, arrastava junto as colunas fixas. Agora
    //     usa o mesmo CSS, cada th recebe a largura medida do original e ele rola por scrollLeft
    //     (as colunas sticky do espelho ficam paradas como as da grade).
    useEffect(() => {
        const grade = orcamentoGridRef.current;
        const cabecalhoFixo = orcamentoGridCabecalhoFixoRef.current;
        const scrollControl = orcamentoGridScrollControlRef.current;
        const scrollProxy = orcamentoGridScrollProxyRef.current;
        const scrollProxyConteudo = orcamentoGridScrollProxyConteudoRef.current;

        if (!grade || !cabecalhoFixo || !scrollControl || !scrollProxy || !scrollProxyConteudo) {
            return undefined;
        }

        const tabela = grade.querySelector('table');
        const cabecalho = tabela ? tabela.querySelector('thead') : null;
        if (!tabela || !cabecalho) {
            return undefined;
        }

        // Valor que a sincronização acabou de escrever em cada lado: o evento de scroll com
        // esse valor é eco e não deve ser devolvido ao outro lado.
        let ecoProxy = null;
        let ecoGrade = null;
        let quadroLayout = null;

        const sincronizarCabecalho = () => {
            const tabelaEspelho = cabecalhoFixo.querySelector('table');
            if (!tabelaEspelho) {
                return;
            }

            const retangulo = grade.getBoundingClientRect();
            const alturaCabecalho = cabecalho.getBoundingClientRect().height;
            const fixar = deveFixarCabecalho({
                top: retangulo.top,
                bottom: retangulo.bottom,
                alturaCabecalho: alturaCabecalho
            });

            cabecalhoFixo.style.display = fixar ? 'block' : 'none';
            if (!fixar) {
                return;
            }

            cabecalhoFixo.style.left = `${retangulo.left + grade.clientLeft}px`;
            cabecalhoFixo.style.width = `${grade.clientWidth}px`;
            if (cabecalhoFixo.scrollLeft !== grade.scrollLeft) {
                cabecalhoFixo.scrollLeft = grade.scrollLeft;
            }
        };

        // Grade → barra + cabeçalho. Chamado pelo scroll da grade (setas, teclado, foco,
        // scrollIntoView, "Mostrar campo", trackpad) e direto pelos botões ←/→.
        const sincronizarDaGrade = () => {
            if (scrollProxy.scrollLeft !== grade.scrollLeft) {
                scrollProxy.scrollLeft = grade.scrollLeft;
                ecoProxy = scrollProxy.scrollLeft;
            }
            sincronizarCabecalho();
        };

        // Limite real de rolagem (o scrollWidth − clientWidth pode não descontar o gutter).
        const limiteReal = (elemento) => {
            const atual = elemento.scrollLeft;
            elemento.scrollLeft = elemento.scrollWidth;
            const limite = elemento.scrollLeft;
            elemento.scrollLeft = atual;
            return limite;
        };

        const recriarCabecalhoEspelho = () => {
            const tabelaEspelho = document.createElement('table');
            const larguraTabela = `${tabela.getBoundingClientRect().width}px`;
            tabelaEspelho.className = tabela.className;
            tabelaEspelho.style.borderCollapse = 'separate';
            tabelaEspelho.style.borderSpacing = '0';
            tabelaEspelho.style.width = larguraTabela;
            tabelaEspelho.style.minWidth = larguraTabela;
            tabelaEspelho.style.maxWidth = larguraTabela;
            tabelaEspelho.style.margin = '0';
            tabelaEspelho.style.backgroundColor = '#f8f9fa';

            const cabecalhoEspelho = cabecalho.cloneNode(true);
            cabecalhoEspelho.querySelectorAll('[id]').forEach((elemento) => elemento.removeAttribute('id'));
            cabecalhoEspelho.querySelectorAll('button, input, select, textarea, a').forEach((elemento) => {
                elemento.setAttribute('tabindex', '-1');
            });
            // Sem o corpo, a tabela espelho distribuiria as colunas pelo texto do cabeçalho:
            // cada th leva a largura medida do original.
            const copias = cabecalhoEspelho.querySelectorAll('th');
            cabecalho.querySelectorAll('th').forEach((original, indice) => {
                const copia = copias[indice];
                if (!copia) {
                    return;
                }
                const largura = `${original.getBoundingClientRect().width}px`;
                copia.style.boxSizing = 'border-box';
                copia.style.width = largura;
                copia.style.minWidth = largura;
                copia.style.maxWidth = largura;
            });
            tabelaEspelho.appendChild(cabecalhoEspelho);
            cabecalhoFixo.replaceChildren(tabelaEspelho);
            observarColunas();
        };

        const atualizarLayout = () => {
            quadroLayout = null;
            const possuiOverflow = temOverflowHorizontal(tabela.scrollWidth, grade.clientWidth);
            scrollControl.style.display = possuiOverflow ? 'flex' : 'none';
            // A barra fixa é mais estreita que a grade por conter as setas e o
            // texto de ajuda. Ajustamos a largura interna para que ambos tenham
            // exatamente o mesmo limite de rolagem; sem isso, arrastar o thumb
            // fazia a grade atingir o fim antes da barra e "dar um pulo".
            const larguraConteudo = larguraConteudoProxyParaMesmoLimite({
                larguraVisivelProxy: scrollProxy.clientWidth,
                scrollWidthGrade: grade.scrollWidth,
                larguraVisivelGrade: grade.clientWidth
            });
            scrollProxyConteudo.style.width = `${larguraConteudo}px`;
            if (possuiOverflow) {
                const corrigida = correcaoLarguraProxy({
                    larguraConteudoAtual: larguraConteudo,
                    limiteRealProxy: limiteReal(scrollProxy),
                    limiteGrade: limiteReal(grade)
                });
                if (corrigida) {
                    scrollProxyConteudo.style.width = `${corrigida}px`;
                }
            }

            recriarCabecalhoEspelho();
            sincronizarDaGrade();
        };

        // Várias mudanças no mesmo quadro (resize, colunas, fontes) viram um único recálculo.
        const agendarLayout = () => {
            if (quadroLayout === null) {
                quadroLayout = window.requestAnimationFrame(atualizarLayout);
            }
        };

        const aoRolarGrade = () => {
            if (ecoGrade !== null && Math.abs(grade.scrollLeft - ecoGrade) < 1) {
                ecoGrade = null;
                sincronizarCabecalho();
                return;
            }
            ecoGrade = null;
            sincronizarDaGrade();
        };

        const aoRolarProxy = () => {
            if (ecoProxy !== null && Math.abs(scrollProxy.scrollLeft - ecoProxy) < 1) {
                ecoProxy = null;
                return;
            }
            ecoProxy = null;
            if (grade.scrollLeft !== scrollProxy.scrollLeft) {
                grade.scrollLeft = scrollProxy.scrollLeft;
                ecoGrade = grade.scrollLeft;
            }
            sincronizarCabecalho();
        };

        const aoRolarPagina = () => sincronizarCabecalho();
        const observador = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(agendarLayout);
        // Largura de cada coluna do cabeçalho: muda sem mudar a tabela quando o conteúdo
        // redistribui as colunas (o espelho precisa ser refeito com as novas medidas).
        const observadorColunas = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(agendarLayout);
        let colunasObservadas = [];
        function observarColunas() {
            if (!observadorColunas) {
                return;
            }
            // Só refaz a observação se os th mudaram: observar de novo dispara uma medição
            // inicial, que recriaria o espelho em laço.
            const atuais = Array.from(cabecalho.querySelectorAll('th'));
            if (atuais.length === colunasObservadas.length && atuais.every((th, indice) => th === colunasObservadas[indice])) {
                return;
            }
            observadorColunas.disconnect();
            atuais.forEach((th) => observadorColunas.observe(th));
            colunasObservadas = atuais;
        }
        const fontes = typeof document !== 'undefined' ? document.fonts : null;

        grade.addEventListener('scroll', aoRolarGrade, { passive: true });
        scrollProxy.addEventListener('scroll', aoRolarProxy, { passive: true });
        window.addEventListener('scroll', aoRolarPagina, { passive: true });
        window.addEventListener('resize', agendarLayout);
        if (observador) {
            observador.observe(grade);
            observador.observe(tabela);
            observador.observe(cabecalho);
            observador.observe(scrollProxy);
        }
        if (fontes && typeof fontes.addEventListener === 'function') {
            fontes.addEventListener('loadingdone', agendarLayout);
            if (fontes.ready && typeof fontes.ready.then === 'function') {
                fontes.ready.then(agendarLayout).catch(() => {});
            }
        }
        orcamentoGridSincronizarRef.current = sincronizarDaGrade;

        atualizarLayout();

        return () => {
            grade.removeEventListener('scroll', aoRolarGrade);
            scrollProxy.removeEventListener('scroll', aoRolarProxy);
            window.removeEventListener('scroll', aoRolarPagina);
            window.removeEventListener('resize', agendarLayout);
            if (fontes && typeof fontes.removeEventListener === 'function') {
                fontes.removeEventListener('loadingdone', agendarLayout);
            }
            if (observador) {
                observador.disconnect();
            }
            if (observadorColunas) {
                observadorColunas.disconnect();
            }
            if (quadroLayout !== null) {
                window.cancelAnimationFrame(quadroLayout);
            }
            if (orcamentoGridSincronizarRef.current === sincronizarDaGrade) {
                orcamentoGridSincronizarRef.current = null;
            }
            cabecalhoFixo.replaceChildren();
        };
    }, [
        showPagamento,
        showPreEvento,
        showNegociado,
        showFechamento,
        quantidadeColunasPagamento,
        podeCalcularImpostoNfAccess,
        colunasNegociadoAdicionais.length,
        dados.orcamentoitem?.length,
        alturaAvisosRodape
    ]);

    return (
        <ErpTemplate processando={isLoading} chatbot={false}>
            <style>
                {`
                    .dropdown-toggle-no-caret::after {
                        display: none !important;
                    }
                    /* ── Grade do orçamento: compacta mas com respiro (meio-termo) ── */
                    /* O cabeçalho espelho (.orcamento-cabecalho-fixo) fica fora de .orcamento-grid:
                       recebe as mesmas regras do thead para ter as mesmas medidas (caso 20). */
                    .orcamento-grid table,
                    .orcamento-cabecalho-fixo table {
                        font-size: 0.85rem !important;
                        border: 1px solid #e9edf2 !important;
                    }
                    .orcamento-grid th,
                    .orcamento-grid td,
                    .orcamento-cabecalho-fixo th {
                        border-color: #eef1f5 !important;
                        padding: 7px 10px !important;
                        height: auto !important;
                        vertical-align: middle !important;
                    }
                    .orcamento-grid thead th,
                    .orcamento-cabecalho-fixo thead th {
                        font-size: 0.78rem !important;
                        font-weight: 600 !important;
                        color: #5b6b86 !important;
                        padding: 9px 10px !important;
                    }
                    .orcamento-grid input.form-control,
                    .orcamento-grid select.form-control,
                    .orcamento-grid select,
                    .orcamento-grid input[type="text"],
                    .orcamento-grid input[type="number"] {
                        height: 36px !important;
                        min-height: 36px !important;
                        font-size: 0.85rem !important;
                        padding: 5px 10px !important;
                    }
                    /* D-0132: em R$ o FEE tem mais dígitos que na moeda; cabe sem cortar no campo estreito. */
                    .orcamento-grid input.form-control.orcamento-fee-em-real {
                        font-size: 0.72rem !important;
                        padding: 5px 4px !important;
                    }
                    .orcamento-grid .fin-pp__btn,
                    .orcamento-cabecalho-fixo .fin-pp__btn {
                        padding: 5px 10px !important;
                        font-size: 0.82rem !important;
                        line-height: 1.3 !important;
                    }
                    /* ícones dentro da grade (status, chevrons) */
                    .orcamento-grid td svg,
                    .orcamento-grid .fin-pp__btn svg,
                    .orcamento-cabecalho-fixo .fin-pp__btn svg {
                        width: 15px !important;
                        height: 15px !important;
                    }
                    /* botões de ação (seta/lixeira/+subitem) — td .btn vence .btn.icon do app.css */
                    .orcamento-grid td .fin-pp__btn,
                    .orcamento-grid td .fin-pp__btn.icon {
                        padding: 5px 9px !important;
                        line-height: 1 !important;
                        min-height: 0 !important;
                        height: 34px !important;
                    }
                    .orcamento-grid td .fin-pp__btn svg {
                        width: 14px !important;
                        height: 14px !important;
                    }
                    /* A grade continua rolável por touch, trackpad e API; somente a
                       barra nativa dela fica oculta para não duplicar o controle fixo. */
                    .orcamento-grid {
                        -ms-overflow-style: none;
                        scrollbar-width: none;
                        -webkit-overflow-scrolling: touch;
                    }
                    .orcamento-grid::-webkit-scrollbar {
                        display: none;
                        width: 0;
                        height: 0;
                    }
                    .orcamento-conteudo-scroll:focus,
                    .orcamento-conteudo-scroll:focus-visible {
                        outline: none !important;
                    }
                    .orcamento-scroll-control {
                        display: none;
                        position: fixed;
                        z-index: 102;
                        left: var(--access-sidebar-w, 230px);
                        right: 0;
                        bottom: ${alturaAvisosRodape > 0 ? 68 + alturaAvisosRodape : 62}px;
                        height: 38px;
                        align-items: center;
                        gap: 7px;
                        padding: 5px 10px;
                        background: #f8fafc;
                        border-top: 1px solid #cbd5e1;
                        box-shadow: 0 -2px 8px rgba(15, 23, 42, .12);
                    }
                    /* Caso 20: sem scrollbar-gutter (reservava ~10px que o scrollWidth não
                       descontava — a barra parava antes da grade) e com flex-basis 0 (a
                       largura da barra não depende do conteúdo que ela mesma rola). */
                    .orcamento-scroll-proxy {
                        flex: 1 1 0;
                        min-width: 70px;
                        height: 24px;
                        overflow-x: auto;
                        overflow-y: hidden;
                    }
                    .orcamento-scroll-hint {
                        color: #415a77;
                        font-size: .78rem;
                        font-weight: 600;
                        white-space: nowrap;
                    }
                    .orcamento-scroll-button {
                        width: 27px;
                        height: 27px;
                        flex: 0 0 27px;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        color: #1d4f91;
                        background: #fff;
                        border: 1px solid #9db9d8;
                        border-radius: 6px;
                        cursor: pointer;
                    }
                    .orcamento-scroll-button:hover { background: #eaf2ff; }
                    .orcamento-scroll-button:focus-visible,
                    .orcamento-scroll-proxy:focus-visible {
                        outline: 3px solid rgba(49, 120, 212, .45);
                        outline-offset: 2px;
                    }
                    .orcamento-scroll-proxy::-webkit-scrollbar { height: 12px; }
                    .orcamento-scroll-proxy::-webkit-scrollbar-track { background: #e9edf2; }
                    .orcamento-scroll-proxy::-webkit-scrollbar-thumb { background: #58769b; border-radius: 8px; border: 2px solid #e9edf2; }
                    @media (max-width: 760px) {
                        .orcamento-scroll-hint { display: none; }
                        .orcamento-scroll-control { padding-left: 6px; padding-right: 6px; }
                    }
                    .orcamento-cabecalho-fixo {
                        display: none;
                        position: fixed;
                        top: 0;
                        z-index: 101;
                        overflow: hidden;
                        pointer-events: none;
                        box-shadow: 0 3px 9px rgba(15, 23, 42, .14);
                    }
                    /* react-select: o tamanho compacto agora vem do prop compact (API styles do
                       componente ReactSelect), que mantém o alinhamento interno correto. Não estilizar
                       o control/value/indicadores por CSS aqui (causava traço/seta/texto desalinhados). */
                `}
            </style>
            <div
                ref={orcamentoConteudoRef}
                className="main-content container-fluid fin-pp orcamento-conteudo-scroll"
                tabIndex={-1}
                onKeyDown={lidarComTeclaNoScrollOrcamento}
                onMouseDown={focarConteudoParaScrollHorizontal}
                style={{
                // SEM height/overflowY próprios: só a TELA rola (regra do Rafael —
                // dois scrolls verticais na mesma página atrapalham a usabilidade;
                // este é o mesmo ajuste já feito em outras telas). O rodapé é
                // position:fixed ao viewport, então não depende desta caixa.
                // overflowX fica: a grade larga rola horizontal AQUI dentro,
                // sem estourar a página para o lado.
                overflowX: 'auto',
                // padding-bottom reserva espaço para a barra fixa (.fixoRodape) não
                // cobrir o fim da grade (ex.: botão "+ Grupo") quando ela cresce e a página rola.
                // + altura dos avisos fixos (item 13): com o alerta aberto, o fim da página ainda consegue
                // subir acima dele (o "Mostrar campo" da última linha não fica atrás do alerta).
                // ATENÇÃO (20/10): o custom.css anula este padding com !important; quem reserva o espaço
                // dos avisos é o div data-espaco-avisos-rodape no fim da página.
                padding: `10px 10px ${90 + (alturaAvisosRodape > 0 ? alturaAvisosRodape + 38 : 0)}px 10px`
            }}>
                {/* Taxonomia Sanofi (23/10): detalhe dos 6 critérios da matriz de complexidade. */}
                {showTaxonomiaSanofi && taxonomiaSanofi && (
                    <div className="fin-pp fin-pp__sheet-backdrop" onClick={() => setShowTaxonomiaSanofi(false)}>
                        <div className="fin-pp__sheet" onClick={(e) => e.stopPropagation()} data-taxonomia-sanofi-detalhe="1">
                            <div className="fin-pp__sheet-head">
                                <span className="fin-pp__sheet-head-ic"><FaList size={17} /></span>
                                <div style={{ minWidth: 0, flex: 1 }}>
                                    <h3 className="fin-pp__sheet-title">
                                        Taxonomia Sanofi: {taxonomiaSanofi.completo ? `${taxonomiaSanofi.rotulo} (${taxonomiaSanofi.total} pts)` : 'incompleta'}
                                    </h3>
                                    <p className="fin-pp__sheet-sub">Simples 6–9 · Média 10–14 · Complexa 15–18</p>
                                </div>
                                <button type="button" className="fin-pp__sheet-close" onClick={() => setShowTaxonomiaSanofi(false)}><FaTimes size={16} /></button>
                            </div>
                            <div className="fin-pp__sheet-body">
                                {taxonomiaSanofi.criterios.map((criterio) => (
                                    <div key={criterio.chave} className="fin-pp__sheet-item" style={{ cursor: 'default' }}>
                                        <span className={'fin-pp__sheet-item-ic ' + (criterio.pontos === null ? 'is-muted' : 'is-ok')}>{criterio.pontos ?? '–'}</span>
                                        <span className="fin-pp__sheet-item-txt">
                                            <span className="fin-pp__sheet-item-label">{criterio.rotulo}</span>
                                            <span className="fin-pp__sheet-item-desc">{criterio.motivo}</span>
                                        </span>
                                        <span className="fin-pp__sheet-badge">{criterio.pontos === null ? 'Pendente' : `${criterio.pontos} pt${criterio.pontos > 1 ? 's' : ''}`}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
                {/* ── Cabeçalho compacto: título + ações + chips de alerta ── */}
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: '8px',
                    marginBottom: '8px',
                }}>
                    <div className="d-flex align-items-center flex-wrap gap-2">
                        <h4 style={{ margin: 0, fontWeight: 600, color: '#1a1a2e' }}>
                            {(copiar ? 'Copiar ' : '')}{dados.nomeEvento ? `${dados.nomeEvento}` : 'Orçamento'}
                        </h4>
                        {/* Item 2 (01/10): pax de todas as contas do orçamento — só leitura, edita no evento. */}
                        {eventoIdOrcamento && (
                            <span
                                className={'fin-pp__pill ' + (faltaConvidadosEsperados ? 'is-warn' : 'is-info')}
                                data-convidados-esperados="1"
                                style={{ fontSize: '0.75rem' }}
                                title={faltaConvidadosEsperados
                                    ? 'Sem o número, as contas por pax (FEE) não usam o evento. O link abre o evento em outra aba; ao voltar o número é recarregado.'
                                    : 'Número de convidados esperados do cadastro do evento. É o pax usado no FEE e nas demais contas do orçamento.'}
                            >
                                {faltaConvidadosEsperados
                                    ? 'Convidados esperados: não informado'
                                    : `Convidados esperados: ${Number(eventoConvidadosEsperados).toLocaleString('pt-BR')} (do evento)`}
                                {' · '}
                                <Link to={'/cadastroEvento/' + eventoIdOrcamento} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'underline' }}>editar no evento</Link>
                            </span>
                        )}
                        {taxonomiaSanofi && (
                            <button
                                type="button"
                                className={'fin-pp__pill ' + (taxonomiaSanofi.completo ? 'is-info' : 'is-warn')}
                                data-taxonomia-sanofi={taxonomiaSanofi.classificacao || 'incompleta'}
                                style={{ fontSize: '0.75rem', cursor: 'pointer', border: 0 }}
                                title="Matriz de complexidade Sanofi: 6 critérios de 1 a 3 pontos. Clique para ver o detalhe."
                                onClick={() => setShowTaxonomiaSanofi(true)}
                            >
                                {taxonomiaSanofi.completo
                                    ? `Taxonomia: ${taxonomiaSanofi.rotulo} · ${taxonomiaSanofi.total} pts`
                                    : 'Taxonomia: incompleta'}
                            </button>
                        )}
                    </div>
                    <div className="d-flex align-items-center flex-wrap gap-2">
                        {/* Badge PO ausente — compacto, com tooltip */}
                        {posAprovadasDoEvento !== null && posAprovadasDoEvento.length === 0 && (dados?.evento?.id ?? dados?.evento) && (
                            <span
                                title="Evento sem PO aprovada. Pagamentos aos fornecedores serão bloqueados até que ao menos uma PO seja aprovada na tela do Evento."
                                style={{
                                    background: '#ffebee', border: '1px solid #ef5350',
                                    color: '#b71c1c', borderRadius: 20,
                                    padding: '3px 10px', fontSize: '0.78rem',
                                    display: 'inline-flex', alignItems: 'center', gap: 4,
                                    cursor: 'help', fontWeight: 500,
                                }}
                            >
                                ⛔ Sem PO
                            </span>
                        )}
                        {/* Câmbio do topo (Rafael 19/10, voltou): reserva — linhas sem câmbio próprio e célula de câmbio do Excel
                            enquanto o câmbio de Fechamento não foi informado. Não regrava o Fechamento das linhas. */}
                        {eventoEhInternacional && (
                            <button type="button" className="btn btn-sm btn-outline-secondary" style={{ fontSize: '0.8rem' }} onClick={() => setShowModalCambio(true)}>
                                <FaExchangeAlt size={12} /> Câmbio
                                {obterMoedaOrcamento() !== 'real' && !carregandoCambioSugerido && (
                                    <span style={{ marginLeft: 4, fontSize: '0.75rem' }}>
                                        1 {obterSimboloMoedaOrcamento()} = R$ {formatarCambio(obterCambioAtual())}
                                    </span>
                                )}
                                {carregandoCambioSugerido && <span style={{ marginLeft: 4, fontStyle: 'italic', fontSize: '0.75rem' }}>...</span>}
                            </button>
                        )}
                        {/* Tabela do FEE — Épico 12 (só exibe quando há mais de 1 versão pra escolher) */}
                        {obterVersoesFee().length > 1 && (
                            <button type="button" className="btn btn-sm btn-outline-secondary" style={{ fontSize: '0.8rem' }}
                                onClick={abrirModalFeeVersao}>
                                <FaPercent size={12} /> Tabela do FEE: <strong style={{ marginLeft: 4 }}>{dados.fee_versao || '— selecionar'}</strong>
                                <span style={{ marginLeft: 6, textDecoration: 'underline' }}>(trocar)</span>
                            </button>
                        )}
                        {/* Tabela de valores (período) — Épico 13 (Abbvie) */}
                        {obterVersoesTabela().length > 0 && !feeAllerganGravado && (
                            <button type="button" className="btn btn-sm btn-outline-secondary" style={{ fontSize: '0.8rem' }}
                                onClick={abrirModalTabelaVersao}>
                                <FaTable size={12} /> Tabela de valores: <strong style={{ marginLeft: 4 }}>{dados.tabela_versao || '— selecionar'}</strong>
                            </button>
                        )}
                        {/* FEE do Mini Meeting (AbbVie, 28/09): qual regra valeu em cada etapa */}
                        {resumoFeeMiniMeeting && !feeAllerganGravado && (
                            <span
                                className="fin-pp__pill is-info"
                                data-fee-mini-meeting="1"
                                style={{ fontSize: '0.75rem' }}
                                title={resumoFeeMiniMeeting.map((e) => `${e.etapa}: base R$ ${Number(e.base).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} → FEE R$ ${Number(e.valor).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`).join('\n')}
                            >
                                FEE Mini Meeting · {resumoFeeMiniMeeting.map((e) => `${e.etapa}: ${e.texto}`).join(' · ')}
                            </span>
                        )}
                        {/* Informações */}
                        <button type="button" className="btn btn-sm btn-outline-secondary" style={{ fontSize: '0.8rem' }} onClick={() => setShowModalInformacoes(true)}>
                            <FaList size={12} /> Informações
                        </button>
                        {/* Produtos */}
                        <button type="button" className="btn btn-sm btn-outline-secondary" style={{ fontSize: '0.8rem' }} onClick={() => setShowModalProdutos(true)}>
                            <FaList size={12} /> Produtos
                            {dados.orcamentoproduto && dados.orcamentoproduto.length > 0 && (
                                <span className="badge rounded-pill ms-1" style={{ background: '#6c757d', color: '#fff', fontSize: '0.7rem' }}>
                                    {dados.orcamentoproduto.length}
                                </span>
                            )}
                        </button>
                        {/* Solicitar NF — toggle */}
                        {dados.orcamentoitem && dados.orcamentoitem.length > 0 && (() => {
                            const fornecedoresMap = {};
                            dados.orcamentoitem.forEach((item, iS) => {
                                (item.subitem || []).forEach((sub, iI) => {
                                    const fId = sub.fornecedor?.id || `u_${iS}_${iI}`;
                                    if (!fornecedoresMap[fId]) fornecedoresMap[fId] = { nome: sub.fornecedor?.nome || 'Fornecedor não identificado', itens: [] };
                                    fornecedoresMap[fId].itens.push({ indexSuperior: iS, indexInferior: iI, subitem: sub });
                                });
                            });
                            const cnt = Object.keys(fornecedoresMap).length;
                            if (cnt === 0) return null;
                            return (
                                <button
                                    type="button"
                                    className="fin-pp__btn fin-pp__btn--sm"
                                    style={{
                                        fontSize: '0.8rem',
                                        background: showNFSection ? '#fff3e0' : 'transparent',
                                        border: '1px solid #fb8c00',
                                        color: '#e65100',
                                    }}
                                    onClick={() => setShowNFSection(!showNFSection)}
                                    title="Solicitar Nota Fiscal por fornecedor"
                                >
                                    <FaEnvelope size={12} /> Solicitar NF
                                    <span className="badge rounded-pill ms-1" style={{ background: '#fb8c00', color: '#fff', fontSize: '0.7rem' }}>
                                        {cnt}
                                    </span>
                                </button>
                            );
                        })()}
                    </div>
                </div>

                {/* D-0052 parte 4a: outro operador com versão não salva deste orçamento (aviso ao abrir) */}
                <AvisoOutroOperadorOrcamento outros={rascunhoOrcamento.outrosOperadores} />

                {/* Selector de modelos (só em novo orçamento) */}
                {!id && (
                    <div className="mb-2">
                        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                            <div className="d-flex align-items-center flex-wrap gap-2">
                                <span className="fw-bold d-inline-flex align-items-center" style={{ color: '#1f3556', fontSize: '0.9rem' }}>
                                    <FaFileAlt size={13} style={{ marginRight: '5px' }} /> Selecionar Modelo:
                                </span>
                                {modeloSelecionadoOrcamento?.nome && (
                                    <span className="badge rounded-pill d-inline-flex align-items-center" style={{ backgroundColor: '#e7eefb', color: '#1d4fa8', fontSize: '0.95rem', fontWeight: 600, padding: '6px 12px', gap: 8 }}>
                                        <span>{modeloSelecionadoOrcamento.nome}</span>
                                        <button type="button" onClick={() => setModeloSelecionadoOrcamento(null)} className="fin-pp__btn" style={{ border: 'none', color: '#7b7b7b', lineHeight: 1 }} title="Limpar modelo">
                                            <FaTimes size={13} />
                                        </button>
                                    </span>
                                )}
                            </div>
                            <div className="d-flex gap-2 flex-wrap">
                                <button type="button" className="fin-pp__btn fin-pp__btn--sm" style={{ backgroundColor: '#1f56b8', borderColor: '#1f56b8', color: '#fff' }} onClick={() => abrirModalModelosOrcamento('meus')}>
                                    <FaFolder size={13} style={{ marginRight: '5px' }} /> Meus Modelos
                                </button>
                                <button type="button" className="fin-pp__btn fin-pp__btn--sm" style={{ backgroundColor: '#072a63', borderColor: '#072a63', color: '#fff' }} onClick={() => abrirModalModelosOrcamento('outros')}>
                                    <FaGlobeAmericas size={13} style={{ marginRight: '5px' }} /> Outros Modelos
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Painel Solicitar NF — colapsável */}
                {showNFSection && dados.orcamentoitem && dados.orcamentoitem.length > 0 && (() => {
                    const fornecedoresMap = {};
                    dados.orcamentoitem.forEach((item, iS) => {
                        (item.subitem || []).forEach((sub, iI) => {
                            const fId = sub.fornecedor?.id || `u_${iS}_${iI}`;
                            if (!fornecedoresMap[fId]) fornecedoresMap[fId] = { nome: sub.fornecedor?.nome || 'Fornecedor não identificado', itens: [] };
                            fornecedoresMap[fId].itens.push({ indexSuperior: iS, indexInferior: iI, subitem: sub });
                        });
                    });
                    const fornecedores = Object.values(fornecedoresMap);
                    if (fornecedores.length === 0) return null;
                    return (
                        <div className="mb-2" style={{ background: '#fff8f0', border: '1px solid #ffe0b2', borderRadius: 8, padding: '10px 14px' }}>
                            <div style={{ fontSize: '0.75rem', color: '#bf360c', fontWeight: 600, marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                                <FaEnvelope size={12} style={{ marginRight: 5 }} /> Solicitar Nota Fiscal por fornecedor
                            </div>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                                {fornecedores.map((fornecedor, idx) => (
                                    <button
                                        key={idx}
                                        type="button"
                                        className="fin-pp__btn fin-pp__btn--sm"
                                        onClick={() => {
                                            const primeiroItem = fornecedor.itens[0];
                                            setItemSolicitarNF({
                                                indexSuperior: primeiroItem.indexSuperior,
                                                indexInferior: primeiroItem.indexInferior,
                                                fornecedor_nome: fornecedor.nome,
                                                produto_nome: primeiroItem.subitem.titulo || primeiroItem.subitem.nome_evento || 'Descrição não disponível',
                                                ...primeiroItem.subitem
                                            });
                                            const emailFornecedor = primeiroItem.subitem.fornecedor?.email || '';
                                            setEmailsDestinatarios(emailFornecedor ? [emailFornecedor] : []);
                                            setNovoEmail('');
                                            setShowModalSolicitarNF(true);
                                        }}
                                        style={{
                                            backgroundColor: '#1976d2', border: 'none', color: 'white',
                                            borderRadius: 16, padding: '4px 12px', fontSize: '0.8rem',
                                            display: 'flex', alignItems: 'center', gap: 5,
                                        }}
                                    >
                                        <FaBuilding size={12} />
                                        {fornecedor.nome}
                                        <span style={{ background: 'rgba(255,255,255,0.25)', borderRadius: 10, padding: '1px 6px', fontSize: '0.72rem', fontWeight: 700 }}>
                                            {fornecedor.itens.length}
                                        </span>
                                    </button>
                                ))}
                            </div>
                        </div>
                    );
                })()}

                {/* ── Faixa sticky de resumo financeiro ── */}
                {parseValorBrFlexivel(dados.valorAdiantamento) > 0 && (() => {
                    const rf = calcularResumoFinanceiro();
                    return (
                        <div
                            className="d-flex flex-wrap mb-2"
                            style={{
                                position: 'sticky',
                                top: 0,
                                zIndex: 90,
                                background: '#fff',
                                borderBottom: '1px solid #dee2e6',
                                borderTop: '1px solid #dee2e6',
                                padding: '8px 4px',
                                gap: 0,
                                marginLeft: -10,
                                marginRight: -10,
                                paddingLeft: 14,
                                paddingRight: 14,
                            }}
                        >
                            <div style={{ flex: '1 1 140px', minWidth: 120, padding: '2px 12px 2px 0' }}>
                                <div style={{ fontSize: '0.65rem', color: '#6c757d', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 1 }}>📊 Total do Orçamento</div>
                                <div style={{ fontSize: '1rem', fontWeight: 600, color: '#343a40' }}>R$ {rf.totalOrcamento.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</div>
                            </div>
                            <div style={{ flex: '1 1 140px', minWidth: 120, padding: '2px 12px', borderLeft: '1px solid #e9ecef' }}>
                                <div style={{ fontSize: '0.65rem', color: '#6c757d', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 1 }}>💰 Adiantamento Aprovado</div>
                                <div style={{ fontSize: '1rem', fontWeight: 600, color: '#e65100' }}>R$ {rf.aprovado.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</div>
                            </div>
                            <div style={{ flex: '1 1 140px', minWidth: 120, padding: '2px 12px', borderLeft: '1px solid #e9ecef' }}>
                                <div style={{ fontSize: '0.65rem', color: '#6c757d', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 1 }}>✅ Adiantamento Utilizado</div>
                                <div style={{ fontSize: '1rem', fontWeight: 600, color: '#1565c0' }}>R$ {rf.totalDistribuido.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</div>
                            </div>
                            <div style={{ flex: '1 1 140px', minWidth: 120, padding: '2px 0 2px 12px', borderLeft: '1px solid #e9ecef' }}>
                                <div style={{ fontSize: '0.65rem', color: '#6c757d', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 1 }}>💵 Saldo Disponível</div>
                                <div style={{ fontSize: '1rem', fontWeight: 600, color: rf.saldo < 0 ? '#c62828' : '#2e7d32' }}>R$ {rf.saldo.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</div>
                            </div>
                        </div>
                    );
                })()}

                <section id="multiple-column-form">
                    <div className="row match-height">
                        <div className="col-sm-12">
                            <form className="form" onSubmit={(e) => { salvar(); e.preventDefault(); }} style={{ marginBottom: '10px' }}>
                                <div className="row" style={{ marginBottom: '10px' }}>

                                    <div className="row mb-2" style={{ marginLeft: '0', marginRight: '0' }}>
                                        <div className="col-sm-12" style={{ padding: '0' }}>
                                            <div className="d-flex justify-content-end mb-2" style={{ gap: '8px' }}>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-outline-secondary"
                                                    onClick={toggleColunaAcoesTravada}
                                                    disabled={colunaDescricaoTravada}
                                                    title={colunaDescricaoTravada ? 'A coluna Ações fica travada enquanto Descrição de Custos estiver travada' : (colunaAcoesTravadaEfetiva ? 'Destravar coluna Ações' : 'Travar coluna Ações')}
                                                >
                                                    {colunaAcoesTravadaEfetiva ? <FaLock className="me-1" /> : <FaLockOpen className="me-1" />}
                                                    Ações
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-outline-secondary"
                                                    onClick={toggleColunaDescricaoTravada}
                                                    title={colunaDescricaoTravada ? 'Destravar coluna Descrição de Custos' : 'Travar coluna Descrição de Custos (e Ações)'}
                                                >
                                                    {colunaDescricaoTravada ? <FaLock className="me-1" /> : <FaLockOpen className="me-1" />}
                                                    Descrição de Custos
                                                </button>
                                            </div>
                                            {/* Banner de pendências removido — informações já exibidas nos cards sticky acima (2026-05-29) */}

                                            {/* Sem scroll vertical próprio: a grade cresce e quem rola é a página
                                                (evita "scroll dentro de scroll"). Mantém só o scroll horizontal
                                                da grade por causa das muitas colunas de valor. */}
                                            <div ref={orcamentoGridCabecalhoFixoRef} className="orcamento-cabecalho-fixo" aria-hidden="true" />
                                            <div
                                                ref={orcamentoGridRef}
                                                className="orcamento-grid"
                                                style={{
                                                overflowX: 'auto',
                                                width: '100%',
                                                position: 'relative'
                                                }}
                                            >
                                                <table
                                                    className="table table-bordered mb-0"
                                                    style={{
                                                        borderCollapse: 'separate',
                                                        borderSpacing: 0,
                                                        border: '2px solid #dee2e6'
                                                    }}
                                                >
                                                    <thead style={{
                                                        backgroundColor: '#f8f9fa',
                                                        position: 'sticky',
                                                        top: 0,
                                                        zIndex: 10
                                                    }}>
                                                        <tr>
                                                            <th rowSpan="2" style={{
                                                                width: `${larguraColunaAcoes}px`,
                                                                minWidth: `${larguraColunaAcoes}px`,
                                                                maxWidth: `${larguraColunaAcoes}px`,
                                                                verticalAlign: 'middle',
                                                                border: '1px solid #dee2e6',
                                                                textAlign: 'center',
                                                                backgroundColor: '#f8f9fa',
                                                                color: '#495057',
                                                                fontWeight: '600',
                                                                ...getColunaAcoesStickyStyle(11)
                                                            }}>
                                                                <button
                                                                    title={expandedRows === true ? 'Recolher Todos' : 'Expandir Todos'}
                                                                    type="button"
                                                                    className="fin-pp__btn"
                                                                    style={{
                                                                        position: 'absolute',
                                                                        bottom: 2,
                                                                        left: 2,
                                                                        zIndex: 2,
                                                                        padding: 2,
                                                                        minWidth: 28,
                                                                        minHeight: 28
                                                                    }}
                                                                    onClick={() => {
                                                                        if (expandedRows === true) {
                                                                            setExpandedRows([]);
                                                                        } else {
                                                                            setExpandedRows(true);
                                                                        }
                                                                    }}
                                                                >
                                                                    {expandedRows === true ? <><FaChevronDown /></> : <><FaChevronRight /></>}
                                                                </button>
                                                                Ações
                                                            </th>
                                                            <th rowSpan="2" style={{
                                                                width: `${larguraColunaDescricao}px`,
                                                                minWidth: `${larguraColunaDescricao}px`,
                                                                maxWidth: `${larguraColunaDescricao}px`,
                                                                verticalAlign: 'middle',
                                                                border: '1px solid #dee2e6',
                                                                textAlign: 'center',
                                                                backgroundColor: '#f8f9fa',
                                                                color: '#495057',
                                                                fontWeight: '600',
                                                                ...getColunaDescricaoStickyStyle(10)
                                                            }}>Descrição de Custos</th>
                                                            <th rowSpan="2" style={{
                                                                width: '300px',
                                                                minWidth: '300px',
                                                                maxWidth: '300px',
                                                                verticalAlign: 'middle',
                                                                border: '1px solid #dee2e6',
                                                                textAlign: 'center',
                                                                backgroundColor: '#f8f9fa',
                                                                color: '#495057',
                                                                fontWeight: '600'
                                                            }}>Fornecedor Custos</th>
                                                            <th colSpan={showPreEvento ? 8 : 1} style={{
                                                                textAlign: 'center',
                                                                backgroundColor: '#e3f2fd',
                                                                border: '1px solid #dee2e6',
                                                                color: '#1976d2',
                                                                fontWeight: 'bold',
                                                                position: 'relative',
                                                                paddingRight: '40px',
                                                                ...(!showPreEvento ? { width: 200, minWidth: 200, maxWidth: 200 } : {})
                                                            }}>
                                                                Valor Pré-evento
                                                                <Dropdown style={{ position: 'absolute', right: '2px', top: '2px' }}>
                                                                    <Dropdown.Toggle
                                                                        variant="light"
                                                                        size="sm"
                                                                        className="dropdown-toggle-no-caret"
                                                                        style={{
                                                                            padding: '2px 6px',
                                                                            fontSize: '16px',
                                                                            color: '#000',
                                                                            backgroundColor: '#f0f0f0',
                                                                            border: '1px solid #ddd',
                                                                            textDecoration: 'none',
                                                                            lineHeight: '1'
                                                                        }}
                                                                    >
                                                                        ⋮
                                                                    </Dropdown.Toggle>
                                                                    <Dropdown.Menu>
                                                                        <Dropdown.Item onClick={() => setShowPreEvento(!showPreEvento)}>
                                                                            {showPreEvento ? '− Recolher colunas' : '+ Expandir colunas'}
                                                                        </Dropdown.Item>
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            </th>
                                                            {/* Colunas Adicionais de Negociado - Títulos Principais */}
                                                            {colunasNegociadoAdicionais.map((coluna) => (
                                                                <th key={coluna.id} colSpan={colunasNegociadoVisibility[coluna.id] ? 6 : 1} style={{
                                                                    textAlign: 'center',
                                                                    backgroundColor: '#fff3e0',
                                                                    border: '1px solid #dee2e6',
                                                                    color: '#f57c00',
                                                                    fontWeight: 'bold',
                                                                    position: 'relative',
                                                                    ...(!colunasNegociadoVisibility[coluna.id] ? { width: 100, minWidth: 100, maxWidth: 100 } : {})
                                                                }}>
                                                                    <button
                                                                        title={colunasNegociadoVisibility[coluna.id] ? `Esconder colunas de ${coluna.nome}` : `Mostrar colunas de ${coluna.nome}`}
                                                                        type="button"
                                                                        className="fin-pp__btn fin-pp__btn--sm"
                                                                        style={{
                                                                            position: 'absolute',
                                                                            top: '2px',
                                                                            left: '2px',
                                                                            zIndex: 2,
                                                                            padding: '2px 4px',
                                                                            fontSize: '10px',
                                                                            backgroundColor: 'rgba(255,255,255,0.8)',
                                                                            border: '1px solid #ccc'
                                                                        }}
                                                                        onClick={() => toggleColunaVisibility(coluna.id)}
                                                                    >
                                                                        {colunasNegociadoVisibility[coluna.id] ? '−' : '+'}
                                                                    </button>
                                                                    {ehVersaoCongelada(coluna) ? rotuloVersao(coluna) : coluna.nome}
                                                                    {ehVersaoCongelada(coluna) && <span style={{ display: 'block', fontSize: '10px', fontWeight: 'normal', color: '#8a6d3b' }}>histórico · só leitura</span>}
                                                                    {!ehVersaoCongelada(coluna) && <span style={{ display: 'block', fontSize: '10px', fontWeight: 'normal', color: '#c1232b' }}>jeito antigo · não soma</span>}
                                                                    <button
                                                                        type="button"
                                                                        className="fin-pp__btn fin-pp__btn--sm"
                                                                        style={{
                                                                            position: 'absolute',
                                                                            top: '2px',
                                                                            right: '2px',
                                                                            fontSize: '8px',
                                                                            padding: '1px 3px',
                                                                            backgroundColor: '#ff5722',
                                                                            color: 'white',
                                                                            border: 'none',
                                                                            zIndex: 2
                                                                        }}
                                                                        onClick={() => removerColunaNegociado(coluna.id)}
                                                                        title={ehVersaoCongelada(coluna) ? `Excluir a ${coluna.nome}` : 'Remover coluna'}
                                                                    >
                                                                        ×
                                                                    </button>
                                                                </th>
                                                            ))}

                                                            <th colSpan={showNegociado ? 8 : 1} style={{
                                                                textAlign: 'center',
                                                                backgroundColor: '#fff3e0',
                                                                border: '1px solid #dee2e6',
                                                                color: '#f57c00',
                                                                fontWeight: 'bold',
                                                                position: 'relative',
                                                                paddingRight: '40px',
                                                                ...(!showNegociado ? { width: 230, minWidth: 230, maxWidth: 230 } : {})
                                                            }}>
                                                                Custos Negociados{rotuloVersaoAtual(colunasNegociadoAdicionais) ? ` (${rotuloVersaoAtual(colunasNegociadoAdicionais)})` : ''}
                                                                <Dropdown style={{ position: 'absolute', right: '2px', top: '2px' }}>
                                                                    <Dropdown.Toggle
                                                                        variant="light"
                                                                        size="sm"
                                                                        className="dropdown-toggle-no-caret"
                                                                        style={{
                                                                            padding: '2px 6px',
                                                                            fontSize: '16px',
                                                                            color: '#000',
                                                                            backgroundColor: '#f0f0f0',
                                                                            border: '1px solid #ddd',
                                                                            textDecoration: 'none',
                                                                            lineHeight: '1'
                                                                        }}
                                                                    >
                                                                        ⋮
                                                                    </Dropdown.Toggle>
                                                                    <Dropdown.Menu>
                                                                        <Dropdown.Item onClick={() => setShowNegociado(!showNegociado)}>
                                                                            {showNegociado ? '− Recolher colunas' : '+ Expandir colunas'}
                                                                        </Dropdown.Item>
                                                                        <Dropdown.Divider />
                                                                        <Dropdown.Item onClick={() => {
                                                                            copiaValores("PreEvento", "Negociado", null, false);
                                                                            toast.success('Valores copiados de Pré-evento!');
                                                                        }}>
                                                                            <FaCopy style={{ marginRight: '8px' }} /> Copiar de Pré-evento
                                                                        </Dropdown.Item>
                                                                        <Dropdown.Item onClick={adicionarColunaNegociado} disabled={!!motivoBloqueioNovaVersao(dados.orcamentoitem)}>
                                                                            <FaPlus style={{ marginRight: '8px' }} /> Nova versão do Negociado
                                                                            <small className="d-block text-muted" style={{ whiteSpace: 'normal', maxWidth: 260 }}>
                                                                                {motivoBloqueioNovaVersao(dados.orcamentoitem) || 'Guarda os valores de agora como histórico; esta coluna segue editável e vigente.'}
                                                                            </small>
                                                                        </Dropdown.Item>
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            </th>
                                                            <th colSpan={showFechamento ? 8 : 1} style={{
                                                                textAlign: 'center',
                                                                backgroundColor: '#e8f5e8',
                                                                border: '1px solid #dee2e6',
                                                                color: '#388e3c',
                                                                fontWeight: 'bold',
                                                                position: 'relative',
                                                                paddingRight: '40px',
                                                                ...(!showFechamento ? { width: 260, minWidth: 260, maxWidth: 260 } : {})
                                                            }}>
                                                                Valor Real (Fechamento)
                                                                <Dropdown style={{ position: 'absolute', right: '2px', top: '2px' }}>
                                                                    <Dropdown.Toggle
                                                                        variant="light"
                                                                        size="sm"
                                                                        className="dropdown-toggle-no-caret"
                                                                        style={{
                                                                            padding: '2px 6px',
                                                                            fontSize: '16px',
                                                                            color: '#000',
                                                                            backgroundColor: '#f0f0f0',
                                                                            border: '1px solid #ddd',
                                                                            textDecoration: 'none',
                                                                            lineHeight: '1'
                                                                        }}
                                                                    >
                                                                        ⋮
                                                                    </Dropdown.Toggle>
                                                                    <Dropdown.Menu>
                                                                        <Dropdown.Item onClick={() => setShowFechamento(!showFechamento)}>
                                                                            {showFechamento ? '− Recolher colunas' : '+ Expandir colunas'}
                                                                        </Dropdown.Item>
                                                                        <Dropdown.Divider />
                                                                        <Dropdown.Item onClick={() => {
                                                                            copiaValores("Negociado", "Fechamento", null, false);
                                                                            toast.success('Valores copiados de Negociado!');
                                                                        }}>
                                                                            <FaCopy style={{ marginRight: '8px' }} /> Copiar de Negociado
                                                                        </Dropdown.Item>
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            </th>
                                                            <th colSpan={showPagamento ? quantidadeColunasPagamento : 1} style={{
                                                                textAlign: 'center',
                                                                backgroundColor: '#f1f8e9',
                                                                border: '1px solid #dee2e6',
                                                                color: '#33691e',
                                                                fontWeight: 'bold',
                                                                position: 'relative',
                                                                paddingRight: '40px',
                                                                ...(!showPagamento ? { width: 200, minWidth: 200, maxWidth: 200 } : {})
                                                            }}>
                                                                Pagamento
                                                                <Dropdown style={{ position: 'absolute', right: '2px', top: '2px' }}>
                                                                    <Dropdown.Toggle
                                                                        variant="light"
                                                                        size="sm"
                                                                        className="dropdown-toggle-no-caret"
                                                                        style={{
                                                                            padding: '2px 6px',
                                                                            fontSize: '16px',
                                                                            color: '#000',
                                                                            backgroundColor: '#f0f0f0',
                                                                            border: '1px solid #ddd',
                                                                            textDecoration: 'none',
                                                                            lineHeight: '1'
                                                                        }}
                                                                    >
                                                                        ⋮
                                                                    </Dropdown.Toggle>
                                                                    <Dropdown.Menu>
                                                                        <Dropdown.Item onClick={() => setShowPagamento(!showPagamento)}>
                                                                            {showPagamento ? '− Recolher colunas' : '+ Expandir colunas'}
                                                                        </Dropdown.Item>
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            </th>

                                                            {/* Épico 2 — Grupo: Atribuir Adiantamento — removido da UI do orçamento em 2026-06-02 (gerenciado na Central Financeira) */}
                                                            {false && showPagamento && (
                                                                <th colSpan={2} style={{
                                                                    textAlign: 'center',
                                                                    backgroundColor: '#e65100',
                                                                    border: '1px solid #bf360c',
                                                                    color: '#fff',
                                                                    fontWeight: 'bold',
                                                                    letterSpacing: '0.04em',
                                                                    fontSize: '0.82rem',
                                                                }}>💰 Atribuir Adiantamento</th>
                                                            )}

                                                            {/* Colunas independentes: Fora Escopo e Equipamentos (rowSpan=2 para ambas as linhas do cabeçalho) */}
                                                            {/* 20/10 (Rafael, treinamento turma 5): "Fora Escopo?" oculta — MOSTRAR_COLUNA_FORA_ESCOPO. */}
                                                            {MOSTRAR_COLUNA_FORA_ESCOPO && (
                                                            <th rowSpan={2} style={{
                                                                width: '120px',
                                                                minWidth: '120px',
                                                                maxWidth: '120px',
                                                                backgroundColor: '#fff3e0',
                                                                border: '1px solid #dee2e6',
                                                                textAlign: 'center',
                                                                verticalAlign: 'middle',
                                                                color: '#f57c00',
                                                                fontWeight: 'bold'
                                                            }}>Fora Escopo?</th>
                                                            )}
                                                            <th rowSpan={2} style={{
                                                                width: '180px',
                                                                minWidth: '180px',
                                                                maxWidth: '180px',
                                                                backgroundColor: '#e8f0fe',
                                                                border: '1px solid #dee2e6',
                                                                textAlign: 'center',
                                                                verticalAlign: 'middle',
                                                                color: '#1a73e8',
                                                                fontWeight: 'bold'
                                                            }}>Equipamentos</th>
                                                        </tr>
                                                        <tr>
                                                            {showPreEvento && (
                                                                <>
                                                                    <th style={{
                                                                        width: larguraColunaMonetaria,
                                                                        minWidth: larguraColunaMonetaria,
                                                                        maxWidth: larguraColunaMonetaria,
                                                                        backgroundColor: '#e3f2fd',
                                                                        border: '1px solid #dee2e6',
                                                                        textAlign: 'center',
                                                                        color: '#1976d2'
                                                                    }}>Valor Unit.</th>
                                                                    <th style={{
                                                                        width: '80px',
                                                                        minWidth: '80px',
                                                                        maxWidth: '80px',
                                                                        backgroundColor: '#e3f2fd',
                                                                        border: '1px solid #dee2e6',
                                                                        textAlign: 'center',
                                                                        color: '#1976d2'
                                                                    }}>Diárias</th>
                                                                    <th style={{
                                                                        width: '80px',
                                                                        minWidth: '80px',
                                                                        maxWidth: '80px',
                                                                        backgroundColor: '#e3f2fd',
                                                                        border: '1px solid #dee2e6',
                                                                        textAlign: 'center',
                                                                        color: '#1976d2'
                                                                    }}>Qtde</th>
                                                                    <th style={{
                                                                        width: '80px',
                                                                        minWidth: '80px',
                                                                        maxWidth: '80px',
                                                                        backgroundColor: '#e3f2fd',
                                                                        border: '1px solid #dee2e6',
                                                                        textAlign: 'center',
                                                                        color: '#1976d2'
                                                                    }}>% Serviço</th>
                                                                    <th style={{
                                                                        width: '80px',
                                                                        minWidth: '80px',
                                                                        maxWidth: '80px',
                                                                        backgroundColor: '#e3f2fd',
                                                                        border: '1px solid #dee2e6',
                                                                        textAlign: 'center',
                                                                        color: '#1976d2'
                                                                    }} title="Tributo ou taxa local cobrada pelo fornecedor; compõe o valor do serviço.">% Tributo fornecedor</th>
                                                                    <th style={{
                                                                        width: '80px',
                                                                        minWidth: '80px',
                                                                        maxWidth: '80px',
                                                                        backgroundColor: '#e3f2fd',
                                                                        border: '1px solid #dee2e6',
                                                                        textAlign: 'center',
                                                                        color: '#1976d2'
                                                                    }}>% Imposto NF</th>
                                                                    <th style={{
                                                                        width: larguraColunaTotalMonetaria,
                                                                        minWidth: larguraColunaTotalMonetaria,
                                                                        maxWidth: larguraColunaTotalMonetaria,
                                                                        backgroundColor: '#e3f2fd',
                                                                        border: '1px solid #dee2e6',
                                                                        textAlign: 'center',
                                                                        color: '#1976d2'
                                                                    }}>Total</th>
                                                                    <th style={{
                                                                        width: '180px',
                                                                        minWidth: '180px',
                                                                        maxWidth: '180px',
                                                                        backgroundColor: '#e3f2fd',
                                                                        border: '1px solid #dee2e6',
                                                                        textAlign: 'center',
                                                                        color: '#1976d2'
                                                                    }}>Observação</th>
                                                                </>
                                                            )}

                                                            {/* Célula em branco quando Pré-evento está escondido */}
                                                            {!showPreEvento && (
                                                                <th style={{
                                                                    backgroundColor: '#fff',
                                                                    border: '1px solid #dee2e6',
                                                                    width: 150,
                                                                    minWidth: 150,
                                                                    maxWidth: 150
                                                                }}></th>
                                                            )}

                                                            {/* Colunas Adicionais de Negociado - Subcabeçalhos */}
                                                            {colunasNegociadoAdicionais.map((coluna, indexColuna) => (
                                                                <React.Fragment key={coluna.id}>
                                                                    {colunasNegociadoVisibility[coluna.id] && (
                                                                        <>
                                                                            <th style={{
                                                                                width: larguraColunaMonetaria,
                                                                                minWidth: larguraColunaMonetaria,
                                                                                maxWidth: larguraColunaMonetaria,
                                                                                backgroundColor: '#fff3e0',
                                                                                border: '1px solid #dee2e6',
                                                                                textAlign: 'center',
                                                                                color: '#f57c00'
                                                                            }}>Valor Unit.</th>
                                                                            <th style={{
                                                                                width: '80px',
                                                                                minWidth: '80px',
                                                                                maxWidth: '80px',
                                                                                backgroundColor: '#fff3e0',
                                                                                border: '1px solid #dee2e6',
                                                                                textAlign: 'center',
                                                                                color: '#f57c00'
                                                                            }}>Diária</th>
                                                                            <th style={{
                                                                                width: '80px',
                                                                                minWidth: '80px',
                                                                                maxWidth: '80px',
                                                                                backgroundColor: '#fff3e0',
                                                                                border: '1px solid #dee2e6',
                                                                                textAlign: 'center',
                                                                                color: '#f57c00'
                                                                            }}>Qtd</th>
                                                                            <th style={{
                                                                                width: '80px',
                                                                                minWidth: '80px',
                                                                                maxWidth: '80px',
                                                                                backgroundColor: '#fff3e0',
                                                                                border: '1px solid #dee2e6',
                                                                                textAlign: 'center',
                                                                                color: '#f57c00'
                                                                            }}>% Serviço</th>
                                                                            <th style={{
                                                                                width: larguraColunaTotalMonetaria,
                                                                                minWidth: larguraColunaTotalMonetaria,
                                                                                maxWidth: larguraColunaTotalMonetaria,
                                                                                backgroundColor: '#fff3e0',
                                                                                border: '1px solid #dee2e6',
                                                                                textAlign: 'center',
                                                                                color: '#f57c00'
                                                                            }}>Total</th>
                                                                            <th style={{
                                                                                width: '150px',
                                                                                minWidth: '150px',
                                                                                maxWidth: '150px',
                                                                                backgroundColor: '#fff3e0',
                                                                                border: '1px solid #dee2e6',
                                                                                textAlign: 'center',
                                                                                color: '#f57c00'
                                                                            }}>Observação</th>
                                                                        </>
                                                                    )}
                                                                    {!colunasNegociadoVisibility[coluna.id] && (
                                                                        <th style={{
                                                                            backgroundColor: '#fff',
                                                                            border: '1px solid #dee2e6',
                                                                            width: 150,
                                                                            minWidth: 150,
                                                                            maxWidth: 150
                                                                        }}></th>
                                                                    )}
                                                                </React.Fragment>
                                                            ))}

                                                            {showNegociado && (
                                                                <>
                                                                    <th style={{
                                                                        width: larguraColunaMonetaria,
                                                                        minWidth: larguraColunaMonetaria,
                                                                        maxWidth: larguraColunaMonetaria,
                                                                        backgroundColor: '#fff3e0',
                                                                        border: '1px solid #dee2e6',
                                                                        textAlign: 'center',
                                                                        color: '#f57c00'
                                                                    }}>Valor Unit.</th>
                                                                    <th style={{
                                                                        width: '80px',
                                                                        minWidth: '80px',
                                                                        maxWidth: '80px',
                                                                        backgroundColor: '#fff3e0',
                                                                        border: '1px solid #dee2e6',
                                                                        textAlign: 'center',
                                                                        color: '#f57c00'
                                                                    }}>Diárias</th>
                                                                    <th style={{
                                                                        width: '80px',
                                                                        minWidth: '80px',
                                                                        maxWidth: '80px',
                                                                        backgroundColor: '#fff3e0',
                                                                        border: '1px solid #dee2e6',
                                                                        textAlign: 'center',
                                                                        color: '#f57c00'
                                                                    }}>Qtde</th>
                                                                    <th style={{
                                                                        width: '80px',
                                                                        minWidth: '80px',
                                                                        maxWidth: '80px',
                                                                        backgroundColor: '#fff3e0',
                                                                        border: '1px solid #dee2e6',
                                                                        textAlign: 'center',
                                                                        color: '#f57c00'
                                                                    }}>% Serviço</th>
                                                                    <th style={{
                                                                        width: '80px',
                                                                        minWidth: '80px',
                                                                        maxWidth: '80px',
                                                                        backgroundColor: '#fff3e0',
                                                                        border: '1px solid #dee2e6',
                                                                        textAlign: 'center',
                                                                        color: '#f57c00'
                                                                    }} title="Tributo ou taxa local cobrada pelo fornecedor; compõe o valor do serviço.">% Tributo fornecedor</th>
                                                                    <th style={{
                                                                        width: '80px',
                                                                        minWidth: '80px',
                                                                        maxWidth: '80px',
                                                                        backgroundColor: '#fff3e0',
                                                                        border: '1px solid #dee2e6',
                                                                        textAlign: 'center',
                                                                        color: '#f57c00'
                                                                    }}>% Imposto NF</th>
                                                                    <th style={{
                                                                        width: larguraColunaTotalMonetaria,
                                                                        minWidth: larguraColunaTotalMonetaria,
                                                                        maxWidth: larguraColunaTotalMonetaria,
                                                                        backgroundColor: '#fff3e0',
                                                                        border: '1px solid #dee2e6',
                                                                        textAlign: 'center',
                                                                        color: '#f57c00'
                                                                    }}>Total</th>
                                                                    <th style={{
                                                                        width: '180px',
                                                                        minWidth: '180px',
                                                                        maxWidth: '180px',
                                                                        backgroundColor: '#fff3e0',
                                                                        border: '1px solid #dee2e6',
                                                                        textAlign: 'center',
                                                                        color: '#f57c00'
                                                                    }}>Observação</th>
                                                                </>
                                                            )}

                                                            {/* Célula em branco quando Negociado está escondido */}
                                                            {!showNegociado && (
                                                                <th style={{
                                                                    backgroundColor: '#fff',
                                                                    border: '1px solid #dee2e6',
                                                                    width: 150,
                                                                    minWidth: 150,
                                                                    maxWidth: 150
                                                                }}></th>
                                                            )}

                                                            {showFechamento && (
                                                                <>
                                                                    <th style={{
                                                                        width: larguraColunaMonetaria,
                                                                        minWidth: larguraColunaMonetaria,
                                                                        maxWidth: larguraColunaMonetaria,
                                                                        backgroundColor: '#e8f5e8',
                                                                        border: '1px solid #dee2e6',
                                                                        textAlign: 'center',
                                                                        color: '#388e3c'
                                                                    }}>Valor Unit.</th>
                                                                    <th style={{
                                                                        width: '80px',
                                                                        minWidth: '80px',
                                                                        maxWidth: '80px',
                                                                        backgroundColor: '#e8f5e8',
                                                                        border: '1px solid #dee2e6',
                                                                        textAlign: 'center',
                                                                        color: '#388e3c'
                                                                    }}>Diárias</th>
                                                                    <th style={{
                                                                        width: '80px',
                                                                        minWidth: '80px',
                                                                        maxWidth: '80px',
                                                                        backgroundColor: '#e8f5e8',
                                                                        border: '1px solid #dee2e6',
                                                                        textAlign: 'center',
                                                                        color: '#388e3c'
                                                                    }}>Qtde</th>
                                                                    <th style={{
                                                                        width: '80px',
                                                                        minWidth: '80px',
                                                                        maxWidth: '80px',
                                                                        backgroundColor: '#e8f5e8',
                                                                        border: '1px solid #dee2e6',
                                                                        textAlign: 'center',
                                                                        color: '#388e3c'
                                                                    }}>% Serviço</th>
                                                                    <th style={{
                                                                        width: '80px',
                                                                        minWidth: '80px',
                                                                        maxWidth: '80px',
                                                                        backgroundColor: '#e8f5e8',
                                                                        border: '1px solid #dee2e6',
                                                                        textAlign: 'center',
                                                                        color: '#388e3c'
                                                                    }} title="Tributo ou taxa local cobrada pelo fornecedor; compõe o valor do serviço.">% Tributo fornecedor</th>
                                                                    <th style={{
                                                                        width: '80px',
                                                                        minWidth: '80px',
                                                                        maxWidth: '80px',
                                                                        backgroundColor: '#e8f5e8',
                                                                        border: '1px solid #dee2e6',
                                                                        textAlign: 'center',
                                                                        color: '#388e3c'
                                                                    }}>% Imposto NF</th>
                                                                    <th style={{
                                                                        width: larguraColunaTotalMonetaria,
                                                                        minWidth: larguraColunaTotalMonetaria,
                                                                        maxWidth: larguraColunaTotalMonetaria,
                                                                        backgroundColor: '#e8f5e8',
                                                                        border: '1px solid #dee2e6',
                                                                        textAlign: 'center',
                                                                        color: '#388e3c'
                                                                    }}>Total</th>
                                                                    <th style={{
                                                                        width: '180px',
                                                                        minWidth: '180px',
                                                                        maxWidth: '180px',
                                                                        backgroundColor: '#e8f5e8',
                                                                        border: '1px solid #dee2e6',
                                                                        textAlign: 'center',
                                                                        color: '#388e3c'
                                                                    }}>Observação</th>
                                                                </>
                                                            )}

                                                            {/* Célula em branco quando Fechamento está escondido */}
                                                            {!showFechamento && (
                                                                <th style={{
                                                                    backgroundColor: '#fff',
                                                                    border: '1px solid #dee2e6',
                                                                    width: 150,
                                                                    minWidth: 150,
                                                                    maxWidth: 150
                                                                }}></th>
                                                            )}

                                                            {/* Colunas de Pagamento (Clone) */}
                                                            {showPagamento && (
                                                                <>
                                                                    <th style={{
                                                                        width: '200px',
                                                                        minWidth: '200px',
                                                                        maxWidth: '200px',
                                                                        backgroundColor: '#f1f8e9',
                                                                        border: '1px solid #dee2e6',
                                                                        textAlign: 'center',
                                                                        color: '#33691e'
                                                                    }}>Fornecedor Pagamento</th>
                                                                    <th style={{
                                                                        width: '100px',
                                                                        minWidth: '100px',
                                                                        maxWidth: '100px',
                                                                        backgroundColor: '#f1f8e9',
                                                                        border: '1px solid #dee2e6',
                                                                        textAlign: 'center',
                                                                        color: '#33691e'
                                                                    }}>Compõe FEE?</th>
                                                                    <th style={{
                                                                        width: '100px',
                                                                        minWidth: '100px',
                                                                        maxWidth: '100px',
                                                                        backgroundColor: '#f1f8e9',
                                                                        border: '1px solid #dee2e6',
                                                                        textAlign: 'center',
                                                                        color: '#33691e',
                                                                        display: podeCalcularImpostoNfAccess ? 'table-cell' : 'none'
                                                                    }}>Somar % no total da planilha</th>
                                                                    {/* Tipo Pagamento (Antecipado/Padrão) — removido a pedido em 2026-06-01 */}
                                                                    {false && <th style={{ width: '120px', minWidth: '120px', maxWidth: '120px', backgroundColor: '#f1f8e9', border: '1px solid #dee2e6', textAlign: 'center', color: '#33691e' }}>Tipo Pagamento</th>}
                                                                    {/* Tipo Faturamento — removido da UI do orçamento em 2026-06-02 (campo mantido no DB e exports; gerenciado na Central Financeira) */}
                                                                    {false && <th style={{ width: '120px', minWidth: '120px', maxWidth: '120px', backgroundColor: '#f1f8e9', border: '1px solid #dee2e6', textAlign: 'center', color: '#33691e' }}>Tipo Faturamento</th>}
                                                                    {/* Valor Real — removido da UI do orçamento em 2026-06-02 (campo mantido no DB e exports; gerenciado na Central Financeira) */}
                                                                    {false && <th style={{ width: '120px', minWidth: '120px', maxWidth: '120px', backgroundColor: '#f1f8e9', border: '1px solid #dee2e6', textAlign: 'center', color: '#33691e' }}>Valor Real</th>}
                                                                    {/* Forma Pagamento — removida a pedido em 2026-06-01 (será redirecionada para outro local) */}
                                                                    {false && <th style={{ width: '170px', minWidth: '170px', maxWidth: '170px', backgroundColor: '#f1f8e9', border: '1px solid #dee2e6', textAlign: 'center', color: '#33691e' }}>Forma Pagamento</th>}
                                                                    {/* Prazo — removido da UI do orçamento em 2026-06-02 (campo mantido no DB e exports; gerenciado na Central Financeira) */}
                                                                    {false && <th style={{ width: '120px', minWidth: '120px', maxWidth: '120px', backgroundColor: '#f1f8e9', border: '1px solid #dee2e6', textAlign: 'center', color: '#33691e' }}>Prazo</th>}
                                                                    {/* Vencimento — removida a pedido em 2026-06-01 */}
                                                                    {false && <th style={{ width: '150px', minWidth: '150px', maxWidth: '150px', backgroundColor: '#f1f8e9', border: '1px solid #dee2e6', textAlign: 'center', color: '#33691e' }}>Vencimento</th>}
                                                                    {/* Entrega NF — oculto (display:none→false&& para não gerar coluna fantasma) */}
                                                                    {false && <th style={{ width: '150px', minWidth: '150px', maxWidth: '150px', backgroundColor: '#f1f8e9', border: '1px solid #dee2e6', textAlign: 'center', color: '#33691e' }}>Entrega NF</th>}
                                                                    <th style={{
                                                                        width: '200px',
                                                                        minWidth: '200px',
                                                                        maxWidth: '200px',
                                                                        backgroundColor: '#f1f8e9',
                                                                        border: '1px solid #dee2e6',
                                                                        textAlign: 'center',
                                                                        color: '#33691e'
                                                                    }}>Observação</th>
                                                                    {false && <th style={{
                                                                        width: '220px',
                                                                        minWidth: '220px',
                                                                        maxWidth: '220px',
                                                                        backgroundColor: '#f1f8e9',
                                                                        border: '1px solid #dee2e6',
                                                                        textAlign: 'center',
                                                                        color: '#33691e'
                                                                    }}>Nome Item Planilha</th>}
                                                                    {/* Estornos — removido da UI do orçamento em 2026-06-02 (gerenciado na Central Financeira) */}
                                                                    {false && <th style={{ width: '90px', minWidth: '90px', maxWidth: '90px', backgroundColor: '#fce4ec', border: '1px solid #dee2e6', textAlign: 'center', color: '#880e4f' }} title="Estornos / devoluções do item">Estornos</th>}
                                                                    {/* Aéreo — removido da UI do orçamento em 2026-06-02 (gerenciado na Central Financeira) */}
                                                                    {false && <th style={{ width: '70px', minWidth: '70px', maxWidth: '70px', backgroundColor: '#e1f5fe', border: '1px solid #dee2e6', textAlign: 'center', color: '#01579b' }} title="Vincular este item a uma despesa aérea do evento">✈ Aéreo</th>}
                                                                    {/* Forma Pgto — removido da UI do orçamento em 2026-06-02 (gerenciado na Central Financeira) */}
                                                                    {false && <th style={{ width: '110px', minWidth: '110px', maxWidth: '110px', backgroundColor: '#fb8c00', border: '1px solid #e65100', textAlign: 'center', color: '#fff', fontWeight: 700 }}><div style={{ fontSize: '0.65rem' }}>💳 Forma Pgto</div></th>}
                                                                    {/* Adiantamento — removido da UI do orçamento em 2026-06-02 (gerenciado na Central Financeira) */}
                                                                    {false && <th style={{ width: '170px', minWidth: '170px', maxWidth: '170px', backgroundColor: '#fff3e0', border: '1px solid #dee2e6', textAlign: 'center', color: '#bf360c' }}>💰 Adiantamento</th>}
                                                                </>
                                                            )}

                                                            {/* Célula em branco quando Pagamento está escondido */}
                                                            {!showPagamento && (
                                                                <th style={{
                                                                    backgroundColor: '#fff',
                                                                    border: '1px solid #dee2e6',
                                                                    width: 150,
                                                                    minWidth: 150,
                                                                    maxWidth: 150
                                                                }}></th>
                                                            )}
                                                        </tr>
                                                    </thead>
                                                    {/* Cada grupo é um <tbody> arrastável (cabeçalho + itens + subtotal andam juntos) — 07/10 */}
                                                    <ListaOrdenavel ids={(dados.orcamentoitem || []).map((g, i) => idOrdenavel('g', g, i))} onMover={moverGrupo}>
                                                        {dados.orcamentoitem && dados.orcamentoitem.map((item, indexSuperior) => (
                                                            <GrupoOrdenavel key={`grupo-${item.id ?? item.chavegrupo ?? indexSuperior}`} id={idOrdenavel('g', item, indexSuperior)} disabled={grupoTemPosicaoFixa(item)}>{(alcaGrupo) => (<>
                                                                {/* Linha Superior do Item Principal */}
                                                                <tr style={{ backgroundColor: '#f8f9fa', fontWeight: 'bold', borderTop: '2px solid #dee2e6' }}>
                                                                    <td style={{
                                                                        backgroundColor: '#f8f9fa',
                                                                        border: '1px solid #dee2e6',
                                                                        width: `${larguraColunaAcoes}px`,
                                                                        minWidth: `${larguraColunaAcoes}px`,
                                                                        maxWidth: `${larguraColunaAcoes}px`,
                                                                        ...getColunaAcoesStickyStyle(9)
                                                                    }}>
                                                                        <div className="d-flex align-items-center">
                                                                            <div className="me-2">
                                                                                {/* Status de preenchimento */}
                                                                                {item.statuspreenchimento === 'embranco' && <FaRegCircle size={16} />}
                                                                                {item.statuspreenchimento === 'preenchendo' && <FaCircle size={16} color={"#FFFF00"} />}
                                                                                {item.statuspreenchimento === 'completo' && <FaCircle size={16} color={"#00FF00"} />}
                                                                            </div>
                                                                            <button
                                                                                type="button"
                                                                                className="fin-pp__btn fin-pp__btn--sm"
                                                                                onClick={() => {
                                                                                    if (expandedRows === true || expandedRows === false) {
                                                                                        // Se estiver no modo "expandir todos", volte para o modo individual
                                                                                        setExpandedRows([]);
                                                                                    } else {
                                                                                        const newExpandedRows = [...(expandedRows || [])];
                                                                                        const index = newExpandedRows.indexOf(indexSuperior);
                                                                                        if (index > -1) {
                                                                                            newExpandedRows.splice(index, 1);
                                                                                        } else {
                                                                                            newExpandedRows.push(indexSuperior);
                                                                                        }
                                                                                        setExpandedRows(newExpandedRows);
                                                                                    }
                                                                                }}
                                                                            >
                                                                                {(expandedRows === true || (Array.isArray(expandedRows) && expandedRows.includes(indexSuperior))) ? <FaChevronDown /> : <FaChevronRight />}
                                                                            </button>
                                                                            <AlcaArrastar alca={alcaGrupo} titulo="Arraste para mudar a posição do grupo" tituloFixo="O grupo Agência fica sempre no topo" />
                                                                            {podeClonarGrupo(item) && <button type="button" className="fin-pp__btn fin-pp__btn--sm" disabled title={MSG_CLONAR_GRUPO_UNICO} data-clonar-grupo><FaCopy size={13} /></button>}
                                                                            <button type="button" className="fin-pp__btn fin-pp__btn--danger-ghost fin-pp__btn--sm" title="Remover" onClick={() => { dados.orcamentoitem.splice(indexSuperior, 1); calculaTotalOrcamento(); }}><FaTrash size={15} /></button>
                                                                        </div>
                                                                    </td>
                                                                    <td style={{
                                                                        backgroundColor: '#f8f9fa',
                                                                        border: '1px solid #dee2e6',
                                                                        width: `${larguraColunaDescricao}px`,
                                                                        minWidth: `${larguraColunaDescricao}px`,
                                                                        maxWidth: `${larguraColunaDescricao}px`,
                                                                        ...getColunaDescricaoStickyStyle(7)
                                                                    }}>
                                                                        <ReactSelect compact
                                                                            key={`grupo-${dados.evento ?? 'sem-evento'}-${dados.cliente?.id ?? dados.cliente ?? 'sem-cliente'}-${indexSuperior}`}
                                                                            placeholder={"Item Principal"}
                                                                            value={item.produto !== null ? { value: item.produto?.id ?? null, label: AgenciaOrcamentoPolicy.nomeGrupoExibicao(item.produto) } : null}
                                                                            // D-0134: grupo que já está no orçamento fica apagado, em grupo novo e na troca.
                                                                            isOptionDisabled={(opcao) => grupoJaIncluido(opcao.value, dados.orcamentoitem, indexSuperior)}
                                                                            formatOptionLabel={(opcao, { context }) => rotuloOpcaoGrupo(opcao, context, dados.orcamentoitem, indexSuperior)}
                                                                            onChange={(e) => {
                                                                                if (!e) {
                                                                                    return;
                                                                                }

                                                                                const itemAtual = dados.orcamentoitem[indexSuperior];

                                                                                itemAtual.produto = {
                                                                                    id: e.value,
                                                                                    codigo: e.codigo ?? null,
                                                                                    nome: e.nomeCatalogo ?? e.label,
                                                                                    somarTodosFee: e.somarTodosFee,
                                                                                    feeBaseTipo: e.feeBaseTipo,
                                                                                    feeBaseId: e.feeBaseId,
                                                                                    feeMomentoCalculo: e.feeMomentoCalculo,
                                                                                    precificacaoFaixas: normalizarFaixasPrecificacao(e)
                                                                                };

                                                                                // Troca de grupo: zera todas as instâncias de subitens do grupo.
                                                                                itemAtual.subitem = [];
                                                                                // Força remount visual do bloco do grupo/subitens após troca.
                                                                                itemAtual.chavegrupo = rand18();
                                                                                dados.itemSomarAtual = null;
                                                                                dados.orcamentoitem = ordenarGruposComAgenciaNoTopo(dados.orcamentoitem || []);

                                                                                const dadosCalculados = calculaTotalOrcamento2(dados);
                                                                                setDados({ ...dadosCalculados });
                                                                            }}
                                                                            defaultOptions
                                                                            loadOptions={(input) => {
                                                                                const clienteId = dados.cliente?.id ?? null;
                                                                                if (!clienteId) {
                                                                                    return Promise.resolve([]);
                                                                                }
                                                                                return Promise.all(AgenciaOrcamentoPolicy.termosBuscaGrupos(input).map((termo) => api({
                                                                                    method: 'get',
                                                                                    action: '/produto',
                                                                                    token: token,
                                                                                    params: {
                                                                                        situacaoRegistro: 'ativo',
                                                                                        nome: termo,
                                                                                        modulo: 'servicoOrcamento',
                                                                                        cliente: clienteId,
                                                                                        superiorIsNull: true
                                                                                    }
                                                                                })))
                                                                                    .then(responses => {
                                                                                        let options = AgenciaOrcamentoPolicy.mesclarResultadosGrupos(responses.map((response) => response.data.data)).map((registro) => {
                                                                                            return {
                                                                                                value: registro.id,
                                                                                                codigo: registro.codigo,
                                                                                                label: AgenciaOrcamentoPolicy.nomeGrupoExibicao(registro, true),
                                                                                                nomeCatalogo: registro.codigo + ' - ' + registro.nome,
                                                                                                // D-0121: o 3028 - FEE não entra quando o orçamento já tem o 130 - FEE.
                                                                                                disabled: grupoFeeDesabilitado({ value: registro.id, codigo: registro.codigo }, dados),
                                                                                                somarTodosFee: registro.somarTodosFee ?? 'nao',
                                                                                                feeBaseTipo: registro.feeBaseTipo ?? 'compoe_fee_global',
                                                                                                feeBaseId: registro.feeBaseId ?? null,
                                                                                                feeMomentoCalculo: registro.feeMomentoCalculo ?? 'todos',
                                                                                                orcamentoConfig: registro.orcamento_config ?? registro.orcamentoConfig ?? null,
                                                                                                precificacaoFaixas: normalizarFaixasPrecificacao(registro)
                                                                                            };
                                                                                        });
                                                                                        return options;
                                                                                    })
                                                                                    .catch(function (error) {
                                                                                        //console.log(error);
                                                                                    });
                                                                            }}
                                                                        />
                                                                    </td>
                                                                    <td colSpan={
                                                                        (MOSTRAR_COLUNA_FORA_ESCOPO ? 3 : 2) + // Fornecedor Custos + Equipamentos (+ Fora Escopo, oculta desde 20/10)
                                                                        (showPagamento ? quantidadeColunasPagamento : 1) + // Pagamento (sempre pelo menos 1 para o cabeçalho)
                                                                        (showPreEvento ? 8 : 1) + // Pré-evento (sempre pelo menos 1 para o cabeçalho)
                                                                        (showNegociado ? 8 : 1) + // Negociado (sempre pelo menos 1 para o cabeçalho)
                                                                        (showFechamento ? 8 : 1) // Fechamento (sempre pelo menos 1 para o cabeçalho)
                                                                    } style={{
                                                                        backgroundColor: '#f8f9fa',
                                                                        border: '1px solid #dee2e6'
                                                                    }}></td>
                                                                </tr>

                                                                {/* Subitens */}
                                                                {(expandedRows === true || (Array.isArray(expandedRows) && expandedRows.includes(indexSuperior))) && item.subitem && (<ListaOrdenavel ids={item.subitem.map((s, i) => idOrdenavel('s', s, i))} onMover={(de, para) => moverSubitem(indexSuperior, de, para)}>{item.subitem.map((subitem, indexInferior) => {
                                                                    const linhaImpostoAccessCalculada = clienteAtualEhChiesi
                                                                        && isGrupoServicosAgencia(item)
                                                                        && isSubitemImpostoNfAccess(subitem);
                                                                    const linhaImpostoAccessManualAgencia = clienteAtualEhChiesi
                                                                        && AgenciaOrcamentoPolicy.isGrupoAgencia(item)
                                                                        && isSubitemImpostoNfAccess(subitem);
                                                                    // Fee Agência (130) é COMPOSTO pelos itens Compõe FEE = sim — não aceita digitação (regra Rafael 17/09).
                                                                    const linhaFeeAgenciaComposta = AgenciaOrcamentoPolicy.isGrupoAgencia(item)
                                                                        && isSubitemFeeAgencia(subitem);
                                                                    // Cliente sem regra de FEE (27/09): o valor do FEE é digitado pelo operador.
                                                                    const linhaFeeAgenciaManual = linhaFeeAgenciaComposta && feeAgenciaManual;
                                                                    // D-0132: FEE calculado mostra a base em R$, só leitura. O digitado segue na moeda
                                                                    // do orçamento, com o R$ embaixo: é o valor que o operador grava.
                                                                    const feeUnitarioEmReal = feeSoEmReal(subitem) && !linhaFeeAgenciaManual;
                                                                    // 130 - FEE AGÊNCIA (Rafael 08/10): é o próprio FEE — Fornecedor Pagamento = Agência
                                                                    // e Compõe FEE = Não, travados (o servidor regrava os dois).
                                                                    const linhaFee130Travada = AgenciaOrcamentoPolicy.isFeeAgenciaGlobal(subitem?.produto || {});
                                                                    const linhaFeeSpeaker = isGrupoFeeSpeaker(item);
                                                                    // D-0092: aéreo da Access na Chiesi não leva a NF Access (travado desmarcado).
                                                                    const aereoDaAccessChiesi = clienteAtualEhChiesi
                                                                        && ChiesiImpostoPolicy.isAereoDaAccess(item, subitem, fornecedorAccessInterno);
                                                                    const impostoAutomaticoServicoProprioChiesi = clienteAtualEhChiesi
                                                                        && !isGrupoServicosAgencia(item)
                                                                        && !aereoDaAccessChiesi
                                                                        && ChiesiImpostoPolicy.isServicoProprio(subitem, fornecedorAccessInterno);
                                                                    const impostoNfBloqueadoPorFornecedor = !ImpostoNfAccessPorFornecedorPolicy.fornecedorEhAccess(
                                                                        subitem,
                                                                        fornecedorAccessInterno
                                                                    );
                                                                    // Long Ping (D-0119): o % Imposto NF é do modelo (19,05 na Access e no FEE), não se digita.
                                                                    const impostoNfTravado = impostoNfBloqueadoPorFornecedor || clienteAtualEhLongPing;
                                                                    const dicaImpostoNf = clienteAtualEhLongPing
                                                                        ? 'Long Ping: 19,05% automático nas linhas da Access e no FEE.'
                                                                        : (impostoNfBloqueadoPorFornecedor ? 'Disponível somente para NF emitida pela Access.' : undefined);
                                                                    // Ledger exterior concluído: o Fechamento exibe o que foi pago de fato (somente leitura; os
                                                                    // valores gravados voltam a aparecer se o fechamento for reaberto).
                                                                    const fechamentoExibicao = subitem.fechamento_exibicao || null;
                                                                    const fechamentoExteriorConcluido = linhaFechamentoExteriorConcluido(subitem);
                                                                    const dicaFechamentoExterior = fechamentoExteriorConcluido ? 'Definido pelo fechamento exterior — reabra o fechamento para editar.' : undefined;
                                                                    const campoFechamento = (campo) => (fechamentoExteriorConcluido ? fechamentoExibicao[campo] : subitem[campo]);
                                                                    return (
                                                                    <React.Fragment key={`linha-${item.id ?? item.chavegrupo ?? indexSuperior}-${subitem.id ?? subitem.chaveunica ?? indexInferior}`}>
                                                                    <LinhaOrdenavel
                                                                        id={idOrdenavel('s', subitem, indexInferior)}
                                                                        disabled={subitemTemPosicaoFixa(item, subitem)}
                                                                        aria-disabled={linhaImpostoAccessCalculada}
                                                                        data-linha-orcamento={`${indexSuperior}-${indexInferior}`}
                                                                        style={{
                                                                            backgroundColor: '#fff',
                                                                            ...(linhaImpostoAccessCalculada && { backgroundColor: '#f7f7f7' }),
                                                                            ...(ehSomenteVisualizacao(subitem) && { backgroundColor: 'var(--fin-sf2)' }),
                                                                            ...(itemDestacado && subitem.id === itemDestacado && {
                                                                                border: '3px solid #ffc107',
                                                                                boxShadow: '0 0 10px rgba(255, 193, 7, 0.5)'
                                                                            })
                                                                        }}
                                                                    >{(alcaItem) => (<>
                                                                        <td style={{
                                                                            backgroundColor: '#fff',
                                                                            border: '1px solid #dee2e6',
                                                                            width: `${larguraColunaAcoes}px`,
                                                                            minWidth: `${larguraColunaAcoes}px`,
                                                                            maxWidth: `${larguraColunaAcoes}px`,
                                                                            ...getColunaAcoesStickyStyle(8)
                                                                        }}>
                                                                            <div className="d-flex align-items-center" style={{ gap: '2px' }}>
                                                                                <input
                                                                                    style={{
                                                                                        border: '1px solid blue',
                                                                                        boxShadow: '0 0 4px 3px yellow',
                                                                                        visibility: (subitem.produto?.somarTodosFee !== 'sim' && dados.itemSomarAtual && dados.itemSomarAtual !== subitem.chaveunica) ? 'visible' : 'hidden'
                                                                                    }}
                                                                                    type="checkbox"
                                                                                    className="form-check-input"
                                                                                    value={subitem.chaveunica}
                                                                                    checked={verificaSeExiste(dados, item, indexInferior)}
                                                                                    onChange={(value) => {
                                                                                        if (verificaSeExiste(dados, item, indexInferior)) {
                                                                                            removeCheck(dados, item, indexInferior);
                                                                                        } else {
                                                                                            adicionaCheck(dados, item, indexInferior);
                                                                                        }
                                                                                        calculaTotalOrcamento();
                                                                                    }}
                                                                                />
                                                                                <AlcaArrastar alca={alcaItem} size={11} tituloFixo="Esta linha tem posição fixa no grupo" />
                                                                                {podeClonarSubitem(item, subitem) && <button type="button" className="fin-pp__btn fin-pp__btn--sm" disabled={produtoInativo(subitem)} title={produtoInativo(subitem) ? MSG_CLONAR_PRODUTO_INATIVO : 'Clonar item'} data-clonar-item onClick={() => clonarSubitemNaPosicao(indexSuperior, indexInferior)}><FaCopy size={10} /></button>}
                                                                                {!linhaImpostoAccessCalculada && <button type="button" className="fin-pp__btn fin-pp__btn--danger-ghost fin-pp__btn--sm" title="Remover" onClick={() => { item.subitem.splice(indexInferior, 1); calculaTotalOrcamento(); }}><FaTrash size={10} /></button>}
                                                                            </div>
                                                                        </td>
                                                                        <td style={{
                                                                            backgroundColor: '#fff',
                                                                            border: '1px solid #dee2e6',
                                                                            width: `${larguraColunaDescricao}px`,
                                                                            minWidth: `${larguraColunaDescricao}px`,
                                                                            maxWidth: `${larguraColunaDescricao}px`,
                                                                            ...getColunaDescricaoStickyStyle(6)
                                                                        }}>
                                                                            <ReactSelect compact
                                                                                key={`subitem-${dados.evento ?? 'sem-evento'}-${dados.cliente?.id ?? dados.cliente ?? 'sem-cliente'}-${item.produto?.id ?? 'sem-superior'}-${indexSuperior}-${indexInferior}`}
                                                                                id={`sub-item-${indexSuperior}-${indexInferior}`}
                                                                                placeholder={"Sub Item"}
                                                                                isDisabled={linhaImpostoAccessCalculada}
                                                                                value={subitem.produto !== null ? { value: subitem.produto?.id ?? null, label: AgenciaOrcamentoPolicy.nomeSubitemExibicao(item, subitem.produto) } : null}
                                                                                onChange={(e) => {
                                                                                    const produtoIdAnterior = obterIdComparavel(item.subitem[indexInferior].produto?.id);
                                                                                    // 21/10: linha que troca de item passa pela observação obrigatória (como linha nova).
                                                                                    if (produtoIdAnterior !== obterIdComparavel(e.value)) item.subitem[indexInferior].produtoTrocadoNaTela = true;
                                                                                    item.subitem[indexInferior].produto = {};
                                                                                    item.subitem[indexInferior].produto.id = e.value;
                                                                                    item.subitem[indexInferior].produto.codigo = e.codigo ?? null;
                                                                                    item.subitem[indexInferior].produto.codigoFornecedor = e.codigoFornecedor ?? null;
                                                                                    item.subitem[indexInferior].produto.nome = e.nomeCatalogo ?? e.label;
                                                                                    item.subitem[indexInferior].produto.somarTodosFee = e.somarTodosFee;
                                                                                    item.subitem[indexInferior].produto.tipoPreco = e.tipoPreco ?? 'fixo';
                                                                                    item.subitem[indexInferior].produto.preco = e.preco;
                                                                                    item.subitem[indexInferior].produto.superior = obterIdComparavel(e.superior);
                                                                                    item.subitem[indexInferior].produto.atributo = obterIdComparavel(e.atributo);
                                                                                    item.subitem[indexInferior].produto.feeBaseTipo = e.feeBaseTipo ?? 'compoe_fee_global';
                                                                                    item.subitem[indexInferior].produto.feeBaseId = e.feeBaseId ?? null;
                                                                                    item.subitem[indexInferior].produto.feeMomentoCalculo = e.feeMomentoCalculo ?? 'todos';
                                                                                    item.subitem[indexInferior].produto.orcamentoConfig = e.orcamentoConfig ?? null;
                                                                                    item.subitem[indexInferior].produto.precificacaoFaixas = normalizarFaixasPrecificacao(e);
                                                                                    if (!produtoPermiteUploadEquipamentos(item.subitem[indexInferior].produto)) {
                                                                                        const arquivoEquipamentoExistente = item.subitem[indexInferior].arquivoequipamentos?.id || item.subitem[indexInferior].arquivoequipamentos;
                                                                                        item.subitem[indexInferior].arquivoequipamentos = null;
                                                                                        if (arquivoEquipamentoExistente) {
                                                                                            item.subitem[indexInferior].removerarquivoequipamentos = true;
                                                                                        }
                                                                                        delete item.subitem[indexInferior].binariosarquivoequipamentos;
                                                                                    }
                                                                                    const fornecedorpagamentoAtual = item.subitem[indexInferior].fornecedorpagamento;
                                                                                    const idFornecedorPagamentoAtual = (fornecedorpagamentoAtual?.id ?? '').toString().toLowerCase();
                                                                                    if (isGrupoFeeSpeaker(item)) {
                                                                                        Object.assign(item.subitem[indexInferior], aplicarRegraFeeSpeaker(item.subitem[indexInferior]));
                                                                                    } else if (idFornecedorPagamentoAtual !== 'agencia' && idFornecedorPagamentoAtual !== 'cliente') {
                                                                                        item.subitem[indexInferior].fornecedorpagamento = {
                                                                                            id: 'agencia',
                                                                                            nome: 'Agência'
                                                                                        };
                                                                                    }
                                                                                    const tipoPrecoSelecionado = (e.tipoPreco ?? 'fixo').toString().toLowerCase();
                                                                                    const possuiFaixaPrecificacao = normalizarFaixasPrecificacao(e).length > 0;
                                                                                    // Ao trocar produto fixo, aplica o preço cadastrado
                                                                                    if (!possuiFaixaPrecificacao && tipoPrecoSelecionado !== 'percentual' && e.preco !== undefined) {
                                                                                        if (produtoIdAnterior !== obterIdComparavel(e.value) || semValor(item.subitem[indexInferior].valorUnitarioPreEvento)) {
                                                                                            item.subitem[indexInferior].valorUnitarioPreEvento = precoCatalogoNaMoeda(e.preco, divisorPrecoCatalogoLinha(item.subitem[indexInferior], 'PreEvento', dados.moeda, dados.cambio));
                                                                                        }
                                                                                    } else if (!possuiFaixaPrecificacao && tipoPrecoSelecionado === 'percentual' && e.preco !== undefined) {
                                                                                        if (produtoIdAnterior !== obterIdComparavel(e.value) || semValor(item.subitem[indexInferior].servicoPreEvento)) {
                                                                                            item.subitem[indexInferior].servicoPreEvento = e.preco;
                                                                                        }
                                                                                        if (produtoIdAnterior !== obterIdComparavel(e.value) || semValor(item.subitem[indexInferior].servicoNegociado)) {
                                                                                            item.subitem[indexInferior].servicoNegociado = e.preco;
                                                                                        }
                                                                                        if (produtoIdAnterior !== obterIdComparavel(e.value) || semValor(item.subitem[indexInferior].servicoFechamento)) {
                                                                                            item.subitem[indexInferior].servicoFechamento = e.preco;
                                                                                        }
                                                                                    }
                                                                                    if (e.quantidade !== undefined) {
                                                                                        if (produtoIdAnterior !== obterIdComparavel(e.value) || semValor(item.subitem[indexInferior].quantidadePreEvento))
                                                                                            item.subitem[indexInferior].quantidadePreEvento = e.quantidade;
                                                                                    }
                                                                                    inicializarCamposCalculoSubitem(item.subitem[indexInferior]);
                                                                                    sincronizarSubitemQueCompoeFee(item.subitem[indexInferior]);
                                                                                    item.subitem[indexInferior].codigoFornecedor = e.codigoFornecedor;
                                                                                    // Reunião Inter 02/10: no grupo 130 (FEE) todo subitem é serviço da Access —
                                                                                    // ao escolher o subitem, o fornecedor já entra como Access (pode ser trocado depois).
                                                                                    if (isGrupoAgencia(item) && fornecedorAccessInterno?.id
                                                                                        && !fornecedorIncompativelComPagamentoExterior(fornecedorAccessInterno, item.subitem[indexInferior].pagamento_exterior, fornecedorAccessInterno)) {
                                                                                        item.subitem[indexInferior].fornecedor = { id: fornecedorAccessInterno.id, nome: fornecedorAccessInterno.nome, cnpj: fornecedorAccessInterno.cnpj ?? null };
                                                                                        calculaTotalOrcamento2(aplicarPadraoMoedaLocal(dados, indexSuperior, indexInferior, { moedaOrcamento: obterMoedaOrcamento(), fornecedorAccess: fornecedorAccessInterno }));
                                                                                        return;
                                                                                    }
                                                                                    calculaTotalOrcamento();
                                                                                    incluirItensObrigatorios(indexSuperior, indexInferior);
                                                                                }}
                                                                                defaultOptions
                                                                                loadOptions={(input) => {
                                                                                    const clienteId = dados.cliente?.id ?? null;
                                                                                    if (!clienteId) {
                                                                                        return Promise.resolve([]);
                                                                                    }
                                                                                    const superiorId = item.produto ? item.produto.id : null;
                                                                                    const idsItensPermanentesAtivos = obterIdsItensPermanentesAtivos(
                                                                                        itensPermanentesIds,
                                                                                        itensPermanentesInternacionaisIds,
                                                                                        eventoNacionalidade
                                                                                    );

                                                                                    const requisicoes = AgenciaOrcamentoPolicy.termosBuscaSubitens(item, input).map((termoBusca) => (
                                                                                        api({
                                                                                            method: 'get',
                                                                                            action: '/produto',
                                                                                            token: token,
                                                                                            params: {
                                                                                                nome: termoBusca,
                                                                                                situacaoRegistro: 'ativo',
                                                                                                modulo: 'servicoOrcamento',
                                                                                                cliente: clienteId,
                                                                                                superior: superiorId
                                                                                            }
                                                                                        })
                                                                                    ));

                                                                                    if (superiorId && idsItensPermanentesAtivos.length > 0) {
                                                                                        requisicoes.push(
                                                                                            api({
                                                                                                method: 'get',
                                                                                                action: '/produto',
                                                                                                token: token,
                                                                                                params: {
                                                                                                    situacaoRegistro: 'ativo',
                                                                                                    modulo: 'servicoOrcamento',
                                                                                                    cliente: clienteId,
                                                                                                    superior: superiorId,
                                                                                                    ids: idsItensPermanentesAtivos.join(',')
                                                                                                }
                                                                                            })
                                                                                        );
                                                                                    }

                                                                                    // SERVIÇOS AGÊNCIA: também os serviços exclusivos do cliente guardados no AGÊNCIA.
                                                                                    const inicioServicosDoCliente = requisicoes.length;
                                                                                    const superiorServicosDoCliente = AgenciaOrcamentoPolicy.superiorServicosDoCliente(item);
                                                                                    if (superiorServicosDoCliente) {
                                                                                        requisicoes.push(api({
                                                                                            method: 'get',
                                                                                            action: '/produto',
                                                                                            token: token,
                                                                                            params: {
                                                                                                nome: String(input ?? '').trim(),
                                                                                                situacaoRegistro: 'ativo',
                                                                                                modulo: 'servicoOrcamento',
                                                                                                cliente: clienteId,
                                                                                                superior: superiorServicosDoCliente
                                                                                            }
                                                                                        }));
                                                                                    }

                                                                                    return Promise.all(requisicoes)
                                                                                        .then((respostas) => {
                                                                                            const registrosMesclados = [];
                                                                                            const registrosPorId = new Map();

                                                                                            respostas.forEach((responseAtual, indiceResposta) => {
                                                                                                const registrosResposta = responseAtual?.data?.data || [];
                                                                                                const registros = superiorServicosDoCliente && indiceResposta >= inicioServicosDoCliente
                                                                                                    ? AgenciaOrcamentoPolicy.filtrarServicosDoCliente(registrosResposta)
                                                                                                    : registrosResposta;
                                                                                                registros.forEach((registro) => {
                                                                                                    const registroId = obterIdComparavel(registro.id);
                                                                                                    if (!registroId || registrosPorId.has(registroId)) {
                                                                                                        return;
                                                                                                    }
                                                                                                    registrosPorId.set(registroId, true);
                                                                                                    registrosMesclados.push(registro);
                                                                                                });
                                                                                            });

                                                                                            const options = AgenciaOrcamentoPolicy.filtrarOpcoesCatalogo(item, registrosMesclados, clienteEscolheFeeNoCatalogo(dados.cliente)).map((registro) => {
                                                                                                return {
                                                                                                    value: registro.id,
                                                                                                    codigo: registro.codigo,
                                                                                                    label: AgenciaOrcamentoPolicy.nomeSubitemExibicao(item, registro, true),
                                                                                                    nomeCatalogo: (registro.codigo ? registro.codigo + " - " : "") + (registro.codigoFornecedor ? registro.codigoFornecedor + " - " : "") + registro.nome,
                                                                                                    preco: registro.preco,
                                                                                                    tipoPreco: registro.tipoPreco ?? 'fixo',
                                                                                                    quantidade: registro.quantidade,
                                                                                                    codigoFornecedor: registro.codigoFornecedor ?? null,
                                                                                                    somarTodosFee: registro.somarTodosFee ?? 'nao',
                                                                                                    superior: obterIdComparavel(registro.superior),
                                                                                                    atributo: obterIdComparavel(registro.atributo),
                                                                                                    feeBaseTipo: registro.feeBaseTipo ?? 'compoe_fee_global',
                                                                                                    feeBaseId: registro.feeBaseId ?? null,
                                                                                                    feeMomentoCalculo: registro.feeMomentoCalculo ?? 'todos',
                                                                                                    orcamentoConfig: registro.orcamento_config ?? registro.orcamentoConfig ?? null,
                                                                                                    precificacaoFaixas: normalizarFaixasPrecificacao(registro)
                                                                                                };
                                                                                            });

                                                                                            options.sort((optionA, optionB) => {
                                                                                                const aPermanente = idsItensPermanentesAtivos.includes(obterIdComparavel(optionA.value));
                                                                                                const bPermanente = idsItensPermanentesAtivos.includes(obterIdComparavel(optionB.value));

                                                                                                if (aPermanente !== bPermanente) {
                                                                                                    return aPermanente ? -1 : 1;
                                                                                                }

                                                                                                return (optionA.label || '').localeCompare(optionB.label || '', 'pt-BR');
                                                                                            });

                                                                                            return options;
                                                                                        })
                                                                                        .catch(function (error) {
                                                                                            //console.log(error);
                                                                                        });
                                                                                }}
                                                                            />
                                                                            {linhaImpostoAccessCalculada && (
                                                                                <small className="text-muted d-block mt-1">{ehImpostoNfContaDireta(subitem)
                                                                                    ? 'Calculado automaticamente em conta direta (base × 19,05%).'
                                                                                    : 'Calculado automaticamente por fora (19,05%).'}</small>
                                                                            )}
                                                                            {linhaFeeAgenciaComposta && !linhaFeeAgenciaManual && (
                                                                                <small className="text-muted d-block mt-1">Composto automaticamente pelos itens marcados com Compõe FEE = Sim, nas três etapas. Não aceita valor digitado.</small>
                                                                            )}
                                                                            {linhaFeeAgenciaManual && (
                                                                                <small className="text-muted d-block mt-1" data-fee-manual="1">Cliente sem regra de FEE cadastrada: informe o valor do FEE (não é calculado).</small>
                                                                            )}
                                                                            {linhaImpostoAccessManualAgencia && (
                                                                                <small className="text-muted d-block mt-1">
                                                                                    Imposto por fora sobre FEE e serviços próprios. O % Imposto informado substitui o NF automático neste grupo, nas três etapas.
                                                                                    {ChiesiAgenciaImpostoPolicy.resolver(item, true)?.erro && (
                                                                                        <span className="text-danger d-block">{ChiesiAgenciaImpostoPolicy.resolver(item, true).erro}</span>
                                                                                    )}
                                                                                </small>
                                                                            )}
                                                                        </td>

                                                                        {/* Nova célula: Fornecedor Custos */}
                                                                        <td style={{
                                                                            backgroundColor: '#fff',
                                                                            border: '1px solid #dee2e6'
                                                                        }}>
                                                                            {/* Fornecedor da linha: botão + modal de busca (Rafael 20/10), no lugar do select com busca
                                                                                por linha. Rótulo com o nome fantasia antes da razão social. */}
                                                                            {(() => {
                                                                                const fornecedorAccessFixo = clienteAtualEhChiesi && isGrupoServicosAgencia(item) && fornecedorAccessInterno?.id;
                                                                                const fornecedorExibido = linhaFeeSpeaker ? null : (fornecedorAccessFixo ? fornecedorAccessInterno : subitem.fornecedor);
                                                                                const rotulo = rotuloFornecedor(fornecedorExibido);
                                                                                const semFornecedor = !temFornecedor(fornecedorExibido);
                                                                                return (
                                                                                    <button type="button"
                                                                                        className="fin-pp__btn fin-pp__btn--sm"
                                                                                        data-fornecedor-linha={`${indexSuperior}-${indexInferior}`}
                                                                                        disabled={linhaFeeSpeaker || linhaImpostoAccessCalculada || (clienteAtualEhChiesi && isGrupoServicosAgencia(item) && statusFornecedorAccessInterno === 'found')}
                                                                                        title={rotulo}
                                                                                        onClick={() => setModalFornecedorLinha({ indexSuperior, indexInferior })}
                                                                                        style={{ width: '100%', minHeight: 34, padding: '6px 10px', justifyContent: 'flex-start', textAlign: 'left', fontWeight: semFornecedor ? 500 : 600, color: semFornecedor ? 'var(--fin-ft)' : 'var(--fin-tx)' }}>
                                                                                        <FaSearch size={11} style={{ flex: 'none', color: 'var(--fin-ft)' }} />
                                                                                        <span style={{ flex: 1, minWidth: 0, overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', whiteSpace: 'normal', wordBreak: 'break-word', lineHeight: 1.3 }}>{rotulo}</span>
                                                                                    </button>
                                                                                );
                                                                            })()}
                                                                            {linhaFeeSpeaker && <small className="text-muted d-block mt-1">Fee Speaker — fornecedor não aplicável; pagamento direto pelo cliente.</small>}
                                                                            {clienteAtualEhChiesi && isGrupoServicosAgencia(item) && statusFornecedorAccessInterno === 'missing' && (
                                                                                <small className="text-warning d-block mt-1">
                                                                                    Access não encontrada pelo CNPJ; selecione o fornecedor manualmente.
                                                                                </small>
                                                                            )}
                                                                            {!linhaImpostoAccessCalculada && !linhaImpostoAccessManualAgencia && !FeeIntelligence.isFeeCalculatorItem(subitem.produto ?? {}) && (
                                                                                <div className="mt-1">
                                                                                    <label className="small text-muted mb-0" htmlFor={`local-pagamento-${indexSuperior}-${indexInferior}`}>
                                                                                        Local do pagamento
                                                                                    </label>
                                                                                    <select
                                                                                        id={`local-pagamento-${indexSuperior}-${indexInferior}`}
                                                                                        className="form-control form-control-sm"
                                                                                        value={valorSeletorLocalPagamento(subitem.pagamento_exterior, { nacional: eventoEhNacional })}
                                                                                        title="Escolha desta linha, independente da moeda e do local do evento. Exterior habilita a estimativa em reais no pré-evento e negociado."
                                                                                        onChange={(e) => {
                                                                                            try {
                                                                                                // R2 (02/10): ao mudar o Local, a linha recebe o padrão de moeda do novo local
                                                                                                // (Brasil em orçamento estrangeiro = Real; Exterior = moeda do orçamento;
                                                                                                // fornecedor com outras linhas no local = a moeda delas).
                                                                                                const comLocal = alterarPagamentoExteriorLinha(dados, indexSuperior, indexInferior, pagamentoExteriorDoSeletor(e.target.value), fornecedorAccessInterno);
                                                                                                calculaTotalOrcamento2(aplicarPadraoMoedaLocal(comLocal, indexSuperior, indexInferior, { moedaOrcamento: obterMoedaOrcamento(), fornecedorAccess: fornecedorAccessInterno }));
                                                                                            } catch (error) {
                                                                                                toast.error(error.message);
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        {!eventoEhNacional && <option value="">Não informado</option>}
                                                                                        <option value="brasil">Brasil</option>
                                                                                        <option value="exterior" disabled={ehFornecedorAccessInterno(subitem.fornecedor, fornecedorAccessInterno)}>Exterior</option>
                                                                                    </select>
                                                                                    {ehFornecedorAccessInterno(subitem.fornecedor, fornecedorAccessInterno) && (
                                                                                        <small className="text-muted d-block">Access: serviço interno, sem pagamento no exterior.</small>
                                                                                    )}
                                                                                    {/* D-0113 (Rafael 26/10): desmarcada = opção para o cliente escolher. A linha mostra o
                                                                                        valor dela aqui e no Excel, mas não soma no total e não vai para o financeiro. */}
                                                                                    {(() => {
                                                                                        const opcao = ehSomenteVisualizacao(subitem);
                                                                                        // Mesma trava da API: item com adiantamento não vira opção.
                                                                                        const travada = !opcao && (virgulaPonto(subitem.valor_adiantamento_item) || 0) > 0;
                                                                                        return (
                                                                                            <div className="mt-2">
                                                                                                <FinCheck
                                                                                                    id={`somar-total-${indexSuperior}-${indexInferior}`}
                                                                                                    label="Somar no valor total"
                                                                                                    checked={!opcao}
                                                                                                    disabled={travada}
                                                                                                    title={travada
                                                                                                        ? 'Este item já tem adiantamento: não pode virar opção.'
                                                                                                        : 'Desmarcado: o item aparece no orçamento e no Excel com o valor dele, mas não soma no total e não vai para o financeiro.'}
                                                                                                    onChange={(e) => {
                                                                                                        item.subitem[indexInferior][CAMPO_SOMENTE_VISUALIZACAO] = !e.target.checked;
                                                                                                        calculaTotalOrcamento();
                                                                                                    }}
                                                                                                />
                                                                                                {opcao && <span className="fin-pp__pill is-warn mt-1">Opção, não soma</span>}
                                                                                            </div>
                                                                                        );
                                                                                    })()}
                                                                                    {renderResumoInternacional(subitem, indexSuperior, indexInferior)}
                                                                                </div>
                                                                            )}
                                                                            {renderImpostoNfContaDireta(item, subitem, indexSuperior, indexInferior)}
                                                                        </td>

                                                                        {/* Colunas Pré-evento */}
                                                                        {showPreEvento && (
                                                                            <>
                                                                                <td style={{
                                                                                    backgroundColor: '#e3f2fd',
                                                                                    border: '1px solid #dee2e6'
                                                                                }}>
                                                                                    <div style={{ position: 'relative' }}>
                                                                                        {(subitem.produto?.somarTodosFee !== 'sim') && dados.itemMostrarAtual === subitem.chaveunica && (
                                                                                            <button
                                                                                                title="Marcar para somar outros itens"
                                                                                                style={{ position: 'absolute', right: '-15px', top: '-15px', fontSize: '10px', visibility: ((dados.itemSomarAtual) && (dados.itemSomarAtual !== subitem.chaveunica)) ? 'hidden' : 'visible' }}
                                                                                                type="button"
                                                                                                className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--sm"
                                                                                                onClick={() => {
                                                                                                    if (dados.itemSomarAtual) {
                                                                                                        dados.itemSomarAtual = null;
                                                                                                    } else {
                                                                                                        dados.itemSomarAtual = subitem.chaveunica;
                                                                                                    }
                                                                                                    setDados({ ...dados });
                                                                                                }}
                                                                                            >
                                                                                                {dados.itemSomarAtual ? 'ok' : '+'}
                                                                                            </button>
                                                                                        )}
                                                                                        <CampoValor
                                                                                            type="text"
                                                                                            className={`form-control form-control-sm${feeUnitarioEmReal ? ' orcamento-fee-em-real' : ''}`}
                                                                                            value={feeUnitarioEmReal ? baseFeeBrlExibida(subitem, 'PreEvento', subitem.valorUnitarioPreEvento) : subitem.valorUnitarioPreEvento}
                                                                                            readOnly={feeUnitarioEmReal || linhaImpostoAccessManualAgencia || (linhaFeeAgenciaComposta && !linhaFeeAgenciaManual)}
                                                                                            onValueChange={(values) => {
                                                                                                item.subitem[indexInferior].valorUnitarioPreEvento = values.value;
                                                                                                calculaTotalOrcamento();
                                                                                            }}
                                                                                            onFocus={(e) => {
                                                                                                dados.itemMostrarAtual = subitem.chaveunica;
                                                                                                setDados({ ...dados });
                                                                                            }}
                                                                                            decimalScale={6}
                                                                                            fixedDecimalScale={false}
                                                                                            moeda={feeUnitarioEmReal ? 'real' : moedaLinhaGrade(subitem, 'PreEvento')}
                                                                                            style={estiloInputMonetario}
                                                                                        />
                                                                                        {!feeUnitarioEmReal && renderEquivalenteAbaixoCampo(subitem.valorUnitarioPreEvento, subitem, 'PreEvento', false, true)}
                                                                                    </div>
                                                                                </td>
                                                                                <td style={{ backgroundColor: '#e3f2fd', border: '1px solid #dee2e6' }}>
                                                                                    <CampoValor
                                                                                        type="text"
                                                                                        className="form-control form-control-sm"
                                                                                        value={subitem.diariaPreEvento}
                                                                                        readOnly={linhaImpostoAccessManualAgencia || linhaFeeAgenciaComposta}
                                                                                        onValueChange={(values) => {
                                                                                            item.subitem[indexInferior].diariaPreEvento = values.value;
                                                                                            calculaTotalOrcamento();
                                                                                        }}
                                                                                        decimalScale={0}
                                                                                        style={{ textAlign: 'right', fontSize: '12px', border: '1px solid #dee2e6' }}
                                                                                    />
                                                                                </td>
                                                                                <td style={{ backgroundColor: '#e3f2fd', border: '1px solid #dee2e6' }}>
                                                                                    <CampoValor
                                                                                        type="text"
                                                                                        className="form-control form-control-sm"
                                                                                        value={subitem.quantidadePreEvento}
                                                                                        readOnly={linhaImpostoAccessManualAgencia || linhaFeeAgenciaComposta}
                                                                                        onValueChange={(values) => {
                                                                                            item.subitem[indexInferior].quantidadePreEvento = values.value;
                                                                                            calculaTotalOrcamento();
                                                                                        }}
                                                                                        decimalScale={0}
                                                                                        style={{ textAlign: 'right', fontSize: '12px', border: '1px solid #dee2e6' }}
                                                                                    />
                                                                                </td>
                                                                                <td style={{ backgroundColor: '#e3f2fd', border: '1px solid #dee2e6' }}>
                                                                                    <CampoPercentual
                                                                                        type="text"
                                                                                        sufixo=""
                                                                                        className="form-control form-control-sm"
                                                                                        value={subitem.servicoPreEvento}
                                                                                        readOnly={linhaImpostoAccessManualAgencia || linhaFeeAgenciaComposta}
                                                                                        onValueChange={(values) => {
                                                                                            item.subitem[indexInferior].servicoPreEvento = values.value;
                                                                                            calculaTotalOrcamento();
                                                                                        }}
                                                                                        decimalScale={4}
                                                                                        fixedDecimalScale={true}
                                                                                        style={{ textAlign: 'right', fontSize: '12px', border: '1px solid #dee2e6' }}
                                                                                    />
                                                                                </td>
                                                                                <td style={{ backgroundColor: '#e3f2fd', border: '1px solid #dee2e6' }}>
                                                                                    <CampoPercentual
                                                                                        type="text"
                                                                                        sufixo=""
                                                                                        className="form-control form-control-sm"
                                                                                        value={subitem.impostoPorcentagemItemPreEvento ?? subitem.impostoPorcentagemItem}
                                                                                        onValueChange={(values) => {
                                                                                            const dadosAtualizados = JSON.parse(JSON.stringify(dados));
                                                                                            dadosAtualizados.orcamentoitem[indexSuperior].subitem[indexInferior].impostoPorcentagemItemPreEvento = values.value;
                                                                                            setDados(calculaTotalOrcamento2(dadosAtualizados));
                                                                                        }}
                                                                                        decimalScale={4}
                                                                                        fixedDecimalScale={true}
                                                                                        style={{ textAlign: 'right', fontSize: '12px', border: '1px solid #dee2e6' }}
                                                                                    />
                                                                                </td>
                                                                                <td style={{ backgroundColor: '#e3f2fd', border: '1px solid #dee2e6' }}>
                                                                                    <CampoPercentual
                                                                                        type="text"
                                                                                        sufixo=""
                                                                                        className="form-control form-control-sm"
                                                                                        value={impostoNfBloqueadoPorFornecedor ? '0' : subitem.imposto}
                                                                                        readOnly={impostoNfTravado}
                                                                                        title={dicaImpostoNf}
                                                                                        onValueChange={(values) => {
                                                                                            if (impostoNfTravado) {
                                                                                                return;
                                                                                            }
                                                                                            const dadosAtualizados = JSON.parse(JSON.stringify(dados));
                                                                                            dadosAtualizados.orcamentoitem[indexSuperior].subitem[indexInferior].imposto = values.value;
                                                                                            setDados(calculaTotalOrcamento2(dadosAtualizados));
                                                                                        }}
                                                                                        decimalScale={2}
                                                                                        fixedDecimalScale={true}
                                                                                        style={{ textAlign: 'right', fontSize: '12px', border: '1px solid #dee2e6', ...(impostoNfTravado && { backgroundColor: '#e9ecef', cursor: 'not-allowed' }) }}
                                                                                    />
                                                                                </td>
                                                                                <td style={{ backgroundColor: '#e3f2fd', border: '1px solid #dee2e6' }}>
                                                                                    <div>
                                                                                        <input
                                                                                            type="text"
                                                                                            className={`form-control form-control-sm${feeSoEmReal(subitem) ? ' orcamento-fee-em-real' : ''}`}
                                                                                            value={feeSoEmReal(subitem) ? textoFeeBrl(subitem, 'PreEvento') : formatarValorMoedaLinha(subitem, subitem.totalPreEvento, 'PreEvento')}
                                                                                            readOnly
                                                                                            style={estiloInputMonetarioTotal}
                                                                                        />
                                                                                        {!feeSoEmReal(subitem) && renderEquivalenteAbaixoCampo(subitem.totalPreEvento, subitem, 'PreEvento', true)}
                                                                                    </div>
                                                                                </td>
                                                                                <td style={{ backgroundColor: '#e3f2fd', border: '1px solid #dee2e6' }}>
                                                                                    <input
                                                                                        type="text"
                                                                                        id={`observacao-pre-${indexSuperior}-${indexInferior}`}
                                                                                        className="form-control form-control-sm"
                                                                                        value={subitem.observacaoPreEvento || ''}
                                                                                        onChange={(e) => {
                                                                                            item.subitem[indexInferior].observacaoPreEvento = e.target.value;
                                                                                            setDados({ ...dados });
                                                                                        }}
                                                                                        style={{ fontSize: '12px', border: '1px solid #dee2e6' }}
                                                                                    />
                                                                                </td>
                                                                            </>
                                                                        )}

                                                                        {/* Célula em branco quando Pré-evento está escondido */}
                                                                        {!showPreEvento && (
                                                                            <td style={{
                                                                                backgroundColor: '#fff',
                                                                                border: '1px solid #dee2e6',
                                                                                width: 150,
                                                                                minWidth: 150,
                                                                                maxWidth: 150
                                                                            }}></td>
                                                                        )}

                                                                        {/* Colunas Adicionais de Negociado */}
                                                                        {colunasNegociadoAdicionais.map((coluna, indexColuna) => (
                                                                            <React.Fragment key={coluna.id}>
                                                                                {colunasNegociadoVisibility[coluna.id] && ehVersaoCongelada(coluna) && (() => {
                                                                                    const versao = valoresDaVersao(coluna, item.id, subitem.id);
                                                                                    const celula = { backgroundColor: '#fbf6ee', border: '1px solid #dee2e6', fontSize: '12px', textAlign: 'right', color: '#5f4b32', padding: '6px 8px' };
                                                                                    if (!versao) return <td colSpan={6} style={{ ...celula, textAlign: 'center', color: '#9aa1ab' }} title="Linha incluída depois desta versão">—</td>;
                                                                                    return (
                                                                                        <>
                                                                                            <td style={celula}>{`${simboloMoeda(versao.moeda || 'real')} ${moeda(virgulaPonto(versao.valorUnitario) || 0)}`}</td>
                                                                                            <td style={celula}>{formatarNumeroVersao(versao.diaria)}</td>
                                                                                            <td style={celula}>{formatarNumeroVersao(versao.quantidade)}</td>
                                                                                            <td style={celula}>{formatarNumeroVersao(versao.servico)}</td>
                                                                                            <td style={{ ...celula, fontWeight: 600 }}>{`${simboloMoeda(versao.moeda || 'real')} ${moeda(virgulaPonto(versao.total) || 0)}`}</td>
                                                                                            <td style={{ ...celula, textAlign: 'left' }}>{versao.observacao || ''}</td>
                                                                                        </>
                                                                                    );
                                                                                })()}
                                                                                {colunasNegociadoVisibility[coluna.id] && !ehVersaoCongelada(coluna) && (
                                                                                    <>
                                                                                        <td style={{ backgroundColor: '#fff3e0', border: '1px solid #dee2e6' }}>
                                                                                            <div>
                                                                                                <CampoValor
                                                                                                    type="text"
                                                                                                    className="form-control form-control-sm"
                                                                                                    value={subitem[`valorUnitarioNegociadoAdicional_${coluna.id}`] || ''}
                                                                                                    onValueChange={(values) => {
                                                                                                        item.subitem[indexInferior][`valorUnitarioNegociadoAdicional_${coluna.id}`] = values.value;
                                                                                                        calculaTotalOrcamento();
                                                                                                        atualizarJSONColunasAdicionais();
                                                                                                    }}
                                                                                                    decimalScale={6}
                                                                                                    fixedDecimalScale={false}
                                                                                                    moeda={moedaLinhaGrade(subitem, 'Negociado')}
                                                                                                    style={estiloInputMonetario}
                                                                                                />
                                                                                                {renderEquivalenteAbaixoCampo(subitem[`valorUnitarioNegociadoAdicional_${coluna.id}`], subitem, 'Negociado')}
                                                                                            </div>
                                                                                        </td>
                                                                                        <td style={{ backgroundColor: '#fff3e0', border: '1px solid #dee2e6' }}>
                                                                                            <CampoValor
                                                                                                type="text"
                                                                                                className="form-control form-control-sm"
                                                                                                value={pontoVirgula(subitem[`diariaNegociadoAdicional_${coluna.id}`] || '')}
                                                                                                decimalScale={6}
                                                                                                fixedDecimalScale={false}
                                                                                                casasMinimas={0}
                                                                                                onValueChange={(values, { source }) => {
                                                                                                    if (source !== 'event') return; // como o input antigo: só edição do usuário
                                                                                                    // mesmo formato de antes (texto com vírgula), lido por virgulaPonto
                                                                                                    item.subitem[indexInferior][`diariaNegociadoAdicional_${coluna.id}`] = pontoVirgula(values.value);
                                                                                                    calculaTotalOrcamento();
                                                                                                    atualizarJSONColunasAdicionais();
                                                                                                }}
                                                                                                style={{ textAlign: 'right', fontSize: '12px', border: '1px solid #dee2e6' }}
                                                                                            />
                                                                                        </td>
                                                                                        <td style={{ backgroundColor: '#fff3e0', border: '1px solid #dee2e6' }}>
                                                                                            <CampoValor
                                                                                                type="text"
                                                                                                className="form-control form-control-sm"
                                                                                                value={pontoVirgula(subitem[`quantidadeNegociadoAdicional_${coluna.id}`] || '')}
                                                                                                decimalScale={6}
                                                                                                fixedDecimalScale={false}
                                                                                                casasMinimas={0}
                                                                                                onValueChange={(values, { source }) => {
                                                                                                    if (source !== 'event') return; // como o input antigo: só edição do usuário
                                                                                                    // mesmo formato de antes (texto com vírgula), lido por virgulaPonto
                                                                                                    item.subitem[indexInferior][`quantidadeNegociadoAdicional_${coluna.id}`] = pontoVirgula(values.value);
                                                                                                    calculaTotalOrcamento();
                                                                                                    atualizarJSONColunasAdicionais();
                                                                                                }}
                                                                                                style={{ textAlign: 'right', fontSize: '12px', border: '1px solid #dee2e6' }}
                                                                                            />
                                                                                        </td>
                                                                                        <td style={{ backgroundColor: '#fff3e0', border: '1px solid #dee2e6' }}>
                                                                                            <CampoPercentual
                                                                                                type="text"
                                                                                                sufixo=""
                                                                                                className="form-control form-control-sm"
                                                                                                value={pontoVirgula(subitem[`servicoNegociadoAdicional_${coluna.id}`] || '')}
                                                                                                decimalScale={4}
                                                                                                fixedDecimalScale={true}
                                                                                                onValueChange={(values, { source }) => {
                                                                                                    if (source !== 'event') return; // como o input antigo: só edição do usuário
                                                                                                    // mesmo formato de antes (texto com vírgula), lido por virgulaPonto
                                                                                                    item.subitem[indexInferior][`servicoNegociadoAdicional_${coluna.id}`] = pontoVirgula(values.value);
                                                                                                    calculaTotalOrcamento();
                                                                                                    atualizarJSONColunasAdicionais();
                                                                                                }}
                                                                                                style={{ textAlign: 'right', fontSize: '12px', border: '1px solid #dee2e6' }}
                                                                                            />
                                                                                        </td>
                                                                                        <td style={{ backgroundColor: '#fff3e0', border: '1px solid #dee2e6' }}>
                                                                                            <div>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    className="form-control form-control-sm"
                                                                                                    value={feeSoEmReal(subitem) ? `R$ ${moeda(converterParaReais(calcularTotalColunaAdicional(subitem, coluna.id)))}` : formatarValorMoedaLinha(subitem, calcularTotalColunaAdicional(subitem, coluna.id), 'Negociado')}
                                                                                                    readOnly
                                                                                                    style={{ ...estiloInputMonetarioTotal, backgroundColor: '#f5f5f5' }}
                                                                                                />
                                                                                                {!feeSoEmReal(subitem) && renderEquivalenteAbaixoCampo(calcularTotalColunaAdicional(subitem, coluna.id), subitem, 'Negociado')}
                                                                                            </div>
                                                                                        </td>
                                                                                        <td style={{ backgroundColor: '#fff3e0', border: '1px solid #dee2e6' }}>
                                                                                            <input
                                                                                                type="text"
                                                                                                className="form-control form-control-sm"
                                                                                                value={subitem[`observacaoNegociadoAdicional_${coluna.id}`] || ''}
                                                                                                onChange={(e) => {
                                                                                                    item.subitem[indexInferior][`observacaoNegociadoAdicional_${coluna.id}`] = e.target.value;
                                                                                                    setDados({ ...dados });
                                                                                                    atualizarJSONColunasAdicionais();
                                                                                                }}
                                                                                                style={{ fontSize: '12px', border: '1px solid #dee2e6' }}
                                                                                            />
                                                                                        </td>
                                                                                    </>
                                                                                )}
                                                                                {!colunasNegociadoVisibility[coluna.id] && (
                                                                                    <td style={{
                                                                                        backgroundColor: '#fff',
                                                                                        border: '1px solid #dee2e6',
                                                                                        width: 150,
                                                                                        minWidth: 150,
                                                                                        maxWidth: 150
                                                                                    }}></td>
                                                                                )}
                                                                            </React.Fragment>
                                                                        ))}

                                                                        {/* Colunas Negociado */}
                                                                        {showNegociado && (
                                                                            <>
                                                                                <td style={{ backgroundColor: '#fff3e0', border: '1px solid #dee2e6' }}>
                                                                                    <CampoValor
                                                                                        type="text"
                                                                                        className={`form-control form-control-sm${feeUnitarioEmReal ? ' orcamento-fee-em-real' : ''}`}
                                                                                            value={feeUnitarioEmReal ? baseFeeBrlExibida(subitem, 'Negociado', subitem.valorUnitarioNegociado) : subitem.valorUnitarioNegociado}
                                                                                            readOnly={feeUnitarioEmReal || linhaImpostoAccessManualAgencia || (linhaFeeAgenciaComposta && !linhaFeeAgenciaManual)}
                                                                                        onValueChange={(values) => {
                                                                                            item.subitem[indexInferior].valorUnitarioNegociado = values.value;
                                                                                            calculaTotalOrcamento();
                                                                                        }}
                                                                                        decimalScale={6}
                                                                                        fixedDecimalScale={false}
                                                                                        moeda={feeUnitarioEmReal ? 'real' : moedaLinhaGrade(subitem, 'Negociado')}
                                                                                        style={estiloInputMonetario}
                                                                                    />
                                                                                    {!feeUnitarioEmReal && renderEquivalenteAbaixoCampo(subitem.valorUnitarioNegociado, subitem, 'Negociado', false, true)}
                                                                                </td>
                                                                                <td style={{ backgroundColor: '#fff3e0', border: '1px solid #dee2e6' }}>
                                                                                    <CampoValor
                                                                                        type="text"
                                                                                        className="form-control form-control-sm"
                                                                                        value={subitem.diariaNegociado}
                                                                                        readOnly={linhaImpostoAccessManualAgencia || linhaFeeAgenciaComposta}
                                                                                        onValueChange={(values) => {
                                                                                            item.subitem[indexInferior].diariaNegociado = values.value;
                                                                                            calculaTotalOrcamento();
                                                                                        }}
                                                                                        decimalScale={0}
                                                                                        style={{ textAlign: 'right', fontSize: '12px', border: '1px solid #dee2e6' }}
                                                                                    />
                                                                                </td>
                                                                                <td style={{ backgroundColor: '#fff3e0', border: '1px solid #dee2e6' }}>
                                                                                    <CampoValor
                                                                                        type="text"
                                                                                        className="form-control form-control-sm"
                                                                                        value={subitem.quantidadeNegociado}
                                                                                        readOnly={linhaImpostoAccessManualAgencia || linhaFeeAgenciaComposta}
                                                                                        onValueChange={(values) => {
                                                                                            item.subitem[indexInferior].quantidadeNegociado = values.value;
                                                                                            calculaTotalOrcamento();
                                                                                        }}
                                                                                        decimalScale={0}
                                                                                        style={{ textAlign: 'right', fontSize: '12px', border: '1px solid #dee2e6' }}
                                                                                    />
                                                                                </td>
                                                                                <td style={{ backgroundColor: '#fff3e0', border: '1px solid #dee2e6' }}>
                                                                                    <CampoPercentual
                                                                                        type="text"
                                                                                        sufixo=""
                                                                                        className="form-control form-control-sm"
                                                                                        value={subitem.servicoNegociado}
                                                                                        readOnly={linhaImpostoAccessManualAgencia || linhaFeeAgenciaComposta}
                                                                                        onValueChange={(values) => {
                                                                                            item.subitem[indexInferior].servicoNegociado = values.value;
                                                                                            calculaTotalOrcamento();
                                                                                        }}
                                                                                        decimalScale={4}
                                                                                        fixedDecimalScale={true}
                                                                                        style={{ textAlign: 'right', fontSize: '12px', border: '1px solid #dee2e6' }}
                                                                                    />
                                                                                </td>
                                                                                <td style={{ backgroundColor: '#fff3e0', border: '1px solid #dee2e6' }}>
                                                                                    <CampoPercentual
                                                                                        type="text"
                                                                                        sufixo=""
                                                                                        className="form-control form-control-sm"
                                                                                        value={subitem.impostoPorcentagemItemNegociado ?? subitem.impostoPorcentagemItem}
                                                                                        onValueChange={(values) => {
                                                                                            const dadosAtualizados = JSON.parse(JSON.stringify(dados));
                                                                                            dadosAtualizados.orcamentoitem[indexSuperior].subitem[indexInferior].impostoPorcentagemItemNegociado = values.value;
                                                                                            setDados(calculaTotalOrcamento2(dadosAtualizados));
                                                                                        }}
                                                                                        decimalScale={4}
                                                                                        fixedDecimalScale={true}
                                                                                        style={{ textAlign: 'right', fontSize: '12px', border: '1px solid #dee2e6' }}
                                                                                    />
                                                                                </td>
                                                                                <td style={{ backgroundColor: '#fff3e0', border: '1px solid #dee2e6' }}>
                                                                                    <CampoPercentual
                                                                                        type="text"
                                                                                        sufixo=""
                                                                                        className="form-control form-control-sm"
                                                                                        value={impostoNfBloqueadoPorFornecedor ? '0' : subitem.imposto}
                                                                                        readOnly={impostoNfTravado}
                                                                                        title={dicaImpostoNf}
                                                                                        onValueChange={(values) => {
                                                                                            if (impostoNfTravado) {
                                                                                                return;
                                                                                            }
                                                                                            const dadosAtualizados = JSON.parse(JSON.stringify(dados));
                                                                                            dadosAtualizados.orcamentoitem[indexSuperior].subitem[indexInferior].imposto = values.value;
                                                                                            setDados(calculaTotalOrcamento2(dadosAtualizados));
                                                                                        }}
                                                                                        decimalScale={2}
                                                                                        fixedDecimalScale={true}
                                                                                        style={{ textAlign: 'right', fontSize: '12px', border: '1px solid #dee2e6', ...(impostoNfTravado && { backgroundColor: '#e9ecef', cursor: 'not-allowed' }) }}
                                                                                    />
                                                                                </td>
                                                                                <td style={{ backgroundColor: '#fff3e0', border: '1px solid #dee2e6', position: 'relative', minWidth: '165px', height: '52px', padding: '4px' }}>
                                                                                    <Dropdown style={{ position: 'absolute', right: '2px', top: '2px', zIndex: 100 }}>
                                                                                        <Dropdown.Toggle
                                                                                            variant="light"
                                                                                            size="sm"
                                                                                            className="dropdown-toggle-no-caret"
                                                                                            style={{
                                                                                                padding: '1px 4px',
                                                                                                fontSize: '14px',
                                                                                                color: '#000',
                                                                                                backgroundColor: '#f0f0f0',
                                                                                                border: '1px solid #ddd',
                                                                                                textDecoration: 'none',
                                                                                                lineHeight: '1'
                                                                                            }}
                                                                                        >
                                                                                            ⋮
                                                                                        </Dropdown.Toggle>
                                                                                        <Dropdown.Menu style={{ zIndex: 101 }}>
                                                                                            <Dropdown.Item onClick={() => {
                                                                                                copiaValoresInferior("PreEvento", "Negociado", indexSuperior, indexInferior);
                                                                                            }}>
                                                                                                <FaCopy style={{ marginRight: '8px' }} /> Copiar de Pré-evento
                                                                                            </Dropdown.Item>
                                                                                        </Dropdown.Menu>
                                                                                    </Dropdown>
                                                                                    <div>
                                                                                        <input
                                                                                            type="text"
                                                                                            className={`form-control form-control-sm${feeSoEmReal(subitem) ? ' orcamento-fee-em-real' : ''}`}
                                                                                            value={feeSoEmReal(subitem) ? textoFeeBrl(subitem, 'Negociado') : formatarValorMoedaLinha(subitem, subitem.totalNegociado, 'Negociado')}
                                                                                            readOnly
                                                                                            style={{ ...estiloInputMonetarioTotal, paddingRight: '30px', marginTop: '16px' }}
                                                                                        />
                                                                                        {!feeSoEmReal(subitem) && renderEquivalenteAbaixoCampo(subitem.totalNegociado, subitem, 'Negociado', true)}
                                                                                    </div>
                                                                                </td>
                                                                                <td style={{ backgroundColor: '#fff3e0', border: '1px solid #dee2e6' }}>
                                                                                    <input
                                                                                        type="text"
                                                                                        id={`observacao-neg-${indexSuperior}-${indexInferior}`}
                                                                                        className="form-control form-control-sm"
                                                                                        value={subitem.observacaoNegociado || ''}
                                                                                        onChange={(e) => {
                                                                                            item.subitem[indexInferior].observacaoNegociado = e.target.value;
                                                                                            setDados({ ...dados });
                                                                                        }}
                                                                                        style={{ fontSize: '12px', border: '1px solid #dee2e6' }}
                                                                                    />
                                                                                </td>
                                                                            </>
                                                                        )}

                                                                        {/* Célula em branco quando Negociado está escondido */}
                                                                        {!showNegociado && (
                                                                            <td style={{
                                                                                backgroundColor: '#fff',
                                                                                border: '1px solid #dee2e6',
                                                                                width: 150,
                                                                                minWidth: 150,
                                                                                maxWidth: 150
                                                                            }}></td>
                                                                        )}

                                                                        {showFechamento && (
                                                                            <>
                                                                                <td style={{ backgroundColor: '#e8f5e8', border: '1px solid #dee2e6' }}>
                                                                                    <CampoValor
                                                                                        type="text"
                                                                                        className={`form-control form-control-sm${feeUnitarioEmReal ? ' orcamento-fee-em-real' : ''}`}
                                                                                            value={feeUnitarioEmReal ? baseFeeBrlExibida(subitem, 'Fechamento', campoFechamento('valorUnitarioFechamento')) : campoFechamento('valorUnitarioFechamento')}
                                                                                            readOnly={feeUnitarioEmReal || linhaImpostoAccessManualAgencia || (linhaFeeAgenciaComposta && !linhaFeeAgenciaManual) || fechamentoExteriorConcluido}
                                                                                        title={dicaFechamentoExterior}
                                                                                        onValueChange={(values) => {
                                                                                            if (fechamentoExteriorConcluido) return;
                                                                                            item.subitem[indexInferior].valorUnitarioFechamento = values.value;
                                                                                            calculaTotalOrcamento();
                                                                                        }}
                                                                                        decimalScale={6}
                                                                                        fixedDecimalScale={false}
                                                                                        moeda={feeUnitarioEmReal ? 'real' : moedaLinhaGrade(subitem, 'Fechamento')}
                                                                                        style={estiloInputMonetario}
                                                                                    />
                                                                                    {!feeUnitarioEmReal && renderEquivalenteAbaixoCampo(campoFechamento('valorUnitarioFechamento'), subitem, 'Fechamento', false, true)}
                                                                                </td>
                                                                                <td style={{ backgroundColor: '#e8f5e8', border: '1px solid #dee2e6' }}>
                                                                                    <CampoValor
                                                                                        type="text"
                                                                                        className="form-control form-control-sm"
                                                                                        value={campoFechamento('diariaFechamento')}
                                                                                        readOnly={linhaImpostoAccessManualAgencia || linhaFeeAgenciaComposta || fechamentoExteriorConcluido}
                                                                                        title={dicaFechamentoExterior}
                                                                                        onValueChange={(values) => {
                                                                                            if (fechamentoExteriorConcluido) return;
                                                                                            item.subitem[indexInferior].diariaFechamento = values.value;
                                                                                            calculaTotalOrcamento();
                                                                                        }}
                                                                                        decimalScale={0}
                                                                                        style={{ textAlign: 'right', fontSize: '12px', border: '1px solid #dee2e6' }}
                                                                                    />
                                                                                </td>
                                                                                <td style={{ backgroundColor: '#e8f5e8', border: '1px solid #dee2e6' }}>
                                                                                    <CampoValor
                                                                                        type="text"
                                                                                        className="form-control form-control-sm"
                                                                                        value={campoFechamento('quantidadeFechamento')}
                                                                                        readOnly={linhaImpostoAccessManualAgencia || linhaFeeAgenciaComposta || fechamentoExteriorConcluido}
                                                                                        title={dicaFechamentoExterior}
                                                                                        onValueChange={(values) => {
                                                                                            if (fechamentoExteriorConcluido) return;
                                                                                            item.subitem[indexInferior].quantidadeFechamento = values.value;
                                                                                            calculaTotalOrcamento();
                                                                                        }}
                                                                                        decimalScale={0}
                                                                                        style={{ textAlign: 'right', fontSize: '12px', border: '1px solid #dee2e6' }}
                                                                                    />
                                                                                </td>
                                                                                <td style={{ backgroundColor: '#e8f5e8', border: '1px solid #dee2e6' }}>
                                                                                    <CampoPercentual
                                                                                        type="text"
                                                                                        sufixo=""
                                                                                        className="form-control form-control-sm"
                                                                                        value={campoFechamento('servicoFechamento')}
                                                                                        readOnly={linhaImpostoAccessManualAgencia || linhaFeeAgenciaComposta || fechamentoExteriorConcluido}
                                                                                        title={dicaFechamentoExterior}
                                                                                        onValueChange={(values) => {
                                                                                            if (fechamentoExteriorConcluido) return;
                                                                                            item.subitem[indexInferior].servicoFechamento = values.value;
                                                                                            calculaTotalOrcamento();
                                                                                        }}
                                                                                        decimalScale={4}
                                                                                        fixedDecimalScale={true}
                                                                                        style={{ textAlign: 'right', fontSize: '12px', border: '1px solid #dee2e6' }}
                                                                                    />
                                                                                </td>
                                                                                <td style={{ backgroundColor: '#e8f5e8', border: '1px solid #dee2e6' }}>
                                                                                    <CampoPercentual
                                                                                        type="text"
                                                                                        sufixo=""
                                                                                        className="form-control form-control-sm"
                                                                                        value={campoFechamento('impostoPorcentagemItemFechamento') ?? campoFechamento('impostoPorcentagemItem')}
                                                                                        readOnly={fechamentoExteriorConcluido}
                                                                                        title={dicaFechamentoExterior}
                                                                                        onValueChange={(values) => {
                                                                                            if (fechamentoExteriorConcluido) return;
                                                                                            const dadosAtualizados = JSON.parse(JSON.stringify(dados));
                                                                                            dadosAtualizados.orcamentoitem[indexSuperior].subitem[indexInferior].impostoPorcentagemItemFechamento = values.value;
                                                                                            setDados(calculaTotalOrcamento2(dadosAtualizados));
                                                                                        }}
                                                                                        decimalScale={4}
                                                                                        fixedDecimalScale={true}
                                                                                        style={{ textAlign: 'right', fontSize: '12px', border: '1px solid #dee2e6' }}
                                                                                    />
                                                                                </td>
                                                                                <td style={{ backgroundColor: '#e8f5e8', border: '1px solid #dee2e6' }}>
                                                                                    <CampoPercentual
                                                                                        type="text"
                                                                                        sufixo=""
                                                                                        className="form-control form-control-sm"
                                                                                        value={impostoNfBloqueadoPorFornecedor ? '0' : subitem.imposto}
                                                                                        readOnly={impostoNfTravado}
                                                                                        title={dicaImpostoNf}
                                                                                        onValueChange={(values) => {
                                                                                            if (impostoNfTravado) {
                                                                                                return;
                                                                                            }
                                                                                            const dadosAtualizados = JSON.parse(JSON.stringify(dados));
                                                                                            dadosAtualizados.orcamentoitem[indexSuperior].subitem[indexInferior].imposto = values.value;
                                                                                            setDados(calculaTotalOrcamento2(dadosAtualizados));
                                                                                        }}
                                                                                        decimalScale={2}
                                                                                        fixedDecimalScale={true}
                                                                                        style={{ textAlign: 'right', fontSize: '12px', border: '1px solid #dee2e6', ...(impostoNfTravado && { backgroundColor: '#e9ecef', cursor: 'not-allowed' }) }}
                                                                                    />
                                                                                </td>
                                                                                <td style={{ backgroundColor: '#e8f5e8', border: '1px solid #dee2e6', position: 'relative', minWidth: '165px', height: '52px', padding: '4px' }}>
                                                                                    <Dropdown style={{ position: 'absolute', right: '2px', top: '2px', zIndex: 100 }}>
                                                                                        <Dropdown.Toggle
                                                                                            variant="light"
                                                                                            size="sm"
                                                                                            className="dropdown-toggle-no-caret"
                                                                                            style={{
                                                                                                padding: '1px 4px',
                                                                                                fontSize: '14px',
                                                                                                color: '#000',
                                                                                                backgroundColor: '#f0f0f0',
                                                                                                border: '1px solid #ddd',
                                                                                                textDecoration: 'none',
                                                                                                lineHeight: '1'
                                                                                            }}
                                                                                        >
                                                                                            ⋮
                                                                                        </Dropdown.Toggle>
                                                                                        <Dropdown.Menu style={{ zIndex: 101 }}>
                                                                                            <Dropdown.Item disabled={fechamentoExteriorConcluido} title={dicaFechamentoExterior} onClick={() => {
                                                                                                copiaValoresInferior("Negociado", "Fechamento", indexSuperior, indexInferior);
                                                                                            }}>
                                                                                                <FaCopy style={{ marginRight: '8px' }} /> Copiar de Negociado
                                                                                            </Dropdown.Item>
                                                                                        </Dropdown.Menu>
                                                                                    </Dropdown>
                                                                                    <div>
                                                                                        <input
                                                                                            type="text"
                                                                                            className={`form-control form-control-sm${feeSoEmReal(subitem) ? ' orcamento-fee-em-real' : ''}`}
                                                                                            value={feeSoEmReal(subitem) ? textoFeeBrl(subitem, 'Fechamento') : formatarValorMoedaLinha(subitem, valorFechamentoExibicao(subitem), 'Fechamento')}
                                                                                            readOnly
                                                                                            title={fechamentoExibicao?.observacao}
                                                                                            style={{ ...estiloInputMonetarioTotal, paddingRight: '30px', marginTop: '16px' }}
                                                                                        />
                                                                                        {!feeSoEmReal(subitem) && renderEquivalenteAbaixoCampo(valorFechamentoExibicao(subitem), subitem, 'Fechamento', !subitem.fechamento_exibicao)}
                                                                                        {fechamentoExibicao && (
                                                                                            <div style={{ marginTop: 2, textAlign: 'right', fontSize: '10px', color: '#15803d' }} title={fechamentoExibicao.observacao} data-fechamento-exibicao={fechamentoExibicao.origem}>
                                                                                                {fechamentoExteriorConcluido ? 'Pago no exterior' : 'Fechamento real'}
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                </td>
                                                                                <td style={{ backgroundColor: '#e8f5e8', border: '1px solid #dee2e6' }}>
                                                                                    <input
                                                                                        type="text"
                                                                                        id={`observacao-fechamento-${indexSuperior}-${indexInferior}`}
                                                                                        className="form-control form-control-sm"
                                                                                        value={subitem.observacaoFechamento || ''}
                                                                                        onChange={(e) => {
                                                                                            item.subitem[indexInferior].observacaoFechamento = e.target.value;
                                                                                            setDados({ ...dados });
                                                                                        }}
                                                                                        style={{ fontSize: '12px', border: '1px solid #dee2e6' }}
                                                                                    />
                                                                                </td>
                                                                            </>
                                                                        )}

                                                                        {/* Célula em branco quando Fechamento está escondido */}
                                                                        {!showFechamento && (
                                                                            <td style={{
                                                                                backgroundColor: '#fff',
                                                                                border: '1px solid #dee2e6',
                                                                                width: 150,
                                                                                minWidth: 150,
                                                                                maxWidth: 150
                                                                            }}></td>
                                                                        )}

                                                                        {/* Células de Pagamento (Clone) */}
                                                                        {showPagamento && (
                                                                            <>
                                                                                {/* Célula 1: Fornecedor Pagamento (Agência | Cliente) — string canônica 'agencia'|'cliente' */}
                                                                                {/* Fundo âmbar quando o cliente paga: sinal PERSISTENTE de que o item
                                                                                    sai do fluxo do Financeiro (o toast avisa na hora, mas some).
                                                                                    Só a cor muda — nada de altura/padding, senão desalinha a grade. */}
                                                                                <td
                                                                                    title={((subitem.fornecedorpagamento?.id ?? subitem.fornecedorpagamento ?? '').toString().toLowerCase() === 'cliente')
                                                                                        ? 'Pago pelo cliente — não vai para Contas a Pagar nem compõe o valor pago pela Access'
                                                                                        : (itemNaoPodeVirarCliente(subitem, opfsEmPagamento.map((f) => f.fornecedor_id)) ? MSG_CLIENTE_BLOQUEADO : undefined)}
                                                                                    style={{
                                                                                        backgroundColor: ((subitem.fornecedorpagamento?.id ?? subitem.fornecedorpagamento ?? '').toString().toLowerCase() === 'cliente')
                                                                                            ? '#fff3cd'
                                                                                            : '#f1f8e9',
                                                                                        border: '1px solid #dee2e6'
                                                                                    }}>
                                                                                    <ReactSelect
                                                                                        placeholder={"Selecione"}
                                                                                        isDisabled={linhaImpostoAccessCalculada || linhaFeeSpeaker || linhaFee130Travada}
                                                                                        value={linhaFee130Travada
                                                                                            ? { value: 'agencia', label: 'Agência' }
                                                                                            : subitem.fornecedorpagamento
                                                                                            ? (() => {
                                                                                                const id = typeof subitem.fornecedorpagamento === 'object' ? subitem.fornecedorpagamento.id : subitem.fornecedorpagamento;
                                                                                                return { value: id, label: id === 'cliente' ? 'Cliente' : 'Agência' };
                                                                                            })()
                                                                                            : null}
                                                                                        onChange={(e) => {
                                                                                            const valorAnterior = item.subitem[indexInferior].fornecedorpagamento;
                                                                                            const idAnterior = (valorAnterior?.id ?? valorAnterior ?? '').toString().toLowerCase();
                                                                                            // D-0137 (Rafael 30/10): quem paga é POR ITEM, inverte a regra de 02/08 (por
                                                                                            // fornecedor). Só esta linha muda; o fornecedor pode ficar misto.
                                                                                            item.subitem[indexInferior].fornecedorpagamento = e ? e.value : null;

                                                                                            // Item pago pelo cliente sai do fluxo do Financeiro sem nenhum
                                                                                            // sinal na tela — ele simplesmente não aparece em Contas a Pagar.
                                                                                            if (e && e.value === 'cliente' && idAnterior !== 'cliente') {
                                                                                                toast.warning('Pagamento pelo cliente: este item NÃO vai para Contas a Pagar e não compõe o valor pago pela Access.');
                                                                                            }
                                                                                            calculaTotalOrcamento();
                                                                                        }}
                                                                                        isClearable={true}
                                                                                        options={[
                                                                                            { value: 'agencia', label: 'Agência' },
                                                                                            {
                                                                                                value: 'cliente',
                                                                                                label: 'Cliente',
                                                                                                // Mesma trava da API: item com pagamento em andamento não vira cliente.
                                                                                                disabled: itemNaoPodeVirarCliente(subitem, opfsEmPagamento.map((f) => f.fornecedor_id)),
                                                                                            },
                                                                                        ]}
                                                                                    />
                                                                                </td>

                                                                                {/* Célula 3: Compõe FEE */}
                                                                                <td style={{
                                                                                    backgroundColor: '#f1f8e9',
                                                                                    border: '1px solid #dee2e6'
                                                                                }}>
                                                                                    <ReactSelect compact
                                                                                        placeholder={"Fee"}
                                                                                        isDisabled={(clienteAtualEhChiesi && isGrupoServicosAgencia(item)) || linhaFee130Travada}
                                                                                        value={(clienteAtualEhChiesi && isGrupoServicosAgencia(item)) || linhaFee130Travada
                                                                                            ? { value: 'nao', label: 'Não' }
                                                                                            : {
                                                                                                value: subitem.compoeFee ?? "nao",
                                                                                                label: subitem.nomeCompoeFee ?? (((subitem.compoeFee ?? 'nao') === 'sim') ? 'Sim' : 'Não')
                                                                                            }}
                                                                                        onChange={(e) => {
                                                                                            item.subitem[indexInferior].compoeFee = e.value;
                                                                                            item.subitem[indexInferior].nomeCompoeFee = e.label;
                                                                                            calculaTotalOrcamento();
                                                                                        }}
                                                                                        options={[
                                                                                            { value: 'sim', label: 'Sim' },
                                                                                            { value: 'nao', label: 'Não' },
                                                                                        ]}
                                                                                    />
                                                                                </td>

                                                                                {/* Célula 4: Imposto NF Access (Chiesi ou evento internacional) */}
                                                                                <td style={{
                                                                                    backgroundColor: '#f1f8e9',
                                                                                    border: '1px solid #dee2e6',
                                                                                    textAlign: 'center',
                                                                                    display: podeCalcularImpostoNfAccess ? 'table-cell' : 'none'
                                                                                }}>
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="form-check-input"
                                                                                        disabled={isSubitemImpostoNfAccess(subitem)
                                                                                            || (clienteAtualEhChiesi && isGrupoServicosAgencia(item))
                                                                                            || impostoAutomaticoServicoProprioChiesi
                                                                                            || aereoDaAccessChiesi
                                                                                            || !!subitem.nfAccessPrincipalExteriorChiesi}
                                                                                        title={subitem.nfAccessPrincipalExteriorChiesi
                                                                                            ? 'Coordenação no exterior (Chiesi e Sanofi): NF Access 19,05% sobre o principal, como na planilha (bloco inteiro).'
                                                                                            : linhaElegivelRemessaExterior(subitem, fornecedorAccessInterno)
                                                                                            ? 'Exterior: NF no principal comercial somente enquanto não houver ledger concluído e conciliado. No realizado, NF Access incide só nos custos IR/IOF/envio.'
                                                                                            : impostoAutomaticoServicoProprioChiesi
                                                                                            ? 'Imposto NF Access automático: serviço próprio Access/FEE da Chiesi (19,05% por fora).'
                                                                                            : aereoDaAccessChiesi
                                                                                            ? 'Chiesi: o aéreo da Access não leva Imposto NF Access. Os 19,05% ficam no fee aéreo (Serviços Agência).'
                                                                                            : undefined}
                                                                                        checked={!aereoDaAccessChiesi && (impostoAutomaticoServicoProprioChiesi || parseBooleanFlag(subitem.inserirCalculoTotalPlanilha))}
                                                                                        onChange={(e) => {
                                                                                            item.subitem[indexInferior].inserirCalculoTotalPlanilha = e.target.checked;
                                                                                            if (e.target.checked) {
                                                                                                aplicarObservacaoImpostoPlanilha(item.subitem[indexInferior]);
                                                                                            }
                                                                                            calculaTotalOrcamento();
                                                                                        }}
                                                                                        style={{
                                                                                            width: '20px',
                                                                                            height: '20px',
                                                                                            cursor: 'pointer'
                                                                                        }}
                                                                                    />
                                                                                    {subitem.nfAccessPrincipalExteriorChiesi
                                                                                        ? <small className="d-block text-muted">NF do bloco</small>
                                                                                        : linhaElegivelRemessaExterior(subitem, fornecedorAccessInterno) && <small className="d-block text-muted">Só fechamento</small>}
                                                                                </td>

                                                                                {/* Célula 5: Tipo Pagamento (Antecipado/Padrão) — removido a pedido em 2026-06-01 */}
                                                                                {false && (
                                                                                    <td style={{ backgroundColor: '#f1f8e9', border: '1px solid #dee2e6' }}>
                                                                                        <ReactSelect compact placeholder={"Pagamento"}
                                                                                            value={{ value: subitem.tipopagamento ?? "", label: subitem.nomeTipopagamento ?? "" }}
                                                                                            onChange={(e) => { item.subitem[indexInferior].tipopagamento = e.value; item.subitem[indexInferior].nomeTipopagamento = e.label; calculaTotalOrcamento(); }}
                                                                                            options={[{ value: 'antecipado', label: 'Antecipado' }, { value: 'padrao', label: 'Padrão' }]}
                                                                                        />
                                                                                    </td>
                                                                                )}

                                                                                {/* Célula 6: Tipo Faturamento — removido da UI do orçamento em 2026-06-02 (campo mantido no DB e exports; gerenciado na Central Financeira) */}
                                                                                {false && (
                                                                                    <td style={{ backgroundColor: '#f1f8e9', border: '1px solid #dee2e6', padding: '4px' }}>
                                                                                        {/* toggle ND/NF — ver isSubitemTipoFaturamentoND */}
                                                                                    </td>
                                                                                )}

                                                                                {/* Célula 7: Valor Real — removido da UI do orçamento em 2026-06-02 (campo mantido no DB e exports; gerenciado na Central Financeira) */}
                                                                                {false && (
                                                                                    <td style={{ backgroundColor: '#f1f8e9', border: '1px solid #dee2e6' }}>
                                                                                        {/* pagamentovalorreal — ver NumericFormat original */}
                                                                                    </td>
                                                                                )}

                                                                                {/* Célula 8: Forma Pagamento — removida a pedido em 2026-06-01 (será redirecionada para outro local) */}
                                                                                {false && (
                                                                                    <td style={{ backgroundColor: '#f1f8e9', border: '1px solid #dee2e6', textAlign: 'center', verticalAlign: 'middle' }}>
                                                                                        {/* botão forma pagamento — ver abrirModalFormaPgtoPagamento */}
                                                                                    </td>
                                                                                )}

                                                                                {/* Célula 9: Prazo — removido da UI do orçamento em 2026-06-02 (campo mantido no DB e exports; gerenciado na Central Financeira) */}
                                                                                {false && (
                                                                                    <td style={{ backgroundColor: '#f1f8e9', border: '1px solid #dee2e6' }}>
                                                                                        {/* pagamentoprazo — ver ReactSelect original */}
                                                                                    </td>
                                                                                )}

                                                                                {/* Célula 10: Vencimento — removida a pedido em 2026-06-01 */}
                                                                                {false && (
                                                                                    <td style={{ backgroundColor: '#f1f8e9', border: '1px solid #dee2e6' }}>
                                                                                        <Data value={subitem.pagamentovencimento} onChange={(e) => { item.subitem[indexInferior].pagamentovencimento = e; setDados({ ...dados }); }} className="form-control form-control-sm" style={{ fontSize: '12px', border: '1px solid #dee2e6' }} withPortal={true} />
                                                                                    </td>
                                                                                )}

                                                                                {/* Célula 11: Entrega NF — oculto (false&& para não gerar coluna fantasma no layout da tabela) */}
                                                                                {false && <td style={{ backgroundColor: '#f1f8e9', border: '1px solid #dee2e6' }}></td>}

                                                                                {/* Célula 12: Observação */}
                                                                                <td style={{
                                                                                    backgroundColor: '#f1f8e9',
                                                                                    border: '1px solid #dee2e6'
                                                                                }}>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control form-control-sm"
                                                                                        value={subitem.pagamentoobservacao || ''}
                                                                                        onChange={(e) => {
                                                                                            item.subitem[indexInferior].pagamentoobservacao = e.target.value;
                                                                                            setDados({ ...dados });
                                                                                        }}
                                                                                        style={{ fontSize: '12px', border: '1px solid #dee2e6' }}
                                                                                    />
                                                                                </td>

                                                                                {/* Nome comercial exclusivamente para o Excel. */}
                                                                                {false && <td style={{ backgroundColor: '#f1f8e9', border: '1px solid #dee2e6' }}>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control form-control-sm"
                                                                                        placeholder="Ex.: Stand multi tridimensional"
                                                                                        value={subitem.nomeItemPlanilha || ''}
                                                                                        onChange={(e) => {
                                                                                            item.subitem[indexInferior].nomeItemPlanilha = e.target.value;
                                                                                            setDados({ ...dados });
                                                                                        }}
                                                                                        style={{ fontSize: '12px', border: '1px solid #dee2e6' }}
                                                                                    />
                                                                                </td>}

                                                                                {/* Estornos — removido da UI do orçamento em 2026-06-02 (gerenciado na Central Financeira) */}
                                                                                {/* Aéreo — removido da UI do orçamento em 2026-06-02 (gerenciado na Central Financeira) */}
                                                                                {/* Forma Pgto — removido da UI do orçamento em 2026-06-02 (gerenciado na Central Financeira) */}
                                                                                {/* Adiantamento — removido da UI do orçamento em 2026-06-02 (gerenciado na Central Financeira) */}
                                                                            </>
                                                                        )}

                                                                        {/* Célula em branco quando Pagamento está escondido */}
                                                                        {!showPagamento && (
                                                                            <td style={{
                                                                                backgroundColor: '#fff',
                                                                                border: '1px solid #dee2e6',
                                                                                width: 150,
                                                                                minWidth: 150,
                                                                                maxWidth: 150
                                                                            }}></td>
                                                                        )}

                                                                        {MOSTRAR_COLUNA_FORA_ESCOPO && (<>
                                                                        {/* Célula independente: Fora Escopo */}
                                                                        <td style={{
                                                                            backgroundColor: '#fff3e0',
                                                                            border: '1px solid #dee2e6',
                                                                            textAlign: 'center',
                                                                            padding: '4px'
                                                                        }}>
                                                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
                                                                                <input
                                                                                    type="checkbox"
                                                                                    className="form-check-input"
                                                                                    checked={subitem.fora_escopo || false}
                                                                                    onChange={(e) => {
                                                                                        if (e.target.checked) {
                                                                                            // Abre modal para justificativa (novo item)
                                                                                            setItemForaEscopo({
                                                                                                indexSuperior: indexSuperior,
                                                                                                indexInferior: indexInferior
                                                                                            });
                                                                                            setDadosForaEscopo({
                                                                                                motivo: '',
                                                                                                descricao: ''
                                                                                            });
                                                                                            setShowModalForaEscopo(true);
                                                                                        } else {
                                                                                            // Desmarca e limpa dados
                                                                                            item.subitem[indexInferior].fora_escopo = false;
                                                                                            item.subitem[indexInferior].motivo_fora_escopo = null;
                                                                                            item.subitem[indexInferior].descricao_fora_escopo = null;
                                                                                            setDados({ ...dados });
                                                                                        }
                                                                                    }}
                                                                                    style={{
                                                                                        width: '20px',
                                                                                        height: '20px',
                                                                                        cursor: 'pointer',
                                                                                        accentColor: '#f57c00'
                                                                                    }}
                                                                                />
                                                                                {subitem.fora_escopo ? (
                                                                                    <button
                                                                                        type="button"
                                                                                        className="fin-pp__btn fin-pp__btn--sm"
                                                                                        title="Editar justificativa"
                                                                                        onClick={(e) => {
                                                                                            e.preventDefault();
                                                                                            e.stopPropagation();
                                                                                            setItemForaEscopo({
                                                                                                indexSuperior: indexSuperior,
                                                                                                indexInferior: indexInferior
                                                                                            });
                                                                                            // Carrega os dados existentes
                                                                                            setDadosForaEscopo({
                                                                                                motivo: subitem.motivo_fora_escopo || '',
                                                                                                descricao: subitem.descricao_fora_escopo || ''
                                                                                            });
                                                                                            setShowModalForaEscopo(true);
                                                                                        }}
                                                                                        style={{
                                                                                            color: '#f57c00',
                                                                                            fontSize: '14px'
                                                                                        }}
                                                                                    >
                                                                                        <FaPen size={14} />
                                                                                    </button>
                                                                                ) : null}
                                                                            </div>
                                                                        </td>
                                                                        </>)}
                                                                        <td style={{
                                                                            backgroundColor: '#e8f0fe',
                                                                            border: '1px solid #dee2e6',
                                                                            textAlign: 'center',
                                                                            padding: '4px'
                                                                        }}>
                                                                            {produtoPermiteUploadEquipamentos(subitem.produto) ? (
                                                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                                                                    {(() => {
                                                                                        const arquivoId = subitem.arquivoequipamentos?.id || subitem.arquivoequipamentos;
                                                                                        return arquivoId ? (
                                                                                            <div style={{ display: 'flex', gap: '4px', justifyContent: 'center' }}>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="fin-pp__btn fin-pp__btn--sm"
                                                                                                    style={{ fontSize: '10px', padding: '2px 6px' }}
                                                                                                    onClick={() => {
                                                                                                        window.open(process.env.REACT_APP_API_URL + `/arquivo/download/${arquivoId}`, '_blank');
                                                                                                    }}
                                                                                                >
                                                                                                    Baixar atual
                                                                                                </button>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="fin-pp__btn fin-pp__btn--danger-ghost fin-pp__btn--sm"
                                                                                                    style={{ fontSize: '10px', padding: '2px 6px' }}
                                                                                                    onClick={() => {
                                                                                                        item.subitem[indexInferior].arquivoequipamentos = null;
                                                                                                        item.subitem[indexInferior].removerarquivoequipamentos = true;
                                                                                                        delete item.subitem[indexInferior].binariosarquivoequipamentos;
                                                                                                        setDados({ ...dados });
                                                                                                    }}
                                                                                                >
                                                                                                    Remover
                                                                                                </button>
                                                                                            </div>
                                                                                        ) : null;
                                                                                    })()}
                                                                                    <input
                                                                                        type="file"
                                                                                        className="form-control form-control-sm"
                                                                                        style={{ fontSize: '10px', border: '1px solid #dee2e6' }}
                                                                                        accept=".xls,.xlsx,.csv"
                                                                                        onChange={(e) => {
                                                                                            const file = e.target.files[0];
                                                                                            if (file) {
                                                                                                const reader = new FileReader();
                                                                                                reader.onload = () => {
                                                                                                    const arrayBuffer = reader.result;
                                                                                                    const uint8Array = new Uint8Array(arrayBuffer);
                                                                                                    const hexString = Array.from(uint8Array)
                                                                                                        .map(byte => byte.toString(16).padStart(2, '0'))
                                                                                                        .join('');
                                                                                                    item.subitem[indexInferior].binariosarquivoequipamentos = {
                                                                                                        name: file.name,
                                                                                                        content: hexString,
                                                                                                        size: file.size,
                                                                                                        type: file.type
                                                                                                    };
                                                                                                    item.subitem[indexInferior].removerarquivoequipamentos = false;
                                                                                                    setDados({ ...dados });
                                                                                                };
                                                                                                reader.readAsArrayBuffer(file);
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                    {subitem.binariosarquivoequipamentos && (
                                                                                        <span style={{ fontSize: '10px', color: '#1a73e8' }}>
                                                                                            Arquivo selecionado. Salve para concluir.
                                                                                        </span>
                                                                                    )}
                                                                                </div>
                                                                            ) : (
                                                                                <span style={{ fontSize: '11px', color: '#6c757d' }}>N/A</span>
                                                                            )}
                                                                        </td>
                                                                    </>)}</LinhaOrdenavel>
                                                                    {renderLinhasRemessaExterior(subitem)}
                                                                    </React.Fragment>
                                                                    );
                                                                })}</ListaOrdenavel>)}

                                                                {renderTotalizadorBlocoExterior(indexSuperior)}

                                                                {/* Linha Inferior com Subtotais */}
                                                                <tr style={{ backgroundColor: '#f8f9fa', fontWeight: 'bold', borderBottom: '2px solid #dee2e6' }}>
                                                                    <td colSpan={1} style={{
                                                                        backgroundColor: '#f8f9fa',
                                                                        border: '1px solid #dee2e6',
                                                                        textAlign: 'left',
                                                                        fontWeight: 'bold',
                                                                        padding: '8px',
                                                                        width: `${larguraColunaAcoes}px`,
                                                                        minWidth: `${larguraColunaAcoes}px`,
                                                                        maxWidth: `${larguraColunaAcoes}px`,
                                                                        ...getColunaAcoesStickyStyle(9)
                                                                    }}>
                                                                        {(expandedRows === true || (Array.isArray(expandedRows) && expandedRows.includes(indexSuperior))) && (
                                                                            <button
                                                                                type="button"
                                                                                className="fin-pp__btn fin-pp__btn--sm"
                                                                                style={{ backgroundColor: '#eef2ff', color: '#4338ca', border: '1px solid #c7d2fe', borderRadius: '7px', fontWeight: 600 }}
                                                                                onClick={() => {
                                                                                    if (!item.subitem) item.subitem = [];
                                                                                    item.subitem.push(criarSubitemOrcamentoPadrao());
                                                                                    calculaTotalOrcamento();
                                                                                }}
                                                                            >
                                                                                <FaPlus size={15} /> Subitem
                                                                            </button>
                                                                        )}
                                                                    </td>
                                                                    <td colSpan={1} style={{
                                                                        backgroundColor: '#f8f9fa',
                                                                        border: '1px solid #dee2e6',
                                                                        textAlign: 'left',
                                                                        fontWeight: 'bold',
                                                                        padding: '8px',
                                                                        width: `${larguraColunaDescricao}px`,
                                                                        minWidth: `${larguraColunaDescricao}px`,
                                                                        maxWidth: `${larguraColunaDescricao}px`,
                                                                        ...getColunaDescricaoStickyStyle(7)
                                                                    }}>
                                                                    </td>
                                                                    <td style={{
                                                                        backgroundColor: '#f8f9fa',
                                                                        border: '1px solid #dee2e6',
                                                                        textAlign: 'right',
                                                                        fontWeight: 'bold',
                                                                        padding: '8px'
                                                                    }}>
                                                                        <strong>Subtotal:</strong>
                                                                    </td>
                                                                    {showPreEvento && (
                                                                        <>
                                                                            <td colSpan={showPreEvento ? 7 : 1} style={{ textAlign: 'right', backgroundColor: '#e3f2fd', border: '1px solid #dee2e6' }}>
                                                                                {showPreEvento ? renderSubtotalComTaxas(totaisBrl.grupos[indexSuperior]?.comEncargos.preEvento) : ''}
                                                                            </td>
                                                                            <td style={{ backgroundColor: '#e3f2fd', border: '1px solid #dee2e6' }}></td>
                                                                        </>
                                                                    )}
                                                                    {!showPreEvento && (
                                                                        <td style={{
                                                                            backgroundColor: '#fff',
                                                                            border: '1px solid #dee2e6',
                                                                            width: 150,
                                                                            minWidth: 150,
                                                                            maxWidth: 150
                                                                        }}></td>
                                                                    )}

                                                                    {/* Colunas Adicionais de Negociado - Subtotal */}
                                                                    {colunasNegociadoAdicionais.map((coluna) => (
                                                                        <React.Fragment key={coluna.id}>
                                                                            {colunasNegociadoVisibility[coluna.id] && (
                                                                                <>
                                                                                    <td colSpan={5} style={{
                                                                                        backgroundColor: '#fff3e0',
                                                                                        border: '1px solid #dee2e6',
                                                                                        textAlign: 'right',
                                                                                        paddingRight: '8px'
                                                                                    }}>
                                                                                        {ehVersaoCongelada(coluna)
                                                                                            ? renderValorComEquivalente(totalDaVersaoNoGrupo(coluna, item).toFixed(2))
                                                                                            : renderValorComEquivalente(calcularSubtotalItemColunaAdicional(item, coluna.id))}
                                                                                    </td>
                                                                                    <td style={{ backgroundColor: '#fff3e0', border: '1px solid #dee2e6' }}></td>
                                                                                </>
                                                                            )}
                                                                            {!colunasNegociadoVisibility[coluna.id] && (
                                                                                <td style={{
                                                                                    backgroundColor: '#fff',
                                                                                    border: '1px solid #dee2e6',
                                                                                    width: 150,
                                                                                    minWidth: 150,
                                                                                    maxWidth: 150
                                                                                }}></td>
                                                                            )}
                                                                        </React.Fragment>
                                                                    ))}

                                                                    {showNegociado && (
                                                                        <>
                                                                            <td colSpan={showNegociado ? 7 : 1} style={{ textAlign: 'right', backgroundColor: '#fff3e0', border: '1px solid #dee2e6' }}>
                                                                                {showNegociado ? renderSubtotalComTaxas(totaisBrl.grupos[indexSuperior]?.comEncargos.negociado) : ''}
                                                                            </td>
                                                                            <td style={{ backgroundColor: '#fff3e0', border: '1px solid #dee2e6' }}></td>
                                                                        </>
                                                                    )}
                                                                    {!showNegociado && (
                                                                        <td style={{
                                                                            backgroundColor: '#fff',
                                                                            border: '1px solid #dee2e6',
                                                                            width: 150,
                                                                            minWidth: 150,
                                                                            maxWidth: 150
                                                                        }}></td>
                                                                    )}

                                                                    {showFechamento && (
                                                                        <>
                                                                            <td colSpan={showFechamento ? 7 : 1} style={{ textAlign: 'right', backgroundColor: '#e8f5e8', border: '1px solid #dee2e6' }}>
                                                                                {showFechamento ? (item.fechamento_exibicao ? renderValorComEquivalente(item.fechamento_exibicao.valorTotalFechamento) : renderSubtotalComTaxas(totaisBrl.grupos[indexSuperior]?.comEncargos.fechamento)) : ''}
                                                                            </td>
                                                                            <td style={{ backgroundColor: '#e8f5e8', border: '1px solid #dee2e6' }}></td>
                                                                        </>
                                                                    )}
                                                                    {!showFechamento && (
                                                                        <td style={{
                                                                            backgroundColor: '#fff',
                                                                            border: '1px solid #dee2e6',
                                                                            width: 150,
                                                                            minWidth: 150,
                                                                            maxWidth: 150
                                                                        }}></td>
                                                                    )}
                                                                    {/* Colunas de Pagamento (Clone) - Subtotal */}
                                                                    {showPagamento && (
                                                                        <td colSpan={quantidadeColunasPagamento} style={{
                                                                            backgroundColor: '#f1f8e9',
                                                                            border: '1px solid #dee2e6',
                                                                            textAlign: 'center'
                                                                        }}></td>
                                                                    )}

                                                                    {/* Célula em branco quando Fake está escondido */}
                                                                    {!showPagamento && (
                                                                        <td style={{
                                                                            backgroundColor: '#fff',
                                                                            border: '1px solid #dee2e6',
                                                                            width: 150,
                                                                            minWidth: 150,
                                                                            maxWidth: 150
                                                                        }}></td>
                                                                    )}
                                                                    {MOSTRAR_COLUNA_FORA_ESCOPO && (
                                                                    <td style={{
                                                                        backgroundColor: '#fff3e0',
                                                                        border: '1px solid #dee2e6'
                                                                    }}></td>
                                                                    )}
                                                                    <td style={{
                                                                        backgroundColor: '#e8f0fe',
                                                                        border: '1px solid #dee2e6'
                                                                    }}></td>
                                                                </tr>
                                                            </>)}</GrupoOrdenavel>
                                                        ))}
                                                    </ListaOrdenavel>
                                                    <tbody>
                                                        {/* Linha de Total Geral */}
                                                        <tr style={{ backgroundColor: '#f8f9fa', fontWeight: 'bold', fontSize: '14px', borderTop: '2px solid #dee2e6' }}>
                                                            <td colSpan={1} style={{
                                                                backgroundColor: '#f8f9fa',
                                                                border: '1px solid #dee2e6',
                                                                width: `${larguraColunaAcoes}px`,
                                                                minWidth: `${larguraColunaAcoes}px`,
                                                                maxWidth: `${larguraColunaAcoes}px`,
                                                                ...getColunaAcoesStickyStyle(9)
                                                            }}>
                                                            </td>
                                                            <td colSpan={1} style={{
                                                                backgroundColor: '#f8f9fa',
                                                                border: '1px solid #dee2e6',
                                                                width: `${larguraColunaDescricao}px`,
                                                                minWidth: `${larguraColunaDescricao}px`,
                                                                maxWidth: `${larguraColunaDescricao}px`,
                                                                ...getColunaDescricaoStickyStyle(7)
                                                            }}>
                                                            </td>
                                                            <td style={{
                                                                backgroundColor: '#f8f9fa',
                                                                border: '1px solid #dee2e6',
                                                                textAlign: 'right',
                                                                color: '#495057',
                                                                fontWeight: 'bold'
                                                            }}>
                                                                <strong>{remessaEstimativaAtiva ? 'SUBTOTAL NA MOEDA DO ORÇAMENTO:' : 'TOTAL GERAL:'}</strong>
                                                            </td>
                                                            {showPreEvento && (
                                                                <>
                                                                    <td colSpan={showPreEvento ? 7 : 1} style={{
                                                                        textAlign: 'right',
                                                                        backgroundColor: '#e3f2fd',
                                                                        border: '1px solid #dee2e6',
                                                                        color: '#1976d2',
                                                                        fontWeight: 'bold'
                                                                    }}>
                                                                        {showPreEvento ? renderSubtotalComTaxas(totaisBrl.totalComEncargos.preEvento) : ''}
                                                                    </td>
                                                                    <td style={{ backgroundColor: '#e3f2fd', border: '1px solid #dee2e6' }}></td>
                                                                </>
                                                            )}
                                                            {!showPreEvento && (
                                                                <td style={{
                                                                    backgroundColor: '#fff',
                                                                    border: '1px solid #dee2e6',
                                                                    width: 150,
                                                                    minWidth: 150,
                                                                    maxWidth: 150
                                                                }}></td>
                                                            )}

                                                            {/* Colunas Adicionais de Negociado - Total Geral */}
                                                            {colunasNegociadoAdicionais.map((coluna) => (
                                                                <React.Fragment key={coluna.id}>
                                                                    {colunasNegociadoVisibility[coluna.id] && (
                                                                        <>
                                                                            <td colSpan={5} style={{
                                                                                backgroundColor: '#fff3e0',
                                                                                border: '1px solid #dee2e6',
                                                                                textAlign: 'right',
                                                                                color: '#f57c00',
                                                                                fontWeight: 'bold',
                                                                                paddingRight: '8px'
                                                                            }}>
                                                                                {ehVersaoCongelada(coluna)
                                                                                    ? renderValorComEquivalente(totalDaVersao(coluna, dados.orcamentoitem).toFixed(2))
                                                                                    : renderValorComEquivalente(calcularTotalGeralColunaAdicional(coluna.id))}
                                                                            </td>
                                                                            <td style={{ backgroundColor: '#fff3e0', border: '1px solid #dee2e6' }}></td>
                                                                        </>
                                                                    )}
                                                                    {!colunasNegociadoVisibility[coluna.id] && (
                                                                        <td style={{
                                                                            backgroundColor: '#fff',
                                                                            border: '1px solid #dee2e6',
                                                                            width: 150,
                                                                            minWidth: 150,
                                                                            maxWidth: 150
                                                                        }}></td>
                                                                    )}
                                                                </React.Fragment>
                                                            ))}

                                                            {showNegociado && (
                                                                <>
                                                                    <td colSpan={showNegociado ? 7 : 1} style={{
                                                                        textAlign: 'right',
                                                                        backgroundColor: '#fff3e0',
                                                                        border: '1px solid #dee2e6',
                                                                        color: '#f57c00',
                                                                        fontWeight: 'bold'
                                                                    }}>
                                                                        {showNegociado ? renderSubtotalComTaxas(totaisBrl.totalComEncargos.negociado) : ''}
                                                                    </td>
                                                                    <td style={{ backgroundColor: '#fff3e0', border: '1px solid #dee2e6' }}></td>
                                                                </>
                                                            )}
                                                            {!showNegociado && (
                                                                <td style={{
                                                                    backgroundColor: '#fff',
                                                                    border: '1px solid #dee2e6',
                                                                    width: 150,
                                                                    minWidth: 150,
                                                                    maxWidth: 150
                                                                }}></td>
                                                            )}

                                                            {showFechamento && (
                                                                <>
                                                                    <td colSpan={showFechamento ? 7 : 1} style={{
                                                                        textAlign: 'right',
                                                                        backgroundColor: '#e8f5e8',
                                                                        border: '1px solid #dee2e6',
                                                                        color: '#388e3c',
                                                                        fontWeight: 'bold'
                                                                    }}>
                                                                        {showFechamento ? (dados.fechamento_exibicao ? renderValorComEquivalente(dados.fechamento_exibicao.valorTotalFechamento) : renderSubtotalComTaxas(totaisBrl.totalComEncargos.fechamento)) : ''}
                                                                    </td>
                                                                    <td style={{ backgroundColor: '#e8f5e8', border: '1px solid #dee2e6' }}></td>
                                                                </>
                                                            )}
                                                            {!showFechamento && (
                                                                <td style={{
                                                                    backgroundColor: '#fff',
                                                                    border: '1px solid #dee2e6',
                                                                    width: 150,
                                                                    minWidth: 150,
                                                                    maxWidth: 150
                                                                }}></td>
                                                            )}
                                                            {/* Colunas de Pagamento (Clone) - Total Geral */}
                                                            {showPagamento && (
                                                                <td colSpan={quantidadeColunasPagamento} style={{
                                                                    backgroundColor: '#f1f8e9',
                                                                    border: '1px solid #dee2e6',
                                                                    textAlign: 'center'
                                                                }}></td>
                                                            )}

                                                            {/* Célula em branco quando Fake está escondido */}
                                                            {!showPagamento && (
                                                                <td style={{
                                                                    backgroundColor: '#fff',
                                                                    border: '1px solid #dee2e6',
                                                                    width: 150,
                                                                    minWidth: 150,
                                                                    maxWidth: 150
                                                                }}></td>
                                                            )}
                                                            {MOSTRAR_COLUNA_FORA_ESCOPO && (
                                                            <td style={{
                                                                backgroundColor: '#fff3e0',
                                                                border: '1px solid #dee2e6'
                                                            }}></td>
                                                            )}
                                                            <td style={{
                                                                backgroundColor: '#e8f0fe',
                                                                border: '1px solid #dee2e6'
                                                            }}></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div
                                                ref={orcamentoGridScrollControlRef}
                                                className="orcamento-scroll-control"
                                                role="group"
                                                aria-label="Controles de rolagem horizontal da planilha"
                                            >
                                                <button type="button" className="orcamento-scroll-button" onClick={() => deslocarScrollOrcamento(-1)} aria-label="Ver colunas à esquerda" title="Ver colunas à esquerda">
                                                    <FaChevronLeft aria-hidden="true" />
                                                </button>
                                                <span className="orcamento-scroll-hint" aria-hidden="true">Arraste a barra ou use ← →</span>
                                                <div
                                                    ref={orcamentoGridScrollProxyRef}
                                                    className="orcamento-scroll-proxy"
                                                    aria-label="Barra de rolagem horizontal da planilha. Use as setas esquerda e direita para navegar."
                                                    tabIndex="0"
                                                >
                                                    <div ref={orcamentoGridScrollProxyConteudoRef} style={{ height: 1 }} />
                                                </div>
                                                <button type="button" className="orcamento-scroll-button" onClick={() => deslocarScrollOrcamento(1)} aria-label="Ver colunas à direita" title="Ver colunas à direita">
                                                    <FaChevronRight aria-hidden="true" />
                                                </button>
                                            </div>
                                            <div className="d-flex flex-wrap align-items-center gap-3 px-3 py-2 mt-2" style={{ border: '1px solid #cfe8d0', borderRadius: 6, backgroundColor: '#f1f8e9', color: '#2e7d32' }}>
                                                <strong style={{ whiteSpace: 'nowrap' }}>TOTAL ACCESS:</strong>
                                                <span><small className="text-muted me-1">Pré-evento</small>{renderValorComEquivalente(totaisAccess.preEvento, 'right', totaisAccess.brl.preEvento)}</span>
                                                <span><small className="text-muted me-1">Negociado</small>{renderValorComEquivalente(totaisAccess.negociado, 'right', totaisAccess.brl.negociado)}</span>
                                                <span><small className="text-muted me-1">Fechamento</small>{renderValorComEquivalente(totaisAccess.fechamento, 'right', totaisAccess.brl.fechamento)}</span>
                                                {valorPainelAoVivo ? (
                                                    <span data-valor-painel-barra={valorPainelAoVivo.fonte} title={`Valor AO VIVO, calculado na tela com a mesma regra do painel de orçamentos (em reais); o painel mostra este valor depois de salvar. Origem: ${valorPainelAoVivo.descricaoFonte}. Última coluna preenchida: ${valorPainelAoVivo.rotuloEtapa}. Soma das linhas sem os encargos da remessa: ${formatarValorMoedaOrcamento(valorVigente.total)}.`}>
                                                        <small className="text-muted me-1">Valor total do orçamento no painel (com remessa do exterior)</small>
                                                        <div style={{ textAlign: 'right', lineHeight: 1.2 }}>
                                                            {valorPainelAoVivo.valorBrl ? 'R$' : simboloMoedaOrcamento(valorPainelAoVivo.moedaOriginal)} {moeda(valorPainelAoVivo.valor)}
                                                            {etiquetasValorPainel(valorPainelAoVivo, dados).map((etiqueta) => (
                                                                <small key={etiqueta.texto} className={`${etiqueta.alerta ? 'text-warning' : 'text-muted'} d-block`} style={{ fontSize: 10 }} title={etiqueta.title} data-valor-painel-etiqueta>{etiqueta.texto}</small>
                                                            ))}
                                                            {(obterMoedaOrcamento() !== 'real' || listarMoedasFornecedores(dados, fornecedorAccessInterno).some(fornecedorComMoedaEstrangeira)) && (
                                                                <small className="text-muted d-block" style={{ fontSize: 10 }} data-valor-painel-moedas>
                                                                    {obterMoedaOrcamento() !== 'real' && <>{formatarValorMoedaOrcamento(valorPainelNaMoedaOrcamento(valorPainelAoVivo, dados))} · câmbio {formatarCambio(obterCambioAtual())}</>}
                                                                    {listarMoedasFornecedores(dados, fornecedorAccessInterno).filter(fornecedorComMoedaEstrangeira).map((f) => (
                                                                        <span key={f.chave} className="d-block">{f.nome} ({f.rotuloLocal}): {f.porEtapa ? textoMoedasPorEtapa(f) : `${f.simbolo} · câmbio Pré ${formatarCambio(f.cambioPreEvento)} / Neg ${formatarCambio(f.cambioNegociado)}`}</span>
                                                                    ))}
                                                                </small>
                                                            )}
                                                        </div>
                                                    </span>
                                                ) : (
                                                    <span title="Valor total do orçamento: soma das linhas na última coluna preenchida (Fechamento, senão Negociado, senão Pré-evento). Pode diferir do painel antes de salvar, porque a tela recalcula na hora o FEE e o Imposto NF Access.">
                                                        <small className="text-muted me-1">Valor total do orçamento (inclui o que o cliente paga; última coluna preenchida: {valorVigente.rotulo})</small>{renderValorComEquivalente(valorVigente.total, 'right', valorVigente.totalBrl)}
                                                    </span>
                                                )}
                                            </div>
                                            {renderResumoRemessaExterior()}
                                            <FechamentoExteriorResumo orcamento={dados} fornecedorAccess={fornecedorAccessInterno} />
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </section>
                {/* 20/10: espaço no fim da página do tamanho da pilha de avisos fixa (ex.: "Alterações NÃO salvas"),
                    para a tarja verde do TOTAL ACCESS subir acima dela no fim da rolagem. O padding-bottom do
                    container não serve: o custom.css força `#main .main-content { padding: .75rem !important }`. */}
                {alturaAvisosRodape > 0 && <div aria-hidden="true" data-espaco-avisos-rodape style={{ height: alturaAvisosRodape + 8 }} />}
                {/* zIndex 102: acima das células da grade (z-index:100) — para "+ Grupo"/Salvar não
                    ficarem cobertos — e ABAIXO do menu (.access-sidebar z-index:103), para o menu
                    sempre cobrir a barra e ela nunca invadir o menu.
                    left = largura do menu para a barra começar depois do menu. */}
                {(regrasFeeIndisponiveis || errosInternacionais.length > 0 || errosObservacao.length > 0 || errosItensObrigatorios.length > 0 || errosSubItem.length > 0 || avisosSubItem.length > 0 || errosGrupoRepetido.length > 0 || avisosGrupoRepetido.length > 0 || avisoFormatoAntigo(colunasNegociadoAdicionais).length > 0 || temAvisoRascunho || !!conflitoSalvar) && (
                    // Avisos que bloqueiam o Salvar, empilhados acima da barra de botões (sem sobrepor).
                    // Parte 3 (19/10): por último (colado nos botões), o aviso do rascunho não salvo.
                    <div ref={refAvisosRodape} style={{ position: 'fixed', zIndex: 102, left: 'var(--access-sidebar-w, 230px)', right: 0, bottom: 68, display: 'flex', flexDirection: 'column' }}>
                {/* Convidados esperados (13/10): sem barra vermelha no rodapé — ela cobria a tarja do TOTAL ACCESS.
                    O aviso fica no selo vermelho do topo (com o link do evento) e no Salvar travado. */}
                {regrasFeeIndisponiveis && (
                    <div role="alert" style={{ padding: '10px 18px', background: '#fef2f2', borderTop: '1px solid #fca5a5', color: '#991b1b', boxShadow: '0 -2px 8px rgba(153,27,27,.08)' }}>
                        <div className="d-flex align-items-center justify-content-between gap-3">
                            <div>
                                <strong>Não foi possível carregar as regras de FEE do cliente.</strong> O FEE pode estar zerado nesta tela; recarregue as regras antes de salvar.
                            </div>
                            <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => { carregarFeeRulesCliente(); carregarFaixasVersao(); }}>Recarregar regras de FEE</button>
                        </div>
                    </div>
                )}
                {errosInternacionais.length > 0 && (
                    <AlertaDadosInternacionais erros={errosInternacionais} colunasVisiveis={colunasEtapaVisiveis}
                        onMostrarCampo={mostrarCampoInternacional} onInformarCambio={() => setShowModalCambio(true)} />
                )}
                {errosObservacao.length > 0 && (
                    <AlertaDadosInternacionais erros={errosObservacao} colunasVisiveis={colunasEtapaVisiveis}
                        titulo="Preencha a observação para salvar:" onMostrarCampo={mostrarCampoInternacional} />
                )}
                {avisoFormatoAntigo(colunasNegociadoAdicionais).length > 0 && (
                    <AlertaDadosInternacionais erros={avisoFormatoAntigo(colunasNegociadoAdicionais)} colunasVisiveis={colunasEtapaVisiveis}
                        titulo="Negociado com coluna do jeito antigo:" onMostrarCampo={mostrarCampoInternacional}
                        onAcao={converterNegociadoFormatoAntigo} />
                )}
                {errosItensObrigatorios.length > 0 && (
                    <AlertaDadosInternacionais erros={errosItensObrigatorios} colunasVisiveis={colunasEtapaVisiveis}
                        titulo="Inclua a linha obrigatória para salvar:" onMostrarCampo={mostrarCampoInternacional}
                        onAcao={(erro) => incluirItensObrigatorios(erro.acao.grupoIndex)} />
                )}
                {errosSubItem.length > 0 && (
                    <AlertaDadosInternacionais erros={errosSubItem} colunasVisiveis={colunasEtapaVisiveis}
                        titulo="Corrija para salvar:" onMostrarCampo={mostrarCampoInternacional} />
                )}
                {avisosSubItem.length > 0 && (
                    <AlertaDadosInternacionais erros={avisosSubItem} colunasVisiveis={colunasEtapaVisiveis}
                        titulo="Fora do FEE (não trava o Salvar):" onMostrarCampo={mostrarCampoInternacional} />
                )}
                {errosGrupoRepetido.length > 0 && (
                    <AlertaDadosInternacionais erros={errosGrupoRepetido} colunasVisiveis={colunasEtapaVisiveis}
                        titulo="Grupo repetido, corrija para salvar:" onMostrarCampo={mostrarCampoInternacional} />
                )}
                {avisosGrupoRepetido.length > 0 && (
                    <AlertaDadosInternacionais erros={avisosGrupoRepetido} colunasVisiveis={colunasEtapaVisiveis}
                        titulo="Grupo repetido (não trava o Salvar):" onMostrarCampo={mostrarCampoInternacional} />
                )}
                {/* D-0052 parte 4b: Salvar recusado porque outra pessoa salvou antes — no lugar do aviso do rascunho */}
                {conflitoSalvar ? (
                    <AvisoConflitoSalvarOrcamento conflito={conflitoSalvar} onRecarregar={rascunhoOrcamento.recarregarTela} />
                ) : (
                    <AvisoRascunhoOrcamento
                        sujo={rascunhoOrcamento.sujo}
                        guardadoEm={rascunhoOrcamento.guardadoEm}
                        erro={rascunhoOrcamento.erroServidor}
                        salvando={saving}
                        podeSalvar={!saving && errosInternacionais.length === 0 && errosObservacao.length === 0 && errosItensObrigatorios.length === 0 && errosSubItem.length === 0 && errosGrupoRepetido.length === 0 && !regrasFeeIndisponiveis}
                        onSalvar={salvar}
                    />
                )}
                    </div>
                )}
                <div className="row fixoRodape" style={{ zIndex: 102, left: 'var(--access-sidebar-w, 230px)' }}>
                    <div className="col-12 d-flex justify-content-between">
                        <button
                            type="button"
                            className="btn me-1 mb-1"
                            onClick={() => {
                                dados.orcamentoitem.push({
                                    chavegrupo: rand18(),
                                    quantidade: "1",
                                    subitem: []
                                });
                                calculaTotalOrcamento();
                            }}
                            style={{ marginLeft: '12px', backgroundColor: '#3d7eff', borderColor: '#3d7eff', color: '#fff', borderRadius: '8px', fontWeight: 600, padding: '8px 18px', boxShadow: '0 2px 6px rgba(61,126,255,.25)' }}
                        >
                            <FaPlus size={20} /> Descrição de Custos
                        </button>
                        <div className="d-flex">
                            {/* Botão de Baixar Excel só aparece quando está editando um orçamento existente */}
                            {/* TODO — PENDÊNCIA: Botão "Gerar ND do Evento" movido para o módulo Contas a Receber (a implementar).
                                Quando Contas a Receber for criado, reativar este botão lá.
                                Código original preservado abaixo para referência:
                            {id && !copiar && (
                                <button
                                    type="button"
                                    className="btn btn-outline-primary me-1 mb-1"
                                    onClick={gerarNdEvento}
                                    disabled={saving || gerandoNdEvento}
                                >
                                    {gerandoNdEvento ? (
                                        <><FaCircleNotch size={14} style={{ marginRight: 8 }} /> Aguarde...</>
                                    ) : (
                                        <><FaFileAlt size={18} /> Gerar ND do Evento</>
                                    )}
                                </button>
                            )}
                            */}
                            {id && !copiar && (
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary me-2 mb-1"
                                    style={{ borderRadius: '8px', fontWeight: 600, padding: '8px 16px' }}
                                    onClick={salvarEBaixarExcel}
                                    disabled={saving || errosInternacionais.length > 0 || errosObservacao.length > 0 || errosItensObrigatorios.length > 0 || errosSubItem.length > 0 || errosGrupoRepetido.length > 0 || regrasFeeIndisponiveis || !!conflitoSalvar}
                                >
                                    {saving ? (
                                        <>
                                            <FaCircleNotch size={14} style={{ marginRight: 8 }} /> Aguarde...
                                        </>
                                    ) : (
                                        <>
                                            <FaTable size={20} /> Baixar Excel
                                        </>
                                    )}
                                </button>
                            )}
                            {id && !copiar && propostaAbbvieInter && (
                                <button
                                    type="button"
                                    className="fin-pp fin-pp__btn me-2 mb-1"
                                    style={{ fontWeight: 600 }}
                                    onClick={salvarEBaixarPropostaPdf}
                                    disabled={saving || errosInternacionais.length > 0 || errosObservacao.length > 0 || errosItensObrigatorios.length > 0 || errosSubItem.length > 0 || errosGrupoRepetido.length > 0 || regrasFeeIndisponiveis || !!conflitoSalvar}
                                    title="Salva o orçamento e baixa a aba de proposta do Excel em PDF"
                                >
                                    {saving ? (
                                        <>
                                            <FaCircleNotch size={14} /> Aguarde...
                                        </>
                                    ) : (
                                        <>
                                            <FaFilePdf size={18} /> Baixar PDF da proposta
                                        </>
                                    )}
                                </button>
                            )}
                            <button type="button" className="btn me-1 mb-1" style={{ backgroundColor: '#2563eb', borderColor: '#2563eb', color: '#fff', borderRadius: '8px', fontWeight: 600, padding: '8px 22px', boxShadow: '0 2px 6px rgba(37,99,235,.25)' }} onClick={salvar} disabled={saving || errosInternacionais.length > 0 || errosObservacao.length > 0 || errosItensObrigatorios.length > 0 || errosSubItem.length > 0 || errosGrupoRepetido.length > 0 || regrasFeeIndisponiveis || !!conflitoSalvar}
                                >
                                {saving ? (
                                    <>
                                        <FaCircleNotch size={14} style={{ marginRight: 8 }} /> Aguarde...
                                    </>
                                ) : (
                                    <>
                                        <FaSave size={20} /> Salvar
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {showModalModelosOrcamento && (
            <div className="modal fade show d-block fin-pp fin-pp__modalbg" onClick={(e) => { if (e.target === e.currentTarget) { setShowModalModelosOrcamento(false) } }}>
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content fin-pp__modal">
                <div className="fin-pp__modal-head">
                    <h3 className="fin-pp__modal-title">
                        {tipoModalModelosOrcamento === 'outros' ? (
                            <>
                                <FaGlobeAmericas size={20} style={{ marginRight: '8px', color: '#2d7dd2' }} />
                                Modelos de Outros Usuários
                            </>
                        ) : (
                            <>
                                <FaFolder size={20} style={{ marginRight: '8px', color: '#49618e' }} />
                                Meus Modelos
                            </>
                        )}
                    </h3>
                    <button type="button" className="fin-pp__modal-close" onClick={() => setShowModalModelosOrcamento(false)}><FaTimes size={16} /></button>
                </div>
                <div className="modal-body">
                    <div style={{ maxHeight: '60vh', overflowY: 'auto', paddingRight: '4px' }}>
                        <div className="row g-2 mb-3">
                            <div className="col-sm-9">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Buscar modelo por nome"
                                    value={buscaModelosOrcamento}
                                    onChange={(e) => setBuscaModelosOrcamento(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            carregarModelosOrcamento(tipoModalModelosOrcamento, buscaModelosOrcamento);
                                        }
                                    }}
                                />
                            </div>
                            <div className="col-sm-3 d-grid">
                                <button
                                    type="button"
                                    className="fin-pp__btn"
                                    onClick={() => carregarModelosOrcamento(tipoModalModelosOrcamento, buscaModelosOrcamento)}
                                >
                                    <FaSearch size={14} style={{ marginRight: '6px' }} />
                                    Buscar
                                </button>
                            </div>
                        </div>

                        {carregandoModelosOrcamento && (
                            <div className="text-center py-4 text-muted">
                                <FaCircleNotch size={14} style={{ marginRight: 8 }} />
                                Carregando modelos...
                            </div>
                        )}

                        {!carregandoModelosOrcamento && listaModelosOrcamento.length === 0 && (
                            <div className="text-center py-4 text-muted">
                                Nenhum modelo encontrado.
                            </div>
                        )}

                        {!carregandoModelosOrcamento && listaModelosOrcamento.length > 0 && (
                            <div style={{ maxHeight: '34vh', overflowY: 'auto', paddingRight: '4px' }}>
                                {listaModelosOrcamento.map((modelo) => {
                                    const isSelecionado = modeloSelecionadoOrcamento?.id === modelo.id;
                                    return (
                                        <button
                                            key={modelo.id}
                                            type="button"
                                            className="w-100 text-start mb-2"
                                            onClick={() => selecionarModeloOrcamento(modelo.id)}
                                            style={{
                                                border: `2px solid ${isSelecionado ? '#2f5fb8' : '#c7d7f6'}`,
                                                borderRadius: '12px',
                                                backgroundColor: isSelecionado ? '#e8f0ff' : '#ffffff',
                                                padding: '12px 16px',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            <div style={{ fontSize: '1.05rem', fontWeight: 700, color: '#162f57' }}>
                                                {modelo.nome}
                                            </div>
                                            {modelo.descricao && (
                                                <div style={{ color: '#5f6778', marginTop: '4px', fontSize: '0.95rem' }}>
                                                    {modelo.descricao}
                                                </div>
                                            )}
                                            {tipoModalModelosOrcamento === 'outros' && (
                                                <div style={{ color: '#2b56aa', marginTop: '6px', fontSize: '0.95rem' }}>
                                                    por {modelo.operadorNome || 'Usuário'}
                                                </div>
                                            )}
                                        </button>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </div>
                <div className="fin-pp__modal-foot">
                    <button
                        type="button"
                        className="fin-pp__btn"
                        onClick={() => setShowModalModelosOrcamento(false)}
                    >
                        Fechar
                    </button>
                </div>
                    </div>
                </div>
            </div>
        )}

            {/* Modal de Produtos */}
            {modalFornecedorLinha && (() => {
                const { indexSuperior, indexInferior } = modalFornecedorLinha;
                const item = dados.orcamentoitem?.[indexSuperior];
                const subitem = item?.subitem?.[indexInferior];
                if (!subitem) return null;
                const fechar = () => setModalFornecedorLinha(null);
                const nomeItem = subitem.produto ? AgenciaOrcamentoPolicy.nomeSubitemExibicao(item, subitem.produto) : '';
                return (
                    <ModalBuscaFornecedor
                        token={token}
                        fornecedorAtual={subitem.fornecedor}
                        subtitulo={(nomeItem ? nomeItem + ' · ' : '') + 'Atual: ' + rotuloFornecedor(subitem.fornecedor)}
                        motivoIndisponivel={(fornecedor) => (fornecedorIncompativelComPagamentoExterior(fornecedor, subitem.pagamento_exterior, fornecedorAccessInterno)
                            ? 'Linha com pagamento no exterior: o fornecedor interno da Access não pode ser usado.'
                            : null)}
                        onSelecionar={(fornecedor) => { if (aplicarFornecedorNaLinha(indexSuperior, indexInferior, fornecedor)) fechar(); }}
                        onRemover={() => { aplicarFornecedorNaLinha(indexSuperior, indexInferior, null); fechar(); }}
                        onFechar={fechar}
                    />
                );
            })()}
            {showModalProdutos && (
            <div className="modal fade show d-block fin-pp fin-pp__modalbg" onClick={(e) => { if (e.target === e.currentTarget) { setShowModalProdutos(false) } }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content fin-pp__modal">
                <div className="fin-pp__modal-head">
                    <h3 className="fin-pp__modal-title">Gerenciar Produtos</h3>
                    <button type="button" className="fin-pp__modal-close" onClick={() => setShowModalProdutos(false)}><FaTimes size={16} /></button>
                </div>
                <div className="modal-body">
                    <div>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr>
                                    <th width="50px">Ações</th>
                                    <th>Produto</th>
                                    <th width="200px">Percentual (%)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {dados.orcamentoproduto ? dados.orcamentoproduto.map((row, rowIndex) => {
                                    return (
                                        <tr key={rowIndex}>
                                            <td>
                                                <button type="button" className="fin-pp__btn fin-pp__btn--danger-ghost fin-pp__btn--sm" title="Remover" onClick={() => { dados.orcamentoproduto.splice(rowIndex, 1); setDados({ ...dados }); }}><FaTrash size={20} /></button>
                                            </td>
                                            <td>
                                                <ReactSelect compact
                                                    key={dados.evento ?? null}
                                                    placeholder={"Produto"}
                                                    value={row.produto !== null ? { value: row.produto?.id ?? null, label: row.produto?.nome ?? null } : null}
                                                    onChange={(e) => {
                                                        dados.orcamentoproduto[rowIndex].produto = {};
                                                        dados.orcamentoproduto[rowIndex].produto.id = e.value;
                                                        dados.orcamentoproduto[rowIndex].produto.nome = e.label;
                                                        setDados({ ...dados });
                                                    }}
                                                    defaultOptions
                                                    loadOptions={(input) => {
                                                        const clienteId = dados.cliente?.id ?? null;
                                                        if (!clienteId) {
                                                            return Promise.resolve([]);
                                                        }
                                                        return api({
                                                            method: 'get',
                                                            action: '/produto',
                                                            token: token,
                                                            params: {
                                                                nome: input,
                                                                cliente: clienteId,
                                                                modulo: 'orcamento'
                                                            }
                                                        })
                                                            .then(response => {
                                                                let options = response.data.data.map(registro => ({ value: registro.id, label: registro.nome }));
                                                                return options;
                                                            })
                                                            .catch(function (error) {
                                                                //console.log(error);
                                                            });
                                                    }}
                                                />
                                            </td>
                                            <td>
                                                <div className="form-floating form-group">
                                                    <CampoPercentual
                                                        className="form-control form-control-lg right"
                                                        id={`percentual_${rowIndex}`}
                                                        placeholder="%"
                                                        decimalScale={4}
                                                        fixedDecimalScale={false}
                                                        value={pontoVirgula(dados.orcamentoproduto[rowIndex].percentual)}
                                                        onValueChange={(values) => {
                                                            // mesmo formato de antes (texto com vírgula); a API aplica virgulaPonto
                                                            dados.orcamentoproduto[rowIndex].percentual = pontoVirgula(values.value);
                                                            setDados({ ...dados });
                                                        }}
                                                    />
                                                    <label htmlFor={`percentual_${rowIndex}`}>Percentual (%)</label>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                }) : (
                                    <tr>
                                        <td colSpan="3" className="text-center text-muted">
                                            Nenhum produto adicionado
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="fin-pp__modal-foot">
                    <button
                        type="button"
                        className="fin-pp__btn fin-pp__btn--primary"
                        onClick={() => {
                            if (dados.orcamentoproduto === undefined || dados.orcamentoproduto === null) dados.orcamentoproduto = [];
                            dados.orcamentoproduto.push({
                                produto: {
                                    id: null,
                                    nome: null
                                },
                            });
                            setDados({ ...dados });
                        }}
                    >
                        <FaPlus size={16} /> Adicionar Produto
                    </button>
                    <button
                        type="button"
                        className="fin-pp__btn"
                        onClick={() => setShowModalProdutos(false)}
                    >
                        Fechar
                    </button>
                </div>
                    </div>
                </div>
            </div>
        )}

            {/* Modal de Câmbio */}
            {renderModalInternacional()}
            {modalFechamentoExterior && <FechamentoExteriorModal
                linha={dados.orcamentoitem[modalFechamentoExterior.grupoIndex].subitem[modalFechamentoExterior.linhaIndex]}
                /* Invoice nova nasce na moeda do FORNECEDOR no Fechamento (27/09; 08/10 moeda por etapa), não na do orçamento; ledger com invoice mantém a dele. */
                contexto={{ ...dados, moeda: moedaLinhaGrade(dados.orcamentoitem[modalFechamentoExterior.grupoIndex].subitem[modalFechamentoExterior.linhaIndex], 'Fechamento') }}
                onClose={() => setModalFechamentoExterior(null)}
                // Aberto pelo modal Internacional (Rafael 19/10): Voltar e Aplicar retornam a ele.
                onVoltar={modalFechamentoExterior.deInternacional ? () => {
                    setModalInternacional({ grupoIndex: modalFechamentoExterior.grupoIndex, linhaIndex: modalFechamentoExterior.linhaIndex });
                    setModalFechamentoExterior(null);
                } : undefined}
                onSave={(config) => {
                    calculaTotalOrcamento2(alterarFechamentoExteriorLinha(dados, modalFechamentoExterior.grupoIndex, modalFechamentoExterior.linhaIndex, config));
                    if (modalFechamentoExterior.deInternacional) setModalInternacional({ grupoIndex: modalFechamentoExterior.grupoIndex, linhaIndex: modalFechamentoExterior.linhaIndex });
                    setModalFechamentoExterior(null);
                }} />}
            {showModalCambio && (
            <div className="modal fade show d-block fin-pp fin-pp__modalbg" onClick={(e) => { if (e.target === e.currentTarget) { cancelarModalCambio() } }}>
                <div className="modal-dialog modal-md">
                    {/* 15/10: lista de fornecedores com moeda própria pode passar da tela — só o corpo rola, Salvar Câmbio sempre visível. */}
                    <div className="modal-content fin-pp__modal fin-pp__modal--scroll">
                <div className="fin-pp__modal-head">
                    <h3 className="fin-pp__modal-title">Câmbio do Orçamento</h3>
                    <button type="button" className="fin-pp__modal-close" onClick={cancelarModalCambio}><FaTimes size={16} /></button>
                </div>
                <div className="modal-body">
                    <div className="form-group mb-3">
                        <label className="text-muted">Moeda do Orçamento</label>
                        <select
                            className="form-control"
                            value={obterMoedaOrcamento()}
                            onChange={(e) => buscarCambioSugerido((e.target.value || 'real').toLowerCase())}
                        >
                            <option value="real">Real (BRL)</option>
                            <option value="dolar">Dólar (USD)</option>
                            <option value="euro">Euro (EUR)</option>
                            <option value="iene">Iene (JPY)</option>
                            <option value="libra">Libra (GBP)</option>
                            <option value="dolarcad">Dólar Canadense (CAD)</option>
                        </select>
                    </div>

                    {obterMoedaOrcamento() !== 'real' && (
                        <div className="form-group mb-3">
                            <label className="text-muted">
                                Cotação em reais (1 {obterSimboloMoedaOrcamento()})
                            </label>
                            <CampoValor
                                className="form-control"
                                value={dados.cambio || ''}
                                onValueChange={(values) => {
                                    setDados((dadosAnteriores) => ({
                                        ...dadosAnteriores,
                                        cambio: values.value
                                    }));
                                }}
                                disabled={carregandoCambioSugerido}
                                milhar={false}
                                moeda="real"
                                decimalScale={6}
                                fixedDecimalScale={false}
                                allowNegative={false}
                                placeholder="Ex.: 5,73"
                            />
                            {carregandoCambioSugerido && (
                                <small className="text-muted d-block mt-1">Buscando cotação sugerida...</small>
                            )}
                            {!carregandoCambioSugerido && infoCambioSugerido?.fonte && (
                                <small className="text-muted d-block mt-1">
                                    Cotação sugerida via {infoCambioSugerido.fonte}
                                    {infoCambioSugerido.dataCotacao ? ` (${moment(infoCambioSugerido.dataCotacao).format('DD/MM/YYYY')})` : ''}
                                </small>
                            )}
                        </div>
                    )}

                    <div style={{
                        backgroundColor: '#f8f9fa',
                        border: '1px solid #e9ecef',
                        borderRadius: '8px',
                        padding: '10px 12px',
                        fontSize: '13px',
                        color: '#495057'
                    }}>
                        <div><strong>Moeda atual:</strong> {obterLabelMoedaOrcamento()}</div>
                        <div>
                            <strong>Cotação atual:</strong>{' '}
                            {carregandoCambioSugerido
                                ? 'Atualizando...'
                                : `R$ ${formatarCambio(obterCambioAtual())}`
                            }
                        </div>
                    </div>
                    {listarMoedasFornecedores(dados, fornecedorAccessInterno).length > 0 && (
                        <div className="mt-3" data-cambio-fornecedores style={{ fontSize: '12px', color: '#495057' }}>
                            <strong className="d-block mb-1">Fornecedores com moeda própria (cada etapa com o câmbio da linha)</strong>
                            {listarMoedasFornecedores(dados, fornecedorAccessInterno).map((f) => (
                                <div key={f.chave}>
                                    {f.nome} ({f.rotuloLocal}): {f.porEtapa ? textoMoedasPorEtapa(f) : `${f.simbolo}${f.moeda !== 'real' ? ` · Pré-evento R$ ${formatarCambio(f.cambioPreEvento)} · Negociado R$ ${formatarCambio(f.cambioNegociado)}` : ''}`}
                                </div>
                            ))}
                            <small className="text-muted d-block mt-1">A moeda e o câmbio de cada etapa são editados na própria linha (botão Editar do Internacional); o Fechamento usa o câmbio da linha ou o da transação registrada. Este câmbio vale para as linhas sem moeda própria e para o Excel enquanto o câmbio de Fechamento não for informado.</small>
                        </div>
                    )}
                </div>
                <div className="fin-pp__modal-foot">
                    <button
                        type="button"
                        className="fin-pp__btn"
                        onClick={cancelarModalCambio}
                    >
                        Cancelar
                    </button>
                    <button
                        type="button"
                        className="fin-pp__btn fin-pp__btn--primary"
                        onClick={salvarCambio}
                        disabled={carregandoCambioSugerido}
                    >
                        Salvar Câmbio
                    </button>
                </div>
                    </div>
                </div>
            </div>
        )}

            {/* Modal de Informações do Orçamento */}
            {showModalFeeVersao && (
            <div className="modal fade show d-block fin-pp fin-pp__modalbg" onClick={(e) => { if (e.target === e.currentTarget) { setShowModalFeeVersao(false) } }}>
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div className="modal-content fin-pp__modal">
                        <div className="fin-pp__modal-head">
                            <span className="fin-pp__modal-head-ic"><FaPercent size={17} /></span>
                            <h3 className="fin-pp__modal-title">Versão do Fee
                                <span className="fin-pp__modal-sub">Selecione a tabela de fee aplicada a este orçamento</span>
                            </h3>
                            <button type="button" className="fin-pp__modal-close" onClick={() => setShowModalFeeVersao(false)}><FaTimes size={16} /></button>
                        </div>
                        <div className="modal-body">
                            {versoesTabela().length === 0 ? (
                                <p style={{ color: 'var(--fin-mt)' }}>Nenhuma versão configurada para este cliente.</p>
                            ) : (
                                <div style={{ display: 'flex', minHeight: 300 }}>
                                    {/* Esquerda: menu de versões (anos) */}
                                    <div style={{ width: 150, borderRight: '1px solid #e2e8f0', flexShrink: 0 }}>
                                        {versoesTabela().map((v) => (
                                            <div key={v} onClick={() => setFeeVersaoSel(v)}
                                                style={{
                                                    cursor: 'pointer', padding: '10px 14px',
                                                    borderLeft: '3px solid ' + (String(feeVersaoSel) === String(v) ? 'var(--fin-ac)' : 'transparent'),
                                                    background: String(feeVersaoSel) === String(v) ? 'var(--fin-acw)' : 'transparent',
                                                    fontWeight: String(feeVersaoSel) === String(v) ? 700 : 500,
                                                    color: 'var(--fin-tx)'
                                                }}>
                                                Tabela {v}
                                            </div>
                                        ))}
                                    </div>
                                    {/* Direita: detalhe da versão em foco (fee + serviços por categoria) */}
                                    <div style={{ flex: 1, paddingLeft: 18, paddingRight: 16, maxHeight: 380, overflowY: 'auto' }}>
                                        {!feeVersaoSel && <p style={{ color: 'var(--fin-mt)' }}>Selecione uma versão à esquerda.</p>}
                                        {feeVersaoSel && categoriasDaVersao(feeVersaoSel).map((cat) => (
                                            <div key={cat} style={{ marginBottom: 14 }}>
                                                <div style={{ fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: 0.5, color: 'var(--fin-mt)', fontWeight: 700, marginBottom: 6 }}>{cat}</div>
                                                {itensDaVersaoCategoria(feeVersaoSel, cat).map((it, i) => (
                                                    <div key={i} style={{ display: 'flex', justifyContent: 'space-between', gap: 12, padding: '3px 0', fontSize: '0.86rem' }}>
                                                        <span style={{ color: 'var(--fin-tx)' }}>{it.nome}</span>
                                                        <strong style={{ color: 'var(--fin-tx)', whiteSpace: 'nowrap' }}>{formatarValorItem(it)}</strong>
                                                    </div>
                                                ))}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="fin-pp__modal-foot">
                            <button type="button" className="fin-pp__btn" onClick={() => setShowModalFeeVersao(false)}>Cancelar</button>
                            <button type="button" className="fin-pp__btn fin-pp__btn--primary" disabled={!feeVersaoSel}
                                onClick={() => { setDados({ ...dados, fee_versao: feeVersaoSel }); setShowModalFeeVersao(false); }}>
                                Confirmar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            )}

            {/* Épico 13 (Abbvie) — Seletor de período da tabela de valores (faixas por pax) */}
            {showModalTabelaVersao && (
            <div className="modal fade show d-block fin-pp fin-pp__modalbg" onClick={(e) => { if (e.target === e.currentTarget) { setShowModalTabelaVersao(false) } }}>
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div className="modal-content fin-pp__modal">
                        <div className="fin-pp__modal-head">
                            <span className="fin-pp__modal-head-ic"><FaTable size={17} /></span>
                            <h3 className="fin-pp__modal-title">Tabela de valores
                                <span className="fin-pp__modal-sub">Período aplicado a este orçamento (novo = atual; retroativo = ano anterior)</span>
                            </h3>
                            <button type="button" className="fin-pp__modal-close" onClick={() => setShowModalTabelaVersao(false)}><FaTimes size={16} /></button>
                        </div>
                        <div className="modal-body">
                            {obterVersoesTabela().length === 0 ? (
                                <p style={{ color: 'var(--fin-mt)' }}>Nenhuma tabela versionada para este cliente.</p>
                            ) : (
                                <div style={{ display: 'flex', minHeight: 300 }}>
                                    {/* Esquerda: menu de períodos (anos) */}
                                    <div style={{ width: 150, borderRight: '1px solid #e2e8f0', flexShrink: 0 }}>
                                        {obterVersoesTabela().map((v) => (
                                            <div key={v} onClick={() => setTabelaVersaoSel(v)}
                                                style={{
                                                    cursor: 'pointer', padding: '10px 14px',
                                                    borderLeft: '3px solid ' + (String(tabelaVersaoSel) === String(v) ? 'var(--fin-ac)' : 'transparent'),
                                                    background: String(tabelaVersaoSel) === String(v) ? 'var(--fin-acw)' : 'transparent',
                                                    fontWeight: String(tabelaVersaoSel) === String(v) ? 700 : 500,
                                                    color: 'var(--fin-tx)'
                                                }}>
                                                Tabela {v}
                                            </div>
                                        ))}
                                    </div>
                                    {/* Direita: detalhe do período (fees + serviços por categoria) */}
                                    <div style={{ flex: 1, paddingLeft: 18, paddingRight: 16, maxHeight: 380, overflowY: 'auto' }}>
                                        {!tabelaVersaoSel && <p style={{ color: 'var(--fin-mt)' }}>Selecione um período à esquerda.</p>}
                                        {tabelaVersaoSel && categoriasDaVersaoFaixa(tabelaVersaoSel).map((cat) => (
                                            <div key={cat} style={{ marginBottom: 14 }}>
                                                <div style={{ fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: 0.5, color: 'var(--fin-mt)', fontWeight: 700, marginBottom: 6 }}>{cat}</div>
                                                {itensDaVersaoFaixaCategoria(tabelaVersaoSel, cat).map((it, i) => (
                                                    <div key={i} style={{ display: 'flex', justifyContent: 'space-between', gap: 12, padding: '3px 0', fontSize: '0.86rem' }}>
                                                        <span style={{ color: 'var(--fin-tx)' }}>{it.nome}</span>
                                                        <strong style={{ color: 'var(--fin-tx)', whiteSpace: 'nowrap' }}>{formatarValorFaixa(it)}</strong>
                                                    </div>
                                                ))}
                                            </div>
                                        ))}
                                        {tabelaVersaoSel && itensMiniMeetingModal().length > 0 && (
                                            <div style={{ marginBottom: 14 }}>
                                                <div style={{ fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: 0.5, color: 'var(--fin-mt)', fontWeight: 700, marginBottom: 6 }}>Mini Meeting</div>
                                                {itensMiniMeetingModal().map((it, i) => (
                                                    <div key={i} style={{ display: 'flex', justifyContent: 'space-between', gap: 12, padding: '3px 0', fontSize: '0.86rem' }}>
                                                        <span style={{ color: 'var(--fin-tx)' }}>{it.nome}</span>
                                                        <strong style={{ color: 'var(--fin-tx)', whiteSpace: 'nowrap' }}>{it.valor}</strong>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="fin-pp__modal-foot">
                            <button type="button" className="fin-pp__btn" onClick={() => setShowModalTabelaVersao(false)}>Cancelar</button>
                            <button type="button" className="fin-pp__btn fin-pp__btn--primary" disabled={!tabelaVersaoSel}
                                onClick={() => { setDados({ ...dados, tabela_versao: tabelaVersaoSel }); setShowModalTabelaVersao(false); }}>
                                Confirmar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            )}

            {showModalInformacoes && (
            <div className="modal fade show d-block fin-pp fin-pp__modalbg" onClick={(e) => { if (e.target === e.currentTarget) { setShowModalInformacoes(false) } }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content fin-pp__modal">
                <div className="fin-pp__modal-head">
                    <h3 className="fin-pp__modal-title">Informações do Orçamento</h3>
                    <button type="button" className="fin-pp__modal-close" onClick={() => setShowModalInformacoes(false)}><FaTimes size={16} /></button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-sm-8">
                            <div className="form-floating form-group mb-3">
                                <input
                                    type="text"
                                    className="form-control form-control-lg"
                                    id="titulo"
                                    placeholder="Título"
                                    value={dados.titulo}
                                    onChange={e => setDados({ ...dados, ...{ "titulo": e.target.value } })}
                                />
                                <label htmlFor="floatingInput">Título</label>
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <Data
                                label="Data"
                                value={dados.data}
                                onChange={date => setDados({ ...dados, ...{ "data": date } })}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-4">
                            <div className="form-group mb-3">
                                <label className="text-muted">Valor de Adiantamento:</label>
                                <div style={{
                                    fontSize: '1.2rem',
                                    fontWeight: '500',
                                    padding: '8px 0',
                                    color: '#495057'
                                }}>
                                    R$ {pontoVirgula(dados.valorAdiantamento || 0)}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="form-group mb-3">
                                <label className="text-muted">Total Antecipado:</label>
                                <div style={{
                                    fontSize: '1.2rem',
                                    fontWeight: '500',
                                    padding: '8px 0',
                                    color: '#495057'
                                }}>
                                    R$ {pontoVirgula(calculaTotalAntecipado(dados.orcamentoitem))}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="form-group mb-3">
                                <label className="text-muted">Saldo Disponível:</label>
                                <div style={{
                                    fontSize: '1.2rem',
                                    fontWeight: '500',
                                    padding: '8px 0',
                                    color: calculaSaldoAdiantamento(dados.valorAdiantamento, dados.orcamentoitem) < 0 ? '#d32f2f' : '#495057'
                                }}>
                                    R$ {pontoVirgula(calculaSaldoAdiantamento(dados.valorAdiantamento, dados.orcamentoitem))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label className="text-muted">Observações sobre Adiantamento:</label>
                                <textarea
                                    className="form-control"
                                    rows="4"
                                    placeholder="Descreva observações sobre o adiantamento"
                                    value={dados.observacaoAdiantamento || ''}
                                    onChange={(e) => setDados({ ...dados, observacaoAdiantamento: e.target.value })}
                                />
                                {dados.arquivoReciboAdiantamento && (
                                    <small className="text-muted">
                                        <button
                                            type="button"
                                            className="fin-pp__btn fin-pp__btn--sm"
                                            onClick={() => {
                                                window.open(process.env.REACT_APP_API_URL + `/arquivo/download/${dados.arquivoReciboAdiantamento}`, '_blank');
                                            }}
                                            style={{ fontSize: '12px', verticalAlign: 'baseline' }}
                                        >
                                            <FaDownload size={12} /> Baixar Recibo
                                        </button>
                                    </small>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="fin-pp__modal-foot">
                    <button
                        type="button"
                        className="fin-pp__btn"
                        onClick={() => setShowModalInformacoes(false)}
                    >
                        Fechar
                    </button>
                </div>
                    </div>
                </div>
            </div>
        )}

            {/* Modal de Fora do Escopo */}
            {showModalForaEscopo && (
            <div className="modal fade show d-block fin-pp fin-pp__modalbg" onClick={(e) => { if (e.target === e.currentTarget) { setShowModalForaEscopo(false) } }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content fin-pp__modal">
                <div className="fin-pp__modal-head" style={{ background: '#ff6b35', color: 'white' }}>
                    <h3 className="fin-pp__modal-title" style={{ color: 'white' }}>
                        <FaCircle style={{ fontSize: '12px' }} />
                        Justificativa - Fora do Escopo
                    </h3>
                    <button type="button" className="fin-pp__modal-close" onClick={() => setShowModalForaEscopo(false)}><FaTimes size={16} /></button>
                </div>
                <div className="modal-body" style={{ padding: '24px', backgroundColor: '#ffffff' }}>
                    <div className="mb-4">
                        <p style={{
                            fontSize: '15px',
                            color: '#666',
                            marginBottom: '0'
                        }}>
                            <strong style={{ color: '#333' }}>Item: </strong>
                            <span style={{ color: '#333', fontWeight: '600' }}>
                                {itemForaEscopo.indexSuperior !== null && itemForaEscopo.indexInferior !== null &&
                                    dados.orcamentoitem[itemForaEscopo.indexSuperior]?.subitem[itemForaEscopo.indexInferior]?.produto?.nome
                                }
                            </span>
                        </p>
                    </div>

                    <div className="mb-4">
                        <label className="form-label" style={{
                            fontSize: '15px',
                            fontWeight: '600',
                            color: '#333',
                            marginBottom: '12px',
                            display: 'block'
                        }}>Motivo:</label>

                        <div style={{
                            border: '1px solid #e0e0e0',
                            borderRadius: '8px',
                            padding: '12px 16px',
                            marginBottom: '12px',
                            cursor: 'pointer',
                            backgroundColor: dadosForaEscopo.motivo === "Solicitação nova do cliente" ? '#fff3e0' : '#fff',
                            transition: 'all 0.2s'
                        }}
                            onClick={() => setDadosForaEscopo({ ...dadosForaEscopo, motivo: "Solicitação nova do cliente" })}
                        >
                            <div className="form-check" style={{ margin: 0 }}>
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="motivo"
                                    id="motivo1"
                                    value="Solicitação nova do cliente"
                                    checked={dadosForaEscopo.motivo === "Solicitação nova do cliente"}
                                    onChange={(e) => {
                                        setDadosForaEscopo({ ...dadosForaEscopo, motivo: e.target.value });
                                    }}
                                    style={{ accentColor: '#ff6b35' }}
                                />
                                <label className="form-check-label" htmlFor="motivo1" style={{
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    color: '#333',
                                    fontWeight: '500'
                                }}>
                                    <span style={{ marginRight: '8px' }}>👤</span>Solicitação nova do cliente
                                </label>
                            </div>
                        </div>

                        <div style={{
                            border: '1px solid #e0e0e0',
                            borderRadius: '8px',
                            padding: '12px 16px',
                            marginBottom: '12px',
                            cursor: 'pointer',
                            backgroundColor: dadosForaEscopo.motivo === "Esqueceu de incluir no orçamento" ? '#fff3e0' : '#fff',
                            transition: 'all 0.2s'
                        }}
                            onClick={() => setDadosForaEscopo({ ...dadosForaEscopo, motivo: "Esqueceu de incluir no orçamento" })}
                        >
                            <div className="form-check" style={{ margin: 0 }}>
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="motivo"
                                    id="motivo2"
                                    value="Esqueceu de incluir no orçamento"
                                    checked={dadosForaEscopo.motivo === "Esqueceu de incluir no orçamento"}
                                    onChange={(e) => {
                                        setDadosForaEscopo({ ...dadosForaEscopo, motivo: e.target.value });
                                    }}
                                    style={{ accentColor: '#ff6b35' }}
                                />
                                <label className="form-check-label" htmlFor="motivo2" style={{
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    color: '#333',
                                    fontWeight: '500'
                                }}>
                                    <span style={{ marginRight: '8px' }}>🕐</span>Esqueceu de incluir no orçamento
                                </label>
                            </div>
                        </div>

                        <div style={{
                            border: '1px solid #e0e0e0',
                            borderRadius: '8px',
                            padding: '12px 16px',
                            cursor: 'pointer',
                            backgroundColor: dadosForaEscopo.motivo === "Outro motivo" ? '#fff3e0' : '#fff',
                            transition: 'all 0.2s'
                        }}
                            onClick={() => setDadosForaEscopo({ ...dadosForaEscopo, motivo: "Outro motivo" })}
                        >
                            <div className="form-check" style={{ margin: 0 }}>
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="motivo"
                                    id="motivo3"
                                    value="Outro motivo"
                                    checked={dadosForaEscopo.motivo === "Outro motivo"}
                                    onChange={(e) => {
                                        setDadosForaEscopo({ ...dadosForaEscopo, motivo: e.target.value });
                                    }}
                                    style={{ accentColor: '#ff6b35' }}
                                />
                                <label className="form-check-label" htmlFor="motivo3" style={{
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    color: '#333',
                                    fontWeight: '500'
                                }}>
                                    <span style={{ marginRight: '8px' }}>❓</span>Outro motivo
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="mb-3">
                        <label htmlFor="descricao" className="form-label" style={{
                            fontSize: '15px',
                            fontWeight: '600',
                            color: '#333',
                            marginBottom: '8px',
                            display: 'block'
                        }}>Descrição</label>
                        <textarea
                            className="form-control"
                            id="descricao"
                            rows="4"
                            placeholder="Explique o motivo..."
                            value={dadosForaEscopo.descricao}
                            onChange={(e) => {
                                setDadosForaEscopo({ ...dadosForaEscopo, descricao: e.target.value });
                            }}
                            style={{
                                borderRadius: '8px',
                                border: '1px solid #e0e0e0',
                                fontSize: '14px',
                                padding: '12px',
                                resize: 'vertical'
                            }}
                        />
                    </div>
                </div>
                <div className="fin-pp__modal-foot" style={{ gap: '12px' }}>
                    <button
                        type="button"
                        className="fin-pp__btn"
                        onClick={() => {
                            // Apenas fecha o modal sem alterar nada
                            setShowModalForaEscopo(false);
                        }}
                        style={{
                            backgroundColor: '#f5f5f5',
                            border: 'none',
                            color: '#666',
                            padding: '10px 24px',
                            borderRadius: '6px',
                            fontSize: '14px',
                            fontWeight: '500',
                            cursor: 'pointer'
                        }}
                    >
                        Cancelar
                    </button>
                    <button
                        type="button"
                        className="fin-pp__btn"
                        onClick={() => {
                            // Valida se selecionou um motivo
                            if (!dadosForaEscopo.motivo) {
                                toast.error('Por favor, selecione um motivo.');
                                return;
                            }

                            if (itemForaEscopo.indexSuperior !== null && itemForaEscopo.indexInferior !== null) {
                                // Salva os dados no item
                                dados.orcamentoitem[itemForaEscopo.indexSuperior].subitem[itemForaEscopo.indexInferior].fora_escopo = true;
                                dados.orcamentoitem[itemForaEscopo.indexSuperior].subitem[itemForaEscopo.indexInferior].motivo_fora_escopo = dadosForaEscopo.motivo;
                                dados.orcamentoitem[itemForaEscopo.indexSuperior].subitem[itemForaEscopo.indexInferior].descricao_fora_escopo = dadosForaEscopo.descricao;
                                setDados({ ...dados });
                            }
                            setShowModalForaEscopo(false);
                        }}
                        style={{
                            backgroundColor: '#ff6b35',
                            border: 'none',
                            color: '#fff',
                            padding: '10px 24px',
                            borderRadius: '6px',
                            fontSize: '14px',
                            fontWeight: '500',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}
                    >
                        <FaSave size={14} /> Salvar
                    </button>
                </div>
                    </div>
                </div>
            </div>
        )}

            {/* Modal Visualizar NF */}
            {showModalVisualizarNF && (
            <div className="modal fade show d-block fin-pp fin-pp__modalbg" onClick={(e) => { if (e.target === e.currentTarget) { setShowModalVisualizarNF(false); setNfParaVisualizar(null); } }}>
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div className="modal-content fin-pp__modal">
                <div className="fin-pp__modal-head" style={{ background: '#1976d2', color: 'white' }}>
                    <h3 className="fin-pp__modal-title" style={{ color: 'white' }}>
                        <FaFileAlt size={20} /> Visualizar Nota Fiscal
                    </h3>
                    <button type="button" className="fin-pp__modal-close" onClick={() => { setShowModalVisualizarNF(false); setNfParaVisualizar(null); }}><FaTimes size={16} /></button>
                </div>
                <div className="modal-body" style={{ padding: 0, height: '80vh' }}>
                    {nfParaVisualizar?.arquivo?.url ? (
                        <iframe
                            src={`https://docs.google.com/viewer?url=${encodeURIComponent(nfParaVisualizar.arquivo.url)}&embedded=true`}
                            style={{
                                width: '100%',
                                height: '100%',
                                border: 'none'
                            }}
                            title="Visualizar Nota Fiscal"
                        />
                    ) : (
                        <div className="text-center py-5">
                            <p className="text-muted">Arquivo não disponível para visualização</p>
                        </div>
                    )}
                </div>
                <div className="fin-pp__modal-foot">
                    <button
                        type="button"
                        className="fin-pp__btn"
                        onClick={() => {
                            setShowModalVisualizarNF(false);
                            setNfParaVisualizar(null);
                        }}
                    >
                        Fechar
                    </button>
                    {nfParaVisualizar?.arquivo?.url && (
                        <a
                            href={nfParaVisualizar.arquivo.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="fin-pp__btn fin-pp__btn--primary"
                        >
                            <FaDownload size={14} style={{ marginRight: 4 }} /> Baixar PDF
                        </a>
                    )}
                </div>
                    </div>
                </div>
            </div>
        )}

            {/* Modal Solicitar NF */}
            {showModalSolicitarNF && (
            <div className="modal fade show d-block fin-pp fin-pp__modalbg" onClick={(e) => { if (e.target === e.currentTarget) { setShowModalSolicitarNF(false) } }}>
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content fin-pp__modal">
                <div className="fin-pp__modal-head" style={{ background: '#f4f6f8', borderBottom: '1px solid #e5e7eb' }}>
                    <h3 className="fin-pp__modal-title">
                        <FaEnvelope size={18} /> Solicitar Notas Fiscais
                    </h3>
                    <button type="button" className="fin-pp__modal-close" onClick={() => setShowModalSolicitarNF(false)}><FaTimes size={16} /></button>
                </div>
                <div className="modal-body" style={{ padding: '24px' }}>
                    {itemSolicitarNF && (() => {
                        // Agrupar todos os itens do fornecedor selecionado (sempre busca de dados atuais)
                        const fornecedorNome = itemSolicitarNF.fornecedor_nome;
                        const fornecedorItens = [];
                        const categorias = new Set();
                        let totalGeral = 0;
                        let totalItensFornecedor = 0;
                        let itensSemValorReal = 0;

                        dados.orcamentoitem?.forEach((item, indexSup) => {
                            item.subitem?.forEach((subitem, indexInf) => {
                                // IMPORTANTE: fornecedorpagamento agora é 'agencia' ou 'cliente' (não o fornecedor)
                                // Sempre usar subitem.fornecedor?.nome para identificar o fornecedor real
                                const fornNome = subitem.fornecedor?.nome || 'Fornecedor não identificado';
                                if (fornNome === fornecedorNome) {
                                    totalItensFornecedor += 1;
                                    const categoria = subitem.produto?.nome || 'Sem categoria';

                                    // Usa pagamentovalorreal que é o valor que realmente será pago ao fornecedor
                                    let valorTotal = 0;
                                    if (subitem.pagamentovalorreal) {
                                        valorTotal = parseFloat(virgulaPonto(subitem.pagamentovalorreal)) || 0;
                                    }

                                    // Só adiciona se tiver valor válido (maior que zero)
                                    if (valorTotal <= 0) {
                                        itensSemValorReal += 1;
                                        return;
                                    }

                                    categorias.add(categoria);
                                    totalGeral += valorTotal;
                                    fornecedorItens.push({
                                        id: `${indexSup}-${indexInf}`,
                                        nome: subitem.titulo || subitem.nome_evento || categoria,
                                        valor: valorTotal,
                                        categoria: categoria
                                    });
                                }
                            });
                        });

                        const numCategorias = categorias.size;

                        return (
                            <>
                                <div className="fin-pp__tabs" style={{ marginBottom: 12 }}>
                                    <button className={`fin-pp__tab${activeTabNF === 'solicitar' ? ' is-active' : ''}`} onClick={() => setActiveTabNF('solicitar')}>📤 Solicitar</button>
                                    <button className={`fin-pp__tab${activeTabNF === 'historico' ? ' is-active' : ''}`} onClick={() => setActiveTabNF('historico')}>📋 Histórico</button>
                                    <button className={`fin-pp__tab${activeTabNF === 'notas-fiscais' ? ' is-active' : ''}`} onClick={() => setActiveTabNF('notas-fiscais')}>📎 Notas Fiscais</button>
                                </div>
                                    {activeTabNF === 'solicitar' && (<>
                                        {/* Informações do Fornecedor */}
                                        <div style={{
                                            backgroundColor: '#f8f8f8',
                                            padding: '16px',
                                            borderRadius: '8px',
                                            marginBottom: '16px',
                                            border: '1px solid #e5e7eb'
                                        }}>
                                            <div style={{
                                                fontSize: '13px',
                                                color: '#2563eb',
                                                marginBottom: '8px',
                                                fontWeight: '600',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px'
                                            }}>
                                                <FaBuilding size={14} /> Fornecedor
                                            </div>
                                            <div style={{
                                                fontSize: '16px',
                                                fontWeight: '700',
                                                color: '#333',
                                                marginBottom: '2px'
                                            }}>
                                                {itemSolicitarNF.fornecedor_nome || 'Nome do Fornecedor'}
                                            </div>
                                            <div style={{
                                                fontSize: '13px',
                                                color: '#666'
                                            }}>
                                                CNPJ: {empresaAtiva?.cnpj
                                                    ? empresaAtiva.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5')
                                                    : '11.222.333/0001-44'}
                                            </div>
                                        </div>

                                        {fornecedorItens.length === 0 && totalItensFornecedor > 0 && (
                                            <div style={{
                                                backgroundColor: '#fff7ed',
                                                border: '1px solid #fed7aa',
                                                color: '#9a3412',
                                                padding: '12px 14px',
                                                borderRadius: '8px',
                                                marginBottom: '16px',
                                                fontSize: '13px'
                                            }}>
                                                Nenhum item com <strong>Valor Real</strong> preenchido para este fornecedor.
                                                Preencha a coluna de pagamento para liberar a solicitação de NF.
                                            </div>
                                        )}

                                        {fornecedorItens.length > 0 && itensSemValorReal > 0 && (
                                            <div style={{
                                                backgroundColor: '#fffaf0',
                                                border: '1px solid #fde68a',
                                                color: '#854d0e',
                                                padding: '10px 12px',
                                                borderRadius: '8px',
                                                marginBottom: '16px',
                                                fontSize: '12px'
                                            }}>
                                                {itensSemValorReal} {itensSemValorReal === 1 ? 'item foi ignorado' : 'itens foram ignorados'} por não ter <strong>Valor Real</strong>.
                                            </div>
                                        )}

                                        {/* Categorias para NF */}
                                        <div style={{
                                            backgroundColor: '#f7f8fc',
                                            padding: '16px',
                                            borderRadius: '8px',
                                            marginBottom: '20px',
                                            border: '1px solid #dbe2ef'
                                        }}>
                                            <div style={{
                                                fontSize: '13px',
                                                color: '#334155',
                                                marginBottom: '12px',
                                                fontWeight: '600',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px'
                                            }}>
                                                <FaTable size={14} /> Categorias para NF
                                                <span style={{
                                                    backgroundColor: '#e2e8f0',
                                                    color: '#334155',
                                                    padding: '2px 10px',
                                                    borderRadius: '12px',
                                                    fontSize: '11px',
                                                    fontWeight: '600'
                                                }}>
                                                    {numCategorias} {numCategorias === 1 ? 'NF esperada' : 'NFs esperadas'}
                                                </span>
                                            </div>
                                            <div style={{
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                gap: '8px',
                                                marginBottom: '12px'
                                            }}>
                                                {Array.from(categorias).map((cat, idx) => (
                                                    <span
                                                        key={idx}
                                                        style={{
                                                            backgroundColor: 'white',
                                                            color: '#334155',
                                                            padding: '6px 14px',
                                                            borderRadius: '16px',
                                                            fontSize: '13px',
                                                            fontWeight: '500',
                                                            border: '1px solid #dbe2ef'
                                                        }}
                                                    >
                                                        {cat}
                                                    </span>
                                                ))}
                                            </div>
                                            <div style={{
                                                fontSize: '12px',
                                                color: '#475569',
                                                fontStyle: 'italic'
                                            }}>
                                                O fornecedor terá {numCategorias} campo(s) de upload, um para cada categoria.
                                            </div>
                                        </div>

                                        {/* Resumo Financeiro */}
                                        <div style={{
                                            backgroundColor: '#f6faf7',
                                            padding: '16px',
                                            borderRadius: '8px',
                                            marginBottom: '20px',
                                            border: '1px solid #d6e5da'
                                        }}>
                                            <div style={{
                                                fontSize: '13px',
                                                fontWeight: '600',
                                                color: '#333',
                                                marginBottom: '12px'
                                            }}>
                                                💰 Resumo Financeiro ({fornecedorItens.length} {fornecedorItens.length === 1 ? 'item' : 'itens'})
                                            </div>
                                            {fornecedorItens.map((item) => (
                                                <div
                                                    key={item.id}
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        padding: '8px 0',
                                                        borderBottom: '1px solid #c8e6c9',
                                                        fontSize: '13px'
                                                    }}
                                                >
                                                    <span style={{ color: '#333' }}>{item.nome}</span>
                                                    <span style={{ fontWeight: '600', color: '#166534' }}>
                                                        R$ {item.valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                    </span>
                                                </div>
                                            ))}
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    padding: '12px 0 0 0',
                                                    fontSize: '15px',
                                                    fontWeight: '700',
                                                    borderTop: '2px solid #c8e6c9',
                                                    marginTop: '8px'
                                                }}
                                            >
                                                <span style={{ color: '#333' }}>Total</span>
                                                <span style={{ color: '#166534', fontSize: '18px' }}>
                                                    R$ {totalGeral.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                </span>
                                            </div>

                                            {/* Mostra histórico de antecipações JÁ SALVAS no banco */}
                                            {(() => {
                                                // Soma TODAS as antecipações anteriores (JÁ SALVAS no banco)
                                                const totalAntecipacoes = historicoAntecipacoes
                                                    .filter(h => h.tem_antecipacao)
                                                    .reduce((sum, h) => sum + (parseFloat(h.valor_antecipacao) || 0), 0);

                                                const temAntecipacaoAnterior = totalAntecipacoes > 0;

                                                if (!temAntecipacaoAnterior) return null;

                                                return (
                                                    <div style={{
                                                        marginTop: '16px',
                                                        paddingTop: '16px',
                                                        borderTop: '2px solid #17a2b8',
                                                        backgroundColor: '#d1ecf1',
                                                        padding: '12px',
                                                        borderRadius: '6px',
                                                        marginLeft: '-16px',
                                                        marginRight: '-16px',
                                                        marginBottom: '-16px'
                                                    }}>
                                                        <div style={{
                                                            fontWeight: '600',
                                                            color: '#0c5460',
                                                            marginBottom: '8px',
                                                            fontSize: '14px',
                                                            padding: '0 4px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '8px'
                                                        }}>
                                                            ⚡ Antecipações Solicitadas Anteriormente
                                                            <span style={{
                                                                fontSize: '11px',
                                                                backgroundColor: '#17a2b8',
                                                                color: 'white',
                                                                padding: '2px 8px',
                                                                borderRadius: '10px'
                                                            }}>
                                                                {historicoAntecipacoes.filter(h => h.tem_antecipacao).length} {historicoAntecipacoes.filter(h => h.tem_antecipacao).length === 1 ? 'solicitação' : 'solicitações'}
                                                            </span>
                                                        </div>
                                                        <div style={{ padding: '0 4px' }}>
                                                            <div style={{
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                marginBottom: '6px',
                                                                fontSize: '14px'
                                                            }}>
                                                                <span style={{ color: '#0c5460' }}>Total Antecipado:</span>
                                                                <span style={{ fontWeight: '700', color: '#dc3545' }}>
                                                                    R$ {totalAntecipacoes.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                </span>
                                                            </div>
                                                            <div style={{
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                fontSize: '14px'
                                                            }}>
                                                                <span style={{ color: '#0c5460' }}>Saldo Restante:</span>
                                                                <span style={{ fontWeight: '700', color: '#28a745' }}>
                                                                    R$ {(totalGeral - totalAntecipacoes).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })()}
                                        </div>

                                        {/* Destinatários */}
                                        <div style={{ marginBottom: '20px' }}>
                                            <label style={{
                                                fontSize: '13px',
                                                fontWeight: '600',
                                                color: '#333',
                                                marginBottom: '8px',
                                                display: 'block'
                                            }}>
                                                Destinatários
                                            </label>

                                            <div style={{
                                                display: 'flex',
                                                gap: '8px',
                                                marginBottom: '12px'
                                            }}>
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    placeholder="Adicionar email..."
                                                    value={novoEmail}
                                                    onChange={(e) => setNovoEmail(e.target.value)}
                                                    onKeyPress={(e) => {
                                                        if (e.key === 'Enter') {
                                                            e.preventDefault();
                                                            if (novoEmail && novoEmail.includes('@')) {
                                                                setEmailsDestinatarios([...emailsDestinatarios, novoEmail]);
                                                                setNovoEmail('');
                                                            }
                                                        }
                                                    }}
                                                    style={{
                                                        fontSize: '13px',
                                                        border: '1px solid #ddd',
                                                        borderRadius: '6px',
                                                        padding: '8px 12px'
                                                    }}
                                                />
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        if (novoEmail && novoEmail.includes('@')) {
                                                            setEmailsDestinatarios([...emailsDestinatarios, novoEmail]);
                                                            setNovoEmail('');
                                                        }
                                                    }}
                                                    style={{
                                                        backgroundColor: '#2196f3',
                                                        color: 'white',
                                                        border: 'none',
                                                        borderRadius: '50%',
                                                        width: '38px',
                                                        height: '38px',
                                                        fontSize: '20px',
                                                        fontWeight: 'bold',
                                                        cursor: 'pointer',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        flexShrink: 0
                                                    }}
                                                >
                                                    +
                                                </button>
                                            </div>

                                            {/* Lista de E-mails */}
                                            {emailsDestinatarios.length > 0 && (
                                                <div style={{
                                                    display: 'flex',
                                                    flexWrap: 'wrap',
                                                    gap: '8px',
                                                    marginBottom: '12px'
                                                }}>
                                                    {emailsDestinatarios.map((email, index) => (
                                                        <div
                                                            key={index}
                                                            style={{
                                                                backgroundColor: '#ffecd2',
                                                                padding: '6px 12px',
                                                                borderRadius: '16px',
                                                                fontSize: '12px',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '8px',
                                                                border: '1px solid #ffc195'
                                                            }}
                                                        >
                                                            <span style={{ color: '#8b4513' }}>{email}</span>
                                                            <button
                                                                type="button"
                                                                onClick={() => {
                                                                    setEmailsDestinatarios(
                                                                        emailsDestinatarios.filter((_, i) => i !== index)
                                                                    );
                                                                }}
                                                                style={{
                                                                    backgroundColor: 'transparent',
                                                                    border: 'none',
                                                                    color: '#8b4513',
                                                                    cursor: 'pointer',
                                                                    padding: '0',
                                                                    fontSize: '16px',
                                                                    fontWeight: 'bold',
                                                                    lineHeight: '1'
                                                                }}
                                                            >
                                                                ×
                                                            </button>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>

                                        {/* Antecipação */}
                                        <div style={{ marginBottom: '20px', padding: '16px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: solicitarAntecipacao ? '16px' : '0' }}>
                                                <input
                                                    type="checkbox"
                                                    id="checkAntecipacao"
                                                    checked={solicitarAntecipacao}
                                                    onChange={(e) => {
                                                        setSolicitarAntecipacao(e.target.checked);
                                                        if (!e.target.checked) {
                                                            setValorAntecipacao('');
                                                        }
                                                    }}
                                                    style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                                                />
                                                <label
                                                    htmlFor="checkAntecipacao"
                                                    style={{
                                                        fontSize: '14px',
                                                        fontWeight: '600',
                                                        color: '#495057',
                                                        cursor: 'pointer',
                                                        margin: 0
                                                    }}
                                                >
                                                    💰 Solicitar Antecipação de Pagamento
                                                </label>
                                            </div>

                                            {solicitarAntecipacao && (() => {
                                                const totalGeral = (() => {
                                                    let total = 0;
                                                    dados.orcamentoitem?.forEach((item) => {
                                                        item.subitem?.forEach((subitem) => {
                                                            // IMPORTANTE: fornecedorpagamento agora é 'agencia' ou 'cliente' (não o fornecedor)
                                                            // Sempre usar subitem.fornecedor?.nome para identificar o fornecedor real
                                                            const fornNome = subitem.fornecedor?.nome || '';
                                                            if (fornNome === itemSolicitarNF.fornecedor_nome) {
                                                                // Usa pagamentovalorreal (mesmo campo usado no Resumo Financeiro)
                                                                let valorTotal = 0;
                                                                if (subitem.pagamentovalorreal) {
                                                                    valorTotal = parseFloat(virgulaPonto(subitem.pagamentovalorreal)) || 0;
                                                                }
                                                                // Só soma se tiver valor válido
                                                                if (valorTotal > 0) {
                                                                    total += valorTotal;
                                                                }
                                                            }
                                                        });
                                                    });
                                                    return total;
                                                })();

                                                // Calcula total de antecipações anteriores (JÁ ENVIADAS)
                                                const totalAntecipacoes = historicoAntecipacoes
                                                    .filter(h => h.tem_antecipacao)
                                                    .reduce((sum, h) => sum + (parseFloat(h.valor_antecipacao) || 0), 0);

                                                const valorAntecipacaoNum = valorAntecipacao ? parseFloat(String(valorAntecipacao).replace(',', '.')) || 0 : 0;

                                                // Saldo = Total - Antecipações Anteriores - Antecipação Atual
                                                const saldoRestante = totalGeral - totalAntecipacoes - valorAntecipacaoNum;

                                                return (
                                                    <>
                                                        {/* Info box mostrando antecipações ANTERIORES (já enviadas) */}
                                                        {totalAntecipacoes > 0 && (
                                                            <div style={{
                                                                backgroundColor: '#d1ecf1',
                                                                padding: '12px',
                                                                borderRadius: '6px',
                                                                marginBottom: '12px',
                                                                border: '1px solid #17a2b8'
                                                            }}>
                                                                <div style={{ fontSize: '12px', color: '#0c5460', marginBottom: '8px' }}>
                                                                    ℹ️ <strong>Antecipações já solicitadas:</strong>
                                                                </div>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                                                                    <span style={{ fontSize: '13px', color: '#0c5460' }}>Valor Total:</span>
                                                                    <span style={{ fontSize: '13px', fontWeight: '600', color: '#212529' }}>
                                                                        R$ {totalGeral.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                    </span>
                                                                </div>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                                                                    <span style={{ fontSize: '13px', color: '#0c5460' }}>Já Antecipado:</span>
                                                                    <span style={{ fontSize: '13px', fontWeight: '600', color: '#dc3545' }}>
                                                                        - R$ {totalAntecipacoes.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                    </span>
                                                                </div>
                                                                <div style={{
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    paddingTop: '8px',
                                                                    borderTop: '1px solid #17a2b8',
                                                                    marginTop: '4px'
                                                                }}>
                                                                    <span style={{ fontSize: '14px', fontWeight: '600', color: '#0c5460' }}>Disponível para Antecipação:</span>
                                                                    <span style={{ fontSize: '15px', fontWeight: '700', color: '#28a745' }}>
                                                                        R$ {(totalGeral - totalAntecipacoes).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        )}

                                                        <div style={{ marginBottom: '12px' }}>
                                                            <label style={{
                                                                fontSize: '13px',
                                                                fontWeight: '600',
                                                                color: '#495057',
                                                                marginBottom: '6px',
                                                                display: 'block'
                                                            }}>
                                                                Valor da Antecipação
                                                            </label>
                                                            <CampoValor
                                                                className="form-control"
                                                                moeda="real"
                                                                decimalScale={2}
                                                                fixedDecimalScale
                                                                allowNegative={false}
                                                                value={valorAntecipacao}
                                                                onValueChange={(values) => {
                                                                    setValorAntecipacao(values.value);
                                                                }}
                                                                style={{
                                                                    fontSize: '14px',
                                                                    border: '1px solid #ced4da',
                                                                    borderRadius: '6px',
                                                                    padding: '8px 12px'
                                                                }}
                                                            />
                                                        </div>

                                                        <div style={{
                                                            backgroundColor: '#fff',
                                                            padding: '12px',
                                                            borderRadius: '6px',
                                                            border: '1px solid #dee2e6',
                                                            fontSize: '13px'
                                                        }}>
                                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
                                                                <span style={{ color: '#6c757d' }}>Valor Total:</span>
                                                                <span style={{ fontWeight: '600', color: '#212529' }}>{moeda(totalGeral)}</span>
                                                            </div>
                                                            {totalAntecipacoes > 0 && (
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
                                                                    <span style={{ color: '#6c757d' }}>Já Antecipado:</span>
                                                                    <span style={{ fontWeight: '600', color: '#dc3545' }}>- {moeda(totalAntecipacoes)}</span>
                                                                </div>
                                                            )}
                                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
                                                                <span style={{ color: '#6c757d' }}>Antecipação Atual:</span>
                                                                <span style={{ fontWeight: '600', color: '#dc3545' }}>- {moeda(valorAntecipacaoNum)}</span>
                                                            </div>
                                                            <div style={{
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                paddingTop: '8px',
                                                                borderTop: '2px solid #dee2e6',
                                                                marginTop: '4px'
                                                            }}>
                                                                <span style={{ fontWeight: '700', color: '#212529' }}>Saldo Restante:</span>
                                                                <span style={{ fontWeight: '700', color: saldoRestante < 0 ? '#dc3545' : '#28a745', fontSize: '15px' }}>
                                                                    {moeda(saldoRestante)}
                                                                </span>
                                                            </div>
                                                            {saldoRestante < 0 && (
                                                                <div style={{
                                                                    marginTop: '8px',
                                                                    padding: '8px',
                                                                    backgroundColor: '#f8d7da',
                                                                    color: '#721c24',
                                                                    borderRadius: '4px',
                                                                    fontSize: '12px'
                                                                }}>
                                                                    ⚠️ A antecipação não pode ser maior que o valor disponível
                                                                </div>
                                                            )}
                                                        </div>
                                                    </>
                                                );
                                            })()}
                                        </div>

                                        {/* Info Box */}
                                        <div style={{
                                            backgroundColor: '#f1f5f9',
                                            padding: '12px 16px',
                                            borderRadius: '8px',
                                            border: '1px solid #cbd5e1',
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                            gap: '10px'
                                        }}>
                                            <span style={{ fontSize: '16px' }}>ℹ️</span>
                                            <div style={{
                                                fontSize: '12px',
                                                color: '#334155',
                                                lineHeight: '1.5'
                                            }}>
                                                O fornecedor receberá <strong>um único link</strong> com {numCategorias} campo(s) de upload para as NFs.
                                            </div>
                                        </div>
                                    </>)}

                                    {/* ABA 2: Histórico */}
                                    {activeTabNF === 'historico' && (<>
                                        {loadingHistorico ? (
                                            <div className="text-center py-5">
                                                <FaCircleNotch className="fa-spin" size={32} color="#ff6b35" />
                                                <p className="mt-3 text-muted">Carregando histórico...</p>
                                            </div>
                                        ) : historicoAntecipacoes.length === 0 ? (
                                            <div className="alert alert-info" style={{
                                                backgroundColor: '#e3f2fd',
                                                color: '#1976d2',
                                                border: '1px solid #90caf9'
                                            }}>
                                                <strong>ℹ️ Nenhuma solicitação anterior</strong>
                                                <p className="mb-0 mt-2" style={{ fontSize: '14px' }}>
                                                    Não há histórico de solicitações de NF ou antecipações para este fornecedor neste orçamento.
                                                </p>
                                            </div>
                                        ) : (
                                            <>
                                                {/* Resumo */}
                                                <div className="card mb-3" style={{
                                                    backgroundColor: '#f8f9fa',
                                                    border: '1px solid #dee2e6'
                                                }}>
                                                    <div className="card-body">
                                                        <h6 className="mb-3" style={{ fontWeight: '600', color: '#495057' }}>
                                                            📊 Resumo do Fornecedor
                                                        </h6>
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <div className="mb-2">
                                                                    <small className="text-muted d-block">Total de Solicitações</small>
                                                                    <h5 className="mb-0" style={{ color: '#212529' }}>
                                                                        {historicoAntecipacoes.length}
                                                                    </h5>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="mb-2">
                                                                    <small className="text-muted d-block">Valor Total Antecipado</small>
                                                                    <h5 className="mb-0" style={{ color: '#dc3545' }}>
                                                                        {moeda(historicoAntecipacoes
                                                                            .filter(h => h.tem_antecipacao)
                                                                            .reduce((sum, h) => sum + (parseFloat(h.valor_antecipacao) || 0), 0)
                                                                        )}
                                                                    </h5>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="mb-2">
                                                                    <small className="text-muted d-block">Antecipações Solicitadas</small>
                                                                    <h5 className="mb-0" style={{ color: '#856404' }}>
                                                                        {historicoAntecipacoes.filter(h => h.tem_antecipacao).length}
                                                                    </h5>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Tabela de Histórico */}
                                                <div className="card">
                                                    <div className="card-body">
                                                        <h6 className="mb-3" style={{ fontWeight: '600', color: '#495057' }}>
                                                            🕒 Histórico de Solicitações
                                                        </h6>
                                                        <div>
                                                            <table className="table table-hover">
                                                                <thead style={{ backgroundColor: '#f8f9fa' }}>
                                                                    <tr>
                                                                        <th>Data</th>
                                                                        <th>Valor Antecipado</th>
                                                                        <th>Saldo</th>
                                                                        <th>Status</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {historicoAntecipacoes.map((item, index) => (
                                                                        <tr key={index}>
                                                                            <td>
                                                                                {item.data_solicitacao ?
                                                                                    moment(item.data_solicitacao).format('DD/MM/YYYY HH:mm') :
                                                                                    'N/A'
                                                                                }
                                                                            </td>
                                                                            <td>
                                                                                {item.tem_antecipacao ? (
                                                                                    <span style={{
                                                                                        color: '#dc3545',
                                                                                        fontWeight: '600',
                                                                                        fontSize: '15px'
                                                                                    }}>
                                                                                        {moeda(item.valor_antecipacao || 0)}
                                                                                    </span>
                                                                                ) : (
                                                                                    <span className="text-muted">-</span>
                                                                                )}
                                                                            </td>
                                                                            <td>
                                                                                {item.tem_antecipacao ? (
                                                                                    <span style={{
                                                                                        color: '#28a745',
                                                                                        fontWeight: '600'
                                                                                    }}>
                                                                                        {moeda(item.valor_saldo || 0)}
                                                                                    </span>
                                                                                ) : (
                                                                                    <span style={{ color: '#212529', fontWeight: '600' }}>
                                                                                        {moeda(item.valor_total || 0)}
                                                                                    </span>
                                                                                )}
                                                                            </td>
                                                                            <td>
                                                                                <span className="badge" style={{
                                                                                    backgroundColor: item.tem_antecipacao ? '#fff3cd' : '#d1ecf1',
                                                                                    color: item.tem_antecipacao ? '#856404' : '#0c5460',
                                                                                    padding: '4px 12px',
                                                                                    borderRadius: '12px',
                                                                                    fontSize: '11px'
                                                                                }}>
                                                                                    {item.tem_antecipacao ? '⚡ Com Antecipação' : '📄 Solicitação Simples'}
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </>)}

                                    {/* ABA 3: Notas Fiscais Enviadas */}
                                    {activeTabNF === 'notas-fiscais' && (<>
                                        {loadingNotasFiscais ? (
                                            <div className="text-center py-5">
                                                <FaCircleNotch className="fa-spin" size={32} color="#1976d2" />
                                                <p className="mt-3 text-muted">Carregando notas fiscais...</p>
                                            </div>
                                        ) : historicoNotasFiscais.length === 0 ? (
                                            <div className="alert alert-info" style={{
                                                backgroundColor: '#e3f2fd',
                                                color: '#1976d2',
                                                border: '1px solid #90caf9'
                                            }}>
                                                <strong>ℹ️ Nenhuma nota fiscal enviada</strong>
                                                <p className="mb-0 mt-2" style={{ fontSize: '14px' }}>
                                                    Não há notas fiscais enviadas para este fornecedor neste orçamento.
                                                </p>
                                            </div>
                                        ) : (
                                            <div className="card">
                                                <div className="card-body">
                                                    <h6 className="mb-3" style={{ fontWeight: '600', color: '#495057' }}>
                                                        📄 Histórico de Upload
                                                    </h6>
                                                    <div>
                                                        <table className="table table-hover">
                                                            <thead style={{ backgroundColor: '#f8f9fa' }}>
                                                                <tr>
                                                                    <th>Data Envio</th>
                                                                    <th>Status</th>
                                                                    <th>Arquivo</th>
                                                                    <th>Ações</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {historicoNotasFiscais.map((nf, index) => (
                                                                    <tr key={nf.id || index}>
                                                                        <td>
                                                                            {nf.data_envio ?
                                                                                moment(nf.data_envio).format('DD/MM/YYYY HH:mm') :
                                                                                'N/A'
                                                                            }
                                                                        </td>
                                                                        <td>
                                                                            {(() => {
                                                                                const s = nf.status;
                                                                                const aprovado = s === 'aprovada' || s === 'validado';
                                                                                const recusado = s === 'recusada' || s === 'rejeitado';
                                                                                const recebido = s === 'recebida' || s === 'processado';
                                                                                const revisao = s === 'em_revisao';
                                                                                return (
                                                                                    <span className="badge" style={{
                                                                                        backgroundColor: aprovado ? '#d4edda' : recusado ? '#f8d7da' : recebido ? '#cce5ff' : revisao ? '#fff3cd' : '#fff3cd',
                                                                                        color: aprovado ? '#155724' : recusado ? '#721c24' : recebido ? '#004085' : '#856404',
                                                                                        padding: '4px 12px',
                                                                                        borderRadius: '12px',
                                                                                        fontSize: '11px'
                                                                                    }}>
                                                                                        {aprovado ? '✅ Aprovada' : recusado ? '❌ Recusada' : recebido ? '📬 Recebida' : revisao ? '🔍 Em revisão' : '⏳ Pendente'}
                                                                                    </span>
                                                                                );
                                                                            })()}
                                                                            {nf.nota_fiscal_id && (
                                                                                <a
                                                                                    href={'/cadastroNotaFiscal/' + nf.nota_fiscal_id}
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                    className="d-block mt-1"
                                                                                    style={{ fontSize: '11px', color: '#1976d2' }}
                                                                                >
                                                                                    🔗 Ver NF{nf.nota_fiscal_numero ? ` nº ${nf.nota_fiscal_numero}` : ''}
                                                                                </a>
                                                                            )}
                                                                            {nf.observacao && (
                                                                                <small className="d-block text-muted mt-1" style={{ fontSize: '11px' }}>
                                                                                    {nf.observacao}
                                                                                </small>
                                                                            )}
                                                                        </td>
                                                                        <td>
                                                                            {nf.arquivo ? (
                                                                                <div style={{
                                                                                    maxWidth: '250px',
                                                                                    overflow: 'hidden',
                                                                                    textOverflow: 'ellipsis',
                                                                                    whiteSpace: 'nowrap'
                                                                                }}>
                                                                                    <span style={{ fontSize: '13px', color: '#333' }} title={nf.arquivo.nome}>
                                                                                        <FaFileAlt size={14} style={{ marginRight: 4 }} />
                                                                                        {(() => {
                                                                                            const fileName = nf.arquivo.nome;
                                                                                            if (fileName.length <= 30) return fileName;
                                                                                            const extension = fileName.split('.').pop();
                                                                                            const nameWithoutExt = fileName.substring(0, fileName.lastIndexOf('.'));
                                                                                            const truncated = nameWithoutExt.substring(0, 20);
                                                                                            return `${truncated}...${extension}`;
                                                                                        })()}
                                                                                    </span>
                                                                                </div>
                                                                            ) : (
                                                                                <span className="text-muted">-</span>
                                                                            )}
                                                                        </td>
                                                                        <td>
                                                                            {nf.arquivo && nf.arquivo.url ? (
                                                                                <div style={{ display: 'flex', gap: '8px' }}>
                                                                                    <button
                                                                                        type="button"
                                                                                        onClick={() => {
                                                                                            setNfParaVisualizar(nf);
                                                                                            setShowModalVisualizarNF(true);
                                                                                        }}
                                                                                        className="btn btn-sm btn-info"
                                                                                        style={{
                                                                                            fontSize: '12px',
                                                                                            padding: '4px 12px'
                                                                                        }}
                                                                                    >
                                                                                        <FaFileAlt size={12} style={{ marginRight: 4 }} />
                                                                                        Visualizar
                                                                                    </button>
                                                                                    <a
                                                                                        href={nf.arquivo.url}
                                                                                        target="_blank"
                                                                                        rel="noopener noreferrer"
                                                                                        className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--sm"
                                                                                        style={{
                                                                                            fontSize: '12px',
                                                                                            padding: '4px 12px'
                                                                                        }}
                                                                                    >
                                                                                        <FaDownload size={12} style={{ marginRight: 4 }} />
                                                                                        Download
                                                                                    </a>
                                                                                </div>
                                                                            ) : nf.arquivo && !nf.arquivo.url ? (
                                                                                <span className="text-warning" style={{ fontSize: '12px' }}>
                                                                                    <FaCircleNotch className="fa-spin mr-1" size={12} />
                                                                                    Processando...
                                                                                </span>
                                                                            ) : (
                                                                                <span className="text-muted" style={{ fontSize: '12px' }}>
                                                                                    Sem arquivo
                                                                                </span>
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </>)}

                            </>
                        );
                    })()}
                </div>
                <div className="fin-pp__modal-foot">
                    {(() => {
                        // Função auxiliar para enviar solicitação
                        const enviarSolicitacao = (reenviar = false) => {
                            if (emailsDestinatarios.length === 0) {
                                toast.error('Adicione pelo menos um email de destinatário');
                                return;
                            }

                            setLoadingNF(true);

                            // Calcula os dados do fornecedor para enviar
                            const fornecedorNome = itemSolicitarNF.fornecedor_nome;
                            const itensDoFornecedor = [];
                            const categoriasUnicas = [];
                            const categoriasSet = new Set();
                            let totalGeral = 0;

                            dados.orcamentoitem?.forEach((item) => {
                                item.subitem?.forEach((subitem) => {
                                    // IMPORTANTE: fornecedorpagamento agora é 'agencia' ou 'cliente' (não o fornecedor)
                                    // Sempre usar subitem.fornecedor?.nome para identificar o fornecedor real
                                    const fornNome = subitem.fornecedor?.nome || 'Fornecedor não identificado';
                                    if (fornNome === fornecedorNome) {
                                        const categoria = subitem.produto?.nome || 'Sem categoria';
                                        categoriasSet.add(categoria);

                                        // Usa pagamentovalorreal que é o valor que realmente será pago ao fornecedor
                                        let valorTotal = 0;
                                        if (subitem.pagamentovalorreal) {
                                            valorTotal = parseFloat(virgulaPonto(subitem.pagamentovalorreal)) || 0;
                                        }

                                        // Só adiciona se tiver valor válido (maior que zero)
                                        if (valorTotal <= 0) {
                                            return;
                                        }

                                        totalGeral += valorTotal;

                                        itensDoFornecedor.push({
                                            nome: subitem.titulo || subitem.nome_evento || categoria,
                                            valor: valorTotal,
                                            categoria: categoria
                                        });
                                    }
                                });
                            });

                            categoriasSet.forEach(cat => categoriasUnicas.push(cat));

                            // Validação: deve ter itens
                            if (itensDoFornecedor.length === 0) {
                                toast.error('Não há itens com Valor Real para este fornecedor. Preencha a coluna de pagamento.');
                                setLoadingNF(false);
                                return;
                            }

                            if (totalGeral <= 0) {
                                toast.error('O valor total dos itens deve ser maior que zero.');
                                setLoadingNF(false);
                                return;
                            }

                            // Validação de antecipação
                            const valorAntecipacaoNum = solicitarAntecipacao && valorAntecipacao
                                ? parseFloat(String(valorAntecipacao).replace(',', '.')) || 0
                                : 0;

                            if (solicitarAntecipacao && valorAntecipacaoNum < 0) {
                                toast.error('O valor da antecipação não pode ser negativo');
                                setLoadingNF(false);
                                return;
                            }

                            if (solicitarAntecipacao && valorAntecipacaoNum <= 0) {
                                toast.error('Informe um valor válido para a antecipação');
                                setLoadingNF(false);
                                return;
                            }

                            if (solicitarAntecipacao && valorAntecipacaoNum > totalGeral) {
                                toast.error(`O valor da antecipação (R$ ${valorAntecipacaoNum.toFixed(2)}) não pode ser maior que o total dos itens (R$ ${totalGeral.toFixed(2)})`);
                                setLoadingNF(false);
                                return;
                            }

                            const payload = {
                                orcamento_id: dados.id,
                                item_index_superior: itemSolicitarNF.indexSuperior,
                                item_index_inferior: itemSolicitarNF.indexInferior,
                                emails: emailsDestinatarios,
                                fornecedorNome: fornecedorNome,
                                eventoNome: dados.evento?.nome || 'Evento não informado',
                                itens: itensDoFornecedor,
                                categorias: categoriasUnicas,
                                totalGeral: totalGeral,
                                reenviar: reenviar,
                                antecipacao: solicitarAntecipacao ? {
                                    valor: valorAntecipacaoNum,
                                    saldo: totalGeral - valorAntecipacaoNum
                                } : null
                            };

                            console.log('Enviando solicitação de NF...', payload);

                            api({
                                method: 'post',
                                action: '/orcamento/solicitarNotaFiscal',
                                token: token,
                                data: payload
                            })
                                .then(response => {
                                    console.log('Resposta da API:', response.data);
                                    if (response.data.status) {
                                        toast.success(response.data.msg || 'Solicitação enviada com sucesso!');
                                        if (response.data.aviso) {
                                            toast.warning(response.data.aviso);
                                        }
                                    } else {
                                        toast.error(response.data.error || 'Erro ao processar solicitação');
                                    }
                                    setShowModalSolicitarNF(false);
                                    setEmailsDestinatarios([]);
                                    setNovoEmail('');
                                    setSolicitarAntecipacao(false);
                                    setValorAntecipacao('');
                                })
                                .catch(err => {
                                    console.error('Erro ao enviar:', err);
                                    const errorMsg = err.response?.data?.error || err.response?.data?.message || err.message || 'Erro desconhecido';
                                    toast.error('Erro ao enviar solicitação: ' + errorMsg);
                                })
                                .finally(() => {
                                    setLoadingNF(false);
                                });
                        };

                        // Retorna os botões
                        const semDestinatarios = emailsDestinatarios.length === 0;
                        return (
                            <>
                                {semDestinatarios && (
                                    <div style={{
                                        width: '100%',
                                        padding: '10px',
                                        backgroundColor: '#fff3cd',
                                        color: '#856404',
                                        borderRadius: '6px',
                                        fontSize: '14px',
                                        marginBottom: '12px',
                                        border: '1px solid #ffeaa7'
                                    }}>
                                        ⚠️ Adicione pelo menos um email de destinatário para enviar a solicitação
                                    </div>
                                )}
                                <button
                                    type="button"
                                    onClick={() => {
                                        if (semDestinatarios) {
                                            toast.warning('Adicione pelo menos um email de destinatário');
                                            return;
                                        }
                                        enviarSolicitacao(true);
                                    }}
                                    style={{
                                        backgroundColor: (loadingNF || semDestinatarios) ? '#ccc' : '#4a90e2',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '6px',
                                        padding: '10px 24px',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        cursor: (loadingNF || semDestinatarios) ? 'not-allowed' : 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        opacity: (loadingNF || semDestinatarios) ? 0.6 : 1
                                    }}
                                    disabled={semDestinatarios || loadingNF}
                                >
                                    {loadingNF ? <FaCircleNotch style={{ animation: "spin 1s linear infinite" }} /> : '🔄'} Reenviar NF
                                </button>

                                <button
                                    type="button"
                                    onClick={() => {
                                        if (semDestinatarios) {
                                            toast.warning('Adicione pelo menos um email de destinatário');
                                            return;
                                        }
                                        enviarSolicitacao(false);
                                    }}
                                    style={{
                                        backgroundColor: (loadingNF || semDestinatarios) ? '#ccc' : '#ff6b35',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '6px',
                                        padding: '10px 24px',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        cursor: (loadingNF || semDestinatarios) ? 'not-allowed' : 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        opacity: (loadingNF || semDestinatarios) ? 0.6 : 1
                                    }}
                                    disabled={semDestinatarios || loadingNF}
                                >
                                    {loadingNF ? <FaCircleNotch style={{ animation: "spin 1s linear infinite" }} /> : '📤'} Solicitar NF
                                </button>
                            </>
                        );
                    })()}
                </div>
                    </div>
                </div>
            </div>
        )}

            {/* Modal de Estornos por subitem (Épico 1 financeiro — 22/05/2026) */}
            {showModalEstornos && (
            <div className="modal fade show d-block fin-pp fin-pp__modalbg">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content fin-pp__modal">
                <div className="fin-pp__modal-head" style={{ background: '#fce4ec' }}>
                    <h3 className="fin-pp__modal-title" style={{ color: '#880e4f' }}>
                        🔄 Estornos / Devoluções
                        {subitemEstornoAtual?.descricao && (
                            <small className="d-block text-muted" style={{ fontSize: '0.85rem' }}>
                                Item: {subitemEstornoAtual.descricao}
                            </small>
                        )}
                    </h3>
                    <button type="button" className="fin-pp__modal-close" onClick={() => fecharModalEstornos()}><FaTimes size={16} /></button>
                </div>
                <div className="modal-body">
                    {/* Form de novo estorno */}
                    <div className="card mb-3" style={{ borderColor: '#c2185b' }}>
                        <div className="card-body" style={{ background: '#fff8f9' }}>
                            <h6 style={{ color: '#880e4f' }}>
                                <FaPlus style={{ marginRight: 4 }} /> Registrar novo estorno
                            </h6>
                            <div className="row mt-2">
                                <div className="col-sm-3">
                                    <label className="small font-weight-bold mb-1">Valor (R$)</label>
                                    <CampoValor
                                        className="form-control"
                                        value={novoEstorno.valor}
                                        onValueChange={(values) => setNovoEstorno({ ...novoEstorno, valor: values.value })}
                                        moeda="real"
                                        decimalScale={2}
                                        fixedDecimalScale={false}
                                        allowNegative={false}
                                        placeholder="0,00"
                                    />
                                </div>
                                <div className="col-sm-3">
                                    <label className="small font-weight-bold mb-1">Data</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={novoEstorno.data_estorno}
                                        onChange={(e) => setNovoEstorno({ ...novoEstorno, data_estorno: e.target.value })}
                                    />
                                </div>
                                <div className="col-sm-6">
                                    <label className="small font-weight-bold mb-1">Tipo</label>
                                    <select
                                        className="form-control"
                                        value={novoEstorno.tipo}
                                        onChange={(e) => setNovoEstorno({ ...novoEstorno, tipo: e.target.value })}
                                    >
                                        <option value="duplicidade">Pagamento em duplicidade</option>
                                        <option value="devolucao_fornecedor">Devolução pelo fornecedor</option>
                                        <option value="ajuste">Ajuste de valor</option>
                                        <option value="outros">Outros</option>
                                    </select>
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-sm-12">
                                    <label className="small font-weight-bold mb-1">Justificativa *</label>
                                    <textarea
                                        className="form-control"
                                        rows="2"
                                        value={novoEstorno.justificativa}
                                        onChange={(e) => setNovoEstorno({ ...novoEstorno, justificativa: e.target.value })}
                                        placeholder="Descreva o motivo do estorno — ex.: NF cancelada pelo fornecedor por erro no valor"
                                    />
                                </div>
                            </div>
                            <div className="text-right mt-3">
                                <button type="button" className="fin-pp__btn fin-pp__btn--danger" onClick={salvarEstorno} style={{ background: '#c2185b', borderColor: '#c2185b' }}>
                                    <FaSave style={{ marginRight: 6 }} /> Registrar estorno
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Histórico de estornos */}
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6 className="mb-0" style={{ color: '#880e4f' }}>
                            Histórico ({estornosCarregados.length})
                        </h6>
                        {totalEstornado > 0 && (
                            <span style={{
                                background: '#c2185b', color: '#fff',
                                padding: '0.3rem 0.8rem', borderRadius: 20,
                                fontWeight: 700, fontSize: '0.9rem',
                            }}>
                                Total estornado: R$ {totalEstornado.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </span>
                        )}
                    </div>

                    {carregandoEstornos && (
                        <div className="text-center py-3 text-muted">
                            <FaCircleNotch style={{ animation: "spin 1s linear infinite" }} /> Carregando estornos...
                        </div>
                    )}

                    {!carregandoEstornos && estornosCarregados.length === 0 && (
                        <div className="text-center py-4 text-muted" style={{ background: '#fafafa', borderRadius: 6 }}>
                            Nenhum estorno registrado para este item.
                        </div>
                    )}

                    {!carregandoEstornos && estornosCarregados.map((estorno) => {
                        const tipoLabels = {
                            duplicidade: 'Duplicidade',
                            devolucao_fornecedor: 'Devolução fornecedor',
                            ajuste: 'Ajuste',
                            outros: 'Outros',
                        };
                        return (
                            <div
                                key={estorno.id}
                                className="d-flex justify-content-between align-items-start p-3 mb-2"
                                style={{
                                    background: '#fff',
                                    border: '1px solid #fce4ec',
                                    borderLeft: '3px solid #c2185b',
                                    borderRadius: 6,
                                }}
                            >
                                <div style={{ flex: 1 }}>
                                    <div className="d-flex align-items-center mb-1">
                                        <strong style={{ color: '#c2185b', fontSize: '1.05rem' }}>
                                            R$ {parseFloat(estorno.valor).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </strong>
                                        <span style={{
                                            background: '#c2185b', color: '#fff',
                                            fontSize: '0.7rem', fontWeight: 600,
                                            padding: '0.2rem 0.5rem', borderRadius: 4,
                                            marginLeft: 8, textTransform: 'uppercase',
                                        }}>
                                            {tipoLabels[estorno.tipo] || estorno.tipo}
                                        </span>
                                        <small className="text-muted ml-2">
                                            {estorno.data_estorno ? moment(estorno.data_estorno).format('DD/MM/YYYY') : '—'}
                                        </small>
                                    </div>
                                    <div className="small">{estorno.justificativa}</div>
                                    {estorno.registrado_por_user_nome && (
                                        <small className="text-muted" style={{ fontStyle: 'italic' }}>
                                            por {estorno.registrado_por_user_nome} em {estorno.created_at ? moment(estorno.created_at).format('DD/MM/YYYY HH:mm') : '—'}
                                        </small>
                                    )}
                                </div>
                                <button
                                    type="button"
                                    onClick={() => removerEstorno(estorno.id)}
                                    title="Remover estorno"
                                    style={{
                                        background: '#fff',
                                        border: '1px solid #dc3545',
                                        color: '#dc3545',
                                        borderRadius: 4,
                                        padding: '0.25rem 0.5rem',
                                        cursor: 'pointer',
                                    }}
                                    onMouseEnter={(e) => { e.currentTarget.style.background = '#dc3545'; e.currentTarget.style.color = '#fff'; }}
                                    onMouseLeave={(e) => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.color = '#dc3545'; }}
                                >
                                    <FaTrash />
                                </button>
                            </div>
                        );
                    })}
                </div>
                <div className="fin-pp__modal-foot">
                    <button type="button" className="fin-pp__btn" onClick={fecharModalEstornos}>Fechar</button>
                </div>
                    </div>
                </div>
            </div>
        )}

            {/* Modal de Vínculo Aéreo (Épico 1 financeiro — 22/05/2026) */}
            {showModalAereo && (
            <div className="modal fade show d-block fin-pp fin-pp__modalbg">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content fin-pp__modal">
                <div className="fin-pp__modal-head" style={{ background: '#e1f5fe' }}>
                    <h3 className="fin-pp__modal-title" style={{ color: '#01579b' }}>
                        ✈ Vincular despesa aérea
                        {subitemAereoAtual?.descricao && (
                            <small className="d-block text-muted" style={{ fontSize: '0.85rem' }}>
                                Item: {subitemAereoAtual.descricao}
                            </small>
                        )}
                    </h3>
                    <button type="button" className="fin-pp__modal-close" onClick={() => fecharModalAereo()}><FaTimes size={16} /></button>
                </div>
                <div className="modal-body">
                    <p className="text-muted small mb-3">
                        Selecione abaixo um aéreo do evento para vincular a este item orçamentário.
                        O vínculo só é gravado depois de salvar o orçamento.
                    </p>
                    <div className="alert alert-light small py-2 mb-3" style={{ background: '#f0f9ff', border: '1px solid #bae6fd' }}>
                        ℹ️ A lista mostra apenas aéreos cadastrados no nível do evento (não os de participantes específicos).
                    </div>

                    {subitemAereoAtual?.currentAereoId && (
                        <div className="alert alert-info d-flex justify-content-between align-items-center mb-3">
                            <div>
                                <strong>Atualmente vinculado:</strong> aéreo #{subitemAereoAtual.currentAereoId}
                            </div>
                            <button type="button" className="fin-pp__btn fin-pp__btn--danger-ghost fin-pp__btn--sm" onClick={desvincularAereoDoSubitem}>
                                <FaTimes style={{ marginRight: 4 }} /> Desvincular
                            </button>
                        </div>
                    )}

                    {carregandoAereos && (
                        <div className="text-center py-3 text-muted">
                            <FaCircleNotch style={{ animation: "spin 1s linear infinite" }} /> Carregando aéreos do evento...
                        </div>
                    )}

                    {!carregandoAereos && aereosDoEvento.length === 0 && (
                        <div className="text-center py-4 text-muted" style={{ background: '#fafafa', borderRadius: 6 }}>
                            Nenhum aéreo cadastrado neste evento.
                        </div>
                    )}

                    {!carregandoAereos && aereosDoEvento.map((aereo) => {
                        const selecionado = subitemAereoAtual?.currentAereoId === aereo.id;
                        return (
                            <div
                                key={aereo.id}
                                onClick={() => selecionarAereoParaSubitem(aereo)}
                                style={{
                                    background: selecionado ? '#b3e5fc' : '#fff',
                                    border: '1px solid ' + (selecionado ? '#01579b' : '#e1f5fe'),
                                    borderLeft: '3px solid #01579b',
                                    borderRadius: 6,
                                    padding: '12px 16px',
                                    marginBottom: 8,
                                    cursor: 'pointer',
                                    transition: 'all 0.15s',
                                }}
                                onMouseEnter={(e) => { if (!selecionado) e.currentTarget.style.background = '#f0f9ff'; }}
                                onMouseLeave={(e) => { if (!selecionado) e.currentTarget.style.background = '#fff'; }}
                            >
                                <div style={{ fontWeight: 700, color: '#01579b' }}>
                                    {aereo.codigo || ('Aéreo #' + aereo.id)}
                                </div>
                                <div className="small mt-1">
                                    {aereo.idaorigem && aereo.idadestino && (
                                        <span>
                                            <strong>Ida:</strong> {aereo.idaorigem} → {aereo.idadestino}
                                            {aereo.idadata && <> em {moment(aereo.idadata).format('DD/MM/YYYY')}</>}
                                            {aereo.idacompanhia && <> · {aereo.idacompanhia} {aereo.idavoo}</>}
                                        </span>
                                    )}
                                </div>
                                {aereo.retornoorigem && aereo.retornodestino && (
                                    <div className="small">
                                        <strong>Volta:</strong> {aereo.retornoorigem} → {aereo.retornodestino}
                                        {aereo.retornodata && <> em {moment(aereo.retornodata).format('DD/MM/YYYY')}</>}
                                        {aereo.retornocompanhia && <> · {aereo.retornocompanhia} {aereo.retornovoo}</>}
                                    </div>
                                )}
                                {aereo.participante && (
                                    <small className="text-muted">Participante #{aereo.participante}</small>
                                )}
                            </div>
                        );
                    })}
                </div>
                <div className="fin-pp__modal-foot">
                    <button type="button" className="fin-pp__btn" onClick={fecharModalAereo}>Cancelar</button>
                </div>
                    </div>
                </div>
            </div>
        )}

            {/* Modal de Adiantamento por item (Épico 2 — 22/05/2026) */}
            {showModalAdiantamento && (
            <div className="modal fade show d-block fin-pp fin-pp__modalbg">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content fin-pp__modal">
                <div className="fin-pp__modal-head" style={{ background: '#fff3e0' }}>
                    <h3 className="fin-pp__modal-title" style={{ color: '#bf360c' }}>
                        💰 Adiantamentos do item
                        {subitemAdiantamentoAtual?.descricao && (
                            <small className="d-block text-muted" style={{ fontSize: '0.85rem' }}>
                                Item: {subitemAdiantamentoAtual.descricao}
                                {subitemAdiantamentoAtual.valorTotal > 0 && (
                                    <> · Valor: R$ {subitemAdiantamentoAtual.valorTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</>
                                )}
                            </small>
                        )}
                    </h3>
                    <button type="button" className="fin-pp__modal-close" onClick={() => fecharModalAdiantamento()}><FaTimes size={16} /></button>
                </div>
                <div className="modal-body">
                    <p className="text-muted small mb-3">
                        Vincule recibos de adiantamento do orçamento a este item, com valor parcial. Um recibo pode ser distribuído entre múltiplos itens.
                    </p>

                    {carregandoAdiantamento && (
                        <div className="text-center py-3 text-muted">
                            <FaCircleNotch style={{ animation: "spin 1s linear infinite" }} /> Carregando...
                        </div>
                    )}

                    {!carregandoAdiantamento && (
                        <>
                            {/* Form de nova distribuição */}
                            <div className="card mb-3" style={{ borderColor: '#fb8c00' }}>
                                <div className="card-body" style={{ background: '#fff8f0' }}>
                                    <h6 style={{ color: '#bf360c' }}>
                                        <FaPlus style={{ marginRight: 4 }} /> Vincular recibo a este item
                                    </h6>
                                    {recibosDisponiveis.length === 0 && (
                                        <div className="alert alert-warning small mb-0">
                                            <strong>⚠ Nenhum recibo de adiantamento cadastrado neste orçamento.</strong>
                                            <div className="mt-2">
                                                <strong>Como cadastrar:</strong>
                                                <ol className="mb-0 pl-3">
                                                    <li>Vá em <strong>/orcamento</strong> (Painel de Orçamentos)</li>
                                                    <li>Localize este orçamento na lista</li>
                                                    <li>Clique no botão <strong>⋮ (três pontos verticais)</strong> no final da linha</li>
                                                    <li>No menu, clique em <strong>"Solicitar Adiantamento"</strong> (ícone 💰)</li>
                                                    <li>Na aba <strong>"Enviar Recibos"</strong>, faça upload do PDF + valor + observação</li>
                                                </ol>
                                                <div className="mt-2">Depois volte aqui e o recibo aparecerá no select acima para você distribuí-lo entre itens.</div>
                                            </div>
                                        </div>
                                    )}
                                    {recibosDisponiveis.length > 0 && (
                                        <>
                                            {(() => {
                                                // Épico 2 Quick Win 2.3 — Validação de overflow no front
                                                const reciboSel = recibosDisponiveis.find((r) => String(r.id) === String(novaDistribuicao.orcamento_recibo_adiantamento_id));
                                                const valorDigitado = paraNumero(novaDistribuicao.valor ?? '0') || 0;
                                                const saldoRecibo = reciboSel ? reciboSel.saldo_disponivel : null;
                                                const overflow = reciboSel && valorDigitado > saldoRecibo + 0.001;
                                                return (
                                                    <>
                                                        <div className="row mt-2">
                                                            <div className="col-sm-8">
                                                                <label className="small font-weight-bold mb-1">Recibo</label>
                                                                <select
                                                                    className="form-control"
                                                                    value={novaDistribuicao.orcamento_recibo_adiantamento_id}
                                                                    onChange={(e) => setNovaDistribuicao({ ...novaDistribuicao, orcamento_recibo_adiantamento_id: e.target.value })}
                                                                >
                                                                    <option value="">— selecione um recibo —</option>
                                                                    {recibosDisponiveis.map((r) => (
                                                                        <option key={r.id} value={r.id} disabled={r.saldo_disponivel <= 0}>
                                                                            Recibo #{r.id} · Valor R$ {r.valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                                                                            · Saldo R$ {r.saldo_disponivel.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                                                                            {r.observacao ? ' · ' + r.observacao : ''}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                                {reciboSel && (
                                                                    <small className="text-muted">
                                                                        Saldo disponível: R$ {saldoRecibo.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                                                                    </small>
                                                                )}
                                                            </div>
                                                            <div className="col-sm-4">
                                                                <label className="small font-weight-bold mb-1">Valor distribuído</label>
                                                                <CampoValor
                                                                    className={'form-control' + (overflow ? ' is-invalid' : '')}
                                                                    value={novaDistribuicao.valor}
                                                                    onValueChange={(values) => setNovaDistribuicao({ ...novaDistribuicao, valor: values.value })}
                                                                    moeda="real"
                                                                    decimalScale={2}
                                                                    fixedDecimalScale={false}
                                                                    allowNegative={false}
                                                                    placeholder="0,00"
                                                                    style={overflow ? { borderColor: '#dc3545', borderWidth: 2 } : {}}
                                                                />
                                                                {overflow && (
                                                                    <small className="text-danger" style={{ fontWeight: 600 }}>
                                                                        ⚠ Valor excede saldo do recibo (R$ {saldoRecibo.toLocaleString('pt-BR', { minimumFractionDigits: 2 })})
                                                                    </small>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </>
                                                );
                                            })()}
                                            <div className="row mt-2">
                                                <div className="col-sm-12">
                                                    <label className="small font-weight-bold mb-1">Observação (opcional)</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={novaDistribuicao.observacao}
                                                        onChange={(e) => setNovaDistribuicao({ ...novaDistribuicao, observacao: e.target.value })}
                                                        placeholder="ex.: parcela 1 de 2"
                                                    />
                                                </div>
                                            </div>
                                            <div className="text-right mt-3">
                                                <button type="button" className="fin-pp__btn fin-pp__btn--primary" onClick={salvarDistribuicao} style={{ background: '#fb8c00', borderColor: '#fb8c00' }}>
                                                    <FaSave style={{ marginRight: 4 }} /> Vincular adiantamento
                                                </button>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>

                            {/* Lista de distribuições atuais */}
                            <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
                                <h6 className="mb-0" style={{ color: '#bf360c' }}>
                                    Distribuições neste item ({distribuicoesItem.length})
                                </h6>
                                <div className="d-flex align-items-center" style={{ gap: 8 }}>
                                    {totalDistribuicoesItem > 0 && (
                                        <span style={{
                                            background: '#fb8c00', color: '#fff',
                                            padding: '0.3rem 0.8rem', borderRadius: 20,
                                            fontWeight: 700, fontSize: '0.9rem',
                                        }}>
                                            Total adiantado: R$ {totalDistribuicoesItem.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                                        </span>
                                    )}
                                    {/* Épico 2 Quick Win 2.4 — % cobertura do item */}
                                    {totalDistribuicoesItem > 0 && subitemAdiantamentoAtual?.valorTotal > 0 && (() => {
                                        const percentual = (totalDistribuicoesItem / subitemAdiantamentoAtual.valorTotal) * 100;
                                        const corBadge = percentual >= 100 ? '#2e7d32' : (percentual >= 50 ? '#f57c00' : '#c62828');
                                        return (
                                            <span style={{
                                                background: corBadge, color: '#fff',
                                                padding: '0.3rem 0.8rem', borderRadius: 20,
                                                fontWeight: 700, fontSize: '0.9rem',
                                            }} title={`R$ ${totalDistribuicoesItem.toLocaleString('pt-BR', { minimumFractionDigits: 2 })} de R$ ${subitemAdiantamentoAtual.valorTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`}>
                                                {percentual.toFixed(1)}% coberto
                                            </span>
                                        );
                                    })()}
                                </div>
                            </div>

                            {distribuicoesItem.length === 0 && (
                                <div className="text-center py-4 text-muted" style={{ background: '#fafafa', borderRadius: 6 }}>
                                    Nenhum adiantamento vinculado a este item ainda.
                                </div>
                            )}

                            {distribuicoesItem.map((d) => {
                                const valorNumerico = parseFloat(d?.valor) || 0;
                                const arquivoId = d?.recibo?.arquivo_id;
                                const arquivoNome = d?.recibo?.arquivo_nome;
                                const conciliado = !!d.nota_fiscal_id; // Épico 2.1/3.1
                                return (
                                <div
                                    key={d.id}
                                    className="d-flex justify-content-between align-items-start p-3 mb-2"
                                    style={{
                                        background: conciliado ? '#f1f8e9' : '#fff',
                                        border: `1px solid ${conciliado ? '#a5d6a7' : '#ffcc80'}`,
                                        borderLeft: `3px solid ${conciliado ? '#43a047' : '#fb8c00'}`,
                                        borderRadius: 6,
                                    }}
                                >
                                    <div style={{ flex: 1 }}>
                                        <div className="d-flex align-items-center flex-wrap mb-1" style={{ gap: 6 }}>
                                            <strong style={{ color: conciliado ? '#2e7d32' : '#fb8c00', fontSize: '1.05rem' }}>
                                                R$ {valorNumerico.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                                            </strong>
                                            {/* Badge de conciliação */}
                                            {conciliado && (
                                                <a
                                                    href={'/cadastroNotaFiscal/' + d.nota_fiscal_id}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{
                                                        background: '#e8f5e9', color: '#2e7d32',
                                                        border: '1px solid #a5d6a7', borderRadius: 12,
                                                        fontSize: 11, padding: '1px 8px',
                                                        textDecoration: 'none', fontWeight: 600,
                                                    }}
                                                    title="Clique para ver a Nota Fiscal"
                                                >
                                                    🧾 Conciliado com NF
                                                </a>
                                            )}
                                            <small className="text-muted">
                                                recibo #{d.orcamento_recibo_adiantamento_id}
                                                {arquivoId && (
                                                    <>
                                                        {' · '}
                                                        <a
                                                            href={process.env.REACT_APP_API_URL + '/arquivo/download/' + arquivoId}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ color: '#fb8c00' }}
                                                            title={arquivoNome || ''}
                                                        >
                                                            📎 baixar{arquivoNome ? ' ' + arquivoNome : ''}
                                                        </a>
                                                    </>
                                                )}
                                            </small>
                                        </div>
                                        {d.observacao && <div className="small">{d.observacao}</div>}
                                        {d.created_at && (
                                            <small className="text-muted" style={{ fontStyle: 'italic' }}>
                                                vinculado em {moment(d.created_at).format('DD/MM/YYYY HH:mm')}
                                            </small>
                                        )}
                                    </div>
                                    <button
                                        type="button"
                                        onClick={() => removerDistribuicao(d.id)}
                                        title={conciliado ? 'Distribuição conciliada com NF — excluir NF primeiro para liberar' : 'Remover distribuição'}
                                        disabled={conciliado}
                                        style={{
                                            background: conciliado ? '#f5f5f5' : '#fff',
                                            border: `1px solid ${conciliado ? '#bdbdbd' : '#dc3545'}`,
                                            color: conciliado ? '#bdbdbd' : '#dc3545',
                                            borderRadius: 4, padding: '0.25rem 0.5rem',
                                            cursor: conciliado ? 'not-allowed' : 'pointer',
                                        }}
                                        onMouseEnter={(e) => { if (!conciliado) { e.currentTarget.style.background = '#dc3545'; e.currentTarget.style.color = '#fff'; } }}
                                        onMouseLeave={(e) => { if (!conciliado) { e.currentTarget.style.background = '#fff'; e.currentTarget.style.color = '#dc3545'; } }}
                                    >
                                        <FaTrash />
                                    </button>
                                </div>
                                );
                            })}

                            {/* ─── Épico 2.1 — Notas Fiscais vinculadas ao item ─── */}
                            <div className="mt-4 pt-3" style={{ borderTop: '1px solid #e0e0e0' }}>
                                <h6 className="mb-2" style={{ color: '#1a237e' }}>
                                    🧾 Notas Fiscais vinculadas
                                    {nfsDoItem.length > 0 && (
                                        <span style={{
                                            background: '#1a237e', color: '#fff',
                                            borderRadius: 20, fontSize: '0.75rem',
                                            padding: '0.1rem 0.5rem', marginLeft: 6,
                                        }}>{nfsDoItem.length}</span>
                                    )}
                                </h6>
                                {carregandoNfsItem && (
                                    <div className="text-muted small py-2">
                                        <FaCircleNotch style={{ animation: "spin 1s linear infinite", marginRight: 4 }} /> Carregando notas fiscais...
                                    </div>
                                )}
                                {!carregandoNfsItem && nfsDoItem.length === 0 && (
                                    <div className="text-muted small py-2" style={{
                                        background: '#f5f5f5', borderRadius: 6, padding: '0.75rem 1rem',
                                    }}>
                                        Nenhuma nota fiscal vinculada a este item ainda.
                                    </div>
                                )}
                                {!carregandoNfsItem && nfsDoItem.length > 0 && nfsDoItem.map((nf) => {
                                    const s = nf.status;
                                    const aprovada = s === 'aprovada' || s === 'validado';
                                    const recusada = s === 'recusada' || s === 'rejeitado';
                                    const recebida = s === 'recebida' || s === 'processado';
                                    const revisao  = s === 'em_revisao';
                                    const badgeLabel = aprovada ? '✅ Aprovada'
                                        : recusada ? '❌ Recusada'
                                        : recebida ? '📬 Recebida'
                                        : revisao  ? '🔍 Em revisão'
                                        : '⏳ Pendente';
                                    const badgeColor = aprovada ? '#2e7d32'
                                        : recusada ? '#b71c1c'
                                        : recebida ? '#1565c0'
                                        : revisao  ? '#e65100'
                                        : '#616161';
                                    return (
                                        <div key={nf.id} className="p-3 mb-2" style={{
                                            background: '#fff',
                                            border: '1px solid #c5cae9',
                                            borderLeft: '3px solid #3949ab',
                                            borderRadius: 6,
                                        }}>
                                            <div className="d-flex justify-content-between align-items-start">
                                                <div>
                                                    <div className="d-flex align-items-center flex-wrap mb-1" style={{ gap: 6 }}>
                                                        <strong style={{ color: '#3949ab' }}>
                                                            {nf.numero ? 'NF nº ' + nf.numero : 'NF sem número'}
                                                            {nf.serie ? ' / Série ' + nf.serie : ''}
                                                        </strong>
                                                        <span style={{
                                                            background: badgeColor, color: '#fff',
                                                            borderRadius: 20, fontSize: '0.72rem',
                                                            padding: '0.1rem 0.5rem', fontWeight: 600,
                                                        }}>{badgeLabel}</span>
                                                    </div>
                                                    {nf.fornecedor_nome && (
                                                        <div className="small text-muted mb-1">
                                                            Fornecedor: {nf.fornecedor_nome}
                                                        </div>
                                                    )}
                                                    <div className="small" style={{ color: '#333' }}>
                                                        <span className="mr-3">
                                                            Valor bruto: <strong>R$ {(nf.valor_bruto || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</strong>
                                                        </span>
                                                        {nf.valor_retencoes > 0 && (
                                                            <span className="mr-3 text-muted">
                                                                Retenções: R$ {nf.valor_retencoes.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                                                            </span>
                                                        )}
                                                        {nf.valor_liquido > 0 && nf.valor_liquido !== nf.valor_bruto && (
                                                            <span>
                                                                Líquido: <strong>R$ {nf.valor_liquido.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</strong>
                                                            </span>
                                                        )}
                                                    </div>
                                                    {nf.data_emissao && (
                                                        <small className="text-muted">
                                                            Emissão: {moment(nf.data_emissao).format('DD/MM/YYYY')}
                                                        </small>
                                                    )}
                                                </div>
                                                <a
                                                    href={'/cadastroNotaFiscal/' + nf.id}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{
                                                        color: '#3949ab', border: '1px solid #3949ab',
                                                        borderRadius: 4, padding: '0.2rem 0.5rem',
                                                        fontSize: '0.8rem', whiteSpace: 'nowrap', textDecoration: 'none',
                                                    }}
                                                >
                                                    🔗 Ver NF
                                                </a>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </>
                    )}
                </div>
                <div className="fin-pp__modal-foot">
                    <button type="button" className="fin-pp__btn" onClick={fecharModalAdiantamento}>Fechar</button>
                </div>
                    </div>
                </div>
            </div>
        )}

            {/* ─── Modal Forma de Pagamento do Item (pagamento regular — NÃO é adiantamento) ─── */}
            {showModalFormaPgtoPagamento && (
            <div className="modal fade show d-block fin-pp fin-pp__modalbg">
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content fin-pp__modal">
                <div className="fin-pp__modal-head" style={{ background: '#f1f8e9', borderBottom: '2px solid #388e3c' }}>
                    <h3 className="fin-pp__modal-title" style={{ color: '#2e7d32' }}>
                        💳 Forma de Pagamento — Item
                        {subitemFormaPgtoPagamentoAtual?.descricao && (
                            <small className="d-block text-muted" style={{ fontSize: '0.82rem' }}>
                                {subitemFormaPgtoPagamentoAtual.descricao}
                            </small>
                        )}
                    </h3>
                    <button type="button" className="fin-pp__modal-close" onClick={() => fecharModalFormaPgtoPagamento()}><FaTimes size={16} /></button>
                </div>
                <div className="modal-body">
                    <>
                        <div className="form-group mb-3">
                            <label className="font-weight-bold small mb-1">Forma de pagamento <span className="text-danger">*</span></label>
                            <select className="form-control" value={formaPgtoPagamentoAtual.forma}
                                onChange={(e) => setFormaPgtoPagamentoAtual({ ...formaPgtoPagamentoAtual, forma: e.target.value, dados_pagamento: {} })}>
                                <option value="">— selecione —</option>
                                <option value="pix">PIX</option>
                                <option value="cartao_credito">Cartão de Crédito</option>
                                <option value="cartao_debito">Cartão de Débito</option>
                                <option value="boleto">Boleto Bancário</option>
                                <option value="fatura">Fatura</option>
                                <option value="remessa">Remessa / TED / DOC</option>
                                <option value="link">Link de Pagamento</option>
                            </select>
                        </div>

                        {formaPgtoPagamentoAtual.forma === 'pix' && (
                            <div className="card p-3 mb-3" style={{ background: '#f0fdf4', border: '1px solid #a7f3d0' }}>
                                <h6 className="mb-3" style={{ color: '#065f46' }}>🟢 Dados do PIX</h6>
                                <div className="row">
                                    <div className="col-7 form-group mb-2">
                                        <label className="small font-weight-bold">Chave PIX</label>
                                        <input className="form-control form-control-sm" placeholder="CPF, CNPJ, e-mail, telefone ou chave aleatória"
                                            value={formaPgtoPagamentoAtual.dados_pagamento.chave || ''}
                                            onChange={(e) => setFormaPgtoPagamentoAtual({ ...formaPgtoPagamentoAtual, dados_pagamento: { ...formaPgtoPagamentoAtual.dados_pagamento, chave: e.target.value } })} />
                                    </div>
                                    <div className="col-5 form-group mb-2">
                                        <label className="small font-weight-bold">Tipo da chave</label>
                                        <select className="form-control form-control-sm" value={formaPgtoPagamentoAtual.dados_pagamento.tipo_chave || ''}
                                            onChange={(e) => setFormaPgtoPagamentoAtual({ ...formaPgtoPagamentoAtual, dados_pagamento: { ...formaPgtoPagamentoAtual.dados_pagamento, tipo_chave: e.target.value } })}>
                                            <option value="">—</option><option value="cpf">CPF</option><option value="cnpj">CNPJ</option>
                                            <option value="email">E-mail</option><option value="telefone">Telefone</option><option value="aleatoria">Chave aleatória</option>
                                        </select>
                                    </div>
                                    <div className="col-8 form-group mb-2">
                                        <label className="small font-weight-bold">Beneficiário</label>
                                        <input className="form-control form-control-sm" placeholder="Nome do favorecido"
                                            value={formaPgtoPagamentoAtual.dados_pagamento.beneficiario || ''}
                                            onChange={(e) => setFormaPgtoPagamentoAtual({ ...formaPgtoPagamentoAtual, dados_pagamento: { ...formaPgtoPagamentoAtual.dados_pagamento, beneficiario: e.target.value } })} />
                                    </div>
                                    <div className="col-4 form-group mb-0">
                                        <label className="small font-weight-bold">Banco (opcional)</label>
                                        <input className="form-control form-control-sm" placeholder="Ex.: Itaú"
                                            value={formaPgtoPagamentoAtual.dados_pagamento.banco || ''}
                                            onChange={(e) => setFormaPgtoPagamentoAtual({ ...formaPgtoPagamentoAtual, dados_pagamento: { ...formaPgtoPagamentoAtual.dados_pagamento, banco: e.target.value } })} />
                                    </div>
                                </div>
                            </div>
                        )}
                        {(formaPgtoPagamentoAtual.forma === 'cartao_credito' || formaPgtoPagamentoAtual.forma === 'cartao_debito') && (
                            <div className="card p-3 mb-3" style={{ background: '#eff6ff', border: '1px solid #bfdbfe' }}>
                                <h6 className="mb-3" style={{ color: '#1e40af' }}>{formaPgtoPagamentoAtual.forma === 'cartao_credito' ? '💳 Cartão de Crédito' : '💳 Cartão de Débito'}</h6>
                                <div className="row">
                                    <div className="col-4 form-group mb-2"><label className="small font-weight-bold">Últimos 4 dígitos</label>
                                        <input className="form-control form-control-sm" placeholder="0000" maxLength={4} value={formaPgtoPagamentoAtual.dados_pagamento.ultimos4 || ''}
                                            onChange={(e) => setFormaPgtoPagamentoAtual({ ...formaPgtoPagamentoAtual, dados_pagamento: { ...formaPgtoPagamentoAtual.dados_pagamento, ultimos4: e.target.value.replace(/\D/g, '') } })} /></div>
                                    <div className="col-4 form-group mb-2"><label className="small font-weight-bold">Bandeira</label>
                                        <select className="form-control form-control-sm" value={formaPgtoPagamentoAtual.dados_pagamento.bandeira || ''}
                                            onChange={(e) => setFormaPgtoPagamentoAtual({ ...formaPgtoPagamentoAtual, dados_pagamento: { ...formaPgtoPagamentoAtual.dados_pagamento, bandeira: e.target.value } })}>
                                            <option value="">—</option><option value="visa">Visa</option><option value="mastercard">Mastercard</option>
                                            <option value="elo">Elo</option><option value="amex">Amex</option><option value="hipercard">Hipercard</option><option value="outro">Outro</option>
                                        </select></div>
                                    <div className="col-4 form-group mb-2"><label className="small font-weight-bold">Titular</label>
                                        <input className="form-control form-control-sm" placeholder="Nome no cartão" value={formaPgtoPagamentoAtual.dados_pagamento.titular || ''}
                                            onChange={(e) => setFormaPgtoPagamentoAtual({ ...formaPgtoPagamentoAtual, dados_pagamento: { ...formaPgtoPagamentoAtual.dados_pagamento, titular: e.target.value } })} /></div>
                                    <div className="col-12 form-group mb-0"><label className="small font-weight-bold">Link de pagamento (opcional)</label>
                                        <input className="form-control form-control-sm" placeholder="https://..." value={formaPgtoPagamentoAtual.dados_pagamento.link_pagamento || ''}
                                            onChange={(e) => setFormaPgtoPagamentoAtual({ ...formaPgtoPagamentoAtual, dados_pagamento: { ...formaPgtoPagamentoAtual.dados_pagamento, link_pagamento: e.target.value } })} /></div>
                                </div>
                            </div>
                        )}
                        {formaPgtoPagamentoAtual.forma === 'boleto' && (
                            <div className="card p-3 mb-3" style={{ background: '#fffbeb', border: '1px solid #fde68a' }}>
                                <h6 className="mb-3" style={{ color: '#78350f' }}>🧾 Dados do Boleto</h6>
                                <div className="row">
                                    <div className="col-5 form-group mb-2"><label className="small font-weight-bold">Banco</label>
                                        <input className="form-control form-control-sm" value={formaPgtoPagamentoAtual.dados_pagamento.banco || ''}
                                            onChange={(e) => setFormaPgtoPagamentoAtual({ ...formaPgtoPagamentoAtual, dados_pagamento: { ...formaPgtoPagamentoAtual.dados_pagamento, banco: e.target.value } })} /></div>
                                    <div className="col-3 form-group mb-2"><label className="small font-weight-bold">Agência</label>
                                        <input className="form-control form-control-sm" value={formaPgtoPagamentoAtual.dados_pagamento.agencia || ''}
                                            onChange={(e) => setFormaPgtoPagamentoAtual({ ...formaPgtoPagamentoAtual, dados_pagamento: { ...formaPgtoPagamentoAtual.dados_pagamento, agencia: e.target.value } })} /></div>
                                    <div className="col-4 form-group mb-2"><label className="small font-weight-bold">Conta</label>
                                        <input className="form-control form-control-sm" value={formaPgtoPagamentoAtual.dados_pagamento.conta || ''}
                                            onChange={(e) => setFormaPgtoPagamentoAtual({ ...formaPgtoPagamentoAtual, dados_pagamento: { ...formaPgtoPagamentoAtual.dados_pagamento, conta: e.target.value } })} /></div>
                                    <div className="col-8 form-group mb-2"><label className="small font-weight-bold">Favorecido</label>
                                        <input className="form-control form-control-sm" value={formaPgtoPagamentoAtual.dados_pagamento.favorecido || ''}
                                            onChange={(e) => setFormaPgtoPagamentoAtual({ ...formaPgtoPagamentoAtual, dados_pagamento: { ...formaPgtoPagamentoAtual.dados_pagamento, favorecido: e.target.value } })} /></div>
                                    <div className="col-4 form-group mb-2"><label className="small font-weight-bold">CPF / CNPJ</label>
                                        <input className="form-control form-control-sm" value={formaPgtoPagamentoAtual.dados_pagamento.cpf_cnpj || ''}
                                            onChange={(e) => setFormaPgtoPagamentoAtual({ ...formaPgtoPagamentoAtual, dados_pagamento: { ...formaPgtoPagamentoAtual.dados_pagamento, cpf_cnpj: e.target.value } })} /></div>
                                    <div className="col-12 form-group mb-0"><label className="small font-weight-bold">Linha digitável (opcional)</label>
                                        <input className="form-control form-control-sm" value={formaPgtoPagamentoAtual.dados_pagamento.linha_digitavel || ''}
                                            onChange={(e) => setFormaPgtoPagamentoAtual({ ...formaPgtoPagamentoAtual, dados_pagamento: { ...formaPgtoPagamentoAtual.dados_pagamento, linha_digitavel: e.target.value } })} /></div>
                                </div>
                            </div>
                        )}
                        {formaPgtoPagamentoAtual.forma === 'remessa' && (
                            <div className="card p-3 mb-3" style={{ background: '#faf5ff', border: '1px solid #e9d5ff' }}>
                                <h6 className="mb-3" style={{ color: '#4c1d95' }}>🏦 Dados para Remessa / TED / DOC</h6>
                                <div className="row">
                                    <div className="col-5 form-group mb-2"><label className="small font-weight-bold">Banco</label>
                                        <input className="form-control form-control-sm" value={formaPgtoPagamentoAtual.dados_pagamento.banco || ''}
                                            onChange={(e) => setFormaPgtoPagamentoAtual({ ...formaPgtoPagamentoAtual, dados_pagamento: { ...formaPgtoPagamentoAtual.dados_pagamento, banco: e.target.value } })} /></div>
                                    <div className="col-3 form-group mb-2"><label className="small font-weight-bold">Agência</label>
                                        <input className="form-control form-control-sm" value={formaPgtoPagamentoAtual.dados_pagamento.agencia || ''}
                                            onChange={(e) => setFormaPgtoPagamentoAtual({ ...formaPgtoPagamentoAtual, dados_pagamento: { ...formaPgtoPagamentoAtual.dados_pagamento, agencia: e.target.value } })} /></div>
                                    <div className="col-4 form-group mb-2"><label className="small font-weight-bold">Conta</label>
                                        <input className="form-control form-control-sm" value={formaPgtoPagamentoAtual.dados_pagamento.conta || ''}
                                            onChange={(e) => setFormaPgtoPagamentoAtual({ ...formaPgtoPagamentoAtual, dados_pagamento: { ...formaPgtoPagamentoAtual.dados_pagamento, conta: e.target.value } })} /></div>
                                    <div className="col-7 form-group mb-2"><label className="small font-weight-bold">Favorecido</label>
                                        <input className="form-control form-control-sm" value={formaPgtoPagamentoAtual.dados_pagamento.favorecido || ''}
                                            onChange={(e) => setFormaPgtoPagamentoAtual({ ...formaPgtoPagamentoAtual, dados_pagamento: { ...formaPgtoPagamentoAtual.dados_pagamento, favorecido: e.target.value } })} /></div>
                                    <div className="col-5 form-group mb-2"><label className="small font-weight-bold">CPF / CNPJ</label>
                                        <input className="form-control form-control-sm" value={formaPgtoPagamentoAtual.dados_pagamento.cpf_cnpj || ''}
                                            onChange={(e) => setFormaPgtoPagamentoAtual({ ...formaPgtoPagamentoAtual, dados_pagamento: { ...formaPgtoPagamentoAtual.dados_pagamento, cpf_cnpj: e.target.value } })} /></div>
                                    <div className="col-12 form-group mb-0"><label className="small font-weight-bold">SWIFT / BIC (internacional, opcional)</label>
                                        <input className="form-control form-control-sm" value={formaPgtoPagamentoAtual.dados_pagamento.swift || ''}
                                            onChange={(e) => setFormaPgtoPagamentoAtual({ ...formaPgtoPagamentoAtual, dados_pagamento: { ...formaPgtoPagamentoAtual.dados_pagamento, swift: e.target.value } })} /></div>
                                </div>
                            </div>
                        )}
                        {formaPgtoPagamentoAtual.forma === 'fatura' && (
                            <div className="card p-3 mb-3" style={{ background: '#f0f4ff', border: '1px solid #c7d2fe' }}>
                                <h6 className="mb-3" style={{ color: '#3730a3' }}>📋 Dados da Fatura</h6>
                                <div className="row">
                                    <div className="col-6 form-group mb-0"><label className="small font-weight-bold">Número da fatura</label>
                                        <input className="form-control form-control-sm" placeholder="Ex.: FAT-2026-001" value={formaPgtoPagamentoAtual.dados_pagamento.numero || ''}
                                            onChange={(e) => setFormaPgtoPagamentoAtual({ ...formaPgtoPagamentoAtual, dados_pagamento: { ...formaPgtoPagamentoAtual.dados_pagamento, numero: e.target.value } })} /></div>
                                    <div className="col-6 form-group mb-0"><label className="small font-weight-bold">Vencimento</label>
                                        <input type="date" className="form-control form-control-sm" value={formaPgtoPagamentoAtual.dados_pagamento.vencimento || ''}
                                            onChange={(e) => setFormaPgtoPagamentoAtual({ ...formaPgtoPagamentoAtual, dados_pagamento: { ...formaPgtoPagamentoAtual.dados_pagamento, vencimento: e.target.value } })} /></div>
                                </div>
                            </div>
                        )}
                        {formaPgtoPagamentoAtual.forma === 'link' && (
                            <div className="card p-3 mb-3" style={{ background: '#fff7ed', border: '1px solid #fed7aa' }}>
                                <h6 className="mb-3" style={{ color: '#c2410c' }}>🔗 Link de Pagamento</h6>
                                <div className="form-group mb-2"><label className="small font-weight-bold">URL do link</label>
                                    <input className="form-control form-control-sm" placeholder="https://..." value={formaPgtoPagamentoAtual.dados_pagamento.url || ''}
                                        onChange={(e) => setFormaPgtoPagamentoAtual({ ...formaPgtoPagamentoAtual, dados_pagamento: { ...formaPgtoPagamentoAtual.dados_pagamento, url: e.target.value } })} /></div>
                                <div className="form-group mb-0"><label className="small font-weight-bold">Descrição (opcional)</label>
                                    <input className="form-control form-control-sm" value={formaPgtoPagamentoAtual.dados_pagamento.descricao || ''}
                                        onChange={(e) => setFormaPgtoPagamentoAtual({ ...formaPgtoPagamentoAtual, dados_pagamento: { ...formaPgtoPagamentoAtual.dados_pagamento, descricao: e.target.value } })} /></div>
                            </div>
                        )}
                        {formaPgtoPagamentoAtual.forma && (
                            <div className="form-group mb-0">
                                <label className="small font-weight-bold">Observação (opcional)</label>
                                <textarea className="form-control form-control-sm" rows={2} placeholder="Informações adicionais sobre este pagamento..."
                                    value={formaPgtoPagamentoAtual.observacao || ''}
                                    onChange={(e) => setFormaPgtoPagamentoAtual({ ...formaPgtoPagamentoAtual, observacao: e.target.value })} />
                            </div>
                        )}
                    </>
                </div>
                <div className="fin-pp__modal-foot" style={{ justifyContent: "space-between" }}>
                    <div>
                        {formaPgtoPagamentoPorItem[subitemFormaPgtoPagamentoAtual?.id] && (
                            <button type="button" className="fin-pp__btn fin-pp__btn--danger-ghost fin-pp__btn--sm" onClick={removerFormaPgtoPagamento}>🗑 Remover</button>
                        )}
                    </div>
                    <div style={{ display: 'flex', gap: 8 }}>
                        <button type="button" className="fin-pp__btn" onClick={fecharModalFormaPgtoPagamento}>Cancelar</button>
                        <button type="button" className="fin-pp__btn fin-pp__btn--ok" onClick={salvarFormaPgtoPagamento}
                            disabled={salvandoFormaPgtoPagamento || !formaPgtoPagamentoAtual.forma}>
                            {salvandoFormaPgtoPagamento ? 'Salvando...' : '💾 Salvar'}
                        </button>
                    </div>
                </div>
                    </div>
                </div>
            </div>
        )}

            {/* ─── Épico 2 — Modal Forma de Pagamento do Adiantamento ─── */}
            {showModalFormaPgto && (
            <div className="modal fade show d-block fin-pp fin-pp__modalbg">
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content fin-pp__modal">
                <div className="fin-pp__modal-head" style={{ background: '#e3f2fd', borderBottom: '2px solid #1565c0' }}>
                    <h3 className="fin-pp__modal-title" style={{ color: '#1565c0' }}>
                        💳 Forma de Pagamento — Adiantamento
                        {subitemFormaPgtoAtual?.descricao && (
                            <small className="d-block text-muted" style={{ fontSize: '0.82rem' }}>
                                {subitemFormaPgtoAtual.descricao}
                            </small>
                        )}
                    </h3>
                    <button type="button" className="fin-pp__modal-close" onClick={() => fecharModalFormaPgto()}><FaTimes size={16} /></button>
                </div>
                <div className="modal-body">
                    {carregandoFormaPgto ? (
                        <div className="text-center py-4 text-muted">
                            <FaCircleNotch style={{ animation: "spin 1s linear infinite", marginRight: 4 }} /> Carregando...
                        </div>
                    ) : (
                        <>
                            {/* Seleção da forma */}
                            <div className="form-group mb-3">
                                <label className="font-weight-bold small mb-1">Forma de pagamento <span className="text-danger">*</span></label>
                                <select
                                    className="form-control"
                                    value={formaPgtoAtual.forma}
                                    onChange={(e) => setFormaPgtoAtual({ ...formaPgtoAtual, forma: e.target.value, dados_pagamento: {} })}
                                >
                                    <option value="">— selecione —</option>
                                    <option value="pix">PIX</option>
                                    <option value="cartao_credito">Cartão de Crédito</option>
                                    <option value="cartao_debito">Cartão de Débito</option>
                                    <option value="boleto">Boleto Bancário</option>
                                    <option value="fatura">Fatura</option>
                                    <option value="remessa">Remessa / TED / DOC</option>
                                    <option value="link">Link de Pagamento</option>
                                </select>
                            </div>

                            {/* Campos dinâmicos por forma */}
                            {formaPgtoAtual.forma === 'pix' && (
                                <div className="card p-3 mb-3" style={{ background: '#f0fdf4', border: '1px solid #a7f3d0' }}>
                                    <h6 className="mb-3" style={{ color: '#065f46' }}>🟢 Dados do PIX</h6>
                                    <div className="row">
                                        <div className="col-7 form-group mb-2">
                                            <label className="small font-weight-bold">Chave PIX</label>
                                            <input className="form-control form-control-sm" placeholder="CPF, CNPJ, e-mail, telefone ou chave aleatória"
                                                value={formaPgtoAtual.dados_pagamento.chave || ''}
                                                onChange={(e) => setFormaPgtoAtual({ ...formaPgtoAtual, dados_pagamento: { ...formaPgtoAtual.dados_pagamento, chave: e.target.value } })} />
                                        </div>
                                        <div className="col-5 form-group mb-2">
                                            <label className="small font-weight-bold">Tipo da chave</label>
                                            <select className="form-control form-control-sm"
                                                value={formaPgtoAtual.dados_pagamento.tipo_chave || ''}
                                                onChange={(e) => setFormaPgtoAtual({ ...formaPgtoAtual, dados_pagamento: { ...formaPgtoAtual.dados_pagamento, tipo_chave: e.target.value } })}>
                                                <option value="">—</option>
                                                <option value="cpf">CPF</option>
                                                <option value="cnpj">CNPJ</option>
                                                <option value="email">E-mail</option>
                                                <option value="telefone">Telefone</option>
                                                <option value="aleatoria">Chave aleatória</option>
                                            </select>
                                        </div>
                                        <div className="col-8 form-group mb-2">
                                            <label className="small font-weight-bold">Beneficiário</label>
                                            <input className="form-control form-control-sm" placeholder="Nome do favorecido"
                                                value={formaPgtoAtual.dados_pagamento.beneficiario || ''}
                                                onChange={(e) => setFormaPgtoAtual({ ...formaPgtoAtual, dados_pagamento: { ...formaPgtoAtual.dados_pagamento, beneficiario: e.target.value } })} />
                                        </div>
                                        <div className="col-4 form-group mb-0">
                                            <label className="small font-weight-bold">Banco (opcional)</label>
                                            <input className="form-control form-control-sm" placeholder="Ex.: Itaú"
                                                value={formaPgtoAtual.dados_pagamento.banco || ''}
                                                onChange={(e) => setFormaPgtoAtual({ ...formaPgtoAtual, dados_pagamento: { ...formaPgtoAtual.dados_pagamento, banco: e.target.value } })} />
                                        </div>
                                    </div>
                                </div>
                            )}

                            {(formaPgtoAtual.forma === 'cartao_credito' || formaPgtoAtual.forma === 'cartao_debito') && (
                                <div className="card p-3 mb-3" style={{ background: '#eff6ff', border: '1px solid #bfdbfe' }}>
                                    <h6 className="mb-3" style={{ color: '#1e40af' }}>
                                        {formaPgtoAtual.forma === 'cartao_credito' ? '💳 Cartão de Crédito' : '💳 Cartão de Débito'}
                                    </h6>
                                    <div className="row">
                                        <div className="col-4 form-group mb-2">
                                            <label className="small font-weight-bold">Últimos 4 dígitos</label>
                                            <input className="form-control form-control-sm" placeholder="0000" maxLength={4}
                                                value={formaPgtoAtual.dados_pagamento.ultimos4 || ''}
                                                onChange={(e) => setFormaPgtoAtual({ ...formaPgtoAtual, dados_pagamento: { ...formaPgtoAtual.dados_pagamento, ultimos4: e.target.value.replace(/\D/g, '') } })} />
                                        </div>
                                        <div className="col-4 form-group mb-2">
                                            <label className="small font-weight-bold">Bandeira</label>
                                            <select className="form-control form-control-sm"
                                                value={formaPgtoAtual.dados_pagamento.bandeira || ''}
                                                onChange={(e) => setFormaPgtoAtual({ ...formaPgtoAtual, dados_pagamento: { ...formaPgtoAtual.dados_pagamento, bandeira: e.target.value } })}>
                                                <option value="">—</option>
                                                <option value="visa">Visa</option>
                                                <option value="mastercard">Mastercard</option>
                                                <option value="elo">Elo</option>
                                                <option value="amex">Amex</option>
                                                <option value="hipercard">Hipercard</option>
                                                <option value="outro">Outro</option>
                                            </select>
                                        </div>
                                        <div className="col-4 form-group mb-2">
                                            <label className="small font-weight-bold">Titular</label>
                                            <input className="form-control form-control-sm" placeholder="Nome no cartão"
                                                value={formaPgtoAtual.dados_pagamento.titular || ''}
                                                onChange={(e) => setFormaPgtoAtual({ ...formaPgtoAtual, dados_pagamento: { ...formaPgtoAtual.dados_pagamento, titular: e.target.value } })} />
                                        </div>
                                        <div className="col-12 form-group mb-0">
                                            <label className="small font-weight-bold">Link de pagamento (opcional)</label>
                                            <input className="form-control form-control-sm" placeholder="https://..."
                                                value={formaPgtoAtual.dados_pagamento.link_pagamento || ''}
                                                onChange={(e) => setFormaPgtoAtual({ ...formaPgtoAtual, dados_pagamento: { ...formaPgtoAtual.dados_pagamento, link_pagamento: e.target.value } })} />
                                        </div>
                                    </div>
                                </div>
                            )}

                            {formaPgtoAtual.forma === 'boleto' && (
                                <div className="card p-3 mb-3" style={{ background: '#fffbeb', border: '1px solid #fde68a' }}>
                                    <h6 className="mb-3" style={{ color: '#78350f' }}>🧾 Dados do Boleto</h6>
                                    <div className="row">
                                        <div className="col-5 form-group mb-2">
                                            <label className="small font-weight-bold">Banco</label>
                                            <input className="form-control form-control-sm" placeholder="Ex.: Bradesco"
                                                value={formaPgtoAtual.dados_pagamento.banco || ''}
                                                onChange={(e) => setFormaPgtoAtual({ ...formaPgtoAtual, dados_pagamento: { ...formaPgtoAtual.dados_pagamento, banco: e.target.value } })} />
                                        </div>
                                        <div className="col-3 form-group mb-2">
                                            <label className="small font-weight-bold">Agência</label>
                                            <input className="form-control form-control-sm" placeholder="0000"
                                                value={formaPgtoAtual.dados_pagamento.agencia || ''}
                                                onChange={(e) => setFormaPgtoAtual({ ...formaPgtoAtual, dados_pagamento: { ...formaPgtoAtual.dados_pagamento, agencia: e.target.value } })} />
                                        </div>
                                        <div className="col-4 form-group mb-2">
                                            <label className="small font-weight-bold">Conta</label>
                                            <input className="form-control form-control-sm" placeholder="00000-0"
                                                value={formaPgtoAtual.dados_pagamento.conta || ''}
                                                onChange={(e) => setFormaPgtoAtual({ ...formaPgtoAtual, dados_pagamento: { ...formaPgtoAtual.dados_pagamento, conta: e.target.value } })} />
                                        </div>
                                        <div className="col-8 form-group mb-2">
                                            <label className="small font-weight-bold">Favorecido</label>
                                            <input className="form-control form-control-sm" placeholder="Razão social / nome"
                                                value={formaPgtoAtual.dados_pagamento.favorecido || ''}
                                                onChange={(e) => setFormaPgtoAtual({ ...formaPgtoAtual, dados_pagamento: { ...formaPgtoAtual.dados_pagamento, favorecido: e.target.value } })} />
                                        </div>
                                        <div className="col-4 form-group mb-2">
                                            <label className="small font-weight-bold">CPF / CNPJ</label>
                                            <input className="form-control form-control-sm" placeholder=""
                                                value={formaPgtoAtual.dados_pagamento.cpf_cnpj || ''}
                                                onChange={(e) => setFormaPgtoAtual({ ...formaPgtoAtual, dados_pagamento: { ...formaPgtoAtual.dados_pagamento, cpf_cnpj: e.target.value } })} />
                                        </div>
                                        <div className="col-12 form-group mb-0">
                                            <label className="small font-weight-bold">Linha digitável (opcional)</label>
                                            <input className="form-control form-control-sm" placeholder="000.00000 00000.000000 00000.000000 0 00000000000000"
                                                value={formaPgtoAtual.dados_pagamento.linha_digitavel || ''}
                                                onChange={(e) => setFormaPgtoAtual({ ...formaPgtoAtual, dados_pagamento: { ...formaPgtoAtual.dados_pagamento, linha_digitavel: e.target.value } })} />
                                        </div>
                                    </div>
                                </div>
                            )}

                            {(formaPgtoAtual.forma === 'remessa') && (
                                <div className="card p-3 mb-3" style={{ background: '#faf5ff', border: '1px solid #e9d5ff' }}>
                                    <h6 className="mb-3" style={{ color: '#4c1d95' }}>🏦 Dados para Remessa / TED / DOC</h6>
                                    <div className="row">
                                        <div className="col-5 form-group mb-2">
                                            <label className="small font-weight-bold">Banco</label>
                                            <input className="form-control form-control-sm" placeholder="Ex.: Itaú"
                                                value={formaPgtoAtual.dados_pagamento.banco || ''}
                                                onChange={(e) => setFormaPgtoAtual({ ...formaPgtoAtual, dados_pagamento: { ...formaPgtoAtual.dados_pagamento, banco: e.target.value } })} />
                                        </div>
                                        <div className="col-3 form-group mb-2">
                                            <label className="small font-weight-bold">Agência</label>
                                            <input className="form-control form-control-sm" placeholder="0000"
                                                value={formaPgtoAtual.dados_pagamento.agencia || ''}
                                                onChange={(e) => setFormaPgtoAtual({ ...formaPgtoAtual, dados_pagamento: { ...formaPgtoAtual.dados_pagamento, agencia: e.target.value } })} />
                                        </div>
                                        <div className="col-4 form-group mb-2">
                                            <label className="small font-weight-bold">Conta</label>
                                            <input className="form-control form-control-sm" placeholder="00000-0"
                                                value={formaPgtoAtual.dados_pagamento.conta || ''}
                                                onChange={(e) => setFormaPgtoAtual({ ...formaPgtoAtual, dados_pagamento: { ...formaPgtoAtual.dados_pagamento, conta: e.target.value } })} />
                                        </div>
                                        <div className="col-7 form-group mb-2">
                                            <label className="small font-weight-bold">Favorecido</label>
                                            <input className="form-control form-control-sm"
                                                value={formaPgtoAtual.dados_pagamento.favorecido || ''}
                                                onChange={(e) => setFormaPgtoAtual({ ...formaPgtoAtual, dados_pagamento: { ...formaPgtoAtual.dados_pagamento, favorecido: e.target.value } })} />
                                        </div>
                                        <div className="col-5 form-group mb-2">
                                            <label className="small font-weight-bold">CPF / CNPJ</label>
                                            <input className="form-control form-control-sm"
                                                value={formaPgtoAtual.dados_pagamento.cpf_cnpj || ''}
                                                onChange={(e) => setFormaPgtoAtual({ ...formaPgtoAtual, dados_pagamento: { ...formaPgtoAtual.dados_pagamento, cpf_cnpj: e.target.value } })} />
                                        </div>
                                        <div className="col-12 form-group mb-0">
                                            <label className="small font-weight-bold">SWIFT / BIC (internacional, opcional)</label>
                                            <input className="form-control form-control-sm" placeholder="Ex.: BRASBRRJXXX"
                                                value={formaPgtoAtual.dados_pagamento.swift || ''}
                                                onChange={(e) => setFormaPgtoAtual({ ...formaPgtoAtual, dados_pagamento: { ...formaPgtoAtual.dados_pagamento, swift: e.target.value } })} />
                                        </div>
                                    </div>
                                </div>
                            )}

                            {formaPgtoAtual.forma === 'fatura' && (
                                <div className="card p-3 mb-3" style={{ background: '#f0f4ff', border: '1px solid #c7d2fe' }}>
                                    <h6 className="mb-3" style={{ color: '#3730a3' }}>📋 Dados da Fatura</h6>
                                    <div className="row">
                                        <div className="col-6 form-group mb-0">
                                            <label className="small font-weight-bold">Número da fatura</label>
                                            <input className="form-control form-control-sm" placeholder="Ex.: FAT-2026-001"
                                                value={formaPgtoAtual.dados_pagamento.numero || ''}
                                                onChange={(e) => setFormaPgtoAtual({ ...formaPgtoAtual, dados_pagamento: { ...formaPgtoAtual.dados_pagamento, numero: e.target.value } })} />
                                        </div>
                                        <div className="col-6 form-group mb-0">
                                            <label className="small font-weight-bold">Vencimento</label>
                                            <input type="date" className="form-control form-control-sm"
                                                value={formaPgtoAtual.dados_pagamento.vencimento || ''}
                                                onChange={(e) => setFormaPgtoAtual({ ...formaPgtoAtual, dados_pagamento: { ...formaPgtoAtual.dados_pagamento, vencimento: e.target.value } })} />
                                        </div>
                                    </div>
                                </div>
                            )}

                            {formaPgtoAtual.forma === 'link' && (
                                <div className="card p-3 mb-3" style={{ background: '#fff7ed', border: '1px solid #fed7aa' }}>
                                    <h6 className="mb-3" style={{ color: '#c2410c' }}>🔗 Link de Pagamento</h6>
                                    <div className="form-group mb-2">
                                        <label className="small font-weight-bold">URL do link</label>
                                        <input className="form-control form-control-sm" placeholder="https://..."
                                            value={formaPgtoAtual.dados_pagamento.url || ''}
                                            onChange={(e) => setFormaPgtoAtual({ ...formaPgtoAtual, dados_pagamento: { ...formaPgtoAtual.dados_pagamento, url: e.target.value } })} />
                                    </div>
                                    <div className="form-group mb-0">
                                        <label className="small font-weight-bold">Descrição (opcional)</label>
                                        <input className="form-control form-control-sm" placeholder="Ex.: Mercado Pago — link gerado em 29/05"
                                            value={formaPgtoAtual.dados_pagamento.descricao || ''}
                                            onChange={(e) => setFormaPgtoAtual({ ...formaPgtoAtual, dados_pagamento: { ...formaPgtoAtual.dados_pagamento, descricao: e.target.value } })} />
                                    </div>
                                </div>
                            )}

                            {/* Observação (sempre visível quando forma selecionada) */}
                            {formaPgtoAtual.forma && (
                                <div className="form-group mb-0">
                                    <label className="small font-weight-bold">Observação (opcional)</label>
                                    <textarea
                                        className="form-control form-control-sm"
                                        rows={2}
                                        placeholder="Informações adicionais sobre este pagamento..."
                                        value={formaPgtoAtual.observacao || ''}
                                        onChange={(e) => setFormaPgtoAtual({ ...formaPgtoAtual, observacao: e.target.value })}
                                    />
                                </div>
                            )}
                        </>
                    )}
                </div>
                <div className="fin-pp__modal-foot" style={{ justifyContent: "space-between" }}>
                    <div>
                        {formaPgtosPorItem[subitemFormaPgtoAtual?.id] && (
                            <button type="button" className="fin-pp__btn fin-pp__btn--danger-ghost fin-pp__btn--sm" onClick={removerFormaPgto}>
                                🗑 Remover
                            </button>
                        )}
                    </div>
                    <div style={{ display: 'flex', gap: 8 }}>
                        <button type="button" className="fin-pp__btn" onClick={fecharModalFormaPgto}>Cancelar</button>
                        <button type="button" className="fin-pp__btn fin-pp__btn--primary" style={{ background: '#1565c0' }} onClick={salvarFormaPgto} disabled={salvandoFormaPgto || !formaPgtoAtual.forma}>
                            {salvandoFormaPgto ? <><FaCircleNotch style={{ animation: "spin 1s linear infinite", marginRight: 4 }} /> Salvando...</> : '💾 Salvar'}
                        </button>
                    </div>
                </div>
                    </div>
                </div>
            </div>
        )}

            {/* ─── Modal Re-Aprovação — Épico 7 ajuste ──────────────────────────── */}
            {/* Pagamento pelo cliente em fornecedor JÁ em Contas Pendentes.
                Não é re-aprovação: o item deixa de ser pago. Modal (não toast)
                porque o operador precisa ler e avisar o Financeiro. */}
            {clientesEmPendentes.length > 0 && (
            <div className="modal fade show d-block fin-pp fin-pp__modalbg">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content fin-pp__modal">
                        <div className="fin-pp__modal-head" style={{ background: '#dc3545', color: '#fff' }}>
                            <h3 className="fin-pp__modal-title" style={{ color: '#fff' }}>
                                🔒 Item já está na agenda de pagamentos
                            </h3>
                        </div>
                        <div className="modal-body" style={{ padding: '24px' }}>
                            <div style={{ background: '#f8d7da', color: '#842029', border: '1px solid #f5c2c7', borderRadius: 6, padding: '14px 16px', marginBottom: 16 }}>
                                <strong>{clientesEmPendentes.length} fornecedor(es)</strong> em <strong>Contas Pendentes</strong> passaram a ser pagos <strong>pelo cliente</strong>:
                                <ul style={{ margin: '8px 0 0 18px' }}>
                                    {clientesEmPendentes.map(function (f, i) {
                                        return <li key={i}><strong>{f.fornecedor_nome}</strong></li>;
                                    })}
                                </ul>
                            </div>
                            <p style={{ marginBottom: 12 }}>
                                As parcelas em aberto serão <strong>canceladas</strong> e passarão a aparecer na aba
                                <strong> Cancelado</strong>. Como o cliente assume o pagamento,
                                <strong> nenhuma nova previsão é criada</strong>.
                            </p>
                            <div style={{ background: '#fff3cd', border: '1px solid #ffe69c', borderRadius: 6, padding: '12px 14px', color: '#664d03' }}>
                                ⚠️ <strong>Entre em contato com o Financeiro.</strong> Este item já estava na agenda de
                                pagamentos — confirme que não será pago pela Access.
                            </div>
                        </div>
                        <div className="modal-footer" style={{ gap: 8 }}>
                            <button type="button" className="fin-pp__btn" onClick={function () { setClientesEmPendentes([]); }}>
                                Cancelar
                            </button>
                            <button type="button" className="fin-pp__btn fin-pp__btn--danger"
                                onClick={function () {
                                    setClientesEmPendentes([]);
                                    salvarIgnorarOPFCheck.current = true;
                                    salvarComReaprovacao.current = false;
                                    salvar();
                                }}>
                                ✅ Entendi, salvar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            )}

            {itensEmBrancoAviso && (() => {
                const voltarERevisar = () => {
                    setItensEmBrancoAviso(null);
                    salvarIgnorarOPFCheck.current = false;
                    salvarComReaprovacao.current = false;
                };
                return (
                    <div className="modal fade show d-block fin-pp fin-pp__modalbg" data-aviso-itens-em-branco
                        onClick={(e) => { if (e.target === e.currentTarget) voltarERevisar(); }}>
                        <div className="modal-dialog modal-dialog-centered modal-lg">
                            {/* 15/10: com muitas colunas/itens a lista passava da tela e escondia o "Salvar mesmo assim" — só o corpo rola. */}
                            <div className="modal-content fin-pp__modal fin-pp__modal--scroll">
                                <div className="fin-pp__modal-head">
                                    <span className="fin-pp__modal-head-ic is-danger"><FaExclamationTriangle size={17} /></span>
                                    <h3 className="fin-pp__modal-title">Existem itens em branco ou zerados
                                        <span className="fin-pp__modal-sub">Confira se nenhum item foi esquecido. Nada é preenchido automaticamente.</span>
                                    </h3>
                                    <button type="button" className="fin-pp__modal-close" onClick={voltarERevisar}><FaTimes size={16} /></button>
                                </div>
                                <div className="modal-body">
                                    {COLUNAS_ITENS_EM_BRANCO.filter((coluna) => itensEmBrancoAviso[coluna].length > 0).map((coluna) => {
                                        const { visiveis, restantes } = resumirItensEmBranco(itensEmBrancoAviso[coluna], 10);
                                        return (
                                            <div key={coluna} style={{ marginBottom: 14 }} data-aviso-itens-em-branco-coluna={coluna}>
                                                <div className="fin-pp__cell-strong" style={{ marginBottom: 4 }}>
                                                    {ROTULO_COLUNA_ITENS_EM_BRANCO[coluna]} · {itensEmBrancoAviso[coluna].length} {itensEmBrancoAviso[coluna].length === 1 ? 'item' : 'itens'}
                                                </div>
                                                <ul style={{ margin: 0, paddingLeft: 18, fontSize: 13 }}>
                                                    {visiveis.map((item) => <li key={`${item.grupoIndex}-${item.linhaIndex}`}>{item.rotulo}</li>)}
                                                    {restantes > 0 && <li className="fin-pp__cell-muted" style={{ listStyle: 'none', marginLeft: -18 }}>e mais {restantes}</li>}
                                                </ul>
                                            </div>
                                        );
                                    })}
                                </div>
                                <div className="fin-pp__modal-foot">
                                    <button type="button" className="fin-pp__btn" onClick={voltarERevisar}>Voltar e revisar</button>
                                    <button type="button" className="fin-pp__btn fin-pp__btn--primary"
                                        onClick={() => {
                                            const continuar = itensEmBrancoAviso.continuar;
                                            setItensEmBrancoAviso(null);
                                            salvarIgnorarItensEmBranco.current = true;
                                            if (ARQUIVOS_SALVAR_E_BAIXAR[continuar]) salvarEBaixar(continuar); else salvar();
                                        }}>
                                        Salvar mesmo assim
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })()}

            {showModalReaprovacao && (
            <div className="modal fade show d-block fin-pp fin-pp__modalbg">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content fin-pp__modal">
                <div className="fin-pp__modal-head" style={{ background: '#dc3545', color: '#fff' }}>
                    <h3 className="fin-pp__modal-title" style={{ color: '#fff' }}>
                        {travadosViraramCliente.length > 0
                            ? '🔒 Pagamento travado pelo Financeiro'
                            : avisoPagamento.some(a => a.tipo === 'reduziu' || a.tipo === 'removido')
                            ? '🚨 Item em processo de pagamento'
                            : avisoPagamento.length > 0
                            ? '🔒 Fornecedor em processo de pagamento'
                            : opfsLiberadosFiltrados.length > 0
                            ? '🔒 Fornecedor com pagamento em Contas Pendentes'
                            : '⚠️ Atenção — Valores já aprovados pelo Financeiro'}
                    </h3>
                </div>
                <div className="modal-body" style={{ padding: '24px' }}>
                    {travadosViraramCliente.length > 0 && (
                        <div data-trava-cliente style={{ background: '#f8d7da', color: '#842029', border: '1px solid #f5c2c7', borderRadius: 6, padding: '14px 16px' }}>
                            <p style={{ marginBottom: 8, fontSize: '14px', fontWeight: 600 }}>
                                🔒 Não dá para salvar: o Financeiro já travou o pagamento de
                            </p>
                            <ul style={{ marginBottom: 8, paddingLeft: 20, fontSize: '13px' }}>
                                {travadosViraramCliente.map(function(f, i) { return <li key={i}><strong>{f.fornecedor_nome}</strong></li>; })}
                            </ul>
                            <p style={{ marginBottom: 0, fontSize: '13px' }}>
                                Marcar como <strong>pago pelo cliente</strong> cancelaria uma conta que está sendo paga. Desfaça essa marcação ou ligue para o Financeiro: ele devolve a parcela para o Custo Previsto e aí a alteração passa.
                            </p>
                        </div>
                    )}
                    {travadosViraramCliente.length === 0 && avisoPagamento.length > 0 && (
                        <div data-aviso-pagamento style={{ marginBottom: (opfsLiberadosFiltrados.length > 0 || opfsAprovadosFiltrados.length > 0) ? 20 : 0 }}>
                            {avisoPagamento.map(function(a, i) {
                                const reduz = a.tipo === 'reduziu' || a.tipo === 'removido';
                                const situacao = a.pago ? 'já tem parcela PAGA' : 'foi travado pelo Financeiro para pagamento';
                                return (
                                    <div key={i} style={{ background: reduz ? '#f8d7da' : '#fff8e1', color: reduz ? '#842029' : '#7a5000', border: '1px solid ' + (reduz ? '#f5c2c7' : '#ffe082'), borderRadius: 6, padding: '12px 14px', marginBottom: i < avisoPagamento.length - 1 ? 10 : 0, fontSize: '13px' }}>
                                        <p style={{ marginBottom: 6, fontSize: '14px', fontWeight: 600 }}>
                                            {reduz ? '🚨 ' : '🔒 '}{a.nome} — {situacao}
                                        </p>
                                        <p style={{ marginBottom: 6 }}>
                                            Valor no orçamento: R$ {moeda(a.antes)} → R$ {moeda(a.depois)}{a.tipo === 'removido' ? ' (removido)' : ''}
                                        </p>
                                        {reduz ? (
                                            <p style={{ marginBottom: 0 }}>
                                                Este item está <strong>em processo de pagamento</strong>. <strong>Fale URGENTE com o Financeiro</strong>: se ainda não foi pago, ele devolve para o Custo Previsto e reprova. Se já foi pago, não tem volta — a parcela fica marcada com o aviso vermelho (data, hora e quem alterou).
                                            </p>
                                        ) : null}
                                        {reduz && a.livres > 0 ? (
                                            <p style={{ marginBottom: 0, marginTop: 6 }} data-aviso-livres-voltam>
                                                {a.livres === 1 ? 'A parcela' : `As ${a.livres} parcelas`} deste fornecedor que {a.livres === 1 ? 'está' : 'estão'} em Contas Pendentes <strong>sem trava</strong> {a.livres === 1 ? 'volta' : 'voltam'} <strong>sozinha{a.livres === 1 ? '' : 's'} para o Custo Previsto</strong> ao salvar, e o Financeiro é avisado.
                                            </p>
                                        ) : null}
                                        {reduz ? null : a.tipo === 'aumentou' ? (
                                            <p style={{ marginBottom: 0 }}>
                                                Este item está <strong>em processo de pagamento</strong> e não muda. A diferença de <strong>R$ {moeda(a.depois - a.antes)}</strong> vai como <strong>nova previsão</strong> para o Financeiro aprovar no <strong>Custo Previsto</strong>.
                                            </p>
                                        ) : (
                                            <p style={{ marginBottom: 0 }}>Este item está <strong>em processo de pagamento</strong>. O total do fornecedor não muda, mas avise o Financeiro.</p>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    )}
                    {/* Bloqueado pela trava: só o aviso do bloqueio — o resto ("ao salvar…") não vai acontecer. */}
                    {travadosViraramCliente.length === 0 && opfsLiberadosFiltrados.length > 0 && (
                        <div style={{ background: '#f8d7da', color: '#842029', border: '1px solid #f5c2c7', borderRadius: 6, padding: '14px 16px', marginBottom: opfsAprovadosFiltrados.length > 0 ? 20 : 0 }}>
                            <p style={{ marginBottom: 8, fontSize: '14px', fontWeight: 600 }}>
                                {opfsLiberadosFiltrados.length} fornecedor(es) já estão em Contas Pendentes (liberados para pagamento):
                            </p>
                            <ul style={{ marginBottom: 8, paddingLeft: 20, fontSize: '13px' }}>
                                {opfsLiberadosFiltrados.map(function(f, i) {
                                    return <li key={i}><strong>{f.fornecedor_nome}</strong>{(f.parcelas_travadas || 0) > 0 ? ' — 🔒 travado para pagamento (o Financeiro está pagando)' : ''}</li>;
                                })}
                            </ul>
                            <p style={{ marginBottom: 0, fontSize: '13px' }}>
                                Se o valor <strong>subir</strong>, as parcelas que já estão em Contas Pendentes não mudam: só a <strong>diferença</strong> vai para aprovação do Financeiro no Custo Previsto (complemento) e os responsáveis do evento recebem um e-mail. Para refazer o valor inteiro, peça ao Financeiro para devolver a parcela ao Custo Previsto <strong>antes</strong> de salvar. Se o valor <strong>descer</strong>, as parcelas <strong>sem trava</strong> voltam sozinhas para o Custo Previsto (nova aprovação) e o Financeiro é avisado; parcela travada ou paga não muda.
                            </p>
                        </div>
                    )}
                    {travadosViraramCliente.length === 0 && opfsAprovadosFiltrados.length > 0 && (
                        <>
                            <p style={{ marginBottom: 12, fontSize: '14px' }}>
                                Este orçamento possui <strong>{opfsAprovadosFiltrados.length} fornecedor(es)</strong> com Custo Previsto já aprovado pelo Financeiro:
                            </p>
                            <ul style={{ marginBottom: 16, paddingLeft: 20, fontSize: '13px' }}>
                                {opfsAprovadosFiltrados.map(function(f, i) {
                                    return <li key={i}><strong>{f.fornecedor_nome}</strong></li>;
                                })}
                            </ul>
                            <p style={{ marginBottom: 0, fontSize: '14px' }}>
                                Ao salvar, a Previsão de Pagamento desse(s) fornecedor(es) <strong>volta para aprovação do Financeiro</strong> (Custo Previsto)
                                e os responsáveis do evento recebem um <strong>e-mail</strong> avisando que os valores aprovados voltaram por mudança no orçamento.
                            </p>
                        </>
                    )}
                </div>
                <div className="fin-pp__modal-foot">
                    {travadosViraramCliente.length > 0 ? (
                        <button type="button" className="fin-pp__btn" onClick={function() { setShowModalReaprovacao(false); }}>
                            Voltar e corrigir
                        </button>
                    ) : opfsAprovadosFiltrados.length > 0 ? (
                        <>
                            {/* Rafael 07/10: não existe "salvar sem re-enviar" — o servidor sempre devolve para aprovação. */}
                            <button type="button" className="fin-pp__btn" onClick={function() { setShowModalReaprovacao(false); }}>
                                Cancelar
                            </button>
                            <button type="button" className="fin-pp__btn fin-pp__btn--danger" data-confirmar-reaprovacao onClick={function() { setShowModalReaprovacao(false); salvarIgnorarOPFCheck.current = true; salvarComReaprovacao.current = false; cientePagamento.current = avisoPagamento.length > 0; salvar(); }}>
                                Salvar e enviar para reaprovação
                            </button>
                        </>
                    ) : (
                        <>
                            <button type="button" className="fin-pp__btn" onClick={function() { setShowModalReaprovacao(false); }}>
                                Cancelar
                            </button>
                            <button type="button" className="fin-pp__btn fin-pp__btn--danger" onClick={function() { setShowModalReaprovacao(false); salvarIgnorarOPFCheck.current = true; salvarComReaprovacao.current = false; cientePagamento.current = avisoPagamento.length > 0; salvar(); }}>
                                Entendi, salvar
                            </button>
                        </>
                    )}
                </div>
                    </div>
                </div>
            </div>
        )}
            {/* Rascunho não salvo (08/10; parte 3 em 19/10): o aviso fixo fica na pilha acima da barra de
                botões; aqui, o aviso ao sair pela navegação do sistema e a oferta de restaurar ao voltar. */}
            <ModalSairSemSalvarOrcamento
                aberto={!!rascunhoOrcamento.saida}
                erro={rascunhoOrcamento.erroServidor}
                onFicar={rascunhoOrcamento.ficarNaTela}
                onSair={rascunhoOrcamento.sairSemSalvar}
            />
            <ModalRascunhoOrcamento
                pendente={rascunhoOrcamento.pendente}
                onRestaurar={rascunhoOrcamento.restaurar}
                onDescartar={rascunhoOrcamento.descartar}
            />
        </ErpTemplate>
    );
}
